var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 383 281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".p{fill:#ef6c56;}.q{fill:#ff9b9d;}.r{fill:#fff;}.s{fill:#fff039;}.t{fill:#16bcff;}.u{fill:#119570;}.v{stroke:#000;}.v,.w{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:.5px;}.w{stroke:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "c",
    className: "r",
    points: "169.31 193.21 73.26 193.21 54.96 109.52 53.76 104.06 41.35 47.32 137.4 47.32 152.86 117.99 158.82 145.25 169.31 193.21"
  }), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.31,193.21H80.63l-2.6-27.61-2.56-27.2c-1.27-5.29-1.03-10.57,.43-15.41,2.58-8.56,8.98-15.72,17.61-19.07,1.73-.67,3.55-1.19,5.44-1.53,20.09-2.96,30.34,1.46,36.01,6.42,4.64,4.07,11.02,12.7,15.71,11.01,1.07-.39,1.77-1.21,2.19-1.83l5.96,27.26,10.49,47.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.58,124.83c-.62,20.43-1.25,40.86-1.87,61.3-.07,2.4-.34,4.77-.78,7.08h-52.68c-5.47-25.03-10.95-50.07-16.42-75.1,2.63-3.06,7.78-8.22,15.87-11.87,9-4.06,17.1-4.19,21.23-3.97-.14,.55-.28,1.11-.42,1.66-1.63,6.5-3.26,13.01-4.9,19.51,13.32,.46,26.65,.93,39.97,1.39Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M87.4,102.39c-5.57,3.81-11.13,7.63-16.7,11.44,7.33,.23,14.67,.45,22,.68l-2.91,7.87,9.43-3.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M109.29,101.71c6.02,2.63,11.72,5.09,17.73,7.72-5.93,1.38-11.85,2.76-17.78,4.13l5.13,5.66-9.28-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M97.34,109.94s1.81,4.53,2.45,14.52c.64,9.99,1.36,34.35,1.36,34.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M102.19,109.65s2.54,5.63,3.39,10.61,1.87,39.06,1.87,39.06"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "w",
    cx: 101.14,
    cy: 114.39,
    r: 1.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M103.54,119.88c0,.58-.47,1.04-1.04,1.04s-1.04-.47-1.04-1.04,.47-1.04,1.04-1.04,1.04,.47,1.04,1.04Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M165.27,93.76c-.89-2.48-3.84-3.5-6.07-2.1-1.18,.74-1.6,1.42-1.65,2.81l-.29,.86c-.19-.74-.5-1.82-.98-3.08-.64-1.72-.98-2.59-1.58-3.1-1.46-1.22-3.84-.57-4.64-.32h0c-1.34,.51-1.8,2.32-1.96,3.67-.19-.34-1.23-2.09-3.34-2.56-.35-.08-1.4-.26-2.54,.15-2,.72-3.19,2.75-2.86,4.82l3.66,23.28-.48,.73c-1.41,2.12-1.74,4.78-.89,7.18,.17,.66,.64,2.06,1.94,3.05,1.88,1.44,4.73,1.43,7.14-.04l1.12,3.28c1.38,4.05,5.51,6.49,9.73,5.74,.08-.01,.16-.03,.24-.04,8.58-1.48,13.88-10.2,11.33-18.52-2.87-9.38-6.08-19.77-7.87-25.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M144.05,117.5l6.59-5.19c1.52-1.19,3.7-1,4.98,.44h0c1.35,1.53,1.19,3.87-.36,5.19l-5.62,4.78,4.07-2.49c1.3-.79,2.97-.61,4.06,.44l.82,.79"
  })), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M147.56,92.15l3.47,19.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M157.55,94.46c.92,5.07,1.84,10.14,2.76,15.22"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "f",
    className: "r",
    points: "169.31 193.21 73.26 193.21 65.73 158.81 162.52 158.81 169.31 193.21"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "v",
    cx: 120.26,
    cy: 175.86,
    r: 12.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.94,167.9c1.2,1.43,2.4,2.85,3.59,4.28,.18,.21,.07,.54-.2,.59l-2.34,.52c-.07,.02-.16,.19-.21,.58-.23,1.6,.95,3.24,1.11,3.46,.48,.65,1.65,2.24,3.21,2.17,.27-.01,.49-.07,.65-.12l.72-2.58c.08-.28,.43-.36,.62-.15l3.52,3.79c.2,.21,.08,.56-.2,.61l-3.27,.59c-.07,.01-.14,.05-.19,.1-2.82,.57-5.74-.48-7.55-2.72-1.82-2.26-2.22-5.37-1.03-8.03,.07-.05,.12-.12,.14-.2,.26-.92,.53-1.84,.79-2.76,.08-.28,.45-.36,.63-.14Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M91.65,92.1c-.67,.04-1.33,.07-2,.11-.88,.15-2.8,.33-4.84-.6-2.76-1.26-4.87-4.18-4.85-7.49,0-.41,.07-4.2,2.55-5.79,1.52-.98,2.73-1.26,7.42-1.66h0c1.36-2.6,2.72-5.21,4.08-7.81,5.26,.91,7.47,.1,8.5-.88,.36-.35,1.57-1.54,3.52-2.39,.35-.15,.74-.27,1.22-.37,2.04-.42,7.09-.05,11.2,3.58,1.37,1.21,2.06,1.82,2.4,2.93,.55,1.82-.15,3.91,.05,5.8,.01,.13,.08,.74,.14,1.59,.02,.26,.04,.56,.05,.95,.05,1.46,0,2.9-.2,4.3,0,.06-.02,.12-.03,.19-.03,.19-.06,.38-.09,.57-.06,.34-.13,.67-.21,1-.25,1.05-.58,2.05-1.02,3.01-.75,1.64-1.8,3.11-3.21,4.33-3.28,2.83-7.47,3.4-8.33,3.51-5.36,.65-9.38-1.55-10.64-2.3l-5.24-.26c-.15-.73-.31-1.5-.49-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M109.54,96.81c-.27,2.54-.54,5.09-.82,7.63-.22,2.06-1.61,3.83-3.58,4.48-1.61,.53-3.61,.97-5.91,1.01-1.86,.03-3.56-.2-5.06-.56-3.77-.92-6.27-4.48-5.84-8.33,.46-4.09,.91-8.18,1.37-12.27,6.61,2.68,13.23,5.36,19.84,8.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M123.34,87.38c-2,1.29-4.38,2.01-5.86,2.24-.29,.04-.52,.08-.66,.1,.02,.05,.29,.06,.63,.06-.04,.16-.07,.32-.11,.49-.07,.28-.15,.57-.23,.84-.27,.89-.64,1.74-1.1,2.56-5.05-.38-8.96-3.81-9.06-8.25-.08-3.25,1.9-6.25,4.94-8.05,.15,0,.27,0,.35,0,.38-.01,.98-.04,1.71-.1,.78-.06,1.47-.14,2.07-.23,2.9-.42,3.96-1.01,5.47-.75,2.83,.48,4.05,3.42,4.18,3.75,1.02,2.58,.16,5.76-2.32,7.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M84.26,85.59l6.27-1.14c-1.93-1.48-3.86-2.95-5.79-4.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M106.92,87.17c.48,.33,1.26,.77,2.31,1.01,1.48,.34,2.72,.09,3.34-.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M97.34,94.61c.74,.48,1.61,.94,2.6,1.34,3.79,1.52,7.33,1.19,9.33,.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M113.38,80.34s4.1-5.5,7.47-.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M121.01,72.07c-6.11-2.87-11.07-6.7-11.47-6.99-.27-.2,0,1.25,0,1.25-.15-.13-.31-.29-.47-.47-1.19-1.33-1.52-2.96-1.62-4.02,.84,0,2.46-.06,3.3-.05h0c.38,.03,.77,.08,1.15,.14,4.16,.64,6.35,3.39,7.15,4.37,.06,.07,.13,.16,.22,.27,0,0,.25,.33,.47,.66,.23,.35,.85,2.21,1.28,4.85Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.66,
    y: 79.41,
    width: 1.1,
    height: 1.1,
    rx: 0.55,
    ry: 0.55,
    transform: "translate(7.1 -9.6) rotate(4.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M99.5,80.94s4.01-5.97,8.2,.05"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.04,
    y: 79.59,
    width: 1.1,
    height: 1.1,
    rx: 0.55,
    ry: 0.55,
    transform: "translate(7.06 -8.46) rotate(4.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M113.35,79.85c-.04,.43-.22,1.25-.06,2.14,.27,1.47,.73,2.59,1.11,3.19-.56,.03-2.13,.08-3.86-.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M107.85,61.78c-2.65,.13-4.9,.29-6.65,.43-2.53,.21-1.23-.06-6.49,.68-1.86,.26-3.33,.52-3.68,.58-.86,.16-1.74,.44-2.63,.81-2.36,.97-10.72,6.47-11.05,15.88-.07,1.98-.26,7.03,3.49,10.46,2.52,2.3,6.96,3.07,8.29,3.17,.07-.37,.19-1.21,.27-1.58-.9-.03-3.45-.09-4.59-.61-2.76-1.26-4.87-4.18-4.85-7.49,0-.41,.07-4.2,2.55-5.79,1.23-.79,2.25-1.13,5.06-1.44,1.49-.17,3-.1,4.47,.2l.12,.02c.76-2.15,1.52-4.3,2.28-6.45,13.17-.85,19.86-2.32,20.06-4.42,.12-1.26-2.09-2.75-6.64-4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M108.65,83.73c.67-2.48,1.34-4.96,2-7.44l-14.68,.17c.37,2.51,.75,5.01,1.12,7.52,3.85-.08,7.7-.16,11.56-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M121.97,82.97l.97-7.31c-3.57,.2-7.14,.39-10.72,.59,.99,2.31,1.99,4.62,2.98,6.92,2.25-.07,4.51-.14,6.76-.21Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "v",
    x1: 110.14,
    y1: 79.66,
    x2: 113.11,
    y2: 79.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M92.04,77.25c1.31-.28,2.63-.56,3.94-.83"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.49,63.2l.08,.03,.1-.07c.17,0,.38,.02,.46,.01-.05,0-.05-.02-.05-.03,.08,0,.18-.08,.22,0,.16-.05,0-.1,.17-.13l-.13,.02v.08c-.15,.02-.09-.11-.27-.08l-.12,.07c-.07-.02-.1-.06-.17-.05,.01,.02,.05,.03,.04,.06l-.08-.02c.04,.05-.13-.04,.02,.07l-.08-.05c-.13,.04-.18-.03-.29-.02l-.08,.08,.18,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M83.91,65.85h.08c-.1-.06-.15,0-.29-.04l.21,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M83.92,66.91l.14-.03s-.04-.04-.02-.06c.01,.08,.13,0,.19,0v.08l-.06-.04c.09,.08-.09,.02-.16,.09l-.1-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "85.64 63.55 85.57 63.56 85.57 63.59 85.64 63.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.47,63.66s0,.05-.06,.03h.12l-.06-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.95,63.47s.06,.01,.03,.03c-.02,0-.03,0-.06-.01,.11,.01-.02,.06-.05,.08-.02-.03,.18-.03,.25,0,.08,.03-.1,.12,.03,.12,.07-.09,0-.03,.03-.13,.04,.01,.04,.03,.08,.02l-.06-.02c.08-.04,.06-.05,.16-.06-.03-.02-.09-.01-.09-.04,.04-.02,.1,0,.13,.02,.02-.07,.06,0,0-.08h.07c-.16,.02-.07-.1-.23-.03l.05,.02s-.08,.04-.13,.05l-.05-.04s.02,.03-.04,.04h-.11s-.02,.02-.03,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M84.17,65.02l.09-.03-.07-.04s0,.05-.02,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.42,63.2h-.03c.13,.06,.16-.08,.27,.02-.09,.02,0,.06-.07,.1,.03-.01,.06,.02,.11-.02-.03-.06,.07-.09-.01-.13h-.08c.06-.03-.06-.07-.13-.07-.01,.04,.02,.07-.04,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M83.82,65.44c.24-.04-.01,.17,.15,.13-.07,0-.04,.02-.06,.05,.03-.13-.21,.04-.21-.07h.05l.02,.03,.02-.05h.06l.02,.02v-.07l-.06-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.03,63.64l.05,.02-.04-.05s-.04,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M84.01,65.38s-.07,.02-.07,.04c.09,0,.1,.06,.2,.05-.06-.01-.05-.06-.13-.09-.03-.03,.05-.03,.07-.04,.07,0,.04,.05,.03,.05l.12-.03v.08h-.07l.07,.04s.05-.06,.1-.03c.05,.04-.1,.03-.07,.08,0-.03,.12-.07,.18-.03l-.03-.05h.15c-.12-.01,.03-.08-.1-.08,.02,0,.02,.03,.03,.05-.04,0-.06-.01-.1,0v.05c-.09,0,0-.1-.09-.07,.08-.02,.05-.12,.19-.1,.02-.05-.05-.04-.08-.07-.03,.02,0,.05-.04,.06,0-.07-.07,0-.12-.03-.06-.02-.13,.11-.26,.08l.02,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "84.51 65.04 84.42 64.92 84.35 65.01 84.51 65.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "86.6 63.43 86.6 63.38 86.56 63.44 86.6 63.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "86.9 63.27 86.84 63.27 86.81 63.3 86.9 63.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M84.61,65.73s.08-.07,.11-.04c.02-.02-.04-.03-.06-.04l-.42,.17c-.06-.02,.22-.17,.25-.23-.13,.06-.34,.08-.44,.09v.05c-.08,.02-.16,.03-.2,.06l.75-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M84.83,65.73h0l-.11,.02s.02,0,.01,0h.04l.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M83.87,65.89c.09,.08,.03,0,.15,.04,.02,.06,0,.08-.05,.12,.03-.01-.01-.02-.01-.02l-.08-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.12,63.35h-.04l.13,.06s.04-.03,.08-.04c.01,.02-.03,.09,.05,.06,.06,.05-.1,.03-.04,.08,.13,0,.16-.04,.23-.06,0,0-.16-.05-.16-.05l.03-.11-.2,.03s.01-.06-.05-.08c.01,0-.07,.02-.07,.03h-.14c.06,.02,.15,.05,.19,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.5,63.61h.09s-.01-.02,0-.02l.13-.02-.13-.02c-.06,.02,.04,.06-.08,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.15,63.45c-.07-.02-.1-.04-.16,0l-.03-.06c-.04,.06,.13,.04,.2,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M84.83,65.16s.05,0,.07,0c-.07-.03,.08-.06-.04-.04-.02,.02-.03,.02-.03,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M84.63,65.56s-.06-.04-.09-.01c-.02,.06,0,.1,.12,.09h-.01c.1-.07,.28-.08,.34-.11,.11,0-.03,.06,.05,.08,.17-.04,.26-.03,.41-.04,.02,.06-.09,.02-.09,.03,.1,.03,.08,.12,.18,.14,0-.09,.19-.01,.21,0h-.11s.03,.02,.03,.04c-.06,.05-.15-.05-.18,.03,.03,.01-.04,.16,.12,.16,0-.03,.04-.03,.06-.03,.05,.02,.03,.09-.04,.08,.07,0,.14-.07,.22-.01v.03h.23l-.04,.07s.04,0,.08,.02h-.02l.09-.04-.06-.02s.07-.05,.09-.08c0,.07,.14,.02,.2,.06h-.02l.08-.03c-.09,0-.16-.04-.26-.06-.09,0-.08,.07-.18,.02,.12-.04-.03-.01,.04-.06,.03-.01,.05,0,.09,0-.04,.04,.04-.08-.09-.06-.03,.02-.11,.01-.14,.01,.07-.02,.01-.04,.07-.05-.02,0-.06-.01-.08-.02,.04,0,.05,.03,.03,.06-.08-.05,0,.1-.13,.04l.03-.07h-.03s.1-.05,.05-.07c.05-.01,.07,.02,.1,.02v-.04h.05l-.1-.03c.18-.02-.03-.11,.17-.09,.05,.04,0,.08,.03,.13-.02-.06,.14-.07,.24-.07l-.02,.03,.15-.02v-.06c-.07-.04-.1,.06-.15,0,.03-.01,.16-.11,.16-.05l-.09-.05h.2s.09-.02,.13-.04c.02,0-.02,.03-.03,.04,.12,.05,.29-.02,.41,0,0-.12,.2-.08,.21-.18h-.02c-.05-.04,.05-.04,.08-.06-.08-.03-.17-.02-.27,0-.01-.06,.12-.04,.15-.08,.02,0,.06,.01,.1,0l-.03-.03c-.1,.07-.3-.04-.35,.08,.03,.03,.12-.01,.1,.04-.06,.05-.19,.03-.23,.09,.03-.06-.09-.07-.06-.12-.02,.03-.03,.06-.08,.04,.08-.05-.03-.07,0-.12h-.06s.03,.02,.04,.02c-.06,.11-.1-.08-.19,.04,.13-.05,.08,.14,.2,.06-.02,.05,.02,.07,.03,.11,.1-.12,.2,.02,.29,.02-.14-.07-.27,.14-.37,.02v-.06c.02,.06-.08,0-.09,.04,.01,0,.06,.01,.05,.03-.04,0-.07-.02-.1-.03-.02,.02,0,.02,0,.03-.02-.03-.11-.09-.13-.11,.01,0,.01,.02,.03,.02-.06-.11-.3,.05-.3-.08-.22,.17-.53,.07-.75,.22-.07-.04-.05-.06-.18-.05-.13,.04-.38,.07-.43,.13-.12,.03-.08-.09-.23-.08,.05,0,.07,.07,.1,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M84.13,66.58c-.06-.01-.21,.07-.26,.05l.11,.03,.15-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.12,62.74l-.02,.05s.05-.03,.08-.05c-.01-.02-.12-.05-.15,0h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.06,65.31h-.1c.21-.05,.2,.11,.4,.07l.03-.07c.05-.01,.06,.01,.09,.01,.05-.1-.12,.01-.11-.06l-.05,.04c-.1-.15-.22,.06-.33-.02,.02,0,.08,0,.06,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.56,63.2s.07,0,.12-.01l-.03-.05s-.07,.03-.09,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.28,62.78c-.06-.02-.09,0-.14,.03l.14-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.84,63.9s.1-.03,.07,.03c.11-.02-.04-.11,.11-.11-.03-.01-.14,.01-.08-.03,.02,.04-.08,.08-.1,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.69,63.31h-.12c.06,0,.13,.03,.2,0-.05-.08-.06,.02-.14-.07,.07,0,.03,.05,.06,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.48,62.79s.12-.05,.22-.07c.12-.02,.24,0,.3,.01h0c.13-.02,.27,0,.31,.06-.05,0,0-.05,.02-.07,.04,0,.17-.01,.23,.01,.03,.09-.27,0-.26,.13,.04,0,.14,.03,.21,.03l-.09-.06c.07-.02,.18,.01,.18,.07v-.05c.13-.04,.18,.06,.26,.03-.07,.03-.06-.02-.08-.03l.08-.02s.07,.07,.12,.07c.06-.02-.03-.07,.01-.11h.09s-.13,0-.11-.07v.07c-.06-.06-.09,.04-.14-.03l-.08,.06s.05-.1,.03-.15c-.07,0-.16,.03-.17,0-.08,0,.07,.02,0,.05-.19,0-.21-.16-.4-.09h0c-.2,.07-.19-.08-.39,.02,.01,.02,.03,.03,0,.05-.09-.04-.2,0-.34,.02l.05,.03-.06,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.02,65.76s0-.03-.03-.05h.11s.02-.05-.03-.05c.06,.05-.06,.02-.1,.04,.1,.03-.08,.04,.05,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.75,63.65l.04-.03-.19-.04s0,.14,.15,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.37,63.09c.11-.06,.16,0,.27-.03,0-.02-.06-.06-.16-.04l.04-.04c-.11,.05-.1-.03-.18,.02l.04,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.7,62.87s-.13,0-.15-.02v.06l.15-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.99,65.05h.03s-.02-.02,0-.03c.07-.03,.08,.02,.11,.04-.05,0-.07,.03-.12,.04,.23-.03,.17,.03,.37,.01l-.05-.03c.1-.09,.05,.04,.17,.02,.02,0-.06-.05,.02-.07,.09-.03,.03,.03,.08,.03l-.02-.03s.03,0,.04,0v-.06c.12-.02,.18-.06,.29-.02,.05-.05-.12-.02-.03-.07,.04,.03,.16,.05,.17-.01h0l-.09,.05s0-.06,.03-.08c-.08,.08-.17-.05-.22,.06-.01-.02,0-.05-.05-.06l-.03,.06s-.14,.03-.19,.04c.02-.03,.15-.07,.04-.08-.06,0-.03,.06-.11,.06l-.02-.04c-.11-.04-.1,.11-.19,.03-.12,.04-.25,.07-.25,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.23,63.21s.07,.02,.09,.03l-.08-.07s.02,.03-.01,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.91,63.53l.18-.02c.01-.05-.1,0-.14-.02,.01,.02-.03,.02-.04,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "88.29 63.26 88.25 63.25 88.23 63.28 88.29 63.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.21,63.58h.24s.03-.06-.07-.07l.05,.03c-.07,0-.11,.04-.19,0,0-.05-.08-.12,.01-.12h-.15c.13,0,.11,.11,.11,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.44,65.74s-.09,0-.09-.03c.02,.06,.02,.03,.09,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M84.01,67.2s.11,.02,.15,.02c-.08,0,.04-.04,.04-.06,.04,.04,.08,.08,.05,.1l-.03,.06s-.09,.07,0,.07l-.13,.02,.05-.06c-.1,.02-.12-.06-.18-.05h.15l-.11-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.98,63.58c.07-.02,.01,.06,.09,.03-.02,0-.07-.07-.09-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.79,63.07c.16-.06,.05,.08,.21,.07-.16-.03,.06-.08-.01-.13-.11,0-.06,.03-.1,.05l-.02-.06c-.08,0-.12,.06-.17,.04,.02,0,.08-.01,.09,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.39,63.44s.18-.03,.15-.07c.15,.02,.06,.08,.19,.1l-.03-.07,.12-.03c-.09-.01,0-.04,.02-.06-.14-.05-.3,.1-.43,0-.16,0-.07,.09-.02,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.68,64.81s.07,0,.12-.01l-.11-.06s-.11,.04-.01,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M84.28,66.78s.1-.04,.15,0c-.03-.03-.16-.04-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.3,63.48s.03,.01,.08,0c-.03,0-.04-.06-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M84.34,66.96l.1,.04s.04-.06,.1-.05c.02-.06-.28,.02-.21-.1l.13,.05s-.06-.02-.1-.04l.06-.05s-.08,.03-.13,0c-.05,.04,.15,.1,.06,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.14,62.88s.07,0,.09-.02c-.09,.02-.04-.03-.09-.04,0,.03,.04,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "84.95 66.54 84.78 66.49 84.75 66.52 84.95 66.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.12,63.07s.12-.06,.08-.1c-.04,.02-.13,.02-.14,0,.05,.07-.06,.06,.06,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.12,63.12h0l-.1-.04s.06,.02,.09,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "88.27 63.78 88.17 63.79 88.33 63.82 88.27 63.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.41,66.55h.05s-.06-.05,.01-.07l-.11-.02v.05c-.09-.01-.26-.01-.25-.02h-.16c.1,.09,.32,0,.46,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M84.63,66.85s.03,0,.04,0c0,.08-.13-.02-.14,.07,.11,.02,.33-.02,.34,0,.12-.01,.34-.05,.32-.08l-.02-.04h.1s-.05-.01-.04-.03c.04-.05,.18,.04,.07,.07,.03-.08,.19,0,.22-.07l-.11-.03c.06-.03,.13-.06,.1-.11l-.15,.04h.06l.02,.06c-.07,0-.17-.03-.13-.08-.04,.02-.13,.02-.06,.05-.05-.02-.16,.06-.17-.01v.02s-.11,0-.17-.02v.05c-.1,0-.13,.03-.24,.04l.06,.04s-.1,.03-.16,.02l.06,.04h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "88.7 63.53 88.67 63.49 88.64 63.55 88.7 63.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.54,65.38s.02-.06,.04-.1c-.02,.02-.07,.03-.07,0,.08,.02-.1,.09,.04,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.99,63.36s.01-.05-.04-.04c.03,0,.04,.03,.04,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M84.29,67.34s.15-.04,.14-.07h-.17s.05,.06,.03,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M84.58,67.15l.04,.04-.08,.02s.07,.04,.1,.06c.06-.03-.03-.11-.05-.12,.04-.08,.08,.03,.14-.05-.07-.02-.24,.02-.22,.05l.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M84.45,67.36s-.08-.03-.1-.02l.1,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "90.2 62.65 90.11 62.66 90.15 62.67 90.2 62.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M84.87,67.04c-.1,.03,0,.05-.09,.06l.1,.02v-.04c.06,.02,.12-.02,.17-.03-.1,0-.16-.03-.2-.05,0,0,.03,.02,.02,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M84.68,67.31v.03s.04-.03,.03-.04c.14,.01,.28,0,.38-.04,.15,0,.09,.13,.24,.06,.18-.05,.39-.03,.5-.05h0c.06-.05,.17-.01,.24-.02l.03,.05,.15-.07-.08-.02,.05-.04c-.2,.07-.39-.11-.57-.03-.1-.03-.13-.07-.25-.09,0,.08-.13,.02-.16,0l.06-.05s-.06-.05-.11,0v-.07c-.08,.05-.06,.05-.12,.1,.18,0,.34,.08,.49,.12-.02,.03-.1,0-.11,0-.02,.03,.08,0,.03,.05-.07,.02-.08,0-.1-.03v.05c-.1,.02,0-.07-.12-.05l.02,.05c-.07,0-.18,.03-.2,.01h.01c-.07,.02-.28,0-.37,0,.05,.02,.09-.03,.11,0-.17-.01-.05,.11-.23,.08,.02,0,.05,.02,.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.61,63.27l.06-.05s.07,.09,.1,.09l-.04-.05c.05-.01,.11,0,.1,.03l.05-.06,.06,.02-.02-.06c-.1,.05-.21,0-.26-.03,.03,.02,0,.04-.02,.06l-.04-.03s-.05,.05,.01,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "90.07 62.92 89.97 62.95 90.05 62.97 90.07 62.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "86.71 65.71 86.62 65.7 86.65 65.72 86.71 65.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.45,65.14c.1-.05,.21,0,.31-.01-.02,.09-.17,0-.18,.09,.11,.01,.24-.05,.34,.01,.03-.02-.11-.02-.05-.09,.09,.08,.22-.06,.27,.04-.07,0,.04-.03-.03-.06,.11,.01,.13-.06,.24-.05,0,.08,.18,.05,.26,.09,.03-.11,.28,.01,.4-.08-.3,.03-.41-.09-.7-.04l.06-.07c-.11,.05-.16-.14-.31-.02-.1,.05-.27,.06-.33,.04l-.02,.05c-.11-.04-.16,.03-.22,.08l-.04-.04c-.06,.03,.02,.04,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.18,66.16c.06,0,.07,0,.07-.04-.07,0-.08,.01-.07,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.63,66.66s.15,0,.21-.04c.03,.02,.03,.06,.1,.03-.01,.05-.03,.06,.04,.1,.02-.02,0-.03,0-.05,.15,0,.12,.05,.18,.08-.02,.02-.14,.03-.08,.06-.09,.03-.1-.08-.15-.04-.03,.09-.29,.04-.37,.15,.03,.02,0,.05,.02,.07,.06,0,.06-.07,.08-.1,.12,.06,.28-.03,.45-.03v-.08c.06,0,.15,.05,.12,.1-.04,.03-.1,.03-.13,0,.02,0,.02,.09,.1,.08,.02-.02,.04-.03,.08-.04v.04c.1,0,.05-.06,.13-.08l-.05-.03s.07-.02,.09,0v-.04s.12,.03,.13,0c-.05-.13-.23,.06-.31-.03,0-.01-.03-.02,0-.04,.04-.02,.1,0,.09,.03,0-.03,0-.08,.07-.08v.06s.1-.04,.12,0v-.03c.12-.02,.03,.09,.13,.08-.03,0-.04-.03-.04-.04l.16-.02v-.05s.21-.05-.13-.03l-.04-.03-.09,.07c0-.14-.22,.05-.3-.03l.02,.03c-.21-.05-.11-.09-.28-.15,.06-.02,.03-.09,.02-.1,.03,.02,.02,.06-.02,.06-.14-.1-.24,.12-.36,.04-.03,.02-.06,.05,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.49,65.94s.06,0,.08,0l-.03-.06-.05,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.95,64.77h.03s.06-.03-.01-.05c.02,0-.02,.03-.02,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.82,65.79l.06,.06c-.09,.02-.01,.05-.12,.09,.04,0,.07,.02,.09,.03h-.01c.15-.01,.3,.04,.46-.05l-.04,.04c.07,.05,.04-.06,.17-.04,.18,.06-.12,.14-.07,.2,.03-.01,.05,0,.05,.02-.11,0,0,0-.07,.05-.14,.01,.03-.11-.13-.08-.12,0-.03,.24-.22,.11l-.16,.02c-.06,0-.08-.05-.15-.04,.02,.07-.15,.08-.18,.04l.02,.04c-.06-.02-.09,.03-.14-.01,0,.01,.05,.03,0,.06,.03-.01,.06,0,.1,0-.12,.03-.19,.14-.3,.16,.08-.02,.13,.08,.22,.02,.02,0-.05-.03,0-.05l.17,.03c-.06-.04,.11-.05,.02-.06,.02,.03-.06,0-.08,.02v-.07c.08-.04,.15,.05,.23,.07l-.05,.03c.12-.04,.3-.03,.43-.04l-.08-.05s.05-.01,.1-.03l.06,.07c.21-.17,.34,.03,.5-.05,0,0-.02,0-.03,0,.13-.06,.08,.03,.21,0,.07-.03,0-.08-.01-.08,.1-.1,.07,.04,.2-.03,.05,.03,.06,.08,.11,.08l.02-.03c.13-.02,.02,.03,.09,.05,.17-.07,.23-.16,.49-.15l-.03,.06c.03-.07,.09,.03,.14-.03-.03,.02,0,.06,.04,.05-.1-.03,.07-.04,.03-.08,0-.05-.1,.01-.13,0l.09-.04c-.1-.02-.1,.01-.23,0,.08-.11,.13-.06,.25-.16l-.09-.04,.06-.05c-.06,.03-.14-.03-.08-.07,.06,.04,.1,.03,.19,0l-.02-.07s-.02,.02,0,.02c-.07,.03-.08-.02-.11-.04,.08-.04,.17,0,.21,.04-.03-.02-.08-.07-.02-.08,.05-.01,.17-.01,.16,.04-.12,.01-.06,.05-.11,.09,.11-.01,.12,.04,.19,.07l-.07,.1s.04-.08,.16-.06c.02,0-.02,.06,.04,.1v-.04c.09,0,.16-.06,.2-.07,.08,.07,.22-.05,.24,0,.12-.06,.13,0,.3-.09,0-.02-.03-.07,.06-.07,.02,.07,.16-.09,.2,.02-.02-.07,.16-.04,.19-.11,.08-.02,.11,.06,.18,0h-.02c.16,.03,.35-.05,.48-.02-.02,0-.05-.03-.05-.06l.11-.02-.05,.05s.1-.03,.15-.04c-.03,0-.06-.04-.07-.05,.01-.04,.07-.03,.11-.02-.01,0-.15-.02-.17,0v.04s-.14,.02-.14-.03l.04,.04c-.11,.07-.18-.03-.2-.06,.1,.06,.19-.13,.25-.01,.06,0,.08-.06,.05-.07-.01,0-.03-.04-.04,0,.03,0,.04,.03,.04,.04-.13,.05-.05-.09-.19-.03,0,.07-.15,.02-.19,.07,.07-.03,.07,.04,.11,.07-.12-.04-.04,.08-.15,.07-.08,0-.1-.08-.05-.09-.09,.03-.16,0-.19-.04,.07,.03,.19-.04,.15-.07-.03,.01-.06,.02-.04,.04-.06-.06-.28,.01-.29-.05l.02,.03c-.16,0-.14,.08-.31,.06,.03,.02,0,.07-.08,.06v-.02c-.1-.08-.19,.08-.26,.03-.04,0,.09,.01,0,.05-.01,0-.11-.02-.13,.02-.12,0-.22-.03-.32-.09,.08,.02,.18-.03,.17,.05,.06-.03,.08-.08,.14-.08,.04-.06-.06-.1-.1-.13,.05,0,.14,.05,.16,0l-.15-.02c.2-.12,.24-.06,.47-.11-.18,.04-.05-.07-.19-.06,.04,0,.02,.04,.03,.07-.08-.09-.18-.03-.31-.09,.03,0,.2,.05,.08,.1-.13,.06-.31,.04-.43,.03v.07h-.09c.11-.09-.13-.07-.17-.14,0,0,.09,.05,.1,.1-.1,0-.07,0-.16,.02v.04c-.05-.02-.19-.01-.26,.02l-.05-.04c.02,.1-.17-.02-.19,.07h0c-.07-.04-.09,.07-.02,.06,.06-.02,.03-.06,.09-.04-.01,0-.03,0-.04,0,.01-.05,.12-.01,.16-.05,.04,.05,.15,.08,.17,.13-.08,.01-.17,0-.23-.01-.06,0,.05,.02,.03,.05-.03,.01-.06-.01-.08-.02,.01,.02,.06,.04,.05,.07-.19,.03-.23-.07-.37-.08,.08,.02-.05,.04-.05,.07,.05-.01,.12,0,.09,.04-.04,.02-.09,.02-.13,0,.02,0,.02,0,.03,.02-.09-.03-.05,0-.14-.01l-.1,.1v-.05h-.13s.02-.07-.09-.05l.02,.06h-.08v-.04c-.06,0-.07,.01-.07,.05-.09-.03-.21-.09-.34-.04,.03,0,.01,.02,.03,.03h-.18l.04-.02-.09,.05-.02-.04s0,.03,0,.06c-.04,.02-.13,0-.11-.04h.02s-.03-.04-.05-.05c-.02,.02-.16,.02-.07,.05l.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.69,65.92l.05-.03h-.1s.03,0,.05,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.69,66.76c-.08-.08,.01,.02-.09-.01h.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.82,62.55l.06-.07c-.09-.03-.03,.04-.11,.02,0,.02,.04,.03,.05,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.98,66.46c.09-.03,.16,.04,.17,.09-.04-.05-.02-.13-.14-.13l-.03,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.54,66.12s.05-.03-.01-.06l.18-.03-.06-.05c.02,.06-.3,.06-.1,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.7,62.69s.04-.04-.03-.05l.03,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.88,63.34l.06,.02c.07-.02,.02-.07-.03-.06,.03,.02-.02,.02-.03,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.04,63.33s.09-.06,0-.09c.08,.05-.16,.05,0,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.05,64.16c.1,.02,.01-.04,.07-.05l-.08-.02c.09,.01,.05,.04,.01,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89,64.37s-.1-.03-.08-.09c-.05,.07,.09,.08,.08,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.15,62.63l.22-.02s-.16,.03-.18-.03c.01,.02-.03,.04-.05,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.42,63.21s.15,0,.18,0c-.01-.06-.12,0-.09-.04,0,.04-.08,.01-.09,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.14,62.91l.03,.04-.15,.02c.09,.07,.25-.11,.22,.02,.08,0,.22-.01,.24-.06-.11,.03-.04-.05-.12-.06-.01-.02,.03,.02-.02,.03-.2,.02,0-.13-.18-.12-.02,.09-.18-.01-.2,.02-.01,.07,.04,.18,.18,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.13,64.35c.08-.05,.06,.05,.12-.03l-.07-.02h.01l-.11,.02,.04,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.94,67.4v-.04c-.07-.02-.35,.01-.48,.09h.01l.15-.03,.14,.04,.11-.08h.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.54,64.07s.06-.03,.1,0c0,0-.05-.07-.11-.08l.03,.07h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.97,67.1c.08-.04,0-.05,0-.08h.06c-.1-.03-.08,0-.18,.02h.12v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.59,65.68l.05,.06s-.02-.03-.02-.04c.03-.01,.06,.01,.08,.02-.03-.03,0-.03,.03-.06l-.12-.03s.03,.05-.02,.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "90.68 63.27 90.7 63.15 90.64 63.22 90.68 63.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.3,66.02s.06,0,.06,.02l.08-.06c-.06,.05-.09,0-.15,0,.07,.03-.06,.02,.02,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.72,62.49s.09,.01,.14-.01c.03,0-.09,0-.05-.05,.03-.01,.04,0,.07,.02-.04-.07-.16,.03-.14-.05l-.02,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.49,62.6c.07-.03,.16,.06,.2-.02-.07,0-.15-.06-.2,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "88.91 64.8 88.81 64.78 88.79 64.81 88.91 64.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.86,65.64c.07-.02,.04,.03,.03,.06,.06,0,.04-.08,.09-.03,0-.06-.11,0-.12-.05v.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.36,63.77s.18-.08,.05-.11c-.04,0,.09,.03,.01,.06l-.1-.02,.04,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.44,62.86s.15,0,.16-.04l-.1-.03,.05,.03-.1,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "92 62.5 91.92 62.48 91.92 62.49 92 62.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.02,65.69s.08-.05,.11-.07c-.03,.04-.14,.01-.11,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.87,66.61s-.03,.07,.05,.13c.03-.02,.05-.08,.11-.06-.09,.04,.03,.05,.01,.08,.15-.08-.04-.1-.05-.16,.04,.03-.03,.02-.08,.04v-.05l-.05,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.38,67.16l.08-.04v.04l.05-.05s-.06,0-.09-.01h0c-.06,.06-.1,0-.15,0-.06,.07,.08,.05,.11,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.71,63.52c.09,.04,.09-.06,.13-.08-.09,.03-.01,.05-.13,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.81,62.87s-.02-.07-.08-.07c0,.04,0,.06,.08,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.3,64.83s-.02,0-.03,.01h.08v-.04h-.06l.02,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.78,62.96l.1-.03c-.08-.02-.22,.02-.23-.06-.05,.05,.11,.08,.12,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.33,65.62h.04l-.02-.04s0,.02-.01,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "92.29 62.43 92.2 62.45 92.24 62.47 92.29 62.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "89.43 64.8 89.36 64.76 89.4 64.79 89.43 64.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "89.14 65.06 89.02 65.04 89.09 65.07 89.14 65.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "86.98 66.82 86.93 66.82 86.91 66.85 86.98 66.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.94,62.91s-.07-.03,.01-.07l.05,.02c.05-.05-.09-.01-.08-.06-.08,.04,.01,.06,.03,.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "91.05 63.57 90.96 63.57 91.04 63.58 91.05 63.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.52,65.57s.11-.04,.15,0c.06-.02-.18-.04-.15,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "92.14 62.84 92.13 62.76 92.06 62.83 92.14 62.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92.59,62.41c.12,0,.22,.03,.32-.02-.11,.01-.25,0-.32,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.44,63.35s.07,0,.09,.01c-.03,0-.11,.09-.12,.14h.22s-.04-.03-.02-.06l.11,.06c.11-.01,.12-.14,.2-.1h-.01c.1-.04,.12-.03,.21-.02-.04-.1-.23-.06-.24-.16-.09-.04-.11,.03-.13,.02,.16-.03,.01,.09,.18,.04-.19,.04,0,.07-.22,.09l.04-.03c-.05,.01-.1,0-.08,.04,.01,0,.06,.02,.02,.04-.06-.05-.13-.03-.2-.1,.01,.02,0,.03-.04,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.95,63.08s.03-.02,.03-.04c-.02,0-.05,.01-.07,.02l.05,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.5,65.25s-.07,.04-.12,.04c.06,.04,.09,.07,.19,.04-.05-.04-.12-.1-.01-.13h.07c-.07-.03-.25-.03-.19-.09h.01l-.15,.1c.05,.06,.09,.01,.19,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.94,67.27c-.07,.02-.01-.08-.09-.03,.03,.02,.03,.05,.09,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.74,68.51c.14-.05-.03-.13,.17-.13l-.08-.08c.08,.08-.08,.02-.09,.08h.02s0,.05-.02,.05c-.03-.01-.08-.03-.06-.07l-.04,.07,.12,.04-.03,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92.99,62.42c.01-.07,.05-.08,.07-.1h-.11l.04,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92,63.12c.07,0,.1-.06,.14-.01l-.05-.07s-.05,.04-.08,.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "90.56 64.33 90.61 64.33 90.58 64.3 90.59 64.33 90.56 64.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.46,67.87s.04-.04,.08-.04c.01,0,.03,.02,.06,.04,.03,0,.04-.03,.07-.04,.01-.07-.1-.03-.16-.04-.05,.03-.13,0-.16,.06l.11,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "90.25 64.64 90.24 64.65 90.32 64.68 90.33 64.67 90.25 64.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "89.97 64.88 89.96 64.89 90.04 64.92 90.05 64.91 89.97 64.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.55,64.66c.06-.03-.05-.03-.07-.04-.02,.02,0,.03-.04,.04l-.09-.04c.09,.01,.05,.07,.2,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.28,64.77l.12,.02s-.06-.06-.02-.07h-.12s.04,.04,.02,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.64,63.7c.07,.05,.11-.05,.2-.05-.03-.02-.11,.03-.12-.02l.04-.03c-.19,0,.1,.12-.11,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.29,67.35l.06-.05s-.06,0-.09,.03h.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "91.52 63.96 91.4 63.94 91.46 64 91.52 63.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92.03,63.59s-.07,0-.05-.04c.03,.01,.14-.01,.12,.05,.06-.05,.18-.08,.23-.03,.02-.06,.02-.14-.09-.13,.03,0,.03,.02,.04,.04-.06,0-.1,0-.07-.03-.08,.02-.22,.08-.28,.12l.1,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.88,67.79h-.05l.08,.05c-.08-.02,.05-.1-.06-.08,.03,0,.03,.02,.03,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M84.63,69.65s.04-.03,.07,0l-.06,.05c.08-.01,.12-.03,.13-.06l.05,.03-.02-.07c.08-.04,.13,.03,.23,0-.04-.03-.15,0-.21-.03-.04,.1-.09,0-.18,.03v.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "90.29 65.04 90.21 65 90.21 65.05 90.29 65.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.28,69.36s-.21,.04-.27-.02l.02,.04h-.07s-.08,.07-.09,.04l.09,.03s-.01-.02,0-.02c.05,.09,.18-.08,.29,0v-.06c.07,0,.08,.05,.1,.08,0,.03-.02-.03,.03-.04l.05,.02c.12,.03,.08-.11,.18-.12,0,.01,.02,.03,.06,.04,0-.04,.03-.07,.1-.05-.02,.03,0,.03,0,.07-.02-.06,.14-.06,.13-.11l-.09-.03s-.02,.03-.04,.05c-.09-.06-.11,.05-.23,.03l-.26,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.83,63.79c.05-.01,0-.05-.05-.06l.05,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.97,66.88h.11c-.05,0,.02-.08-.07-.04-.02,.02-.05,.03-.04,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "91.81 63.83 91.77 63.81 91.76 63.87 91.68 63.84 91.74 63.91 91.81 63.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "90.03 65.19 90.13 65.23 90.09 65.14 90.12 65.17 90.03 65.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.04,66.06h-.01l.07-.02h-.01s.13-.04,.14-.05l-.07-.04c.04,.09-.23,.06-.12,.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "92.81 63.07 92.72 63.04 92.71 63.05 92.81 63.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "89.85 65.48 89.75 65.5 89.77 65.52 89.85 65.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.77,68.84l-.02,.02c.17-.01,.32,0,.48-.07l-.16-.08,.04,.04-.21,.02s.04,0,.06,.01l-.07,.05c-.07-.04-.03-.01-.13-.02,.02,0,.01,.02,.02,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.94,65.46s.05,0,.08-.02l-.11-.02s-.01,.04,.03,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.5,65.12s.09,.03,.15,.04l-.02-.07s0,.05-.08,.02c-.04-.03-.07-.1-.16-.07,.04,.04,.15,0,.12,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.02,67.1l.04-.06h-.1c.07,0-.03,.06,.05,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.23,62.88s-.07-.04-.11-.04c0,.05,.05,.02,.11,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.5,67.6h-.01l.05-.03c.06-.08-.14,.06-.13-.05l-.08,.05s.15,0,.17,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "90.64 64.95 90.59 64.94 90.58 64.97 90.64 64.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.71,64.28v.03c.07-.05-.23,0-.15-.1l-.06,.02c.06,.01,.11,.08,.21,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.3,62.87l.03-.06s-.13,.04-.03,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92.48,63.51c.03,.06,.14,0,.18,0v-.05h.17s.02-.04,.06-.04l-.08-.03v.03s-.08-.02-.12-.02c-.02,.1-.13,.05-.18,.13l-.02-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.4,62.87c.06-.03,.09,.03,.12-.02-.01,0-.01-.02,0-.03,.11-.03,0,.05,.12,.05l.2-.03c-.12,0-.29-.02-.42-.06v.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.08,66.62l-.02-.08c.07-.02,.11-.02,.17-.06,.03-.07-.16,.02-.19-.06v.04l-.11-.02c.07,.04,.12,.13,.15,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M84.48,70.21h.03c-.06,0,.04-.06-.03-.05-.02,.02-.03,.04,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.07,64.8h-.05l.13,.05-.04-.04c.21-.07,.18,.16,.38,.04l.1,.08c.1-.09,.26,0,.3-.09,.06,0,.07,.05,.14,.07,.1-.04,0-.08,.05-.13-.01,0-.11-.02-.07-.07-.06-.04-.16,.05-.17-.02-.01,.05-.13,.04-.18,.06-.04-.09-.23,.06-.25-.04,.01,.02,.04,.05,0,.07-.05-.02-.1-.1-.19-.09,.09,.03-.02,.05-.07,.05v-.05c-.07,0-.17,.05-.08,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.38,65.45c-.09,.03-.05-.03-.12-.03l.09,.06,.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.4,69.56s-.01-.02,0-.03c.06,0,.09,.04,.08,.07h0c.14-.03-.09,.07,.06,.07l.06-.03,.12,.06-.13,.02,.12,.04s-.03-.02-.03-.03c.12-.03,.3-.02,.39-.08l-.16,.03s.03-.04,.04-.04c-.03-.01-.15-.02-.23-.04v-.04l-.11,.02s-.03-.05-.06-.08c.06-.02,.07,.04,.14,.04v-.08c-.13,.06-.34,0-.37,.11h.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.6,65.3l-.02-.04,.09,.04s.1-.04,0-.07c-.03,.04-.09,.04-.11,.02,0,.01,0,.04,.04,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.29,68.82c.08,.07,.02-.02,.1,0-.06,.03-.05-.06-.1,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "85.36 69.66 85.28 69.67 85.3 69.7 85.36 69.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M84.94,70.23c.05-.01-.02-.04-.05-.04l-.28,.07c.11,.04,.21-.08,.33-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.8,65.27c.03-.08,.19,0,.21-.09l.09,.04c.08-.02,.09-.1,.22-.09l-.12-.04h.02l-.08,.05c-.08,.01,.05-.05-.06-.04-.01,.05,.09,.04,.07,.09-.17,.04-.11-.08-.24-.04,.07,0,.03,.06,0,.08,.04-.08-.08,.01-.13-.03-.09,.03,.05,.04,.04,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.28,63.22s-.02,.04,0,.06h-.1c.1,.07,.23-.04,.32,0,.18-.04-.06-.08-.03-.14l.08-.04-.06-.04c-.1,.03,0,.06-.04,.09-.02,.07-.19,.04-.24,.1l.07-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "84.95 70.12 84.91 70.06 84.9 70.1 84.95 70.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.53,65.44s.11,.01,.07,.05l-.03-.06s.08-.01,.11,0c0-.01,.02-.03,0-.05-.04-.03-.17,.02-.15,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.01,69.24s-.01,.04-.02,0h.09c-.11,0,.07-.06-.07-.06,0,.03-.03,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.46,69.83l.09-.08c-.09,0-.07-.04-.15-.05,.07,.03,.05,.09,.05,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.23,63.43v-.02c.14,0,.34-.06,.42,.01,.01,.02-.07-.04,0-.06,.07,.02,.16,0,.18,.05-.05-.07-.18-.11-.27-.11,0,.02-.21,.05-.32,.03,.06,.01-.2,.09-.02,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.19,69.22h.14s-.01,0-.03-.01c.15-.02,.31,.06,.43-.03h-.01l.11-.09,.13,.05v-.07s-.06,.02-.07-.02c.02,0,.05,0,.06,0h-.1c-.06,0,.05,.01,.03,.04l-.12-.03s-.02,.09-.09,.06c-.08-.03-.16-.03-.17-.09-.05,.03-.12,.1-.21,.08-.13-.05-.26,.1-.12,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.9,62.84c.06,.02,.18-.02,.26,.02l-.05,.04s.03-.01,.05-.01l-.02,.04c-.09-.01-.22,.05-.27,.03,.07,.05,.26-.04,.28-.01v-.06s.03,0,.05,0c-.11-.04,.04-.08-.08-.11h-.19s-.01,.04-.03,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.73,65.43h0l.26-.03s-.02-.03-.03-.04c.04,0,.07,0,.1,0l-.06-.02h-.12l.03,.03s-.07,0-.09-.01c.03,.04-.15,.03-.08,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.12,70.06c-.02,.06,.05-.07,.13,0-.01-.08,.18,0,.05-.06h-.07s.01,.02,0,.03c-.04,0-.12,0-.11,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.19,66.74l.25-.06c-.15,0-.03-.06-.14-.08-.04,.06-.08,.08-.1,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.84,67.82s.03-.01,.06-.02c-.01,.05-.1,.12,.05,.12,.05-.05,.12,.03,.16,0-.05-.08-.21-.1-.25-.14l-.03,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.11,70.16l.13,.02-.13-.05s0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.81,68.82s-.06,0-.07,.02c0,.04,.07,.03,.11,.04,.07-.04-.05-.04-.05-.08,.03-.01,.06,.01,.07,.02,.04-.05-.04-.04-.08-.05l.02,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.29,69.43l-.03-.03c.16,.04,.27-.05,.35-.09-.07-.03-.24-.04-.32,0l-.03-.05v.03s-.02-.02-.03-.02c.04,.03-.04,.06-.02,.11l-.08-.03,.05,.03-.09,.06-.04-.04c.03,.09,.17-.01,.24,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "93.65 63.23 93.67 63.2 93.6 63.2 93.66 63.21 93.65 63.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.11,65.37s.03-.04,.02-.05c.05-.01,.09,.05,.13,0-.03,.06-.11-.06-.18-.05l.03,.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "89.62 66.59 89.47 66.59 89.51 66.62 89.62 66.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "87.87 67.99 87.81 67.96 87.82 68.03 87.87 67.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.93,65.51c.06-.03-.05-.02-.05-.04,.03,0,0,.04,.05,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M84.57,70.73l-.02,.02c.07-.02,.19,0,.17-.06-.02,0-.06-.01-.05-.03-.03,.02-.14,.03-.11,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.71,66.57s.2,.08,.31,.07l-.05-.03,.16-.09c-.04,.06-.18,0-.19,.05-.04-.05-.15-.06-.23-.1-.12,0,.06,.05,0,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.16,66.32c.03-.06-.05-.06-.11-.07-.04,.06,.05,.02,.11,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92.92,63.98s.14,0,.23,0c.02-.09,.13,0,.14-.08-.03,.07-.15-.02-.26,0-.01,.07-.11-.01-.15,.05l.05,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.88,68.25s-.1-.02-.04-.05c-.07,0-.16,.07-.18,.03,.04,.1,.12,.01,.22,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M84.78,70.69c.19,.06,.25-.06,.4-.02,.03-.01,0-.02,0-.03,.17-.07,.33,.03,.45-.05,.02-.03-.03-.07,.06-.07-.09-.01-.09-.04-.19,0,.04,0,.05,.02,0,.04-.02-.08-.18,.05-.27,0,.01,0,0,.01,.01,.02-.05,.01-.07-.02-.1-.02,.03,0,.03,.02,.04,.04l-.12,.03s.07,0,.07,.03c-.09-.03-.24-.02-.3,.02l-.06-.05c.09,0,0,.04-.01,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.24,66.28c.11-.03,.2-.03,.3-.02-.01,.04-.15,0-.15,.05,.04,0,.11,0,.17-.02-.09,.09,.14,0,.15,.06,0,.02-.02-.03-.06-.04,0,0,.21-.11,.18,0,.03,.01,.08,.02,.06,.05h-.05l.09-.02c-.07,0,0-.08-.1-.09l.13-.02v.08c.08-.03,0-.05,.07-.07,0,.03,.09,.04,.13,.07-.05-.04,.02-.05,.02-.09,.13-.02,0,.05,.1,.06l-.02-.06c.1-.03,.04,.04,.09,.07-.11,.07-.19,.01-.31,.01,.04,.03-.03,.02,.04,.05h0c.2,.04,.42-.15,.6-.04l-.06,.03h.12c.05-.02-.03-.01-.06-.02,.04-.03,.15-.05,.21-.02v.07c.07,0,.15-.05,.19,0h-.02c.15,.04,.23-.09,.36,.01-.02,.02,.02,.06-.03,.08,.09-.03,.04-.06,.15-.04-.07-.02,.02-.06,.06-.08l.14,.05s-.12-.03-.09-.08c.09,.03,.23-.03,.29,.05,0,.03-.06,.03-.05,.07,.05,.04,.06,.02,.12,.02-.06,.1-.21-.02-.22,.09-.14-.05-.2,0-.34,0l-.06,.09s-.1,0-.13,0c.13,0-.02,.09,.06,.08,.06-.05,.1-.01,.19-.03-.03,.11-.17-.04-.2,.08,.07,0,.23-.03,.22-.06,.03,.06,.23,0,.2,.1,.05-.04-.04-.04-.04-.08l.08-.02s-.08-.05-.03-.06c.07,.05,.05-.03,.14-.01l-.07-.09c.08,.02,.18,0,.21,.05-.02-.04,.07-.09,.11-.06l-.03,.02c.12,0,.28,.01,.33,.07-.04,0-.09,.04-.13,0,.02,0,.02,.03,.02,.04-.03-.07-.27,.02-.23-.09,.02,.06-.07,.1-.03,.15-.04-.08-.13,.05-.17-.02l.03,.11c.02-.09,.08,.05,.17-.01-.04-.03,0,0,.01-.05,.08,.05,.07-.07,.2-.03l-.09,.04c.09-.02,.02,.05,.15,.02l-.02-.04c.07-.02,.17,0,.19-.04,.08,.03,.25-.05,.25,.05-.03,.01-.06-.01-.09-.03l.14,.06s0-.05,.05-.05c.04-.03,.08,.02,.1,.02l-.02,.02c.1,.02,.17-.09,.25-.06l.11,.02-.02-.08,.15,.06s.06-.02,.01-.05h-.1l.03-.08c.11,.04,.07,0,.13-.02-.04-.07-.24-.12-.38-.12v-.05c-.03,.06-.1-.01-.05,.07-.17,.08-.36-.01-.52,.09-.04-.05-.06-.15-.14-.14,.09-.02,.08-.04,.11-.06-.11-.01-.16-.01-.11-.08,.08,.03,.19-.05,.19-.08l-.08-.06h.09s-.02-.02-.02-.03c.04-.04,.11,0,.13,.03,.01-.04,.02,0,.01-.05,.07,.04,.28-.01,.37,.02-.01,0-.03-.01-.04-.03h.11c-.08-.09-.29-.03-.36-.08,.02,.03,0,.04,.02,.07-.12,.03-.31-.02-.46,.02l-.02-.04s-.08,.04-.14,.06l.02-.06c-.12,0-.09-.04-.16-.04,.02,0,.02,0,.01,.02-.05,.03-.18,0-.15,.03-.05,0-.1-.03-.15-.05,.08-.04,.02-.07-.04-.09,0,.02,.04,0,.03,.05-.04,0-.06-.01-.08-.02,0,.05-.1,.03-.04,.08l-.1-.02,.04-.04c-.06,0-.2-.11-.26-.02-.03-.02-.06-.08-.06-.06,.03,.04-.04,.03,0,.08-.13,0-.17-.11-.34-.08l.1-.05s-.06-.02-.03-.05c.09,.05,.11-.06,.16,0-.05-.04-.17-.05-.2,0v.08h-.06v-.07l-.02,.02-.09-.08c-.06,.07-.13,.12-.21,.11,.04-.03-.05-.06,.03-.07l.05,.02-.19-.06,.08,.08s-.2-.03-.26-.04c-.03,.14-.22-.05-.24,.1-.17-.01-.36,.01-.48,.03l-.06,.05h.08s0,.04-.02,.05l-.13-.02s.04,.03,.04,.04h-.11s.07,.06,0,.09c0,0-.03,0-.04,0l.04,.03c-.07-.02-.13,.08-.13,.02-.03,.02,.05,.02,.03,.05-.03,.06-.08-.02-.13,.02,.08-.01,.07,.04,.12,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "94.35 62.86 94.29 62.84 94.24 62.88 94.35 62.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.07,68.88c.12-.04-.04,.06,.09,.01v-.08l-.05,.03-.04-.04c-.07,.02-.12,.09,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.23,65.38s.06,0,.11,0c-.03,0-.08-.02-.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.66,63.51s.03-.06-.04-.05c.02,0,0,.05,.04,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.52,63.62h.08c-.06,.04,.08,.06,.14,.06l-.12-.06s.04-.09,0-.08l-.09,.06-.06-.02s.03,.04,.03,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.33,65.48s.03-.08-.06-.06l.06,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.67,67.58c.05,.04,.14,.07,.2,.02,.1,0,.03-.06,.09-.08-.02,0-.03-.02-.04,0h.01c-.02,.05-.11,0-.16,.02l-.03-.05s-.02,.09-.07,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.92,68.27c.06,.02,.14,0,.18,.03,.06-.03,.14-.06,.21-.05-.11-.04-.12-.02-.22,0l-.02-.06c-.01,.05-.1,.01-.15,.02l.09,.03-.09,.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "88.23 68.1 88.16 68.1 88.16 68.11 88.23 68.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87,69.07s.08,0,.08-.01h-.01c.06,0,.04-.05,.09-.05-.11-.02-.09,.06-.16,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.69,68.65s-.16-.04-.17,.01h.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92.87,64.36c.06-.02,.1,0,.12-.04,.03-.06-.06-.02-.09-.04-.06,.02,.05,.09-.03,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87,69.36v-.05c.07,.02,.17-.03,.19-.07-.03,.02-.08,.04-.15,.05l-.02-.04h.05l-.06-.03c-.01,.07-.12,.01-.11,.06h-.09s.13,0,.18,.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "94.1 63.39 94.05 63.37 93.99 63.41 94.1 63.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.65,65.47c-.05,0-.1,0-.15,0l.02,.03h-.09c.04,.05,.04,0,.14,.01-.01,.04-.09,.08-.05,.13,.05-.05,.23-.02,.36-.09h-.04c0-.05,.09-.04,.12-.02,0,.02-.03,.07,.02,.07-.04-.04,.02-.12,.1-.08l-.04,.03c.08,.03,.18-.09,.22,0l-.03,.02s.12,0,.14-.02c-.09,.06-.08-.03-.11-.05,.05-.04,.16,0,.13,.02v-.05c.06,.07,.05-.03,.13-.02-.05-.03-.03-.06-.01-.06h-.12l.08,.04c-.06,.05-.24-.02-.22,.05l-.09-.05c-.11,.02-.41-.03-.62,0l.12-.03v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92.83,64.44l.08-.05-.1,.03s.01,.02,.03,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "89.15 67.57 89.01 67.54 88.99 67.59 89.15 67.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92,65.27c.14-.01,.07-.1,.07-.14l-.14,.02c.12,.03-.05,.1,.06,.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "93.17 64.32 93.07 64.24 93.04 64.28 93.17 64.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.16,67.54l.06-.05s.05,.03,.07,.05c.03-.02-.04-.03-.03-.05,.08-.04,.18,.04,.24,0-.12,0-.13-.14-.25-.05,.02,0,.02,0,.02,.02-.08,.02-.05-.03-.11-.04,.05,.03-.06,.09,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.11,63.42c.05-.01,.19,.02,.15-.03-.05,.05-.22,.02-.14,.07v-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92.17,64.99c.09,0,.16,.07,.28,.06,.02-.02,0-.03,0-.05,.05-.01,.07,.02,.1,.02l-.05,.03s.15-.02,.19,.03c0-.02,0-.06,.06-.07,.04,0,.07,.02,.09,.03-.06,.02-.01,.04-.07,.04l.05,.05v-.03c.15,0,.07,.08,.11,.12,.02,0,.02-.02,.02-.03,.03,.01,.08,.02,.13,.04h-.01c.02-.05,.16,.02,.27,0-.08-.07,.12-.05,.13-.06-.02,.09-.21,.1-.22,.19,.13-.02,.22,.02,.32,.07,.05-.12,.33-.01,.38-.18-.04,0,.07-.11-.07-.13-.06,.03-.02,.1,.01,.15l-.14-.06,.04,.04c-.11,0-.02-.03-.14-.01-.04-.05,.09-.04,.08-.09-.06-.01-.09,.06-.15,.02l.03-.02c-.05-.04-.11,.03-.15-.02,.08-.05,.24-.06,.36-.06v-.04s-.03,.02-.04,.01c.02-.05-.01-.08,.09-.12h-.03s-.03-.06,.02-.08c.18,0-.02,.09,.16,.08,.06-.06-.03,0-.06-.04,0-.08,.18,0,.14-.09,0,.03,.17,.07,.06,.11,.05,.06,.16-.05,.22-.04-.02,0-.05,0-.07,0,.02-.06,.16-.06,.2-.02-.03-.04,.01-.07,.03-.09,.12,0,.13,0,.28,0-.02-.03,.04-.04,.03-.07,.06,0,.06,.05,0,.06,.16-.06,.08,.07,.2,.04-.04,.02,.01,.08-.07,.09-.02,.03,.06,.02,.06,.05h-.08c.05,.06,.17-.01,.29,0,.03,.06,.16,.15,.24,.1v.05c.09-.05,.3-.05,.35-.08,.12-.03,.03,.06,.09,.09v-.03l.1,.04h.1s-.05-.03-.04-.05c.05-.03,.11,.04,.18,.05,.07-.05-.11,0-.08-.05,.07,0,.17-.05,.26,0l-.07,.04c.05-.07,.14,.05,.22-.04-.02-.08-.09,.03-.13,0l-.02-.04c.12-.03,.19-.04,.31,0-.06,.03-.1,.06-.13,.06,.03,.04,.21-.03,.15,.05,.23,.05,.25-.16,.48-.09,.04,.03-.02-.04-.07-.04,.02,0,.01,0,.01,.02-.03-.07-.29,.07-.17-.05l.03-.02c-.06-.04-.05,.03-.1,.03-.1-.02,.02-.09,.02-.11-.1,0,.01,.08-.09,.09v-.09c.08-.02,.15-.05,.22-.02l.03,.07s.1,0,.14,.01c-.04,0-.08,0-.07-.03,.15,.02,.09-.07,.24-.05,.06-.05-.09-.05,.04-.08,.04,.07,.15,.08,.25,.1,0-.01-.08,.01-.08-.03,.14,.01,.03-.07,.18-.04-.04,0-.09-.04-.14-.01v.03h-.08l.05-.09c-.11-.07-.36,.03-.53-.02l.06-.03h-.11s.02,.02,.02,.03c-.17-.02-.28,.09-.42,.11l.09,.07h-.16v-.06c-.06,.1-.13,.02-.18,.13,.03-.01,.03,0,.06,.01l-.07,.05c.04-.06-.12,0-.13-.07-.2,0-.5-.08-.75-.03-.17,.07-.22-.09-.37-.08,.01,0,.05,.02,.02,.04-.1,0-.04-.07-.08-.09,.09-.04,.23-.07,.31-.05,.08-.02-.02-.08,.08-.11,.01,0,.06,.06,.02,.07,.02,.04,0,0-.01-.02,.07,.09,.37-.1,.26,.08,.14-.08,.14,.01,.31-.03l.03,.04,.07-.05s0,.04,.04,.05c.07-.04,.08-.12,.1-.1-.04-.03-.06-.05-.08-.08,.09,.04,.22,.04,.28,0h-.18s0-.03,0-.05c.15-.02,.21-.04,.34,.01l-.03,.07s.11-.05,.13,0l-.08,.04h.09s-.04-.11-.12-.13q.08-.02,.12-.08c-.07,.02,0-.08-.09-.05,.02,.04-.18,.03-.25,.03h.01s-.1,.06-.14,.05l-.04-.04,.12-.02c-.08,0-.21-.04-.23,0-.01,.05-.05,.05-.11,.06,.07-.04,.03-.06,.05-.08-.06,.03-.16,.06-.23,.03,.12-.02-.05-.06,.03-.07-.08,.09-.3,.04-.44,.08h.01l-.21,.08h.05c-.03,.11-.18,.1-.26,.17,.03-.02-.01-.02-.02-.03,.02,.02-.02,.05-.05,.03-.04-.07,.09-.03,.08-.06h-.11v.05c-.1,0-.18,.08-.25,0h.05l-.07-.04s0,.04,.04,.07c-.07,0-.16-.03-.19,.01l-.05-.04c-.06,.06-.11-.04-.18,.02-.02,0,.03,.01,0,.04-.18,.06-.2-.03-.36,0-.27,.04-.44,.1-.72,.12,.04-.04-.09,0-.08-.06v.03h-.03s-.06,.04-.12,.07c-.1,0-.02-.04-.09-.05h.06l-.12-.06s.09,.12-.05,.12c-.13,.04-.26-.03-.37-.01,.06,.06-.14,.02-.07,.09l-.1-.03s0,.05-.06,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.28,64.23s-.1-.04-.15,0h.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.7,63.82s.08,0,.12,0c-.08,.04-.11-.08-.12,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "94.4 63.34 94.3 63.33 94.37 63.36 94.4 63.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.84,67.05l.12,.03c-.06-.05,.02-.05,.08-.06-.05-.09-.15,.03-.23-.01,.06,0,.04,.05,.03,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.89,67.83s0,.01,.03,.02c.04,0,.03-.02,.02-.05l-.15,.04h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.13,64.38v-.03s-.08,.01-.06,.04h.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "93.72 63.87 93.69 63.91 93.66 63.91 93.77 63.89 93.72 63.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.41,68.27l.06-.02h-.01c.12-.09,.08,.1,.22,.02-.07,.05,0,.07,0,.12,.03-.02,.06-.05,.03-.07-.02,0-.05,.01-.05,0,0-.08,.14-.03,.18-.06-.06,.05-.18-.03-.22-.06,0-.05,.08-.05,.03-.09,0,.03-.13,.05-.09,.08-.03,.01-.06-.01-.08-.02h.01c-.13,.02-.04,.07-.08,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.18,66.9s0-.07-.08-.06l-.05,.05h.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.72,69.74s-.11,.04-.18,.05c.06-.02,.21,0,.18-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.94,63.78c-.07,0-.02,.02-.06,.03,.1,.06,.2,.06,.34,.05l-.03-.05s.08,0,.12,0c-.08-.03-.23-.1-.39-.08l.02,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.58,69.26l.02-.02h-.11s0-.06,.04-.07c-.1-.06-.14,.03-.26,.02,.05,.07,.2,.06,.31,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92.28,65.14s.08,0,.11,0l-.09-.05s.05,.04-.01,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.45,63.36s.13-.05,.13,.02c-.03,.02-.07-.02-.07,.04,.13-.05,.15,.09,.26,.03-.08-.03,0-.15-.16-.14-.03-.04-.09,.04-.16,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.76,70.53c.17-.01,.18-.08,.34-.04-.04-.06-.22,0-.3-.02l.06,.02-.09,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.52,70.79h-.11s.07,.03,.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.66,67.47l.02-.03h-.06s0-.02,0-.04h-.11s.08,.09,.15,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92.72,64.84h-.02c.12,0-.03-.05,.04-.06-.02,.02-.03,.04-.02,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.68,66.52s-.02,0-.04,.02c.14,.03,.15-.05,.28-.06-.04,0-.25-.04-.24,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.44,68.37c.06,.01,.08,.07,.16,.03,.01-.07-.1-.03-.14-.06,.01,0,0,.02-.02,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "87 69.64 86.96 69.59 86.98 69.65 87 69.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.78,67.45l-.07,.03c.12,.03-.01,.12,.16,.13-.11-.01,.01-.05,.02-.07,.02,0,.08,.02,.06,.05h-.05l.08,.06h0c.11-.03,.02,.02,0,.04-.1,0-.12-.04-.19-.06-.02,0,.05,.04-.03,.06,.07-.03,.12,.1,.19,.03,.09-.06,.21,.03,.3-.06,0,.08,.23,.01,.18,.11,.04,0,.06-.02,.08-.04-.14,0,.03-.08,0-.12,.06-.03,.2,0,.18-.06,.05,.06,.19,0,.25,.01l-.02,.02c.07,.02,.03-.02,.06-.05-.16,.03-.26-.03-.4,.03-.03-.04-.18-.03-.09-.1,.03-.02,.08-.02,.07,.02,.13,0,.03-.09,.14-.1l.11,.02-.02-.03s.04,0,.08,.02h-.02s.07-.06,.11-.07h-.11c-.02-.07,.05-.04,.07-.1-.15,.04-.2,.02-.33-.02-.08,.01,.02,.03,.03,.05-.14,.05-.08-.1-.21-.04,.02,.02,.16,.04,.08,.09-.13,.04-.38,0-.41,.1-.07,.02-.15-.05-.22,0,0,.02,.03,.02,.05,.03l-.02-.03c.12-.03,.16,.03,.2,.06h-.11s.02,.01,.04,.03c-.24,.09-.16-.15-.36-.08,.03,0,.08,.03,.12,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.89,69.76s-.05-.02-.08-.02c.02,0,.05,.03,.08,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.64,70.78c.21-.03,.52,.09,.66-.06l-.15-.02-.03,.06c0-.1-.22,.05-.22-.03l.05-.03c-.12-.06-.22,.1-.31,.03,0,.03-.03,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.35,62.3c.02-.1-.09,.04-.13-.02l-.02,.04c-.11,0-.05-.05-.19-.03,.03,.14,.24,0,.34,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.71,67.56l-.09-.05c.05,.04-.02,.06,.09,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.77,70.84c-.08,0-.09-.04-.14,0,.03,.03,.12,.01,.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.01,66.49h.02s.03-.03-.03-.04c.02,.03-.03,.01,0,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "89.67 67.59 89.59 67.62 89.65 67.64 89.67 67.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.46,67.73c.09,.01,.17,.01,.26,0-.03-.02-.01-.09-.1-.06,.04,.09-.14-.01-.16,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.75,68.39s.16-.02,.2,.05c.1-.05-.05-.06,.06-.1-.03,.02-.1,0-.11,.05v.01c-.11,.04-.05-.07-.13-.05,0,.01,.04,.04-.01,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.82,66.69s.06-.02,.11-.03c-.06-.01-.09,0-.11,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.01,64.29l-.06-.11s-.02,.06-.08,.05c-.03,.07,.13,.02,.14,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.26,69.69c.05-.01,.12,0,.16,.02l-.08,.02c.09,0,.27,.04,.4,.07l.08-.04s.08,.06,0,.08c.13-.08,.28,.02,.3-.11,.05-.01,.09,0,.13,0,.01,.02-.02,.03-.04,.04,.09-.02,.13-.06,.26-.07-.2-.02-.43-.05-.59-.08,0,.03,.1-.01,.11,.02-.14,.05-.14,0-.26,0,.05,.02-.02,.05,.02,.07l-.19-.03s.05-.08,.06-.12c-.04,.03-.05,.1-.13,.06,0-.08-.04,.03-.09-.04-.03,.07-.17,0-.14,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.99,63.55s-.06-.02-.06-.05l-.13,.05s.16,.04,.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92.19,65.78s.12-.04,.12-.08c-.02,.05-.14,.03-.12,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.59,70.52s-.08-.08-.06-.08c.01,.02-.09,.12,.06,.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "94.21 64.25 94.08 64.25 94.19 64.26 94.21 64.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.61,64.68s.03,.02,.05,.02c0-.03-.11-.04-.12,0l.07-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "92.22 65.89 92.15 65.83 92.17 65.89 92.22 65.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.31,68.31s-.05-.03-.09,0c.01,.02,.04,0,.09,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "89.11 68.48 89.07 68.43 89.04 68.45 89.11 68.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "95.34 63.41 95.25 63.41 95.33 63.42 95.34 63.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.83,68.73c.04,.09,.31-.06,.37,.01,.05-.03-.02-.11,.09-.08-.15-.05-.28,.01-.41-.03-.06,.05,.09,.08-.05,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.3,64.26c.11-.03,.07,.03,.12-.03,0-.03,0-.06-.01-.06-.05,.01-.01,.07-.05,.07l-.04-.03-.02,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M95.85,63.02c.1-.03,.28-.02,.28-.02,.11,0,.03-.05,.06-.07,0,.05-.1,.04-.18,.06l.03-.04c-.05,.01-.09,.03-.09-.01-.01,.05-.09,.04-.1,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.93,67.01s.12,0,.12-.04c-.13-.05,0,.08-.12,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M95.05,63.97h-.13c-.06,.07,.09,.03,.15,.03v-.03c.06-.01,.06,.05,.1,.04-.19,0-.31,.16-.5,.13,.03,.02,.03,.05,.07,.05,.2,.03,.35-.05,.54-.06-.02-.01-.04-.03-.04-.04,0-.06,.18-.06,.22-.02l-.03-.09,.11-.02s-.01-.02-.01-.02c.03-.01,.04,0,.07,.02l-.06,.05c.07-.05,.13,0,.15-.06-.03-.04-.11-.06-.16-.08,.03,0,.09,.04,.1,.08-.13-.02-.2-.05-.37-.02,.05-.07-.08,0-.07-.05,0,.01,.03,.02,.02,.04-.06,0-.15-.04-.13-.08-.07,.05-.26,.05-.28,.09,0,.08,.21-.02,.25,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.17,71.05c.24,.03,.29,0,.43,.06,.08-.02-.03-.06,.02-.1,.18-.08,.39-.07,.58-.1h-.02c.25,.03,.36-.16,.58-.16-.06-.01-.16,.04-.22,.03-.03-.05,.08-.05,.04-.09-.04,0-.2,.04-.26,0,0,.07-.1,.03-.16,.06l.04,.04c-.1-.09-.19,.07-.24,0,.02,0,0,.03-.01,.04l-.06-.02,.03,.03c-.06-.01-.12,0-.15-.03h.01s-.1,.03-.12,.02c.04,.03,.1,.02,.13,.07-.08-.02-.2,.02-.28,.02l.09,.05s-.04,.02-.07,.03l-.09-.11s-.05,.06-.09,.03c.06,.02,.18,0,.11,.07-.04,.06-.16,.02-.23,.02,.02,0-.03,.04-.04,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.84,70.62c-.04,.06,.06,0,.1,.02,.1-.07,.24-.05,.35-.1-.07-.07-.2,.07-.17-.03l-.23,.05,.02,.06-.07,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.14,69.58s-.13,.02-.06,.05c.03,0,.09,0,.14,.02,.09-.06-.12-.07,.02-.1l-.08-.02s-.04,.04-.02,.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "86.27 71.15 86.2 71.16 86.28 71.17 86.27 71.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.42,63v-.05h-.07s.09,.03,.07,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92.28,66.5c-.01-.08-.21-.03-.31,0,.22-.12,.18,.11,.31,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M95.49,63.78c.07-.03-.02-.06,.02-.09,0,.03-.11,.03-.16,.07h.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.82,67.47s.07,0,.09-.03c-.1-.02,0,.05-.09,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "89.42 68.74 89.38 68.68 89.36 68.72 89.42 68.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.52,67.76h.11c-.07,.03-.03-.02-.05-.05-.03,.01-.07,.03-.06,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.62,69.48c.06-.07,.22-.01,.25-.09-.17,.02-.09,.06-.25,.05v-.06l-.13,.06c.1-.01,.01,.06,.13,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.96,65.08s0-.05-.06-.06l.06,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.37,68.83c.01-.05-.01-.02-.07-.04l.07,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.16,65c-.01-.09-.08,.02-.15-.02l.15,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.49,63.01s.1,0,.08,.05l.12-.04-.17-.05-.04,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92.09,66.72s-.05-.06-.11-.04l.11,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "90.47 68.08 90.4 68.04 90.4 68.06 90.47 68.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "94.05 65.15 94.13 65.17 94.05 65.12 94.06 65.17 94.05 65.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "92.19 66.66 92.15 66.66 92.22 66.72 92.19 66.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.61,68.8l-.09,.02c.13,0-.01,.04,.03,.07,.11,.04,.21-.06,.28,.02-.05-.06,.07-.03,.1-.07-.04,.05,.07,.03,.06,.06,.12-.06,.28-.07,.38-.05-.04-.07-.12,0-.22-.05,.02,.03-.01,.05-.08,.06-.04,0-.03-.03-.03-.05h.02s-.25-.04-.43-.1c.05,0,.05,.07-.02,.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "91.56 67.26 91.43 67.27 91.52 67.29 91.56 67.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.16,67.52s.07,0,.11-.02c-.03,0-.11-.04-.11,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.86,64.58s0-.05,0-.06c.05,.05-.1,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.52,67.23c.07,.02,.18,.04,.25,.02,.15-.08-.18,0-.21-.08,.08,0-.03,.04-.05,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.82,70.42s-.07,0-.08,.02c.09-.03,.15-.02,.24-.03,0-.05-.1,.02-.14-.01l.08-.04-.03-.05s.05,.08-.04,.06c-.03-.01-.03-.07-.09-.04l.07,.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "91.52 67.36 91.43 67.35 91.47 67.36 91.52 67.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.19,67.58s.1-.01,.09-.06c-.08,0-.06,.05-.09,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "95.03 64.5 94.97 64.55 94.93 64.53 94.95 64.56 95.03 64.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92.55,66.48s.05,0,.06,0l-.04-.04s-.03,.02-.03,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "88.74 69.7 88.67 69.67 88.64 69.69 88.74 69.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.54,68.24l.02,.03c.06-.03,.14-.06,.26-.03l-.05-.04c.02-.06,.15,0,.17-.02,.02,.01-.03,.02-.03,.04,.04,0,.09,.03,.13,.02,0-.05-.2-.05-.1-.11l.16-.02c-.04-.07,.09-.02,.06-.08-.09-.03-.17,.09-.27,.04h.01c0,.05-.07,0-.11,0,.08-.01,.14-.1,.21-.03-.01-.02-.11-.07-.15-.04,0,.03-.01,.04-.07,.05h0l-.05,.04c.04,.05,.16-.06,.16,.03-.05,.03-.17,.06-.15,0l.03,.03-.24,.06s.05-.06-.02-.04l.04,.07h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M95.12,64.53v.02h.07s-.09-.08-.12-.03h.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M95.95,63.86s.04,0,.07,.02l.04-.06s-.14,0-.11,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.63,65.11l.04-.03c-.14-.06-.12,.07-.27,.05,.03,.04,.17-.04,.23-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "93.93 65.5 93.92 65.51 94 65.55 94.01 65.54 93.93 65.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.12,70.32s.04,0,.06,.01c-.06,.02-.03,.07-.14,.06l.06,.05c-.04-.06,.07-.03,.09-.03h-.02c.09-.05,.11-.06,.18-.13-.05-.02,.08-.1-.04-.09v.03l-.07-.02c.03,.07-.13,.1-.12,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.09,63.06h.1c-.06-.02-.08-.05-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.41,69.4l.02-.02h-.11s.07,0,.09,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.13,65.48s.05,0,.07-.02l-.06-.02s-.02,.03-.02,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.81,68.31s-.05-.02-.05,.01c.02,.03,.12,0,.15,.02l-.14-.08,.04,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M87.89,70.79c.1-.04,.03-.11,.19-.12h-.01c.2-.07,.32,.03,.47-.08-.23-.03-.45,.03-.67,.08,.09,.04-.11,.08,.02,.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "91.28 67.99 91.18 68 91.21 68.03 91.28 67.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.4,67.99s.07-.04,.07-.04l-.16-.03s.03,.06,.09,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.07,69.94s-.09,0-.14,0c.05,.03,.12,.02,.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.27,68.18c-.09-.05-.07,.04-.16,0-.06,.12,.11-.02,.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M95.36,64.87l.05-.04-.06,.03-.04-.05s.04,.04,.05,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "91.03 68.4 90.96 68.36 90.96 68.41 91.03 68.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M95.11,65.04s.09-.02,.11-.06c-.05-.05-.04,.06-.14,.02l.03,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.77,68.56s.13-.02,.11-.05c-.05-.03-.12,0-.11,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.02,63.64s-.02-.03,.02-.04l-.16,.03h.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M95.45,64.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.15,63.49c.06-.08,.17,.05,.17-.05-.11-.06-.1,.08-.17,0,.02,.03-.06,.05,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M98.39,62.51c.07,.02,.19-.07,.21,.02l-.03-.05c-.08,0-.12,.04-.18,0-.02,.02,0,.03,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.07,68.52s.12-.08,.03-.11c.01,.02-.1,.04-.02,.05-.08,0-.01,.07-.13,.02l.14,.05h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M98.6,62.42l-.02,.02h.12l-.02,.05h.07c.04-.05-.09-.08-.09-.12v.05s-.08-.05-.12-.03l.07,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.87,65.65c-.04-.1-.16,.03-.23-.02-.03,0-.07-.04-.05-.04l-.13,.06c.08,.03,.3,.02,.41,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92.51,67.36l.11,.07h-.02l.18-.07s-.06,0-.09,.02v-.07c-.07,.09-.12,0-.19,0-.06,.02-.07,.09-.15,.08,.07,.05,.08-.06,.17-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M88.96,70.2h-.02c-.05,.02,.04,.03,.05,.05,.22-.07,.51-.1,.73-.16v-.04s.08,.02,.1,.03c-.04-.03-.13-.03-.21-.04,.02,.03,.05,.02,.06,.05-.12-.03-.14-.05-.23-.03,.02,.02,.11,0,.11,.04-.24-.02-.44,.13-.6,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.42,65.93s.03-.04,.01-.05c.07,.03,.26,.02,.38,.02-.08,0,0-.05,.01-.07-.15,0-.19-.03-.3-.07h0c-.06,.03-.1,0-.13-.03,.08,.03-.13,.18,.02,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.25,65.87h.08s-.04-.04-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.27,68.38c-.08,.01-.02,.06-.08,.06,.06,0,.32,.02,.44,.04,.05-.06,.21,0,.21-.07,.02,0,.12,0,.17,.02h-.01c.03-.07,.16,0,.15-.06-.06-.01-.17-.05-.18,0l-.02-.04c-.08,0,.04,.06-.09,.06-.28-.05,.11-.15-.13-.2,.04,.1-.31,0-.33,.15-.1,.05-.1-.04-.18,.02h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.41,63.55c.06-.05,.03,.04,.09,.01l-.07,.04c.07,.03,.1-.03,.21-.03l-.09-.1-.06,.03-.09-.05c.06,.01,.06,.08,.01,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M98.85,62.38c0,.07,.21-.08,.21,.06-.07-.08,.08-.11,.02-.14l-.05,.05s-.08-.04-.04-.07c-.04,0-.12,.08-.15,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M98.58,62.61c.08,.02,.08,.04,.1,.09,.03-.01,.06-.06,.13-.03-.12,0-.03-.11-.18-.11,.02,0-.03,.02-.05,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.95,65.61s-.02,.03-.02,.05c.02-.05,.11,.01,.17,0l-.04,.03c.06,.02,.08,.02,.15,0l.09,.07s.04-.09,.12-.1c.01,0,.06,.01,.05,.03h-.08l.09,.11c.06-.06-.03-.14,.09-.17-.04-.03-.08,.04-.1-.02,0-.05,.05-.05,.12-.08l.08,.11h0c.11,0,.19,.02,.17,.05v-.05c.11-.01,.13,0,.17,.05h-.02s.06,0,.05,.05c.07-.1,.25,0,.35-.01-.03-.01-.02-.06,.02-.07,.06,0,.05,.06,.11,.06l-.02-.07c.08,.03,.1-.04,.14-.07l.06,.02-.02-.04c.17,.02,.12-.07,.24-.04l-.06,.05c.1-.04,.14,.01,.23-.02-.02,.03,0,.06,.04,.05l.27-.13h-.01l.12-.05c-.13,.05-.15-.09-.23-.07h.16s-.02-.03-.03-.05c.19,.02,.25,.01,.38,.02-.04-.04,.05-.03,.02-.06l.11,.02c-.11,.01,.11-.03,.09-.1-.05,.05-.2-.01-.15,.05-.1,0-.03-.05-.11-.06-.03,.02-.13,.04-.09,.07-.08-.11-.3,.08-.36,.02l-.05,.05-.09-.04s-.2,.04-.23,0c-.03,.02-.1,.05-.06,.08-.08,.02,0-.1-.1-.02,.03-.01,.03,0,.04,0-.03,.04-.07,.1-.1,.11-.03,0-.07-.04-.07-.08h.07v-.09c.09-.09,.13,.07,.18-.05h-.04l.08-.06-.11-.04c-.08,.05-.23,.02-.29,.1-.08-.02-.04-.07-.06-.11-.06,.02,.04,.07-.1,.08-.11-.08-.18,.02-.27-.01l.02-.03c-.13,.02-.27,.02-.4,0,.02,.06,.19,.06,.11,.13-.07-.1-.23,.03-.3,.01,0,.06-.09,.03-.03,.09-.06-.01-.15-.04-.11-.07-.12,.11-.18-.04-.25,.07,.14,.01,.19-.01,.29-.02-.01,.05-.1,.03-.11,.08l-.08-.02c.17,.04-.15,.09-.1,.12-.09,.03-.19,0-.29,.02l.06,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.89,63.2c.09,0,.09,.01,.19-.01-.06,0-.16,0-.19,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.01,64.1c-.1,0-.07-.04-.16-.01v.06l.16-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M98.99,62.44s-.03,.07-.11,.05h.09l.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.88,65.76c.06,0,.09-.03,.08-.06-.07,0-.01,.04-.08,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "98.78 62.73 98.72 62.71 98.67 62.75 98.78 62.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.24,64.91s.02-.05,0-.08c-.1,0-.09,.07-.22,.04,.07,.04,.17,.05,.21,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M99.16,62.52c-.02-.1,.2,.01,.17-.08h.28c-.03-.15-.13,.03-.13-.11-.03,.02-.13,.04-.09,.07-.05,.04-.16,0-.25,.01,.02,.06-.09,.07,.02,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M95.79,65.1s.06-.02,.08-.04c-.03-.01-.09,0-.08,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.16,64.16l-.03,.02,.2-.03c-.17,0,.06-.23-.22-.11-.09,.04-.02,.1,.05,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.85,68.29c0,.06,.06,0,.12,0-.03-.04-.02-.04,.05-.04l-.1-.02s.03,.09-.07,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M100.15,61.66l-.02,.02c.08,.02,.27,.09,.25,.01h-.02s0-.04,.02-.06c-.07-.02-.18,.02-.2-.01,0,0,.03,.05-.04,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M98.89,62.7l.03,.02-.02-.07c-.05,0-.04,.04-.01,.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "97.07 64.15 97.02 64.13 97.02 64.18 97.07 64.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M89.22,70.63s-.1-.08-.13-.02l.13,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.87,64.47v-.08h-.11c.06,0,.08,.05,.11,.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "93.46 67.11 93.46 67.07 93.41 67.11 93.46 67.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92.58,68.13c-.08-.02,.04-.09,.03-.09-.01-.06-.16-.02-.11-.09v.05l-.19,.03c.07,.05,.17,.09,.28,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.82,63.77c.05-.01,.17-.05,.15,0,.02-.03,0-.05,.03-.07,.04,.09,.21-.05,.24,.05-.09-.01-.16-.17-.35-.14-.2-.03-.04,.11-.23,.1,.02,.06,.1,.04,.16,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.32,67.22h.09l-.02-.05c-.06,0,.06,.1-.07,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M99.85,62.22c-.06-.11-.16,.11-.23-.03v.05l.23-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.07,67.5c.05,.08-.08,0-.11,.05h.16l-.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M99.11,62.64s.07,.02,.09,.05l.07-.05c.11,.06,.35,.03,.54,.01,.02,.01-.05-.02-.03-.05,.14,.05,.16-.01,.27,.04-.11-.17-.46,.01-.63-.08-.06,.08-.11,.03-.24,.07l-.07-.03-.06,.05h.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92.8,67.99s.16-.03,.15,0c-.03-.05-.13-.03-.19,0-.04-.04-.06-.1-.16-.08,.02,.06,.07,.05,.21,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.07,67.64c-.05-.04,.05-.06-.05-.06-.08,.05,.06,.01,.05,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92.02,68.5l.03-.02-.09,.02s.03,0,.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.79,63.85c.07,.02,.02-.03,.06-.03-.08-.02,0,.04-.06,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M100.63,61.73s-.03-.06,.06-.03l.06,.08h.02s-.01,0-.02-.02h.12s-.14-.02-.17-.09c-.02,.02,.02,.02,.05,.05l.02-.02c-.06-.05-.12-.06-.21-.05,.06,.01,.06,.04,.06,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.35,67.6c.12,0,.29-.05,.37,.02,0-.03,.05-.08-.03-.11,.08,.05,.17,0,.26,0l.02-.09c-.05,.11-.17,.03-.28,.08l.02,.04c-.15,0-.09-.05-.26-.04,.05,0,.09,.03,.07,.07-.06-.06-.19,.03-.24-.06,0,.05-.03,.09,.07,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.18,64.39s.08-.01,.14-.01c-.04,0-.08,.01-.14,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.23,66.87h.08l-.07-.02s-.02,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.85,66.52c.05,.04-.12,.05-.15,.05l.03,.06c.03-.08,.12,0,.2-.03v-.04c.13,.02,.12-.03,.25-.03-.12,0,0-.05-.01-.08-.02,.05-.21,.12-.25,.05,.02-.04,.08,0,.06-.02-.06-.01-.19,.05-.25-.01-.03,.06,.08,.02,.13,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.99,67.26c.12-.03,.06-.06,.2-.03,.05-.04-.1-.04-.14-.03-.01-.02,.02-.03,.04-.04,.1,0,.22-.02,.29-.05-.05,0-.06-.05-.06-.04-.07,0,0,.04-.04,.06-.06-.01-.13,0-.2-.03h.03c-.09,.01-.12,.09-.24,.07,.04,0,.11,.05,.12,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.49,66.7l.24,.03s-.04-.03-.02-.04l.14,.05s-.04,.03-.08,.05h.11l-.07,.04s.04,0,.07,.02l.08-.06c-.1,0-.03-.09-.08-.11-.12,0-.19-.02-.25,.05-.03-.02-.08-.07-.12-.04,0,.01,.01,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M95.05,66.42c-.07-.03-.12,0-.18,.02,.02,.06,.12-.03,.18-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M90.38,70.24c.02-.1-.1,.04-.13,0,0,.04,.1,0,.13,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.55,66.9c-.01,.05-.14,.08-.17,.14l.1,.04s.08-.06,.06-.08c.1,0,.24-.03,.32,.04-.03,.01-.06,.02-.08,.04,.03,0,.06,.04,.08,.02-.03-.01-.05-.07,.03-.06l.03,.04c-.11-.07,0-.1,0-.16,.04,0,.07,.09,.08,.06,.06,0-.07-.02-.02-.04,.06,.02,.15,.05,.16,.08l-.06,.05c.05,0,.11,.02,.15,0h-.02c.16-.07,.11,.07,.26,.02-.02-.06-.15,0-.11-.08,.16,.02-.03-.07,.13-.09,.03,.04,.05,.07,.11,.02-.07,.03-.1-.03-.16-.02,.07-.05,0-.04-.02-.07h.12s-.02,0-.01-.01h.05s-.07-.04-.15-.03c.06-.09-.21-.09-.19-.16l.03,.06c-.09,.03-.24,.06-.29,.11l.03,.04-.16,.03s.05,.04,.01,.08c-.07,0-.11,.02-.14,.04v-.09c-.13,0-.16,.02-.21-.06,.05,0,.15-.03,.18,0-.03-.02-.19-.06-.29,0,.12,0,.01,.09,.14,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.26,67.05l.08-.06h-.09s0,.03,.01,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.06,61.66s.17-.05,.13,.06h-.07s.13,.09,.22,.12c.02-.04,.13-.02,.13-.02,.09-.02,.1-.12,.12-.11,.08,.02,.19,0,.3,.04,.03-.01,0-.02,.02-.04,.04,0,.06,.03,.05,.05,.08-.07,.12-.09,.27-.1l-.06,.05h.11s-.03,0-.04,0c.25-.06,.53-.05,.77-.05,.06-.02-.12-.03-.03-.07,0,.05-.14,.02-.16,0,.02,0,.01,0,.01,.02h-.08s.02,.02,.02,.03c-.05,0-.07,0-.08-.04-.1,.08-.17,.02-.28,.02-.04,0-.05-.06-.01-.08,0,.04,.06,.03,.1,0-.06-.08-.26,0-.31,0,.02,.03-.03,.02-.01,.05-.14,.04-.06-.05-.18-.02l-.08,.05c-.07-.09-.18,0-.29-.07-.04,.03,0,.12-.13,.1-.03-.04,.08-.04,.03-.07-.08-.01-.26,.04-.25-.03q-.01,.05-.06,.12l-.11-.04-.04,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "93.86 67.45 93.81 67.45 93.87 67.49 93.86 67.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92.4,68.88l.07-.05c-.12,0,0-.08-.08-.09,0,.02-.11,.14-.22,.11,.07,.04,.22-.05,.23,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M99.46,63.24h.03l-.13-.05c.11,.03,.21-.04,.27,0v-.03c.07-.03,.21-.03,.18,.03-.05-.02-.04-.03-.07,.02,.09,.01,.07-.04,.17-.05,0-.05,.04-.13-.07-.14,.07,.06-.05,.05-.05,.08-.14,.01,0-.04-.1-.08,0,0-.1,0-.11,.05h.13c-.11,.15-.36-.08-.41,.09l.16,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M100.08,62.63h.05c-.12,0,.07-.09-.07-.04-.02,.02,0,.03,.02,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.83,67.71c-.11-.02-.08,.06-.14,.03,.08,.02,.12,.03,.14-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.85,64.61c.08-.06-.08-.02-.12-.03,.03,.02,.11,0,.12,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.26,64.99s.13,0,.12-.04h-.13v.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "94.18 67.55 94.1 67.52 94.11 67.57 94.18 67.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M95.77,66.39l.06,.04s.11-.05,.06-.08l.2-.03v.05s.02-.02,.02-.04c-.1-.06-.16,.01-.24-.02-.05,.01,.01,.02,0,.03-.02,0-.11-.01-.13-.03h.03c-.07,.07-.14,.07-.23,.1,.06,0,.23,.04,.23-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M100.31,62.71c.11-.05,.24,0,.32,.07,0,.03-.12,.02-.06,.07,.03,0,0-.05,.06-.03,.16,0,.22,.08,.35,.04v-.05l-.1,.05c.04-.13-.31-.02-.2-.19-.09,0-.18-.01-.27,.01,.02,.01,.06,.01,.05,.03-.1,.03-.09-.06-.19-.05,.03,.04-.05,.05,.04,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M91.68,69.7c-.07-.03-.06-.04-.14-.01,.02,.04,.09,0,.14,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M100,62.9s.05,0,.07,.02l-.05-.06s0,.03-.02,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.57,64.92s-.06-.03-.05-.07c-.02,.04,.02,.06,.05,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.22,68.34c.08-.02,.21-.07,.27,0-.03-.06,.11-.05,.06-.09-.01,.05-.31-.06-.33,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.74,64.69s.09,.01,.14,0l-.08-.05s.02,.08-.06,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.48,64.98s.03,0,.04-.02l-.07-.03s0,.05,.03,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.49,65.09c-.09,0-.03-.06-.1-.08,.09,.01-.05,.11,.1,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92.88,68.86c-.04,.06,.07,.02,.11,.06-.02,0-.01-.02-.03-.02,.05-.01,.12,.02,.11-.02-.01,0-.05,.01-.07,0-.03-.03,.06-.05,.06-.07l-.11-.09c-.08,.01-.03,.06-.03,.08l-.08-.05s.03,.06,.04,.1c-.07-.03-.12-.03-.21,0,.03,0,.2-.03,.21,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M98.02,64.79c.1-.03,.2-.03,.32-.01-.02-.04,.01-.05,.07-.07h-.22s0-.06-.06-.09c.07-.03,.13-.02,.12-.08l-.13-.02c-.09,.04-.17,.09-.22,.15,.08,.03,.09,.09,.13,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.81,68.09c.09,.01,.22-.11,.27-.04,.11,0,.13-.09,.18-.06-.02,0-.07-.02-.06-.05l.21,.02h-.01l.08-.04c-.03-.06-.15,0-.23-.02,.05,.06-.07,.02-.1,.03,.03-.01,.05,0,.05,.02-.09,0-.09-.01-.16,.01,.02-.02,.1,.06-.01,.07-.13,0-.03-.11-.19-.07-.04,0-.19,.11-.02,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.06,62.36h0l-.22-.02c.02,.06,.14,.01,.21,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.97,67.14v.09s-.03,0-.05-.02c.07,0,.18,.03,.24,.06-.01-.02,.03-.02,.05-.03,.07,.04,.02,.07,.1,.07-.04-.08-.03-.09-.14-.13,0,0-.03,.04-.06,.03-.07-.03,.02-.07,.03-.09-.08-.05-.23,.02-.32,.06l.15-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M98.53,64.29s-.02,0-.03,.01c0,.05,.06,0,.1,.02l-.04-.07h.02s-.07,0-.12,0l.07,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.63,61.78h.07l-.05-.03s0,.02-.02,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M92.69,69.04s-.02,0,0-.01l.07,.02c-.07,0,.01-.05,0-.06-.04,.02-.11,.02-.07,.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "95.66 66.75 95.53 66.71 95.58 66.78 95.66 66.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.99,65.7h0l.07,.05c-.08-.04,0-.13-.14-.09,.02,0,.04,.03,.06,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M98.69,64.32c.06,0,.1-.04,.13-.07h-.11l-.02,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.67,68.39s.06-.07-.01-.08v.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.13,62.38c.1,.03,.2-.03,.31,0,0,.02-.08,.05-.1,.03-.1,.05,.06,.01,.05,.06-.02-.02,.05-.04,.07-.02,.05,.05-.07,.03-.01,.07-.05,.01-.17-.04-.18,.03,.06,0,.18,.04,.27,.01-.11-.06,.12-.02,.04-.08h-.09c0-.07,.09-.05,.08-.1l.06,.03s-.04-.04-.1-.07c-.04,.02,.01,.08-.08,.06l-.09-.09h.08c-.11-.02-.25-.04-.32,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.48,66.05s.09,0,.12,.03c0-.03,0-.07-.02-.04h0c-.08,.06-.04-.04-.11,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.21,66.35h-.02l.05,.04c-.07-.04,.05-.05,0-.09l-.09,.02c.05,0,.07,.02,.06,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.98,67.29l.1,.02-.1-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "93.47 68.64 93.33 68.63 93.34 68.65 93.47 68.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.1,68.83l.07-.02-.04-.03s-.02,.03-.04,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.3,66.35c.06,.01,.14,0,.13-.04l-.14-.05c-.05,.01,.02,.06,0,.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "101.2 62.46 101.15 62.41 101.17 62.48 101.2 62.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "97.17 65.62 97.13 65.64 97.17 65.66 97.17 65.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "95.62 66.9 95.59 66.88 95.57 66.93 95.62 66.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M100.19,63.22s.07,.02,.12,0c-.03-.05-.09,0-.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.77,66.03s-.14,.02-.09,.06c.08,0,.32-.07,.39,.03l-.03,.02,.07-.04h-.06c0-.07,.15-.08,.18-.03v-.05h0c-.18-.03,.04-.13-.16-.14-.11,.16-.14-.01-.28,.14l-.07-.03,.05,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.5,65.63h0s.05,.02,.07,.05c-.04,.03-.07-.03-.09,.02,.03,.05,.12-.03,.1,.04,.04-.02,.04-.04,.04-.1,.03,0,.07-.03,.09,0l-.03,.07c.12-.05,.13,.07,.17,.09-.05-.14,.26-.06,.2-.21-.05,0-.05-.07-.01-.08l-.17-.04c-.1,.12-.39,.11-.47,.14l-.08-.04,.13-.04c-.05-.07-.09,.06-.16,0,.03,.06,.09,.09,.2,.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "97.13 65.69 97.13 65.7 97.22 65.74 97.23 65.73 97.13 65.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.33,68.77c.13,.02,.19,.08,.33,.07-.09-.03-.12-.17-.33-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.18,62.56c.11-.01-.06-.01,.05-.04h-.08s0,.04,.04,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.65,65.4c.08-.01,0-.05,0-.06v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M99.26,64.05s.14,0,.07-.03c.19,.02-.04,.09-.03,.11l.13,.03v-.03c.06,.02,.18,0,.25-.02v.05c.12-.02,.06-.08,.17-.09-.05-.03-.23-.1-.27-.1-.1-.05-.19,.02-.32,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.11,65.84s0-.06,.08-.06c-.04,.02-.15,.02-.08,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M99.27,64.2s.04-.02,.06-.02l-.15-.03c0,.06,.14-.01,.09,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.56,66.39s.02-.07-.07-.06l-.04,.04h.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M95.81,66.91s.08-.05,.11,0c-.05-.03,.04-.04,0-.07-.15-.02-.04,.08-.11,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.46,68.05s.11-.01,.1-.05c-.06,.05-.07,0-.11-.01-.04,.02,0,.03,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M102.78,61.8c.15,0,.07,0,.21,0-.06-.1-.18,.04-.25-.06l.06,.03s.03-.04,.04-.04c-.11,0-.2,.03-.27,.02l.04-.08s-.13,.04-.22,.05h.02l-.1,.03c.17,.12,.36-.09,.47,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M98.21,65.03s.11,.02,.08,.06c0,.02-.04,.02-.06,.02,.02,.01,.08,0,.12,0l.02-.06s-.02,.03-.07,.03c-.03-.07,.09-.04,.15-.06-.05-.05-.23,0-.24,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M98.25,65.14c-.1-.03-.12,.05-.21,0,.05,.05,.17,.04,.21,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.13,68.4h0s-.04-.04,.06-.02c-.06-.02-.1,0-.21,.03,.04,0,.1,0,.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M95.93,67.06l.06-.08-.21,.03c.06,.01,.16-.01,.15,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M95.15,67.62s.05-.03,.05-.05h-.1l.06,.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "98.11 65.24 98.07 65.24 98.05 65.29 98.11 65.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.31,65.98l.02,.03c.08-.06,.09-.06,.16-.1-.12,0-.15,.06-.2-.01,.03,0-.04,.08,.02,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M99.76,63.99s.1,.02,.13,0c.02-.06-.12,0-.13,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "94.36 68.44 94.27 68.42 94.25 68.43 94.36 68.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M99.48,64.25s.11,.01,.13-.02c-.03,0-.09-.02-.13,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.87,62.38c.07-.03,.09,.03,.1,.05,0-.02-.03-.05,.03-.05,.02-.02-.09-.05-.13,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M95.31,67.67l-.04,.03c.1,.04,.34-.02,.48-.04-.02,0-.04,0-.07,0l.1-.08c-.09,.06-.18,.03-.26,.04t.03,0s-.03,.04-.06,.05l-.08-.05s.12-.03,.09-.04c-.06-.05-.18,.04-.1,.06h-.13s.05,.02,.04,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.17,68.56c.12,0,.13-.02,.21-.02-.04-.05-.22-.01-.21,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M98.5,65.14c-.08,.02-.05,.01-.09,.07l.1,.02-.1-.07c.08,.02,.1-.06,.16-.03l-.12-.03s.06,.01,.05,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.51,62.78c.03-.06,.18-.02,.14-.08-.09-.05-.22,.06-.14,.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "97.38 66.06 97.32 66.04 97.37 66.09 97.38 66.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.46,66.83h.02l-.04-.04c.09-.03,.22-.05,.27-.09-.11-.01-.14,.08-.25,.03-.08,.02,0,.08,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.62,65.9c.08,.08,.25-.07,.27,.02,0,.03-.09,.07-.12,.03l.03,.05c-.05,.01-.16-.01-.08-.05l-.2,.03c.21-.04,.06,.2,.28,.09,.1,0,.22,.04,.28-.03,.06,.04,.19-.01,.14,.06h-.1c-.2,.01-.26,.13-.44,.18-.09-.01-.12-.06-.19-.07v.08s.08,.06,.11,.09h-.06c.02,.06,.1-.03,.14-.04,0,.08,.16,0,.12,.09-.02,.02-.04,0-.05,0,.22-.03,.03,.11,.26,.06h0c.07-.03,.19-.01,.28-.02,.04-.04,0-.1-.09-.09-.09,.03-.14,0-.21,.03,0-.03,.12-.04,.07-.05l-.12,.03c-.09-.05,.04-.11,0-.19l.03,.04s.02-.06,.07-.07l.02,.08s.19-.02,.22-.06v.05c.15-.03,.33-.05,.47-.09,.05,.06-.07,.14-.01,.19-.03,0-.11-.04-.07,.02,.11-.03,.19,.02,.26,.03l-.04,.03h.11l-.04-.04c.09,.03,.21,.04,.3,.01h-.01c.06-.01,.19-.03,.2,.02-.05,.04-.13,.04-.19,.02-.05,.01,0,.03,0,.04,.08-.02,.26,0,.23,.03l.11-.09c-.07,.02-.1,0-.08-.04,.09-.02,.39-.05,.42-.08-.07-.06-.32-.01-.32-.02-.09,.03-.07-.1-.17-.04,.04,0,.06,.03,.05,.05-.08,.04-.06-.03-.09-.04-.07,.03-.21,.05-.22,.03-.12,0-.36-.01-.37-.1,.12,0-.05-.12,.13-.09-.05-.09-.28,0-.35-.07h.12c-.14-.07-.03-.17-.17-.21h.11s.03-.02-.02-.03v.04s-.06-.03-.09-.05c-.05-.03-.17,.1-.28,.02,.01,.02-.03,.04-.06,.06-.02-.07-.18-.04-.25-.03,.07,.04-.05,.03-.02,.07-.03,.01-.07,0-.1,0l.06-.05-.2,.02s.02,.04-.05,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "99.72 64.31 99.67 64.29 99.64 64.33 99.72 64.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M98.1,65.57l.05,.02v-.07c.05,0-.13,.01-.05,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.09,67.22l.09-.03-.08-.02s-.06,.05-.01,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M102.57,62.18c-.08-.01-.07-.06-.16-.01,.04-.02,.15,0,.13,.06-.03,0-.04,0-.07-.02l.15,.11v-.02c.06-.03,.15,.02,.13,.04,.02-.03,.02-.06,.1-.05,.06,.08,.42-.03,.33,.13,.03,.05,0-.05,.08-.02,0,.03-.04,.04-.06,.06h.1c-.1-.1,.13-.14,.1-.22,.05,.02,.08,.09,.06,.1,.02-.02,0-.02,.02-.03,.02,.04,.08,.01,.13,.07h-.08v.02s-.14,.04-.14,.08c.1-.05,.17,0,.25,.03l-.03,.07c-.07-.09-.11,.08-.17,0,.08,.06,.15,.03,.32,0h0c.1,0,.12-.03,.2-.02l.02,.04c.08,0,.01-.07,0-.07-.12,.07-.16-.06-.26,0,0-.04,.07-.05,.12-.05,.05-.05-.16-.01-.12-.08h.05s-.07-.02-.05-.06c.13,.04,.12-.05,.21-.06-.04-.03-.03,.07-.1,.03,.02-.11,.16-.04,.21-.04-.01-.02-.05,.01-.03-.02,.1-.04,.16,.06,.26,0-.1,0-.22-.01-.25-.06,.04-.02,.12-.04,.14,0-.06-.1-.16-.01-.2-.11-.04,.03-.01,.07,.02,.08-.12,.02-.13-.09-.23-.06l.03,.02-.17,.07c-.06-.01,0-.1-.13-.06-.02,.02,.07,0,.09,.03l-.05,.03c.06,.01,.1,0,.14,.02-.06,.05-.06,.03-.1,.08l-.12-.04,.06-.03c-.09-.04-.13-.08-.28-.08l-.06,.06s.05,.02,.09,.02c0,.01-.02,.03,0,.05-.05,0-.13-.07-.15,0l-.12-.09,.02,.03c-.12-.02-.03,.08-.18,.05l.05-.05c-.11,.03-.14-.07-.26-.08l-.1,.03s.08,.05,.09,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.43,69.45s-.08,0-.13,.02l.13-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "102.79 61.94 102.69 61.95 102.74 61.97 102.79 61.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.27,67.15s.09-.06-.01-.06v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M98.2,65.58c.05,.06,.12-.03,.15,0,0,0-.09-.01-.15,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "102.47 62.29 102.47 62.28 102.38 62.29 102.4 62.31 102.47 62.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M99.82,64.4c.06-.02-.02-.03,0-.05l-.09,.03h.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.55,67.04s.01,0,.01,.02c.05,0,.03-.04,.02-.05h-.13s.1-.01,.09,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.33,67.11c.14-.02-.03,.07,.08,.08,.06-.07,.12-.03,.17,0-.03-.02,.09-.03,0-.05l-.19-.02,.04-.04s-.08,.01-.1,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "98.25 65.68 98.25 65.62 98.23 65.65 98.25 65.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.17,66.67c-.07,.03-.22-.05-.27,.04,.1,.04,.16,0,.27-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.13,67.39c-.12,.04,.04,.05,.03,.09l-.12-.03s.04,.05-.04,.06l.18,.04-.02-.06,.15-.03c-.09-.01,0-.03,.03-.06-.09-.01-.19-.13-.28-.02h.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M98.92,65.15c.05-.05,.09,.03,.13,.03,.07,0,.05-.04,.11-.05,0-.04-.14-.01-.1-.08,.03,.07-.17,.02-.15,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M98.35,65.63s.16-.03,.21,.02c0-.03,.05-.05,.07-.07-.09,.03-.08-.04-.14-.05,.03,0,.03,.04,.03,.05-.02,.02-.04,.03-.08,.04l-.02-.07c-.05,.01,.06,.08-.07,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.38,66.51l-.05-.03h.08l-.09-.04s.04,.07,.05,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.83,66.88l.04,.09c.02-.1,.18-.09,.27-.12-.08,0-.28,0-.35,.04h.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "97.77 66.2 97.71 66.21 97.69 66.23 97.77 66.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "96.87 67.03 96.99 67.01 96.74 67.01 96.83 67.05 96.87 67.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.67,66.5h.04s-.06-.04-.13-.07l-.03,.04h0c.06-.03,.06,0,.07,.02,0,.04-.07,0-.09,.03-.09-.01,.04-.06-.07-.06-.04,.09,.16,.03,.21,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.75,67.17l-.04-.08-.08,.04c.12-.03,.04,.05,.12,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M102.09,62.92s.03,0,.07,0c0-.02-.1-.03-.14-.06-.03,.04,.07,.04,.07,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "100.68 63.97 100.68 63.92 100.66 63.97 100.68 63.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M99.91,64.57c.07,.03,.06-.03,.08-.05-.08,0-.04,.04-.08,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.69,67.22s-.05,0-.09,0c.01,.02,.06,.01,.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M100.75,63.96c.06,.05,.22-.05,.21,.05,.07-.07,.13,0,.16-.07-.12,.05-.21-.06-.32-.03,0,.02-.04,.04-.06,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "98.71 65.6 98.77 65.62 98.69 65.58 98.7 65.6 98.71 65.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.43,67.45s.05-.05-.03-.04c0,.01,0,.03,.03,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M95.02,68.6c-.06-.01-.05,.01-.1,.03l.1-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M98.85,65.58s.11-.05,.16,0c.06,.04,.07,.11,.17,.09-.09,0-.01,.11-.13,.06h.09c-.09,.06-.08,.08-.2,.1-.1,.05,0,.05-.06,.1-.11,0-.05-.02-.1,.04,.06,.1,.25-.07,.26,.04-.02,0-.05,.01-.05,0l.07,.04h-.06c.1-.09,.4-.02,.52-.12-.06-.06-.1,.06-.19,.02-.09-.01,.01-.08-.05-.12-.2,.03,.03,.2-.19,.11v-.05c-.06,0-.13,0-.19-.01,.12,.03,.2-.19,.25-.03,.05-.04,.11-.12,0-.13,.09-.07,.08,.03,.12,.03v.06c.08-.07,.11-.11,.08-.16-.04,.04-.09,0-.13,0l.07-.03-.1-.05v.03l-.15-.07,.08-.05c-.11,.02-.27-.02-.37,.03h.16l-.07,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.84,67.11c.09,.03,.24-.01,.33-.01,.11,.01,0,.05,.02,.06l.12-.03c-.01-.08-.1-.03-.17-.09l.06-.03c-.1-.03-.06,.07-.15,.02l.07,.03c-.08,.11-.18-.05-.28,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M94.93,68.72s-.07,.07-.15,.05l.15,.02v-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M103,62.38l.09-.03s-.1,0-.13,.03c0,0,.02,.02,.03,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "98.69 65.85 98.61 65.85 98.67 65.89 98.69 65.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M96.44,67.7l.15,.04c.1,0-.01-.13,.13-.09-.14,0-.06-.08-.22-.04-.06,.03,.07,.07-.05,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M95.34,68.72h.11s-.05-.01-.07-.03c.04,0,.11-.03,.13,0,.04-.09-.16,.01-.16-.07l.04,.05c-.06,.03-.09-.01-.15,0-.04,.03,.06,.05,.11,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "100.88 64.35 100.82 64.31 100.79 64.34 100.88 64.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M98.39,66.43c.01-.05,.11,.01,.18-.02-.06-.01,0-.08-.1-.07l-.02,.05h-.14l.08,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M95.6,68.72l.03,.06c.09-.03,.14,.01,.21-.04-.09,0-.16-.07-.27-.02,.01,0,.03,.02,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.67,67.08v.02c.07,0,.09-.04,.11-.08,0,0-.06,.05-.11,.02l.05,.03h-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.3,67.42c.09,0,.23,0,.22,.06h-.04c.08-.04,.16,.08,.21,0-.06-.03-.12-.04-.11-.11,.14,0,.19,.02,.28,0h.1l-.03-.03c.06-.03,.18,0,.26,0-.06,0-.07,.09-.03,.07-.03,0,0-.03,.01-.04l.09,.09-.02-.03c.09-.03,.17,0,.23,.04-.1,.05,0,.15,0,.2-.08,.04-.16,.05-.23,.07l.2,.03c.06-.05,.06-.1,.02-.16,.09,.05,.07-.05,.14-.04,0,.05,.06,.11-.01,.14h.06c0-.07,.18-.07,.26-.05-.05,.03-.11-.04-.15-.04,.08-.09,.09,.05,.16-.03-.05,.03,.06,.08,.12,.08l.06-.05,.04,.1c.01-.05,.17-.05,.2-.04,0-.03,0-.06,.07-.05,.04,0-.05-.02-.08-.02,.11-.07,0,0,.05-.08,.06,0,.08,.04,.14,.03-.01,.05-.04,.08,.06,.1,0-.08,.08,.05,.12-.03h-.1c0-.05,.07-.13,0-.14,0,.05-.1,.05-.16,.06l-.02-.07c.06,.01,.1,0,.13-.02,0-.03,.04-.03,.01-.05-.1-.05-.17,.02-.19,.06l-.05-.03c-.08,.05,.08,.05,.03,.07v-.02s.04,0,.05,0c0,.04-.05,.05-.11,.06,0-.13-.22-.1-.25-.21-.02,.06-.13-.02-.09,.04-.2-.06,.14-.15-.1-.16-.13,.04-.29,.02-.41,0,0-.02-.02-.06,.03-.06l-.08-.02-.02,.06-.2,.02h.01c-.1,.03-.13,.02-.26,0-.07,.16-.11,.05-.33,.09,0-.08,.1,0,.12-.07-.08,.08-.14-.06-.21,.03,.05-.01,.07,.02,.1,.02,0,.12-.29,.05-.33,.09l.08,.04-.05,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M95.6,68.86l.04-.04s-.15-.02-.11-.05l-.07,.07,.15,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "104.33 61.84 104.28 61.82 104.24 61.85 104.33 61.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M100.23,65.15s.04,0,.07,0l-.02-.06c-.03,.06-.06-.01-.13,0l.08,.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "97.06 67.78 97 67.73 96.98 67.75 97.06 67.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "95.79 68.8 95.69 68.8 95.66 68.83 95.79 68.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M104.56,61.94c0,.06,.19,0,.22,0-.01-.02,.05-.04,.05-.05,.03,.02,.11,.03,.04,.05,.11,.01,.03-.07,.02-.09,0,.03-.12,.02-.08-.04-.11,.08-.33-.08-.23,.06l-.02,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M102.93,63.22l-.03-.06s-.05,.08,.03,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.67,64.32s-.1-.08-.14-.03l.14,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M100.86,64.84c.06,.06,.15,0,.22,.04,.07-.03,.09-.02,.21-.05-.02,.03,0,.05-.06,.05,.01,.02,.07,0,.12-.03,.07-.02,.06,.04,.08,.06-.06,.03-.13,.02-.2,.02,.09,.05-.1,.05-.09,.07,.01,.08,.18,.03,.22,.01-.04,0-.07-.02-.06-.04,.08-.02,.18,.07,.28,.04,0-.06-.06-.06-.09-.1,.19-.01,.3-.04,.47-.02-.01,0-.01-.02-.01-.02h.12c-.09-.08-.28-.07-.44-.07,.05,0,.01,.02,0,.03-.03-.05-.11-.03-.13-.07,0,.04,.03,.09-.06,.09-.03-.04-.02-.08,.02-.12-.08-.01-.09,.06-.11,.09-.13-.04-.35,.04-.45,.02v-.05l-.04,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M99.59,65.93c-.04-.05,.06-.02,.07-.05h-.13s.03,.04,.06,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M103.5,62.89c-.02-.06,.09,0,.07-.04h-.09s-.04,.04,.02,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M103.75,62.8c.06-.02,.08,.02,.11,.03l-.03-.04c.07,.02,.18,.01,.11,.06,.04-.03,.09-.03,.11,0,0-.01,.02-.03,.01-.05,.12,0,.31,.05,.3-.05-.34,.04,0-.21-.33-.18,.29-.01-.06,.16,.22,.18-.1,0,.03,.05-.05,.05-.09-.05-.18-.11-.31-.11,0,.05-.07,.03-.03,.08-.12,.02-.05-.03-.12-.04,.04,.03,.06,.1,0,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M104.63,62.22l.05-.04c-.04-.07-.15,.02-.25,.03,.04,.07,.15-.02,.21,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.76,67.5s.07,.02,.1,0l-.02-.07-.08,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "96.63 68.56 96.53 68.56 96.58 68.57 96.63 68.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M104.69,62.14h.1l-.03,.04,.09-.05c-.03-.07-.07,.01-.15-.04,0,.03,0,.03-.01,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M103.94,63c.07,0,.16,0,.22-.02l-.05-.05h0c0-.05-.13-.04-.24-.04-.03,.06-.13-.01-.18,.04,.01,.08,.22-.04,.25,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.69,64.55s.02,.02,.03,0c.13,.09-.26,.03-.13,.12,.03-.04,.13-.02,.15,0v-.02c.11,.06,.22,0,.34,0-.02,0-.06-.01-.05-.03,.13,.01,.11,.07,.27,.08l.13-.04s.06,.1,.12,.04c.04,.03,.05,.07-.02,.09h-.09s.03,.05,.09,.04v-.03s.11,.03,.16,.06l-.07,.07c.06-.02,.05,.02,.05,.05-.04,.04-.1,0-.13-.01-.02-.02,.05-.04-.02-.04l-.06,.06c.06,0,.04,.03,.06,.04-.04-.03-.17,0-.21-.05-.05,.04,.09,.01,0,.06-.11-.03-.06-.08-.15-.1,.08,.01,.1-.06,.15-.02,.01,.02-.03-.04-.07-.04-.08,.02-.12,.09-.15,.1,.04-.02,.05,.05,.03,.07-.07-.03-.09,.04-.19,.04,.03,.05,.18,0,.2,.04h-.01s.11-.06,.13-.03l-.05,.04c.12-.02,.29-.05,.34,0,0-.1,.21-.05,.24-.07,.2-.02,.18,.14,.41,.05h0s.23-.05,.23,.06l-.02-.07c.15-.02,0,.11,.17,.08v.07c.06,.01,.09-.02,.17-.03h-.02c.03-.06,.07,0,.11,0l-.07-.09h.07s-.06-.03-.05-.05c.08-.06,.09,0,.15,0,.03,.04-.07-.09,.03-.05-.04,0-.13-.02-.11,.02-.03-.11-.25-.07-.28-.15-.09,.02,.04,.08-.09,.07l-.02-.04c-.08,.02-.12,.04-.2,.04-.1-.05-.24-.09-.29-.15h.22c0-.09-.2-.04-.21-.01-.14-.02,0-.14-.17-.13,.07-.04,.19-.05,.27-.1l-.06,.02s.03-.04,.05-.05c-.01-.02-.05,0-.07-.02,.01-.07,.13-.02,.17-.08-.09,.02-.09-.07-.17-.02l-.05,.05c-.15-.02,.08-.06,0-.11v.05s-.09,.02-.1,0l.02-.04c0,.05-.08,.02-.15,.03l-.04-.04s.02,0,.01,.02c-.1-.02-.12,.04-.22,.03,.02,.01,.13-.01,.09,.04-.09,0-.24,.06-.31,.02,0,.02-.1,.04-.04,.06-.05,0-.12-.03-.16,0v-.06c0,.08-.19,.02-.21,.04l.03-.04-.08,.02s.03,0,.04,0c-.02,.03-.07,.05-.13,.06,.06-.05-.03-.02-.05-.05-.02,.02,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.85,67.7s.1-.06,0-.07c.04,.04-.11,.05,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M104.82,62.23c-.07,.07,.23,0,.13,.08,.18,.03,.17-.06,.32-.02-.03,.02,0,.06,.01,.08l.05-.05,.08,.05c-.01-.1-.13-.04-.13-.14l.11,.03s-.08-.05-.12-.06l-.03,.04s-.13-.01-.05-.06c-.04,.02-.08,.03-.14,.03,0-.06-.07-.03-.14-.05-.13-.01-.04,.13-.18,.07,.02,.02,.06,.01,.08,.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "98.21 67.53 98.14 67.5 98.13 67.53 98.21 67.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M100.99,65.32s.05,.02,.05,0l-.05-.05v.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.1,65.28s.1-.03,.15,0l-.05-.09-.11,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M99.6,66.56h-.12s.11,.07,.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.88,67.94s.14-.01,.1-.05c-.02,.07-.1-.02-.14,.01,.03,0,.03,.02,.04,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.31,65.2c.08-.05,.06,.05,.15,.02,0-.03-.14-.06-.15-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M99.9,66.6v-.06c.19-.02,.17,.05,.31,.06l-.13,.02c.07,.02,.03,.04,.13,0,.06-.05-.06-.08-.07-.14,.23,.06,.27-.08,.51,0l.09-.07s-.07-.03-.1-.07c.15,.05,.29-.11,.45-.06,0-.06-.15,0-.19-.05-.14-.02-.21,.08-.3,.13v-.07c-.07-.02-.12,.05-.19,.02-.04-.03,0,.01,.01,.02h-.18c-.11,.06,.12,.09-.06,.12,.04-.09-.13-.02-.12-.08-.09,.06-.29,.07-.37,.08-.13,.13,.22,.05,.2,.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "100 66.38 99.9 66.34 99.88 66.38 100 66.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "99.41 66.84 99.33 66.81 99.32 66.83 99.41 66.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "97.04 68.74 96.96 68.73 96.92 68.76 97.04 68.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.39,62.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.66,65.05s.04,0,.07-.02l-.05-.03s0,.04-.02,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.36,65.27s.1,0,.14-.01c-.03-.04-.11,0-.14,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M104.59,62.82s0-.05,.01-.07c.14,.06,.24,0,.37,.02,0-.01-.01-.03,.02-.04l.05,.02c.03-.06-.08-.02-.07-.06-.06,.03-.05,.07-.13,.07-.02-.02,0-.05,.04-.06-.06-.08-.17,.06-.28,.04v.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M97.77,68.31l.05-.05s.01,.08,.02,.1h0s.12,.02,.1,.04l.16-.05c-.1-.08-.19-.12-.35-.13,0,.02-.04,.1-.09,.06-.05,.07,.11-.03,.11,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.88,65.03s.07-.02,.08-.05c-.06-.01-.07,.02-.08,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.47,65.38c.09,0,.04-.03,.02-.05-.03,.01-.02,.03-.02,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M99.34,67.23h.14l-.05-.03s.12-.05,.07-.1l-.19,.04s.05,.06,.02,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M104.58,63.02c.07-.04,.08,.02,.15,0l-.12-.05s.06,.08-.03,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M98.68,67.83h-.09c-.06,0,.06-.02,.05,.02l-.15,.02c.11,0,.11,.01,.19-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M104.73,63.13c-.04-.05-.17,0-.22,0,.07,0,.1,.05,.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.98,62.06s.06,0,.08-.02c-.03,.01-.1,0-.08,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "105.58 62.46 105.49 62.42 105.48 62.47 105.58 62.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M99.98,66.82c.07-.04,.14,.06,.18,0,0-.03,.07-.05,0-.07,0,.01-.12,.11-.19,.06l.02,.04v-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "99.64 67.09 99.6 67.1 99.62 67.14 99.64 67.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105,62.93l.03-.04-.08,.04s.04,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "102.48 64.92 102.43 64.92 102.44 64.98 102.48 64.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M104.76,63.18c-.03,.08,.12,0,.13,.08,.03-.02,.08-.08,.16-.06,.07,0-.04,0-.08-.02,.02-.02,.05-.07,.11-.05l-.03-.04h.08c-.01-.1-.22,.03-.22-.04-.05,.05-.13,.05-.15,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.02,63c.07,.02,.04-.03,.09-.06l-.05-.02s-.05,.05-.04,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M100.4,66.63s-.03,.04-.03,.06c.12,0,.03-.06,.11-.05h-.11s.01,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.37,62.86c-.04-.05-.02-.06-.09-.09,0,.07-.01,.07,.09,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M100.3,66.78s.08-.02,.04-.04l-.09,.02,.06,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "102.38 65.15 102.31 65.17 102.4 65.18 102.38 65.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M99.05,67.78c.09,.07,.18-.1,.25,0h-.02c.14,.06,.17,.09,.29,.18h.12s-.03-.02-.04-.04c.1,.02,.05-.05,.12-.03-.08,0-.17-.09-.26-.13v.03c-.15,0-.35-.14-.46-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "103.25 64.53 103.18 64.51 103.18 64.6 103.25 64.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M100.85,66.45c.05-.01,0-.05-.03-.06-.07,.03,.02,.04,.03,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "103.18 64.67 103.11 64.65 103.08 64.67 103.18 64.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.93,65.69h.05s-.05-.03-.09-.04c.04,0,.04,.03,.04,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M103.91,64.14h.05l-.05-.03s0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.26,63.14c.05-.03,.06-.06,0-.07v.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M103.59,64.46s-.05,.01-.05,0l.04-.03c-.09,0-.04,.03-.03,.05l.04-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "98.91 68.21 98.74 68.23 98.9 68.24 98.91 68.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M103.78,64.49h.05c-.06,.02,0-.06-.03-.06,.11,.01-.02-.06,.09-.06l-.03-.05c.03,.11-.16,.06-.22,.1-.01-.02,.04-.03,.05-.05h-.07c-.04,.07,.21,.07,.16,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M102.75,65.16s.05-.03,.07-.04h-.1l.03,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M103.75,64.35h.07s-.08-.04-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.35,63.13c.08,.01,.13-.03,.21-.04-.06,0-.2-.03-.21,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M102.53,65.59s-.03-.02-.04-.03c0-.02,.05-.01,.07,0l.02-.09c-.05,0-.12,.03-.13,0-.01,.07-.22-.01-.15,.08l.23,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M104.53,64.1c-.06-.03-.26-.03-.4-.01,.06,.06,.28,.03,.4,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M99.06,68.24c.07-.04,.12,0,.16-.06-.07-.02-.15,.05-.2,.03-.03,.01,.03,.02,.04,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "103.41 64.81 103.36 64.78 103.33 64.82 103.41 64.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "102.23 65.74 102.14 65.74 102.22 65.75 102.23 65.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M100.36,67.2c.09,.11,.38,.01,.45,.15-.11-.01-.27,.01-.39,.05,.12,.08,.32-.05,.5,0l.05-.05-.14-.05c.13,0,.23-.07,.34-.04-.04,.04-.14,.07-.13,.11l.26,.07c-.08-.02,.03-.12-.09-.1l.05-.05s-.05,0-.07-.02c.1,0-.02-.07,.05-.12-.09,.04-.02-.06-.08-.05-.18,.03-.4,.17-.54,.06,.05,.06-.04,.06-.11,.07,.03-.07-.01-.08-.12-.08,.03,.06-.11,0-.02,.06v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M107.66,61.51c.04,.08,.21-.05,.2,.04,0-.02-.04-.05-.05-.07,0,.03-.05,.01-.08,.02l-.02-.07c.07,.02-.03,.05-.04,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.1,63.53c.05,0,.07,.04,.11-.01l.06,.06c.09-.07,.09-.03,.18-.07-.11,.01-.31-.13-.35,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.06,63.64c.1,0-.02-.03,.04-.06-.01,0-.09,.02-.12,.04l.09,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M99.75,67.8h-.03s.13,.02,.19,0c0-.02,0-.08-.06-.08,.07,.09-.16,0-.1,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M104.03,64.42l.03,.07c0-.07,.15-.02,.2,0-.03-.04-.11-.01-.13-.06,.1,.02,.17-.07,.24-.07-.15,0-.19,.04-.32,0-.03,.02,.02,.04-.02,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.31,66.6c.05,0,.06,.01,.08-.02,.06,.04,.14,.11,.28,.06l-.07-.06s-.07,.03-.1,.04c.07-.05-.06-.06-.08-.09h-.08l-.02,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M107.23,62.05c.11-.07,.19-.03,.32-.02-.01,0-.01-.02,0-.03,.04,0,.19,0,.24,0l.06-.06s-.08,0-.08-.02h.05c-.13,0,.03-.06-.06-.06,0,.05,.02,.08-.06,.09-.15-.1-.27,.11-.41,.05-.05,.01-.07-.04-.08-.04-.03,.03,0,.06,.03,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M99.8,67.86s.09,0,.11-.01c-.04-.03-.08,.01-.11,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.54,63.52v-.03s.04,0,.06,.02c-.02-.06-.15-.04-.15-.1-.05,.05,.09,.09,.09,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.76,66.39s-.05-.02-.1,0c.04,.05,.1-.03,.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M102.84,65.54l.05-.03h-.08s.02,.02,.03,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M99.37,68.37c-.05,.01-.08,.08,.01,.08l.03-.08c-.05,.01-.05-.05-.14-.05l.09,.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "108.12 61.41 108.1 61.42 108.18 61.46 108.2 61.44 108.12 61.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.18,66.94s.02-.03,.03-.04c-.07-.03-.05,.01-.13,.02l.1,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M107.39,62.21h.06c.03-.06-.08-.02-.03-.09-.08,.05-.09-.04-.15-.03-.03,.07,.19,.07,.12,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.65,66.56l.07-.05s-.09,0-.12,.03l.06,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "102.18 66.29 102.02 66.29 102.1 66.31 102.18 66.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.82,66.55v-.03c.07-.02,.05,.05,.11,0l-.14-.06s0,.05,.02,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.44,67.06c.06-.03,.07,.1,.18,.09l-.06,.06,.07-.02h-.01s.04-.02,.05-.03l.06,.06s.04-.04,.01-.07c.09-.03,.08,.04,.1,.06v-.09c.07,.02,.16-.03,.24,0l-.06,.06h.1s-.04-.04-.03-.07c.08-.06,.14,.03,.19,0-.07-.03-.21,0-.32,0-.01-.1,.17,0,.31-.06,.02,.01,.11,.03,.19,.02v.1c-.07-.04-.04,.01-.13,.02,.12,.04-.07,.07,.06,.11l-.02-.03c.06-.02,.11,.01,.12,.03,0-.01,.03-.04,0-.05-.06,0-.08-.05-.14-.06,.07-.03,.14,.02,.15,0-.02-.04-.11-.08,.02-.11,.07-.05,.17,.02,.25,.02h-.09c.07-.06,.03-.11,0-.12l.09-.06s-.05-.02-.05-.05l.1,.02h-.03s.15-.03,.16,0c-.06-.01-.03,.05-.1,.04,.08-.04,.17,.04,.16,.05,.03-.11,.21,0,.32-.06v.08c.14,0,.18,0,.29,.05-.11,.04-.11,.19-.2,.18,.12-.04,.27,0,.31,.04-.02-.01-.08-.02-.1-.06,.11-.05,.13,.06,.19,.06-.04,.04-.05,.1-.16,.08-.02-.03,.04-.03,.06-.05l-.09-.02s-.02,.07,.05,.08c-.06,.03-.1-.02-.15-.03-.03,.05,.15,.09,.11,.16-.02-.04,0-.1,.06-.13,.19-.05,.24,.13,.37,.07,.06,.01,.06,.06,.1,.09l-.08,.02,.09,.05h0c.09,0,.26-.02,.28,.02h-.1c.19-.04,.24,.09,.41,0,.05,.07-.07,.05-.05,.12,.08,.02,.18-.03,.19,.04-.12,0-.18,.07-.31,.02l-.09,.07c.06,.03,.14,.03,.13,.09-.02,.03-.15,.02-.09,.07-.02-.04,.07-.04,.07-.01l-.04,.03c.08,0,.08-.05,.16,.01-.07,0-.08,.04-.16,.08,.02,.02,.01-.07,.09-.04,.02,.04,0,.06,.06,.1,.04,0,0-.04,.05-.04,.12,.03,.38-.08,.38,.03l-.03,.02,.14-.03c-.05,.01-.02-.02-.04-.04l.29-.02s-.09-.04-.12,0c-.12-.03-.07-.11-.07-.17-.06,.02,0,.05,0,.09-.15,.05-.22-.03-.33-.02l.05-.04c-.06,.02-.09-.03-.14,.02-.09-.04-.04-.1,.04-.13,.03,.04,.07,.03,.14,.03-.03-.04,0-.07,.05-.1,.04-.03,.19,.02,.25-.03-.05-.03-.08-.06-.12-.1h.05c-.12,0-.31,.06-.45,.01,.02-.04,.16-.08,.19-.03-.05-.06,.09-.03,.09-.07,.11,.04,.18-.03,.24-.03l.15,.13c-.09,0,0,.06-.13,.05,.13,.02,.01,.09,.18,.08,.06-.05,.2-.04,.27-.03-.04,.06,.11,.07,.13,.06l-.1-.02c-.04-.05,.1,0,.02-.04,.07,0,.16,0,.19,.05,.1,0,0-.05,.07-.04,.01,.08,.2-.04,.14,.06-.04,0-.07,0-.12,0,.04,.08,.13,.05,.27,.05,.03,.02-.07-.02-.06-.04,.03-.08,.08,.01,.14-.02l-.05,.05c.1-.02,.25,.02,.31-.07,.17,.02,.34-.01,.49,0l-.03-.05c.19,.09,.33-.12,.51-.06,.03-.08,.35-.02,.2-.1-.16,.02-.34-.01-.45,.04l-.13-.09c-.1,.08-.25,.07-.32,.04,.06-.05-.06-.06-.11-.07,.02,.02-.03,.02-.05,.02-.03-.02,.05-.07-.03-.09v.03s-.09-.02-.1-.03c.15-.04,.32-.06,.48-.04h-.05s0-.04,.02-.05c.05,.02,.21,0,.14,.06,.07,.03,.09-.03,.17,0l-.03-.02c.06-.03,.19,0,.16-.07-.01-.02-.04,0-.06,0h.01c-.16,.02-.26-.06-.41-.06,0,.06-.08,.02-.14,.04,0-.16-.21,0-.35-.03v.02c-.1-.11-.4,.07-.38-.1,.05,0,.14-.02,.18-.03-.26,.05-.5-.07-.79,0v.03c-.09,0-.34,.07-.38,0-.12,.05-.32,.02-.38,.09-.25-.1-.58,.11-.83-.03l.03-.06h.08c-.06,0-.17,0-.17,.03,0-.05-.14-.03-.21-.06h0c-.06-.03-.19,0-.21-.06-.08-.05,.04-.11,.06-.13,.13-.01,.19,.05,.25,.09-.04,.03,.1,.05,.03,.09,.09-.04,.02-.07-.03-.11,.17-.09,.17,.1,.36,0-.02,.03-.1-.05-.16,0,0-.05,.1-.06,.13-.09,.1,0-.13,0-.2,0,0,.06-.08,0-.09,.06-.05-.05-.08,.04-.14-.02,.08-.08,.32-.11,.38-.13,.05,.02,.09,.03,.13,.07,0-.08,.18,.02,.25-.07-.03,0-.12-.04-.12,0-.16,0,.03-.11-.17-.08,.02-.01,.03,0,.02,.01-.12,0-.19,.08-.31,.05,.01,.02,.05,.01,.05,.05h-.09s.01,.01,.01,.01c-.11,.05-.09-.04-.18-.01,.02-.01,.08-.06,.14-.04-.11,.01-.25-.04-.33,0,0-.03,.04-.06,.02-.06,0,.05-.09,.03-.13,.03-.1-.15-.23-.02-.39-.1v.03c-.12,0-.35,0-.41-.02l.02-.03c-.08,.04-.19-.02-.26-.03-.14-.02-.08,.14-.23,.1-.03-.05,.02-.09-.1-.09h.02c-.21,.06-.24,.07-.45,.12-.02-.01-.04-.03-.06-.04-.07,.05-.24,.09-.36,.09,.03-.06-.05-.02-.09-.03,.04,.07,.08,.13,.2,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M100.53,67.65c.08-.01,.18,.03,.23-.03-.08-.02-.28,.08-.26-.04,0-.02,.07-.05,.09-.02l-.02-.06c-.18,0-.07,.14-.04,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M103.02,65.58s.01-.05-.05-.03c-.04,.03,.07,.06,.05,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M108.29,61.63c.08,0,.06,.01,.11-.03-.12-.04-.17,.03-.24-.04,0,.06,.11,.03,.13,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M100.07,68.01l.08,.04-.08,.04c.09,0,.13,0,.14-.06-.02-.06-.09-.07-.21-.04l.06,.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.74,63.69s.09-.02,.08,.02c.13-.01-.06-.05,.05-.07-.02-.01-.1,.05-.15,0l.03,.02c-.08,0-.12,.02-.21,.01,.07,.02,.1,.05,.2,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.13,64.03s.04,0,.06,.01c0-.03-.07,0-.12,0h.08l-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M103.98,64.95l.04,.03h0c.07-.04,.08,.02,.09,.04-.02-.01,0-.03,0-.03,.06,.01,.11,.08,.15,.05h-.02s.08-.05,.14-.07c-.03-.02-.03-.07-.06-.08,.03,0-.01,.05-.04,.08-.12-.02-.29-.09-.36,0l.07-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M103.6,65.4s.06-.05,.03-.07c-.03,0-.08,.06-.11,.02,0,.03,.07,.03,.08,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.27,64.03s.09-.06,.11,.01v-.04c.24,.04,.48-.03,.68-.04v.06c.08-.02,.1,0,.17,.02-.04-.04,.02-.03,.06-.04-.03,0-.1,.02-.11,0,.11-.04,.3,0,.35,0l-.05-.08c-.05,.06-.09-.03-.12,.04-.11,.01-.2-.05-.11-.07-.14-.05-.17,.1-.25,.03h.01c-.08,.03-.24,0-.26-.03-.12,.06-.34,.1-.48,.12v.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.39,67.2l-.06,.07h.06c-.05,0,.15-.21-.12-.11l.12,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M100.5,67.82h.02s.07-.06,.04-.08c-.05,.03,.03,.07-.06,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M108.67,61.49h.02s.06-.13-.09-.03l.07,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M106.28,63.75h.14l-.02,.04c.07-.01,.02-.09,.13-.06,0,.05,.07,.07,.03,.11l-.08-.04c-.04,.1-.09,.03-.18,.06,.09,.05,.4-.04,.36,.07l.12-.03s-.05-.02-.1,0c0-.07-.06-.08-.04-.14,.05,0,.09-.02,.1,.02,.11-.03,.18-.11,.28-.05-.04,0,0-.04,0-.05,.1-.02,.23-.03,.32,.02-.01-.03,.02-.06,.04-.09l-.1-.02h0s-.06,.02-.1,0c.03,0,.03,.02,.03,.04-.04,0-.07,0-.11-.01,0,.01,0,.04-.03,.04-.1-.02,.1-.08-.04-.07,.04,.07-.05,.02-.06,.08-.12,0-.04-.03-.1-.07,0,0,0,.02,0,.03-.09-.05-.28,0-.24-.1l-.12,.05c.06,0,.09,.04,.06,.06l-.06-.04v.06h-.09s.09-.11,0-.12l.08-.02c-.08,.05-.05-.03-.13-.01-.04,.03-.07,.07-.13,.09-.08,0-.21,.01-.29,0,.04,.04,.32,.03,.31,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.9,63.68v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M102.81,66.18s-.06-.03-.1,0c.02,.04,.09-.02,.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.47,67.38l-.05-.05c.06-.02,.08-.09,.1-.1-.02,.04-.16,.06-.11,.12l-.11-.03c0,.07,.14,0,.17,.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "104.52 64.99 104.41 64.93 104.5 65.02 104.52 64.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M102.68,66.33s.17,.06,.24,0l-.12-.04s-.08,.02-.12,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M103.66,65.79c.11-.01,.3-.02,.37-.09,.05,.05,.22-.03,.19,.04,.07-.14,.16,.06,.21-.08l.07,.03c.01-.05,.04-.06,.08-.09-.07-.03-.19,0-.16-.08l-.14,.02s-.1-.03-.03-.09c-.1-.02-.29,.14-.34,.04h.02l-.1,.05c.11-.02,.16,.05,.24,.05-.2,0-.31,.08-.52,.1-.06,.08,.08,.05,.1,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M108.6,61.88c-.09,.03,.01-.08-.09-.03l.03,.07,.06-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M99.86,68.66s.1,.02,.12,0c-.04,0-.1-.02-.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.18,67.65c.09,.03,.21,0,.25,.04l-.03-.05h.08s.03-.06,.06-.07c-.17,0-.13,.01-.3,0,.03,.04,0,.05-.06,.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "104.41 65.2 104.3 65.18 104.4 65.22 104.41 65.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M102.34,66.81h.04s-.09,0-.06-.04c0,.01,0,.03,.02,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M107.54,62.74c.2,.03,.25-.03,.43,.03-.03,0-.02-.01-.02-.02h.07s-.05-.04-.03-.05c.14,0,0,.07,.11,.1,.03-.02-.06-.03-.02-.06,.12,0,.06,.1,.07,.14,.07-.06,.18,.01,.21-.02,0,.05,.05,.07,.13,.06,.08-.09,.14-.02,.21-.14,.09,.09,.32,.04,.41,.08,0-.05,.21-.08,.06-.13-.4,0-.48,.13-.86,.02-.05-.05,.02-.07-.09-.1-.21,.11-.55-.08-.68,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M104.77,64.93s.06-.03,0-.07v.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.6,67.42s.09-.03,.18-.04c-.03,.02-.2-.04-.18,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "101.25 67.72 101.23 67.72 101.23 67.77 101.25 67.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M104.96,64.95s-.02-.04,.01-.05h-.11c.07,.02,.09,.04,.09,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M108.89,61.86h.06l-.07-.05s-.02,.03,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M108.22,62.38c.07-.05,.08,.04,.11,.05-.04-.03,.02-.03,.06-.05l.07,.03c.03-.07-.18,0-.14-.06l.16-.02h-.26s-.03,.02,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.01,64.95c.16-.04,.13,0,.29-.05h-.02c.07-.04,.14-.05,.18,0v-.07s-.14,.05-.11-.02c-.13-.01-.25,.05-.35,.07v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M104.62,65.25c-.08-.02-.09,.05-.12,.07,.1,0,.1,.02,.17,.05-.08-.01,0,.08-.13,.09,.07,.03,.12,0,.18,.03l.15-.1s.05,.02,.07,.03c-.11-.03-.23-.07-.29-.11,.11,.01,.15-.03,.22-.06-.05,0-.09,.06-.15,.02l.02-.02-.14-.04s.04,.03,.04,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M108.05,62.55c.07,.03,.22,.03,.25,0-.02-.02-.18-.01-.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.38,64.71s0-.04-.04-.04c.01,0,.04,0,.04,.03-.04,.06-.09-.05-.12,.03h.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M109.52,61.6c.07-.03,.01-.07-.01-.09v.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M103.74,66.03s.1,0,.13,0c-.01-.02-.1,0-.1-.05l-.03,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M102.16,67.27s-.07,.03-.08,.05l.03,.09s-.01-.1,.09-.07c0,.05,.06,.03,.11,.01,0-.05-.11-.04-.06-.08h-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.73,64.61c-.09,0-.03-.06-.05-.06l-.05,.04,.1,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.91,67.57c.05,0,.02,.03,0,.05,.12,0,.25-.03,.31,0,.02-.06-.07-.09-.13-.12-.05,.05,.01,0,.02,.06-.05,0-.17-.04-.19,.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "103.79 66.16 103.77 66.14 103.72 66.19 103.79 66.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M108.37,62.69c.19-.02-.14-.06,.02-.11,.02,.06,.12,.04,.16,.01l.05,.07v-.05h.13s-.1,0-.08-.04h.1s-.03,0-.04-.02c.04-.02,.06,.01,.09,.02l-.03,.08s.07-.04,.1-.06c.05,.05-.05,.05,0,.1l-.02-.04c.05,0,.16-.04,.16,.01,.04-.08-.13,0-.11-.07-.03-.04,.11-.03,.17,0,.05-.01-.11-.01-.02-.06-.19,.06-.27,.02-.39,.04-.02-.01,0-.03,0-.03-.09,.03-.3-.05-.32,.03-.07,.04,.05,.08,.02,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M106.62,64.03s.11-.03,.01-.05c-.03,0-.06,.05-.01,.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "106.97 63.88 106.83 63.88 106.86 63.93 106.97 63.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M107.35,63.51s.08-.02,.12,0c-.01-.03-.09-.03-.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M106.13,64.56l-.05-.02s.05,.03,0,.05c-.09-.04,0,0-.13,0h.1l-.03,.06c.23,0,.44-.08,.59-.04v-.03c.09,.07,.25,0,.32,.05,.18,.04,.32-.08,.47-.03,.03,.06-.09,.02-.09,.05l.1-.02,.03,.06c.08-.05,.16-.02,.24,0h0c.15,.02,.5-.19,.67-.04l.19,.06c.06-.04,.1-.06,.12-.08-.03,0-.05,0-.08,0-.02-.06,.11-.01,.04-.06l-.1-.03h0c-.06-.05-.21,.05-.27-.04-.03-.06,.14-.07,.22-.1v.02s.21,0,.18-.05c-.03,0-.02-.02-.03-.05,.13,.01,.21,0,.32,0v-.03c.07,.06,.21-.05,.22,.03l.03-.05c.17-.06,.31,.04,.49-.04,.1,.05,.14-.02,.18-.07-.06,0-.09-.05-.1-.06,.03,0,.08,.07,.12,0-.12,0-.15-.08-.29-.08,0,.03-.07,.05-.06,.06-.17,0-.4,.04-.49-.01-.1-.03,.07-.04-.05-.12l-.03,.02s-.09-.05-.03-.06c-.09,.02-.2,.02-.25,0l.02,.06c-.24-.05-.43-.02-.61-.13l.02-.02s-.1,.04-.18,.07c-.03-.02-.06-.04-.12-.04l.04-.06h.02s0-.05,.06-.08c.04,0,.08,.02,.1,.03l-.13,.03c.06,.04,.19-.02,.23-.03-.02-.01-.02-.06-.05-.07,.08,.02,.18,.03,.26,.05l-.04,.03c.06,0,.09-.05,.05-.1-.04-.08-.22,0-.34,0h0s-.14,.02-.24,.03c.04,0,.05,.03,.06,.05-.13,.05-.18,.01-.31-.01l.07-.05c-.06-.06-.15,.03-.22,0,.04,.07,.04,0,.11,.04h0c.08-.02-.01,.04,.05,.06-.07,.05-.14-.02-.21,.05-.07,.01-.22-.03-.32-.05,.03,.06,0,.05,0,.12h-.06c.1,.02,.19,0,.21,.03h-.01s.05,0,.08-.03c0,.03,0,.06,.07,.06l-.05,.05c.13-.03-.02,.13,.17,.08h-.02c.06-.06,.15,0,.24,0h-.02c.15-.04,.26,.01,.45-.05,.14,.05,.28,.1,.41,.1-.02-.06,.13-.01,.07-.06,.08-.03,.04,.04,.12,0-.04,.06,.08,.07,.07,.11h.08c-.15,0,.07-.06-.03-.1-.05,.02-.06,0-.07-.03,.06,.01,.13-.03,.14,.03h-.02s.13,0,.13,.05h-.02s.08,0,.11-.05c.06,.08,.26-.07,.26,.05h-.11c.06,.06-.09,.04-.1,.09l-.03-.05c-.01,.05-.08,.02-.11,.04v-.04h0c-.06,.06-.05-.03-.11,.01,0,.05,.1,0,.11,.04,.01,.03-.08,.03-.08,.06,.04-.03-.2-.04-.1-.06l-.04,.04s-.04,0-.11-.01v.05c-.11-.03-.26,.03-.26,.07-.13-.1-.23,0-.31-.14,.08,.01-.04,.04,.04,.07-.13,.01-.31,0-.43,.04l.04,.04c-.09,0-.17,.03-.21,.04,.18,.01,.35,.05,.38,.02-.01,0,0-.03,0-.04,.05,.07,.27,.01,.24,.11-.11-.05-.26,.12-.3-.02l-.07,.05s-.11,0-.16-.06l.02,.04h-.1s.02-.02,.03-.03l-.13-.06-.08,.05c-.15-.07-.39,.08-.52-.02h.01c-.07,.05-.17,.08-.26,.09,.06-.04,0-.11-.04-.12,.09,.1-.12,0-.17,.03,.02,0,.01,0,.01,.02h-.09c.01-.06,0-.04,0-.09-.06-.01-.15,.02-.22,.04,.04,.03,.13,.06,.03,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M109.73,61.84c-.08-.05,.04-.04,.02-.09-.05,.01-.07,.03-.13,.01,.03,.02,.04,.05,.11,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M107.29,63.72c-.06,.02-.13,0-.15-.02,.05,0,.11,.08,.15,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M109.5,62.07s-.03,0-.04,0l.09,.04s.06-.03,.09-.03l.04,.07-.16,.02,.09,.05-.06,.03s.11-.01,.14,0c-.01,0-.01-.02-.01-.02h.09c-.07,0-.09-.07,.01-.06,0,.03-.04,.04,.03,.05,.02-.03-.05-.08,.03-.07h-.07c-.06-.02,.03-.05,.05-.08-.02,.07,.08,.02,.11,.05-.21-.09,.18-.1,0-.18,.08-.05,.07,.02,.09,.04,.11,.01,.32,0,.5,.01l-.08,.03c.14,.02,.24-.1,.31-.07l.03-.05c-.08-.06-.38-.06-.41-.16l.11,.05c.1-.11,.3,.03,.4-.06,.08-.09-.04,0-.12-.06-.27,.08-.52,.05-.8,.12,.05,.05,.18-.05,.22,.03l-.06,.02c.12-.05,.13,.07,.24,.04,0,.06-.1,.02-.14,0l.07,.04c-.11,.08-.08-.07-.16,.04-.01-.1-.13,.03-.14-.08-.09,.04-.27,.04-.31-.02-.15,.02-.08,.09-.18,.1v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M106.98,63.99c-.09,0-.02-.03-.09-.02,.03,0,.07,.06,.09,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M107.49,63.58c-.06-.03-.03,.04-.06,.06,.05-.01,.07-.03,.06-.06,.07-.03,.06,.04,.13,.02,.06-.05,.02,0,0-.05l-.14-.02,.02,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M106.42,64.41c.07-.01,0,.05,.1,0-.02-.03-.09,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.42,68.39h-.02c.06,.02,.14-.02,.2-.02l-.13-.07s0,.07-.05,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.5,65.43s.08,.04,.09,0c0-.05-.14,0-.16-.05l.12-.02s-.03-.05-.09-.03l-.02,.04-.09-.02s.06,.03,.05,.05c-.04,0-.07-.03-.11-.04-.04,.04-.06,.06-.15,.06,.09-.03,.36,.06,.36,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.79,68.38c-.06-.03-.12,0-.13,.05,.04,.03,.19-.02,.17,.04l.05-.05c.09,.05,.07,.03,.2,.05,0-.06-.18-.04-.24-.08,0-.05-.07-.09,.01-.12l-.07-.02c-.08,.06-.02,.09,0,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M101.66,68.51l.06-.02-.19-.05c-.02,.06,.08,.05,.13,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M102.36,67.87l.1,.02s-.14-.1,0-.12c.03-.01,.06,.01,.08,.02-.04,.02-.13,.05-.04,.06v-.04h.11c-.02-.05-.14-.06-.18-.08-.12,.05,.05,.08-.07,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M109.22,62.59h.02s-.03-.04-.13-.06c-.02,.03,.11,0,.1,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M108.84,62.91l.05-.04h-.14s.07,.03,.09,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "105.35 65.6 105.27 65.59 105.24 65.62 105.35 65.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "103.9 66.74 103.79 66.75 103.88 66.75 103.9 66.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M110.65,61.52s.05,.06,.07,.02c-.05,0-.09-.04-.08-.06l-.06,.07,.07-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M102.2,68.08c.11,.04,.26-.03,.39-.04-.13,.07-.2-.05-.32-.05l-.07,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.23,65.72c.06-.03,.14,0,.15,.03-.02-.07,.08-.04,.13-.05l-.05,.04,.08-.03c-.12-.09-.21-.05-.32,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M102.78,67.87c.06-.03,.21-.04,.19-.09l-.35-.02s.11,.08,.16,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M111.04,61.28c.09-.05,.05,.08,.1,.06-.03-.05,.08-.06,.12-.08-.08,.05-.17-.11-.22,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "110.85 61.61 110.74 61.58 110.77 61.64 110.85 61.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M106.03,65.46s.01,.03,.04,.05l-.05-.03c.13,.01,.27-.03,.41,0l-.02-.09c-.14,.05-.32-.05-.45,.01-.07-.02,.03-.02,0-.05-.07,0-.08,.08-.19,.09h.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M104.79,66.31l.04-.06s-.1-.02-.11,.03l.07,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M109.24,62.89s.05,.03,.13,.01l.06-.06c-.07,0-.17,0-.23,.03l.04,.03h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "103.83 67.08 103.8 67.07 103.77 67.12 103.83 67.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M111.43,61.25s-.04,0-.1,0h.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "105.75 65.67 105.65 65.64 105.74 65.7 105.75 65.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.43,65.85s.08,.01,.11,.05c.03-.02,0-.05,.05-.05,.05-.01-.02-.07-.08-.06,.03,.04-.05,.04-.08,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M109.54,62.75c.08,.01,.04-.04,.06-.06-.04,0-.04,.02-.04,.04l-.08-.02s0,.05,.06,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M103.11,67.77l.17-.02-.18-.03s0,.03,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M104.46,66.66c.11,.04,.23-.04,.36,0v-.05s.15,.06,.2,.06c.05-.04,.01-.07,0-.1-.04,.02-.05,.04-.03,.06-.09,.03-.05-.05-.13-.06-.14,.05-.28,.06-.41,.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "107.22 64.66 107.1 64.65 107.16 64.68 107.22 64.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M109.69,62.74s.01,.02,.01,.02c.02-.01,0-.04,0-.06h.06l-.06-.03s-.07,.05-.02,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M109.45,62.89l.03,.02-.02-.06s0,.03-.02,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M111.08,61.68c.1,0,.08-.05,.17,0l-.02-.04c.08,.04,.06-.04,.12,0-.12,.02,.09,.03,.04,.09,.04-.03,.1-.02,.17-.04-.08,.05,.09,.07,.13,.1-.03-.06,.11,0,.04-.04,.18-.05,.36,.05,.47,.05,0-.03,.05-.02,.01-.05,.13,.1,.42,.05,.52,.04-.05-.05,.04-.03-.03-.07,0,.01,.01,.02-.02,.03-.02-.01-.04-.04-.06-.06l.21-.05s-.05-.02-.05-.05c0,.01,.02,.03,0,.04l-.1-.02s.04,.03,.06,.05c-.08-.06-.22-.09-.36-.1,.01,.03-.06,.02-.09,.03,.07-.05-.07,0-.04-.05,.02,.11-.18,.01-.25,.06-.04-.11-.25-.12-.34-.17h.03c-.1,.05,.04,0,.02,.06h-.07c.03,.09,.15,0,.12,.09-.08,.02-.12-.02-.18-.03,0,0-.02,.02,0,.02l-.06-.04c-.11,.07-.12,.06-.24,.12l-.09-.04,.03,.05-.14,.02v.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M111.58,61.48c-.05-.08-.09,.02-.17-.04,.02,.07,.14,.02,.17,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M106.78,65.17c.01-.05-.06-.05-.13-.06,.03,.04,.1,.05,.13,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M109.5,62.98l.17,.04s-.15-.11-.23-.03l.08,.02v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M102.51,68.42s.12,.02,.08-.04c-.06,0-.04,0-.08,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "108.6 63.74 108.48 63.75 108.56 63.77 108.6 63.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "111.74 61.36 111.65 61.33 111.72 61.36 111.74 61.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M110.12,62.79l.11-.03-.04-.09s.04,.04-.04,.04v-.06l.11-.02-.1-.02h.01s-.15,.05-.17,.11c-.07-.03,.03-.05-.05-.05,.04,.03,0,.13,.17,.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "109.84 62.8 109.89 62.8 109.85 62.76 109.86 62.8 109.84 62.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M107.23,64.99s-.11,0-.1-.05c-.02,.06,.09,.03,.1,.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "106.96 65.11 106.92 65.12 106.93 65.15 106.96 65.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M103.79,67.6c.12,0,.05-.05,.13-.06-.09-.05-.05,.05-.13,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M108.96,63.62s.06-.02,.08-.03c-.07-.03-.04,.02-.08,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M106.98,65.17s.25,.02,.35,0c.09-.04-.1-.05-.07-.07-.05-.02-.17,.04-.14-.02-.11,.01-.07,.04-.14,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M109.54,63.3l-.06-.06v.03s-.05-.02-.06,.01l.12,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M108.91,63.73s.09-.02,.03-.06c.02,.03-.06,.02-.09,.03l.06,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "103.76 67.8 103.67 67.78 103.66 67.8 103.76 67.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M109.69,63.24s-.06,.03-.08,.05c.04-.03,.09,0,.11-.04,.03-.07-.12,0-.13-.07l.1,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M107.44,65.01h-.02l.09-.03h-.21c.02,.05,.1,.02,.14,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.32,66.58s-.04,.04-.03,.07c.03-.08,.11,0,.17,0,.02,.02,0,.04-.03,.06,0-.08-.1,.02-.12-.03-.06,.08,.02-.02,.08,.04l-.07,.04c.06,0,.18,0,.18,.03-.04,0-.07-.02-.05,.02l.07-.03c.02-.06-.17,0-.12-.08,.07-.01,.11,0,.15,.02l-.09-.1c.05-.01,.09-.04,.12-.07l-.26-.02s.06,.03,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M109.36,63.59c.04-.06-.06-.01-.09-.02,0,.02,.06-.02,.09,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M110.59,62.63s.04,0,.07,0v-.07l-.07,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M110.93,62.39c.12-.04,.06,.1,.2,.06v-.06h.18s-.05-.05,0-.05c0,0-.14,0-.23-.02h.02c-.02,.07-.19,0-.17,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M109.46,63.61c-.08-.05,.11-.07,.06-.09-.11,.03-.1,.04-.06,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M103.64,68.2s-.11-.03-.16-.01c0,.06,.13,.01,.16,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M109.89,63.2c.05-.03,.08,.01,.07,.03h-.06l.1,.05c.06-.03-.01-.08,.13-.12-.07-.02-.18,.01-.24,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "106.37 66.03 106.28 65.99 106.26 66.01 106.37 66.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "107.68 65.01 107.64 64.96 107.65 65 107.68 65.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "109.36 63.73 109.35 63.74 109.29 63.71 109.28 63.75 109.36 63.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.66,66.59h-.07s-.03,.02,.04,.06c0-.01,.02-.03,.03-.04,.21,.05-.12,.09,.12,.11l.05-.05s-.06,0-.07-.03c.09,.02,.2-.07,.3-.02-.06-.04,.07-.09-.04-.08l.03,.04c-.05-.12-.29,.03-.37-.05-.04,.02,0,.03,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M109.51,63.6h.06s.07-.06,0-.07c.05,.05-.05,.04-.05,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M106.17,66.22c.14,.09,.38-.04,.53,.02l.06-.06c-.06-.01-.12,.03-.2,0l-.03-.05c-.06,.05-.16,.04-.27,.08,.03-.05-.06-.04-.08-.06l.06,.06h-.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "106.93 65.68 106.84 65.67 106.9 65.7 106.93 65.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M110.89,62.57s-.1,0-.04,.04h.13l-.1-.05h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M107.8,65.01h.01l-.03-.04s0,.03,.02,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "106.08 66.32 106.06 66.31 106.01 66.36 106.08 66.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "111.14 62.53 111.04 62.52 111.1 62.55 111.14 62.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "111.07 62.59 111.01 62.54 110.98 62.57 111.07 62.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M109.99,63.42c-.08-.04,.07-.05-.05-.06,.01,.02,.02,.04,.05,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M104.3,67.93c-.04-.05-.16,.02-.24,.03,.08,0,.18,.02,.24-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M107.97,65.14c-.1,0-.1-.05-.21-.02,.02,.06,.13,.02,.21,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M106.91,65.84c.04,.07,.27,.01,.27,.11l.06-.03c-.08,.03-.05-.03-.07-.06,.03,0,.04,0,.07,.02-.02-.06-.23-.03-.28-.09,.01,.02-.03,.04-.05,.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "111.55 62.42 111.55 62.37 111.53 62.42 111.55 62.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "103.65 68.61 103.64 68.55 103.6 68.6 103.65 68.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M113.15,61.33c.05,.16,.23,.12,.45,.18,0-.05,.05-.02,.09-.02v-.08s-.11,0-.17,0l.04-.04c-.17-.02-.34-.12-.43-.12,.02,.01,0,.04,.02,.06l-.12-.03v.07l.12-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.97,66.81c0,.06-.11,.05-.16,.08,.09,.07,.11-.06,.2-.04-.06-.1,0,0-.06-.1-.05,.03-.02,.04,.02,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M109.2,64.49l-.11-.04c.01,.08-.12,.03-.16,.04,.09,.02,.2,.06,.27,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M106.16,66.72c.06-.03-.07,0-.06-.04,.03,.02-.01,.05,.06,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M106.25,66.72c.1,.03,.07-.05,.14,0l-.06,.05s.05,0,.08,.02c.02-.03,0-.06,.06-.05-.02,.06,.21,0,.24,.08-.03-.05,.08-.05,.12-.05,.03,.04-.02,.03-.06,.05,.06,.01,.08,.01,.18-.03,.02,.06,0,.07,.09,.1v-.07c.14,.01,.11,.09,.21,.09,.06-.03,.21-.06,.19-.09-.03,0-.08-.01-.08-.02,.15-.04,.35,.04,.42,.05h-.05c.11,.04,.29,0,.32,.04,0,.05-.09-.02-.04,.03h.13l.13-.06c-.05-.06-.16,.04-.21-.02l.07-.03s-.06,.02-.08-.01l.04-.03-.08-.04h0c-.14,0,.02-.13-.17-.12h-.02s.06,0,.08,.03c0,.03-.09,.02-.14,0l-.02-.06c-.16,.07-.37,.08-.53,.15-.03-.06-.18-.1-.12-.12-.01-.03,.14-.07,.11-.08h-.12v.03s-.09-.05-.15,0c-.02,.04-.04,.08-.11,.07-.15,.03-.26-.04-.4-.03-.08,.05-.12,.03-.18,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M106.16,66.76h.05l-.03-.04s-.02,.03-.03,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M112.89,61.71l.06-.03,.02,.06,.1-.02c-.05-.06-.17-.02-.18-.07h-.1c.08,0,.02,.07,.09,.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "111.85 62.45 111.75 62.44 111.84 62.48 111.85 62.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M112.52,61.98h-.1c.02,.06,.11,.16,.25,.12v-.02c.08,.05,.22-.02,.26,.07,0-.07,.14-.05,.21-.11,.09,.05-.16,.06-.03,.09l.08-.07c-.06-.01-.13-.04-.13-.07-.01,.07-.12,0-.17,0,.02,.01,.01,.02,.02,.02-.1,.02-.09-.09-.2-.08-.07,.04-.19-.02-.16,.06,0-.02-.06-.04-.09-.05-.02,.02,.05,.02,.06,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M106.76,66.38c.06,0,.18,0,.21-.01-.04,0-.13-.04-.21,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M111.95,62.48c.11,0-.02-.07,.09-.05v.03l.04-.05h-.02c-.07-.03-.26,.04-.11,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M106.35,66.85v.06c.12-.07,.3,.02,.27-.09-.08-.01-.17,.02-.25,.03l.03-.05h-.1s-.02,.08-.08,.05c0,.02,.1,0,.13,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M112.91,61.88s-.14-.08-.21,0c.07,.02,.15,.04,.21,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M110.87,63.39c.09-.04,.15,.04,.2-.03l-.02-.08h.09l-.2-.03s0,.03,0,.04h-.13s.06,.07,.05,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M109.28,64.56s.02,.04,.07,.04l.18-.06s-.02-.06-.08-.05c-.03,0-.06,0-.08,.02,.03,.02,.08,.02,.1,.05-.11,.03-.16-.07-.28,0h.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M107.39,66s.07,.02,.11,.03c-.05,.02-.06-.01-.08,.03,.05,0,.2-.03,.15-.07l-.1-.02,.04-.02s-.09,.05-.17,.06l.05,.02v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M104.21,68.58l-.03,.02h0s.01,.01,.02,.02c.03,.02,.01-.14,.15-.1v.02l.05-.03c-.08,0-.17-.04-.24,.02,.08-.01,0,.03,.04,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M104.05,68.62c.05-.01,.1,.02,.1-.04-.03,.01-.08,.02-.1,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M112.31,62.41s-.04,0-.05,0c0,.1,.1-.02,.15,0-.07-.02-.14-.08-.2-.04l.1,.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "109.13 64.85 109.07 64.81 109.07 64.83 109.13 64.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M109.17,64.79s.02-.02,.09,.02c-.02,.03-.06,.06,0,.08,.12,0,.18-.04,.27,.05,.02,.01-.17-.1,0-.08-.02-.01,.1,0,.1,.02-.06,.03-.01,0-.06,0,0,.04,.12,.02,.13,.07,.06-.02,.02-.09-.03-.09l.06-.02c-.1-.02-.2-.06-.28-.09,.04,.04-.05,.01-.09,.03v-.06s-.09,0-.12-.01c0,.03,.04,.11-.06,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M112.08,62.57h.16c-.05,0-.05-.03-.02-.04h-.16v.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M109.94,64.28c.06,.05,.05-.02,.18,0,0-.02-.07,.01-.11-.01,0-.03,.11,0,.06-.06h-.13c-.05,.03,.06,.04,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M108.47,65.38c.08,.01,.02-.07,.07-.05-.02,.01-.16,.01-.07,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M107.52,66.13c.04,.08,.21,.03,.29-.01-.07-.02-.12-.06-.17-.05,.08,.02-.02,.01,0,.05l-.09-.02s-.02,.03-.03,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M113.24,61.92s-.04,0-.06-.01c.05-.05,.12-.02,.18-.05-.03,0-.18,.02-.27,.02l.15,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "113.4 61.73 113.36 61.71 113.3 61.76 113.4 61.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M112.89,62.27c0-.07,.07,0,.1-.02l-.23-.03,.13,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M108.48,65.63s.04,0,.05-.01l-.08-.02s.02,.02,.03,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.41,68s.16-.01,.11-.02c-.07,.05-.07-.06-.11,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M107.29,66.61s.05-.01,.06-.02c-.03,0-.08-.07-.12,0l.06,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.74,67.88c.1-.05-.1,0-.07-.07,0,.05,.07,.04,.07,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.74,68.06s.03-.14-.1-.1l.08,.13,.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M108.84,65.5s.09,0,.12,.03c0-.04,0-.1,.07-.1v.08c.09-.02-.06-.06,.06-.07-.06-.04-.13,.01-.15-.03l.03,.07h-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M108.05,66.25c-.07,0-.16,.01-.23,.05,.14,.04,.22-.1,.33-.04l-.04-.03h0c-.1,.02-.03-.04-.07-.06,.06,.01,.15,.03,.22,.03,.1,0,0,.07,.09,.07,.02-.04-.05-.1-.06-.1,0,.01,.01,.02,0,.02l-.28-.03s.01,.08,.04,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.59,68.13s.03,.02,.06,0l-.04-.04s-.03,.02-.03,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M113.43,62.33s0-.05,.07-.07c-.15,0-.2,.04-.07,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M111.97,63.5s.09-.07,.11-.01c-.01,.07,.04-.14-.14-.1,.06,.03-.04,.09,.04,.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "107.64 66.94 107.57 66.9 107.64 66.98 107.64 66.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M107.54,67.1s.02,.07,.07,.03c.03-.06-.09-.03-.03-.09,.03,0,.05-.02,.08-.02,0-.06-.15,0-.19-.04l.04-.03c-.15,.07,0,.1,.03,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M109.2,65.81c-.1,.01-.01-.11-.15-.06,.06-.03,.04,.08,.15,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M105.95,68.34s.18-.01,.23-.04c-.05-.03-.02-.09-.15-.08,.03,.02,.07,.02,.06,.04-.05,.02-.17,.05-.16,0-.11,0-.12,.1,.02,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M106.16,68.2l.07,.02v-.05l.23-.04c-.08-.02-.03-.11-.17-.08v.05c-.07,0-.14,.05-.15,0l.09,.11h-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "110.31 65.18 110.25 65.18 110.25 65.22 110.31 65.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M107.78,67.43h-.04l.11,.09h-.02s.31-.03,.4,.03h.13s.01-.04-.01-.09c.04,.03,.11,.07,.16,.06-.01-.03-.1-.06-.03-.09-.13-.04-.16,0-.34-.01,.03,0,.02,.01,.02,.02-.19,0-.2-.11-.41-.06,0,.05,.11,0,.05,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M108.17,67.1s.13-.03,.19-.05c.03,.04,0,.04-.03,.07,.12,.02,.25-.09,.36-.11,0-.02-.04-.03-.05-.03l.02,.02c-.09,.04-.24,.05-.31,.01,.03,.02-.16,.04-.19,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M108.37,67.19c.08,0,.16,.05,.22-.02-.05-.05-.18-.06-.22,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M107.72,67.81v.05l.04-.08-.12,.02s.06,.01,.08,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M108.2,67.74c-.01-.08,.03,0,.09-.07,.03,0,.03,.09,.13,.06-.01-.02,.04-.04,.01-.07,.02,.04-.07,.03-.11,.06,.07-.1-.22-.04-.11-.11h-.06c.03,.07-.06,.1,.06,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M107.81,68s-.04,.09,.06,.1l.17-.05c.02,.06-.12-.16-.25-.04h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M109.46,66.96s.05-.02,.08-.02l-.09-.05s0,.05,.01,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M108.28,67.92c.05,.01,.06,0,.14,0l-.1-.05s0,.03-.03,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M85.67,63.33l-.03,.1c-.07,0,.13,.07,.07,.01v-.07l-.17-.03s-.14,.04-.25,.07v.1l.21,.1c-.09,.03-.18,.04-.27,.02l-.08,.05c.15-.08,0,.04,.12-.01,.03,.03-.02,.03-.06,.03-.05,.09,.11,.03,.18,.05h-.21s-.01,.04,.04,.02l-.11-.02-.05,.05c.13-.02,.19,.06,.32,.04-.12-.07,0,0,0-.05l.13-.04,.1,.05,.18-.02v-.05l.07,.05-.04-.03s.03,.05,.06,.07c0,.02,.01-.07,.13,0v.05h.14s0,.11,.06,.09l-.08,.02,.06,.05h-.15v.07c.03-.11,.03,0,.08-.04-.04,.09,.15,.02,.19,.08,0,.02-.2-.02-.17,.01,.03,.06,.17,.06,.21,.13,.04,0,.06-.02,.08-.04h-.07l.09-.02v-.06c.07,.02,.18-.03,.24,.02l-.02-.08-.13-.02-.06,.05-.1-.04c-.05-.04,0-.08,.02-.11-.15,.08-.03,.01-.07,.02l.1-.07h-.08c-.24-.05-.06,0-.08,0,.07-.1-.03-.11,.07-.19l-.14-.07c.11,0,0-.08,.14-.07l.06,.09-.06,.03h.09l-.02,.07-.07-.03c-.08,.01-.01,.04-.02,.06l.25,.02s.06-.07,0-.08l-.07,.04c.12,0-.04-.11-.07-.16,.26,.06,.56-.06,.85-.06l-.25,.06,.04,.05s-.08,0-.11,.02l.12,.03h-.19v.03h-.13l-.04,.04s0-.07-.06-.06c-.06,.05-.06,.09,0,.14,.03-.01,.15,.02,.11-.04-.1,.05,.03,.06-.02,.09l.14,.06,.15-.03c-.09-.04-.01-.09,0-.14l.1,.05c.08,.03,.31,.02,.39-.06-.05-.08-.27-.12-.41-.05,.08-.04,.03-.06-.02-.07,.05-.01,.16,0,.13-.05l.13,.05,.07-.05,.04,.09c.06,0,.18,.03,.18-.03-.1,.05,.16-.02,.09,.07h.22v.08c-.06,0-.08,.02-.08,.06,.09,.01,.15-.03,.26-.01-.03,.02-.17,.04-.11,.09,.13,0,.13-.09,.23-.03,.03-.04,.14-.03,.17-.07v-.06c.07,.02,.17-.04,.22-.06,.07,0,.05,.08,.14,.08-.17-.03,.04-.04-.05-.08l.09,.04v-.03h.14c0-.09-.12-.03-.18-.03l-.02-.06,.25-.05-.2-.02c.09-.06-.02-.08,.03-.13,.05,0,.13,.07,.16,0v.06c.14-.12,.34-.09,.48-.11l.1,.04c.17-.01,.35-.09,.5-.02l.27-.05,.11,.11-.15,.03,.03,.06h-.1s-.06,.03-.07,.07l.12,.1c.09-.02,.18-.06,.24-.11-.21,.02,.01,0-.09-.01l.31-.04,.04,.07,.07-.04c.08-.01,.23,0,.27,.04l-.03-.04c.07,0,.12,.02,.15-.03l.07,.08c.11-.11,.16,.08,.37,.06,0,.01-.18,0-.16,.03h.01c-.14,.02-.25-.03-.35,0-.18,0-.01,.11-.16,.13,.02-.1-.13-.02-.18-.09l-.06,.05c-.06-.05-.17-.02-.26-.03l.02,.03c-.04-.06-.16-.04-.24-.04l.07,.05c.25,.04,.38,.02,.65,.06,0,.04,.2,.04,.13,.12,.07-.09,.08,0,.14-.02l-.14-.08h.16s.03,.09,.1,.12c-.18,0-.34,.08-.46,.03l-.04,.1c.14-.05,.24,.02,.35,.04l.03-.07s-.02,.07,.11,.08l.02-.05,.1,.1,.04-.04-.03,.09c-.12,.03-.29,.02-.36,.11,.02,.06,.1,.05,.11,.11,.04-.06,.19-.08,.16-.14,.11,.02,.18-.03,.28-.02,.04-.03,.11-.05,.09-.09,.16,.07,.28-.04,.46,0h-.08c.1,.02,.14,.07,.23,.1-.03-.07,.13-.06,.17-.11l.09,.05-.1,.1h-.16l-.05,.17h-.11s.11-.06,.07-.1c-.07-.04-.27,0-.4,.04,.05-.07-.12,0-.08-.05-.09,0-.27-.02-.25,.06l-.07-.03s0,.08,.1,.1c-.09,.03-.18-.03-.27-.04v.05l-.27-.04,.04-.04c-.18-.01-.13,.09-.3,.1l-.05-.03-.06,.05-.1-.03c.04-.11,.13,0,.21-.05-.24,0-.38-.08-.58-.04l-.15,.08c-.1-.03-.18-.07-.24-.04l-.04,.03c.11-.05,.07,.05,.15,.04l-.29,.08-.02,.06c.1,.02-.06-.1,.06-.05,.08-.02,.18,0,.16,0,.02,0-.13,.05-.13,0v.09l.09,.04-.05,.05-.15-.13h-.18l.03-.08,.11,.07,.04-.03c.02-.09-.08-.02-.11-.08h.09l-.03-.05c-.11-.06-.35,.07-.44,.04,.01-.05-.04-.09-.08-.12,.02-.06-.07,.09-.14,.05v-.04l-.18-.02-.09,.05-.09-.11-.07,.02,.03-.06s-.12,.01-.18,.04c0-.04-.08-.07-.02-.1-.05,.05-.07-.03-.14-.05v.07c-.1,.03-.04-.05-.06-.08-.05,.01-.11,.01-.13,0l-.07,.09c-.08-.12-.3,0-.44-.09-.09,.08,.32,.05,.39,.17l-.02-.04c-.09,0,.19-.06,.15,.04-.05-.02-.09-.01-.1,.03l-.13-.02c.05,.07-.12,.06-.06,.14-.11,.06-.23,.08-.36,.12v.08c-.07,0-.15-.06-.18,.01-.14-.04,.07-.08-.01-.15l.21,.04s.02-.13,.09-.16l.18-.04c-.15,0,0-.05-.1-.06-.07,0,.02,.03,.02,.04-.07-.07-.26,.03-.3,0l-.05-.06c.09-.06,.17,0,.26,.01l.08-.04c-.15-.08-.08-.05-.26-.12,0,.03,.02,.06,.02,.08-.19-.04-.21,.15-.39,.12,.07-.02,.08-.05,.07-.08-.02,.06-.18,0-.22,.08,.05,0,.04,0,.06,.04l-.05-.02v.09h-.09l.03-.02s-.11-.04-.18-.03c0-.08-.04-.05-.08-.07v.1l-.14-.02,.03,.05-.02-.03c-.1-.02-.14,.06-.12,.1l-.2-.04s-.03,.04,0,.06h-.22l-.02-.06c-.09,.06-.19,.03-.27,.02l-.02,.06s.07-.02,.1-.03l.02,.03s-.13,.05-.17,0v.02s-.19,0-.2,0v.02s-.09-.03-.25,0h.02l-.25,.06,.07,.02c-.12,.06-.24-.02-.38-.02h.22l.11-.11c.12,.07,.18-.07,.31-.01-.11-.08,.06,0,0-.07l.12,.03s.02-.05-.02-.05c.07,.02,.17,.03,.1,0,.01-.05-.07-.07-.1-.1-.12,.09-.14-.04-.27-.04-.03,.02,.02,.04,.02,.07l-.18,.09-.07-.04-.18,.03,.02,.03h-.14l.04-.04c-.05,0-.11,0-.16,.03l-.03,.11c.06-.02,.1,0,.14,.02-.1-.06-.06,.08-.12,0-.02,.02,.02,.03,.03,.05l-.12-.1-.31,.04h.03c-.07,.01-.06-.02-.07-.04-.08-.03-.04,.09-.1,.03,0-.07,.11-.07,.18-.09l.11-.12c-.11-.07-.14,.03-.24-.03l.14-.03c.01-.05-.07-.04-.12-.05l-.2,.05,.1,.06c-.09-.01-.16-.04-.23-.07l.22-.09,.3,.02,.1-.05v.29l.03-.09,.21,.02,.3-.04,.17-.03,.1-.11,.25-.03,.15,.08,.23,.09,.12-.19,.05,.13,.26-.11,.1,.05,.05-.11-.2-.03,.28-.02-.02-.09-.17-.1-.1-.02v-.23l-.19-.06-.14,.06h-.15l-.05,.09-.26-.14-.18,.07-.06-.18-.1-.09h.42l-.17-.25,.37-.11,.17,.02h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M86.53,69.79l.18-.05-.18,.05Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M283.4,98.25c1.86,.38,3.77,.58,5.73,.58,16.67,0,30.19-14.33,30.19-32.01s-13.52-32.01-30.19-32.01c-13.92,0-25.63,9.98-29.13,23.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M280.43,85.74c2.63,1.36,5.58,2.13,8.7,2.13,10.97,0,19.86-9.43,19.86-21.05s-8.89-21.05-19.86-21.05c-8.13,0-15.12,5.18-18.19,12.6"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "v",
    points: "318.81 61.78 318.97 61.9 308.69 63.17"
  }), /*#__PURE__*/React.createElement("line", {
    className: "v",
    x1: 301.09,
    y1: 37.42,
    x2: 297.09,
    y2: 47.52
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "150.32 243.52 54.26 243.52 35.96 159.83 34.77 154.38 22.36 97.64 118.41 97.64 133.87 168.3 139.83 195.57 150.32 243.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M294.54,145.11h-99.56l-18.97-86.75h97.92c6.87,28.92,13.75,57.83,20.62,86.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M346.98,242.73h-51.24l-9.76-44.64h50.39c3.54,14.88,7.07,29.76,10.61,44.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M290.21,126.91h69.18c-8.05-33.87-16.1-67.73-24.15-101.6h-114.68l7.23,33.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "v",
    x1: 36.27,
    y1: 111.83,
    x2: 56.83,
    y2: 111.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "v",
    x1: 41.35,
    y1: 128.43,
    x2: 61.91,
    y2: 128.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "v",
    x1: 229.67,
    y1: 33.38,
    x2: 255.26,
    y2: 33.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "v",
    x1: 231.83,
    y1: 41.6,
    x2: 244.16,
    y2: 41.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "v",
    x1: 342.73,
    y1: 104.98,
    x2: 334.26,
    y2: 104.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M318.69,25.37l1.71,10.96c.38,2.43,2.66,4.09,5.09,3.71h0c2.43-.38,4.09-2.66,3.71-5.09l-2.5-16.03c-.38-2.43-2.66-4.09-5.09-3.71l-4.4,.69"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "v",
    x: 77.32,
    y: 205.94,
    width: 7.64,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "v",
    x: 90.19,
    y: 216.52,
    width: 7.64,
    height: 20.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "v",
    x: 115.19,
    y: 216.52,
    width: 7.64,
    height: 20.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "v",
    x: 102.14,
    y: 205.94,
    width: 7.64,
    height: 31.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M309.57,117.18c.59-7.96-1.14-13.36-2.79-16.78-3-6.22-5.44-11.18-8.79-18.28-.82-1.74-.41-3.86,1.09-5.07,1.8-1.46,4.45-1.16,5.87,.67l6.62,8.49,3.27-9.02c.88-2.44,2.17-4.71,3.81-6.71l3.31-4.05c1.08-1.32,2.88-1.78,4.46-1.14,1.63,.66,2.62,2.33,2.4,4.08l-.33,2.64,1.48-2.75c1.07-1.99,3.46-2.92,5.55-2.07,2.08,.84,3.17,3.11,2.57,5.25l-.31,1.1,2.24-1.52c.68-.46,1.52-.59,2.3-.36,1.64,.49,2.43,2.34,1.65,3.86l-2.62,5.08c-.77,1.82-1.52,3.73-2.24,5.72-2.35,6.53-3.89,12.71-4.89,18.33-.52,3.9-1.2,8.74-1.72,12.64-7.7,.29-15.24-.37-22.94-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M323.23,87.91c.05-1.55,.23-3.32,.65-5.23,1.06-4.87,3.18-8.54,4.86-10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M330.89,88.94c.2-1.54,.55-3.28,1.15-5.14,1.53-4.75,3.99-8.2,5.88-10.38"
  })), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M261.17,118.06c5.64,21.59,14.13,37.27,18.73,44.68,12.2,19.69,18.33,29.92,30.86,33.45,.19,.05,.38,.1,.56,.15,14.6,3.82,28.72-7.68,28.21-22.77-.67-19.92-1.34-39.83-2.02-59.75-9.66,.78-19.32,1.57-28.99,2.35,.31,10.36,.62,20.73,.93,31.09-5.23-10.45-8.9-18.89-11.35-24.84-1.5-3.65-3.22-6.02-5.32-9.38-3.92-6.28-11.43-9.33-18.63-7.59l-15.08,3.65c.44,2.17,1.12,5.26,2.08,8.94Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "v",
    x1: 296.01,
    y1: 179.51,
    x2: 292.88,
    y2: 156.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M265.59,75.49c-2.36-4.04-6-6.37-9.04-7.36-2.25-.73-4.62-1.01-6.98-.87l-12.7,.77h0c-.28,.02-.55,.05-.83,.09-2.94,.48-4.67,3.27-5.41,4.44-.32,.5-.65,1.15-.96,1.9h0c-.27,.65-.53,1.37-.78,2.16-.49,.99-1.27,2.12-2.48,3.08-1.44,1.13-2.9,1.57-3.76,1.75,.45,.51,1.75,1.95,3.45,3.25,.46,.35,.91,.67,1.32,.94-.15,5.55,1.19,11.28,5.62,14.27,3.15,2.13,6.87,2.19,7.63,2.19,4.74,.01,8.02-2.32,9.03-3.11l9.57-1.63,2.2-.38c3-2.8,5.78-9.86,5.78-9.86,.31-1.29,1.42-6.34-1.66-11.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M244.69,100.43c0,.16-.06,9.29-.06,9.29l19.94,1.66-2.3-15.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M260.19,89.7l-5.59-.34c1.53-1.49,3.06-2.98,4.59-4.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M232.8,86.22c-.33,.54-1.01,1.5-2.21,2.27-1.09,.71-2.13,.95-2.74,1.05"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.91,
    y: 78.2,
    width: 1.88,
    height: 1.88,
    rx: 0.94,
    ry: 0.94,
    transform: "translate(458.42 172.3) rotate(-176.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M236.74,79.73s-3.51-5.25-7.2,.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.82,109.87v-6.91c-8.51,1.05-17.04,2.11-25.56,3.16l3.3,2.74c-.37,1.17-.74,2.34-1.11,3.51,7.79-.83,15.58-1.67,23.37-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.87,68.02c.23,.6,.59,1.44,1.12,2.39,2.55,4.56,6.33,6.83,8.04,7.82,3.37,1.96,5.89,2.33,6.44,2.39,.34,.04,.86,.09,1.5,.12,4.01,.21,5.11-.62,6.68-.06,2.44,.86,3.25,4.09,3.34,4.44,.68,2.82-.54,5.74-2.65,7.37-1.56,1.21-3.24,1.43-4.02,1.48-.47,1.52-1.01,3.64-1.29,6.2-.49,4.38-1.22,11.04,2.26,15.22,4.64,5.56,16.13,5.99,19.55,1.56,2.79-3.62-.44-12.6-6.89-30.54l-.05-.13c-1.94-5.38-2.92-8.16-5.31-11.13-1.65-2.05-4.33-5.49-9.06-7.03-2.25-.73-4.62-1.01-6.98-.87-4.23,.26-8.47,.51-12.7,.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M250.99,109.99l11.22-2.33c17.01,1.57,28.85,20.98,25.92,42.49l7.89,54.49c-28.29-3.55-56.58-7.1-84.87-10.66l-1.61-56.75c.54-28.09,19.42-22.68,41.45-27.25Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.84,
    cy: 109.91,
    r: 16.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.61,
    cy: 122.38,
    r: 16.59
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.54,129.92c-.14-.09-.02-.15-.18-.24l-.14-.03c-.04-.06-.03-.12-.1-.15,0,.02,.02,.06,0,.08l-.05-.07c0,.07-.07-.12-.03,.07l-.04-.09c-.13-.06-.12-.14-.21-.21h-.12l.12,.14,.04,.08,.12,.02c.14,.12,.29,.28,.35,.33-.04-.04-.02-.05-.02-.06,.06,.05,.2,.06,.18,.14,.17,.07,.07-.08,.22,0l-.12-.07-.04,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.57,129.89l.06,.08c-.02-.09-.08-.13-.14-.2l.08,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.49,129.77l-.06-.1s.04,.07,.06,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.97,130.77l.02,.08,.06-.05c-.05-.07-.22-.13-.17-.19-.03,0,0,.04-.03,.05l-.14-.12,.04,.12c.11,.02,.22,.24,.21,.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "279.67 129.77 279.61 129.73 279.59 129.75 279.67 129.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.42,129.74l.08,.06-.03-.06s-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.42,129.74l-.03-.02s.02,.02,.03,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.84,129.95s.02,0,.04,0c-.02-.01-.03-.02-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.35,130.25c.06-.04,.06,.03,.06-.06h.02c-.06-.05,.02-.09-.13-.12l.03,.04s-.09-.02-.15-.04v-.07s-.02,.03-.07,0l-.08-.09s-.03,0-.04,0c.01,.02,.04,.05,0,.05,0,0-.01,0-.01-.01,0,.02-.04,0-.08,0,.05,.03,.14,.12,.17,.17,.04,.08-.16,.02-.05,.11,.12-.01,.03-.02,.11-.07,.02,.03,.01,.04,.05,.07l-.04-.06c.09,.02,.08,0,.18,.06,0-.03-.07-.07-.06-.09,.05,.01,.09,.06,.1,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.96,129.96s0-.02-.02-.03c0,.02,.02,.03,.02,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.47,130.24l-.05-.03s.03,.02,.05,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.5,129.59s-.04,.03-.07,.03l.1,.06-.02-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.6,130.25s.03,.06,.1,.06c0-.07,.11-.02,.07-.11l-.08-.04c.08,0,0-.1-.06-.15-.04,.02-.02,.07-.09,.05l-.02-.03c.06,.14,.17,.05,.2,.2-.09-.04-.04,.05-.12,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.74,129.6h-.06l-.03-.06c-.1,.07,.24,.18,.11,.23,.03,0,.03-.02,.05,0-.06-.08,.22-.02,.02-.19l.02,.08-.06,.03v-.04l-.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.84,129.79s-.02-.03-.03-.03c0,0,.02,.02,.03,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.93,130.12l.03,.05v-.07s-.05,0-.03,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.03,129.7h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.94,129.66c.07,.08,.03,.13,.12,.21-.04-.06,0-.08-.04-.18-.03-.04-.07-.06-.09-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.31,129.83c-.03-.07-.19-.05-.27-.18v.03s.05,.04,.07,.05c.04,.05,0,.07,0,.06l.12,.09-.05,.06-.07-.08,.03,.09s.09,.01,.1,.08c0,.07-.1-.08-.12-.02,.03-.02,.15,.06,.17,.14v-.06l.14,.13c-.09-.11,.08-.02-.02-.14,.01,.03-.01,.03-.01,.06-.04-.03-.04-.06-.08-.08l-.04,.03c-.07-.08,.07-.07-.01-.13,.08,.06,.13-.03,.22,.11,.06,0,0-.07,0-.11-.04-.01-.04,.03-.08,0,.05-.05-.05-.06-.08-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.11,129.79h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "277.58 129.77 277.68 129.94 277.7 129.77 277.58 129.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "280.51 130.32 280.55 130.34 280.58 130.3 280.51 130.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "280.85 130.37 280.82 130.37 280.9 130.4 280.85 130.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.86,130.18c.08,.05,.16,.09,.23,.14l-.14-.14c-.06-.02-.1-.03-.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.36,130.54s-.01-.05-.03-.08c-.08-.04-.17-.09-.25-.14l.15,.14s.13,.03,.13,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.95,130.18c.1,.03,.25,.09,.29,.09-.15-.08-.34-.26-.42-.35l-.04,.03c-.07-.06-.15-.13-.21-.14l.38,.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "277.44 130.66 277.4 130.65 277.43 130.67 277.44 130.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.4,130.65l-.07-.07s.01,.03,0,.01l.03,.04h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.47,130.08h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.6,130.05c-.07-.14-.09-.03-.1-.16l-.04,.16s.02,.03,.01,.03c.07,.03,.1,.02,.12-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.11,130.84c.12,.08,.17,.06,.24,.09,0,0-.12-.14-.12-.14l.09-.07-.2-.1s.05-.05,0-.09c0,.01-.07-.02-.08-.01l-.12-.1c.04,.06,.1,.14,.11,.19l-.04-.02,.08,.12s.05,0,.09,.02c0,.02-.08,.06,.02,.08,.03,.08-.11-.04-.08,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.56,130.52l-.1-.1c-.07-.02,0,.08-.1,0l.08,.06s0-.02,.01-.02l.12,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.02,130.71s-.06-.08-.11-.1c.04,.03,.08,.07,.11,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.91,130.61s-.02-.02-.03-.03v.02s.02,0,.03,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.88,130.58v-.05s-.02,.03,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.86,130.29s.05,.04,.05,.06c-.04-.08,.11,.02,0-.06-.03,0-.04,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.61,131.89s-.07,.02-.1-.03c-.05,.02-.02,.07-.04,.1,.07-.01,.11,.01,.15,.05,.02-.03-.05-.11,0-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.59,131.77l-.07-.04s.02,.04,.04,.04c-.12,.04-.05-.13-.21-.1,.16,.05-.01,.16,.16,.19,.11,.02,.01-.08,.08-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.02,131.58s-.04-.02-.05-.03c.02,.02,.04,.03,.05,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.37,131.93l.03-.03s-.07-.07-.1-.04c0,.01,.05,.05,.03,.06-.05-.03-.06-.06-.08-.1-.03,0-.02,.01-.03,.02,0-.03-.03-.1-.04-.14,.01-.13-.32-.2-.23-.3-.16-.02-.29-.11-.43-.21-.13-.09-.27-.18-.41-.23-.03-.09,0-.08-.12-.19-.14-.09-.38-.27-.47-.28-.13-.09,0-.13-.13-.25,.04,.05,0,.11,.02,.15-.07-.01-.02-.08-.06-.09-.06,.02-.07,.07,.04,.16h0c.13,.03,.3,.18,.38,.2,.09,.1-.07,0-.02,.09,.17,.12,.26,.21,.39,.33-.02,.06-.1-.07-.1-.06,.07,.11-.02,.15,.05,.25,.07-.06,.19,.14,.21,.17l-.09-.07s-.01,.03-.02,.03c-.09-.01-.11-.15-.19-.12,.02,.04-.15,.08,0,.22,.01-.02,.06,0,.08,.02,.02,.03,0,.06-.04,.06,.06,.03,.14,.05,.17,.14l-.03,.02,.23,.2h-.09s.04,.04,.05,.07l.11,.05-.04-.07c.05,0,.1,.01,.15,.02-.05,.05,.12,.14,.16,.21l-.02-.03,.1,.05c-.08-.07-.13-.16-.21-.26-.08-.07-.13-.02-.19-.13,.15,.07-.02-.04,.09-.01,.03,.01,.05,.04,.07,.06,.02-.01,.05-.05-.03-.1-.04,0-.11-.07-.14-.1,.08,.05,.04-.02,.1,.01-.02-.03-.05-.05-.06-.08,.04,.04,.02,.06-.01,.07-.05-.1-.08,.07-.16-.08l.08-.02-.03-.03s.13,.04,.1-.01c.06,.03,.05,.07,.08,.09l.02-.03,.05,.05-.07-.12c.18,.13,.05-.1,.22,.06,.02,.07-.06,.05-.06,.12,.02-.06,.18,.06,.27,.14h-.04c.05,.04,.1,.08,.16,.11l.03-.06c-.04-.07-.12-.02-.14-.11,.02,.01,.13,.03,.17,.05l-.04-.07,.19,.15c0-.06,.11,.04,.16,.06-.03-.02-.05-.04-.06-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.2,132.32c-.07-.08-.15-.13-.27-.18,.03-.06,.15,.05,.19,.04,.02,.03,.05,.05,.1,.07v-.05c-.15,0-.28-.25-.4-.19,0,.05,.12,.08,.08,.11-.08,0-.18-.09-.26-.1,.03,.03,.05,.07,.07,.1-.08-.06-.2-.06-.27-.11,.01,.02-.04,0-.05,0,.08,.12,.3,.19,.41,.3,.07-.09,.25,.09,.32,0h-.02c-.02-.08,.07-.01,.12-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.36,132.03v-.02h-.02l.02,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.57,131.91h0s-.01,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.12,131.88l.02,.03s0-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.6,132.03s.02,0,.03,0h0s0,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "279.43 132.02 279.43 132.02 279.43 132.02 279.43 132.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.16,131.36h.02s0,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.41,131.89h-.01s0,.01,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.9,130.33l.07,.12,.2,.09c-.04-.06-.24-.16-.27-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.18,130.62l.09,.04-.05,.03s.06,0,.1,0c0-.02-.08-.1-.14-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.17,130.88l.08-.02c.05,.03,.04,.06,.07,.08,.11-.03-.11-.09-.05-.13h-.07c.02-.17-.15-.16-.23-.24h0c.09,.11,.05,.2,.21,.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.92,130.51s.02,.04,.04,.06c.01-.01-.03-.04-.04-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.86,130.5l.09,.08h0s-.05-.05-.09-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.52,130.74s.07,.04,.11,.06v-.06s-.08-.02-.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.4,130.78c-.04-.05-.08-.04-.14-.05l.14,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.63,130.85s-.03,0-.02,.02c.01,0,.02,0,.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.52,130.94c.1,.06,.03-.11,.16,0-.01-.02-.06-.04-.07-.06-.04,.01-.11,0-.14,0-.03,0,.11,.05,.04,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.58,130.82s.01,.04,.02,.05c0-.02,.01-.03-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.6,130.87s-.01,.02,0,.04l-.11-.06c.06,.03,.11,.09,.19,.11,0-.07-.04-.04-.07-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.36,131.28s0-.02-.01-.03c0,0,0,.02,.01,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.02,131.5v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.86,131.59s-.04,0-.05-.02c0,.01,.02,.02,.05,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.65,130.87h-.08s.14,.03,.24,.07c.11,.05,.22,.12,.27,.15h0c.11,.03,.21,.1,.25,.16,.01-.01,.04-.02,.06-.03,.04,.03,.17,.07,.21,.11-.01,.1-.26-.13-.3,0,.04,.01,.12,.09,.19,.12l-.06-.09c.08,.02,.16,.09,.15,.14l.03-.04c.09,.02,.13,.08,.17,.11,0-.01,0-.03-.01-.04h.09s.04,.1,.09,.12c.07,0,0-.08,.06-.1l.09,.03s-.09-.03-.09-.08l-.02,.04c-.04-.08-.11,0-.13-.08l-.1,.03c-.02-.05,.09-.07,.09-.13-.06-.02-.16-.04-.17-.07-.07-.03,.06,.05-.01,.05-.19-.09-.13-.24-.35-.26h0c-.21-.02-.14-.15-.37-.15,0,.02,0,.04-.02,.04-.07-.08-.19-.1-.32-.15l.03,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.59,130.8s0,0,0,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.7,130.82c.02,.09-.07-.04-.12-.06,0,.01,.01,.02,.02,.03l.09,.1s.06-.02,.02-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.58,130.85s.02-.02,.01-.05c0,.02-.09-.05-.01,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.45,131.23h.05l-.15-.15s-.08,.12,.1,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.34,130.99v.1c.12,0,.14,.08,.25,.11,.02-.01-.03-.09-.13-.12l.05-.02c-.13-.02-.08-.08-.18-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.61,130.97l-.03,.05,.12,.03s-.08-.06-.09-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.7,131.05s.03,.01,.05,.01h-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.08,131.79h0l-.11-.03s.08,.05,.1,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.28,131.5l-.02-.06c.15,.01,.02,.07,.14,.14,.02,.01-.03-.08,.07-.04,.11,.04,0,.05,.06,.08v-.03s.03,.02,.04,.04l.03-.06c.13,.08,.23,.09,.3,.2,.08,0-.11-.1,.01-.08,0,.02,.03,.05,.06,.08,0-.03,.04-.04,.08-.04-.13,0-.13-.16-.25-.1,0-.02,.02-.05-.01-.08l-.07,.02s-.15-.08-.21-.1c.03,0,.19,.05,.09-.03-.07-.04-.07,.02-.14-.03v-.05c-.08-.1-.15,0-.18-.12-.14-.06-.27-.14-.32-.08l.02,.04s0-.03,.03-.03c.08,.03,.06,.08,.08,.11-.05-.04-.08-.03-.14-.06,.23,.16,.13,.16,.33,.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "279.98 131.76 279.97 131.76 279.97 131.76 279.98 131.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.13,131.12s.06,.05,.07,.07l-.04-.1s0,.03-.03,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.73,131.21s-.04,0-.06,.02c.06,.03,.12,.06,.18,.09,.04-.04-.09-.05-.12-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "282.1 131.18 282.17 131.2 282.13 131.17 282.1 131.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.05,131.32l-.14-.08c.12,.07,.04,.15,.02,.2l.23,.13s.06-.04-.03-.1l.03,.05c-.06-.04-.13-.03-.19-.1,.03-.04-.02-.14,.08-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.96,131.2s-.08-.08-.06-.1c-.02,.06,0,.03,.06,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.45,130.83c.06,.06,.01,.12,.12,.21l-.1-.02,.13,.12c-.08-.09,.04-.02,.06-.04h.07s.04-.05,.04-.11c-.02,0-.15-.09-.09,0-.03-.03-.09-.08-.11-.12l.02,.11-.14-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.57,130.86v-.04s0,.03,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.77,131.38s-.02-.1-.07-.07c.08,.03-.02,.06,.07,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.68,131.24s-.02,0-.03-.02c0,0,.02,.01,.03,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.69,131.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.94,131.33c-.1-.05-.07,0-.12,0v-.06s-.1-.02-.13-.03c.02,.01,.05,.03,.04,.05,.18,.03,0,.09,.16,.16-.14-.1,.1-.04,.05-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.66,131.53c-.11-.11-.33-.07-.41-.22-.16-.08-.11,.04-.08,.09,.06,0,.19,.07,.18,.02,.14,.1,.01,.1,.13,.19v-.08l.14,.04c-.08-.06,.01-.04,.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.88,131.55l-.07-.12s-.13-.05-.05,.04c.05-.02,.06,.05,.12,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.13,130.82s.12,.07,.14,.14c0-.05-.11-.18-.14-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.14,131.44s0-.08-.07-.05c0,.02,.03,.03,.07,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.09,130.92s0,.03,0,.05c0-.01,0-.03,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.2,131.07c.06,0-.03-.07-.06-.13l.09,.03c.01-.06-.09-.06-.12-.12-.03-.01-.02,.03-.02,.08,0,0,.02-.01,.03-.01l.07,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.05,130.99l.06,.13s.09,0,.13,.06c.05-.01-.1-.14-.14-.21,0,.02-.01,.04-.05,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.26,131.3c-.1-.02-.02-.04-.07-.08,0,.02,.02,.05-.03,.05,.02,.04,.06,.03,.1,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "276.75 131.11 276.93 131.31 276.81 131.12 276.75 131.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.17,131.39s-.13-.04-.14-.06c.02,.09-.08,.03,.01,.11,0-.02,.14,0,.12-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.02,131.49h.01l-.09-.08c-.05,.02,.05,.05,.07,.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "281.78 131.59 281.92 131.7 281.88 131.63 281.78 131.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.46,131.74l-.09-.12-.04,.03c-.07-.09-.23-.25-.22-.24h0l-.15-.14c.03,.15,.3,.3,.39,.46l.06,.04s-.03-.08,.05-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "277.26 131.88 277.25 131.88 277.25 131.89 277.26 131.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.39,131.88l-.18-.11,.07,.05-.03,.06c.07,.03,.13,.05,.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.19,131.71c-.05-.02-.13-.1-.09-.02-.03-.05-.17-.1-.16-.15-.03-.06-.11-.1-.16-.17l-.04,.03c-.09-.08-.15-.09-.25-.2l.02,.08c-.05,0-.11-.08-.15-.15l.02,.08h0s.03,.02,.03,.04c-.06,.06-.1-.14-.18-.09,.04,.06,.12,.14,.18,.21,.07,.07,.13,.11,.13,.13,.12,.1,.36,.28,.37,.24v-.05l.1,.09s-.03-.06,0-.06c.06,0,.11,.11,.08,.13,.07,.04,.14,.16,.2,.14l-.08-.13h.03c-.06-.05-.12-.16-.06-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.03,131.84s.06,.02,.07,.02c-.02-.01-.05-.02-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.94,131.52s0,.01,0,.02h0v-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "282.43 131.64 282.42 131.6 282.36 131.63 282.43 131.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.26,131.81s.06-.03,.1-.05c-.02,0-.05-.01-.07-.03,0,.03-.15-.02-.04,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.28,131.71s0,.02,.01,.02c0,0,0-.01-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.76,131.59s.02,.02,.02,.04c0-.01,.02-.03-.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.78,131.65v-.02s0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.88,131.26l-.16-.16s.01,.08-.02,.07c.06,0,.17,.13,.18,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.1,131.35s0,.03,.01,.05v-.05h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.26,131.47c-.05-.08-.23-.23-.24-.19l.08,.06h0c.08,.01,.04,.11,.16,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.02,131.34s.03,.1,.04,.14c.06,.03,.06-.03,.05-.08h0l-.09-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.75,131.23l.08,.11c.07,0-.05-.1-.08-.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "284.18 131.48 284.21 131.51 284.27 131.5 284.18 131.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.34,131.51s.05,.07,.08,.11h.05s.11,.07,.17,.11c-.09-.09-.13-.16-.16-.22-.02,0,0,.04-.02,.04-.12-.08-.04,.03-.13-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.89,131.91s-.02-.09-.1-.11l.05-.05c-.11-.04-.09-.02-.19-.05,.06,.06,.11,.12,.15,.19h0l.09,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.89,132.03s-.06-.09-.09-.13c.02,.03,.05,.1,.09,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.14,132.34c-.08-.12-.08-.17-.18-.3-.02,.02-.05,0-.07-.01,.05,.08,.09,.15,.15,.23-.04,0-.1-.08-.1-.11-.04,0,.07,.08,0,.06-.08-.06-.07-.08-.08-.12l-.03,.04c-.11-.09,.05-.05-.09-.15l-.02,.06c-.05-.06-.17-.13-.2-.17-.06-.04-.17-.15-.26-.25,0,0,0,0,0,.01-.15-.18-.13,.02-.28-.19,.01,.03,.03,.06,.09,.1l-.03,.02s.07,.03,.07,0c.12,.16,.27,.27,.4,.34,.15,.13-.01,.17,.19,.26,.22,.14,.4,.36,.53,.43h0c.09,.02,.18,.14,.25,.19v.06l.2,.08-.07-.08h.08c-.26-.12-.33-.39-.56-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.52,131.85h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.21,131.56s.04,.04,.05,.06c0-.02-.03-.04-.05-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.21,131.56s-.03-.03-.04-.04c0,.02,.02,.03,.04,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.73,131.93l.05,.04v-.06c-.06,0-.11-.01-.15-.04-.04-.03-.07-.07-.1-.09,.02,.03,0,.04-.05,.05l-.03-.04s-.07,.03-.02,.06l.08-.02s.03,.11,.06,.13l-.02-.07c.06,.01,.11,.04,.09,.07l.08-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "284 131.75 284.04 131.71 283.93 131.7 284 131.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "279.13 132.15 279.2 132.19 279.12 132.11 279.13 132.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.99,132.75s0-.02,0-.03c-.01,0-.03,0,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.51,133c.1-.08,.3,.17,.47,.16-.34-.15-.4-.32-.73-.44l.1-.02c-.14-.02-.1-.2-.31-.2-.13-.02-.31-.12-.36-.18l-.05,.02c-.1-.1-.18-.08-.28-.08l-.02-.06c-.08,0,0,.05-.04,.06,.13,.02,.21,.14,.33,.19-.07,.06-.18-.11-.24-.04,.11,.08,.28,.11,.34,.23,.04,0-.1-.09,0-.11,.04,.12,.22,.1,.25,.18,.02,0,.03,0,0-.04,.11,.08,.17,.03,.28,.1-.05,.06,.17,.15,.24,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.38,132.11c.07,.05,.06,.06,.1,.03-.06-.06-.09-.06-.1-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.96,132.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.96,132.22s0,.02,0,.02c0,0,0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.63,133.08s.2,.07-.12-.14l-.02-.05s-.09,0-.14-.02c.1-.09-.26-.15-.28-.27v.04c-.19-.22-.05-.16-.19-.35,.05,.03,.08,0,.08-.03,0,.02-.03,.02-.06,0-.06-.19-.33-.11-.39-.28-.04,0-.09-.02-.03,.04,.03,0,.16,.12,.24,.15,0,.04-.01,.07,.08,.11-.05,.03-.07,.01-.03,.1,.03,0,.03-.02,.04-.03,.16,.12,.08,.13,.12,.21-.03,0-.16-.1-.12-.02-.12-.05-.05-.14-.12-.15-.1,.04-.33-.22-.48-.22,0,.04-.03,.04-.03,.07,.07,.05,.11,.01,.15,0,.07,.15,.32,.22,.48,.37l.04-.07c.07,.07,.13,.18,.07,.19-.06,0-.13-.07-.14-.11,.02,.03-.05,.08,.05,.14,.03,0,.06,.01,.11,.04l-.02,.03c.1,.09,.09,0,.18,.05l-.03-.07s.09,.05,.09,.07l.02-.03c.06,.03,.11,.13,.15,.12,.03-.14-.27-.15-.29-.29,0-.01-.01-.04,.02-.03,.05,.02,.1,.09,.07,.1,.03-.02,.06-.05,.13,0l-.04,.04s.13,.06,.12,.1v-.02c.16,.09,0,.09,.1,.16-.03-.03-.02-.05-.02-.06l.18,.11,.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.91,132.19h-.08s.07,.05,.07,.07v-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.05,132.32s.08,0,.02-.06c.02,.02-.03,.01-.05,.03l.03,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.25,134.3c.06,.1,.28,.07,.29,.12,.17,.01,.16,.07,.4,.07,.02-.02,0-.08,.11-.03,0,.07,.23-.01,.23,.11,0-.07,.21,.03,.27-.02,.11,.01,.11,.1,.22,.09l-.02-.02c.09,.05,.2,.08,.31,.11,.11,.02,.21,.03,.29,.07-.03,0-.05-.05-.05-.07l.15,.02-.07,.03c.07-.02,.14,0,.21,.01-.04-.01-.06-.06-.07-.08,.02-.02,.07-.01,.11,0-.06-.02-.15-.05-.17-.04l-.03,.03s-.09-.02-.12-.04v.02c-.14,.03-.2-.09-.22-.13,.1,.09,.29-.06,.31,.07,.08,.01,.11-.03,.09-.05-.01,0-.02-.04-.05-.02,.04,.01,.04,.04,.03,.05-.18,0-.03-.1-.22-.09-.02,.07-.19-.03-.26,0,.1,0,.07,.07,.11,.11-.14-.09-.08,.05-.21,0-.09-.04-.09-.11-.02-.1-.12,0-.19-.08-.21-.12,.07,.06,.24,.04,.21,0-.04,0-.08,0-.06,.02-.05-.09-.34-.11-.33-.17v.03c-.18-.08-.19,.02-.39-.08,.02,.03-.03,.07-.12,.02l.04-.03h-.02c-.09-.12-.27-.02-.32-.09-.05-.03,.1,.06-.02,.04-.01-.01-.12-.08-.16-.05-.14-.05-.24-.14-.33-.24,.08,.06,.22,.06,.18,.13,.09,0,.14-.03,.2,0,.08-.04-.03-.12-.05-.17,.06,.03,.14,.11,.19,.08l-.17-.09c.25,0,.3,.05,.51,.12-.1-.04,.02-.08-.12-.13,.05,.03,0,.05,0,.08-.04-.09-.13-.11-.22-.17,.03,.03,.04,.07-.05,.06-.18,0-.37-.12-.5-.18l-.03,.06s-.08-.03-.11-.04c.12-.01,.02-.08-.05-.15,0,.02,.01,.05,0,.07-.11-.06-.08-.04-.18-.08v.04c-.06-.06-.22-.12-.32-.14l-.03-.07s-.02,.03-.04,.02c0,0,.01,0,.02,0,.02,.07,.13,.15,.12,.21-.1-.04-.19-.1-.25-.15-.08-.03,.04,.04,0,.06-.04,0-.06-.04-.08-.06,0,.02,.05,.07,.02,.09-.23-.09-.22-.19-.36-.3,.07,.07-.07,0-.1,.02,.06,.02,.13,.08,.08,.09-.04,0-.09-.04-.12-.06,0,0,0,.01,0,.02-.08-.08-.06-.04-.15-.11h-.17l.03-.02-.16-.08s.07-.06-.06-.11v.06l-.11-.05,.05-.04c-.08-.05-.1-.05-.11-.01-.04-.04-.08-.09-.14-.14-.05-.05-.11-.1-.2-.13,.03,.03,0,.02,0,.05l-.19-.13h.06l-.12-.03v-.05s-.02,.02-.03,.04c-.04-.01-.09-.05-.1-.09v.03c-.1-.05-.04,.03-.18-.02,.04,.02,.06,.05,.07,.08,.16,.11,.28,.25,.5,.3h-.06s.02,.03,.02,.04c.04,.06-.08-.03-.01,.04,.05,.02,.07,.04,.05,.06,.04,0,.08,0,.12,0-.08,0-.09-.05-.14-.1,.03,.01,.08-.03,.16,.05,.08,.09,.03,.1-.04,.09-.07,0-.16-.03-.16,.02,.04,.01,.06,.04,.04,.05-.11-.08-.02,0-.1,0-.15-.09,.11-.06-.09-.16-.12-.09-.19,.16-.3-.08l-.18-.1c-.07-.04-.05-.1-.12-.14-.02,.07-.21-.05-.21-.1v.05c-.05-.07-.12-.05-.14-.13,0,.01,.03,.06-.04,.04,.04,.02,.07,.05,.09,.09-.14-.08-.29-.05-.41-.13,.1,.05,.08,.17,.21,.2,.02,.03-.03-.06,.03-.03l.15,.17c-.04-.08,.15,.05,.06-.03,0,.04-.07-.04-.1-.05l.05-.05c.1,.04,.12,.15,.19,.23l-.07-.02c.16,.06,.34,.2,.49,.3l-.06-.1s.06,.03,.13,.06v.1c.18,.01,.26,.08,.34,.16,.08,.07,.14,.14,.25,.16-.02,0-.02-.01-.03-.02,.18,.04,.07,.08,.24,.14,.1,.02,.06-.06,.03-.07,.17-.01,.06,.08,.24,.11,.04,.06,.02,.11,.08,.14h.04c.15,.06,0,.02,.08,.1,.23,.06,.36,0,.65,.18l-.07,.03c.07-.04,.09,.08,.17,.06-.05,0-.03,.05,.02,.07-.1-.09,.1,0,.08-.05,.03-.04-.13-.05-.15-.09l.13,.02c-.11-.08-.13-.05-.26-.14,.15-.04,.18,.02,.38,.01l-.09-.09h.09c-.09-.01-.14-.12-.05-.11,.05,.07,.1,.09,.22,.12v-.07s-.02,0,0,.01c-.1-.02-.08-.07-.11-.1,.11,.02,.2,.1,.22,.16-.02-.03-.05-.1,.01-.08,.07,.02,.2,.09,.16,.13-.14-.06-.09,0-.18,.01,.13,.05,.12,.11,.19,.17-.04,.02-.09,.04-.13,.05,.05,.03,.09-.05,.22,.03,.02,.02-.06,.04,0,.11v-.04c.13,.06,.23,.03,.29,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.61,134.72l.04,.02s-.02,0-.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.65,133.18s.01,.01,.02,.02c0,0,0-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.31,132.38s0-.05-.02-.07c-.03,0-.17-.11-.1,0l.08,.03,.02,.06s0-.02,.01-.02h.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "279.18 132.49 279.17 132.48 279.17 132.48 279.18 132.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.61,134.71h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.28,132.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.97,133.9s.04,.01,.07,.02c-.03,0-.05-.01-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.84,133.36s.02,.05,.05,.08c-.02-.04-.05-.08-.05-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.29,134.67l-.02-.03s0,.02,.02,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.11,133.21h0c-.06-.08-.15,0-.06,.04,.08,.02,.07-.03,.12,.01-.01-.01-.04-.02-.05-.03,.04-.03,.12,.04,.19,.05-.06-.02-.15-.12-.21-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.32,133.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.55,133.62s.06,.05,.09,.07c-.03-.03-.08-.06-.09-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.05,132.33l.07,.02-.1-.08s.03,.04,.03,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.42,132.08s.03,.04,.04,.05c-.02-.1,0-.02-.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.42,132.08l-.03-.04s.02,.03,.03,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.88,131.58s.03,.04,.04,.06l.09-.05c-.08-.05-.04,.03-.12-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.07,132.3s-.01,.04,0,.06c0-.01,.01-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.01,132.15h-.05c.08,.04,.11,.1,.11,.15,.01-.04,.02-.08-.06-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.96,132.35s-.1-.02-.16-.04c-.07-.03-.11-.04-.04,.07,.07,0,.07,.02,.03-.06l.2,.11-.03-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.74,131.68v.05s.06-.03,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.74,132.07c.08,.01,.05-.06,0-.07,.02,.03-.03,0-.04,.02l.05,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.85,132.08s.11-.02,.04-.08c.07,.07-.19-.02-.04,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.28,131.77s-.04,.03-.06,.04l.23,.05s-.17-.02-.17-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.29,132.11s.16,.05,.19,.07c0-.06-.09-.04-.09-.06-.02,.01-.09-.03-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.4,132.11h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.98,131.9c-.03,.06-.02,.19,.15,.17l.02,.04-.16-.03c.07,.1,.29-.02,.22,.09,.08,.03,.24,.06,.26,.01-.13,0-.03-.06-.11-.1,0-.02,.02,.03-.03,.02-.21-.04,.04-.12-.15-.17-.04,.08-.17-.07-.21-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.26,132.8l.02-.03s-.12-.11-.23-.18c-.1-.08-.22-.16-.31-.19h0l.17,.13,.11,.16,.17,.04,.07,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.56,132.56l.07,.05c-.09-.1-.1-.06-.21-.13l.12,.1-.05,.03c.11,.04,.03-.04,.06-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.23,132.9s.02-.02,.07-.02l-.12-.1s0,.06-.05,.02l.02,.06s0-.02,.01-.02c.04,.01,.05,.05,.07,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.15,132.88v-.02s0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.6,132.17s-.06,.03-.09,.04l.02,.07,.06-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286,131.82c-.03-.07-.17,0-.13-.08l-.04,.08s.09,.03,.14,.02c.03,0-.09-.02-.04-.06,.03,0,.04,.02,.06,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.57,131.88c.08,0,.15,.09,.21,.03-.07-.02-.14-.09-.21-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "281.93 132.8 281.88 132.8 282.02 132.87 281.93 132.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.47,132.96s.01,.01,.02,.02c0,0,0-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.44,133.02c.07,.03,.09-.04,.12,.03,.02-.03-.04-.05-.07-.08,0,.02-.03,.03-.04,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "280.44 132.96 280.45 132.95 280.44 132.94 280.44 132.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.46,132.93h-.01l.02,.02s0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284,132.54l.02,.08s.22,0,.09-.08c-.05-.01,.09,.06-.01,.06l-.1-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.63,132.12s-.07-.03-.1-.06c.01,.01,.03,.03,.04,.05h-.12s.16,.04,.17,.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "286.04 131.87 286.12 131.9 286.04 131.86 286.04 131.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.58,133.1s.11,.01,.16,.01c-.05,.01-.16-.08-.16-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.93,133.09s0,.01,0,.02c0,0,0,0,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.93,133.11s-.06-.03-.11-.05l.02-.05h-.06s-.08,.02-.03,.13c.05,0,.11-.03,.16,.04-.13-.03,0,.06-.04,.07,.19,.05,.06-.08,.05-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.98,133h0c-.09,0-.09-.09-.16-.12-.11,0,.06,.11,.07,.13l.11,.04-.02,.03h.08s-.07-.05-.08-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.64,132.48c-.11,0-.03,.05-.16,.03,.09,.07,.11-.03,.16-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.78,132.13s-.02,.06,.06,.08c.01,0,0-.07-.06-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.47,133.14l.04-.04-.08-.03v.03s-.02,0-.03,0l.08,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.68,132.18c-.06,.04,.09,.1,.11,.11h.12c-.08-.04-.24-.03-.22-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.99,133.28v-.06s-.01,.01-.03,.03l.03,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "286.38 131.93 286.43 131.9 286.33 131.9 286.38 131.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "282.53 133.07 282.55 133.11 282.59 133.14 282.53 133.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.14,133.23s-.08-.05-.12-.08l.06,.07s.04,.01,.06,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "278.71 133.21 278.67 133.22 278.77 133.25 278.71 133.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.96,132.17c-.09,.02,0,.06,0,.11,.04-.03-.07-.04,.03-.06l.04,.03c.06-.04-.09-.03-.08-.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "284.82 132.67 284.83 132.67 284.74 132.64 284.82 132.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.36,133.4c.08,.02-.18-.14-.17-.09,.03,.03,.14,.04,.17,.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "286.19 132.26 286.2 132.19 286.11 132.24 286.19 132.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.08,131.96c-.11,0-.26-.04-.34-.03,.12,0,.22,.07,.34,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.81,132.75h-.01c.12-.02,.14,0,.24,.03-.01-.07-.13-.1-.19-.15-.21,0-.01,.07-.26,.04l.05-.02c-.06,0-.1-.03-.1,.02,.01,0,.06,.04,0,.05-.05-.06-.14-.07-.19-.15,0,.02-.01,.03-.05,.02,.05,0,.07,.02,.09,.04-.03-.01-.15,.05-.17,.09l.23,.07s-.03-.04,0-.06l.1,.08c.12,.01,.17-.11,.25-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "285.85 132.64 285.85 132.64 285.85 132.64 285.85 132.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.68,132.56h-.01s0,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.81,132.57c-.07-.04-.11-.02-.13-.01,.15,.01-.01,.09,.17,.08-.02-.02-.04-.04-.04-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.97,132.42s-.06,0-.08,0l.04,.03s.04-.02,.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.45,133.42s-.02,0-.02,.01h.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "282.45 133.58 282.45 133.58 282.45 133.58 282.45 133.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.54,133.56l.09,.03c-.06-.05-.23-.13-.19-.16h-.18c.03,.08,.09,.06,.19,.14,0-.01,.03-.02,.09-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.29,133.55c.05,.06,.07,.11,.2,.14-.02-.04-.05-.09-.04-.11-.01,.02-.1,0-.16-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.34,133.47s0,.06,.08,.09c-.09-.05,.04-.07-.08-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.14,131.92l.02,.09c.02-.06,.07-.08,.09-.09h-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.13,132.53l-.04-.08s-.06,.03-.11,.06c.07,.02,.12-.04,.15,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "283.56 133.37 283.55 133.37 283.63 133.44 283.64 133.44 283.56 133.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.23,133.54s-.05-.04-.08-.07h-.01s.05,.05,.08,.07h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.83,133.45s-.02,.03-.06,.03l-.03-.02s.04,.05,.15,.06c.08,0-.04-.05-.07-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.69,133.4l.06,.05s-.03-.03-.06-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.68,133.57s-.05-.08,0-.07l-.14-.04s.03,.04,0,.05l.13,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.54,132.94l.05-.02c-.21-.04,.07,.14-.15,.06,.07,.07,.14-.02,.23,0-.02-.03-.13,0-.13-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.84,133.9s-.08-.04-.11-.05l.03,.04h.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.86,133.91h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "285.1 133.13 285.15 133.21 285.24 133.19 285.1 133.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.23,133.01c.04-.05,.05-.14-.07-.15,.04,0,.02,.03,.03,.05-.07,0-.11-.02-.07-.05-.1,0-.27,.03-.34,.05l.11,.05s-.07-.02-.04-.06c.03,.02,.16,.02,.12,.07,.07-.03,.22-.03,.27,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278,133.85s.01,.04,0,.05l-.07-.03,.07,.09c-.08-.08,.12-.03-.01-.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "283.37 133.69 283.35 133.73 283.45 133.75 283.37 133.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.58,133.05l.04,.07c.06,0,0-.05-.04-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.91,134.03s-.07-.01-.07,.01l.13,.07c-.06-.04,.07-.05-.06-.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "285.52 133.17 285.44 133.13 285.49 133.21 285.59 133.14 285.55 133.12 285.52 133.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "283.18 133.77 283.18 133.81 283.2 133.81 283.18 133.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "283.19 133.86 283.18 133.81 283.09 133.79 283.19 133.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.73,134.01c0,.09-.26-.07-.2,.02l.09,.03h-.01s.17,.04,.19,.03l-.06-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.53,134.04h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "286.87 132.61 286.77 132.57 286.76 132.58 286.87 132.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "282.75 133.96 282.63 133.93 282.64 133.95 282.75 133.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.87,133.99s.06,.03,.11,.02l-.12-.08s-.04,.03,.01,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.66,133.92s.1,.06,.16,.1v-.07s-.02,.04-.11-.01c-.03-.04-.04-.12-.16-.13,.03,.05,.18,.07,.11,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.77,134.25l.09-.02-.11-.07c.09,.05-.08,.03,.02,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.34,132.49s-.07-.05-.12-.05c0,.05,.05,.03,.12,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.85,134.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.8,134.13l-.12-.02c.03,.06,.14,.11,.17,.15l.07,.02c.12-.01-.2-.07-.11-.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "283.9 133.82 283.84 133.79 283.82 133.81 283.9 133.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.2,133.44h-.08s.03,.02,.05,.04c0-.01,0-.02,.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.34,133.56s-.08-.03-.12-.05c.03,.02,.07,.04,.12,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.35,133.56v.02s.02-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.34,133.56h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.22,133.51s-.03-.02-.04-.04c0,.01,.02,.03,.04,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.47,132.45s-.15,.02-.04,.05l.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.43,133.04h.01v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.41,133s.01,.02,.02,.02v-.03h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.45,133.03s.13,0,.17,0v-.04l.19,.04s.04-.04,.07-.04l-.08-.05v.03c-.06,0-.1-.03-.13-.04-.04,.09-.15,.04-.22,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.78,132.52l.22-.02c-.08,0-.19-.02-.28-.04,.02,.01-.02,.05,.06,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.71,132.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.66,132.49s-.01-.02,0-.03c.03,0,.04,0,.05,0-.06-.01-.11-.03-.16-.05l-.02,.09c.07-.03,.09,.03,.13-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.31,134.46c.1,.03,.15,.05,.23,.06,.07-.04-.2-.08-.2-.17v.04l-.13-.09c.06,.08,.07,.19,.08,.25v-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.92,134.04l.09,.11c.15-.04,.31,.08,.38,0,.08,.02,.07,.07,.15,.1,.13-.01,.03-.07,.1-.11-.01,0-.13-.05-.06-.09-.06-.05-.21,0-.2-.06-.01,.02-.06,.03-.1,.02-.05,0-.1-.02-.13-.01-.02-.08-.24-.04-.28-.1,0,.02,0,.04-.03,.05-.05-.03-.09-.13-.19-.15,.1,.06-.04,.04-.1,.03v-.05c-.07-.01-.2,0-.11,.06l-.06-.02,.13,.09-.03-.05c.28,0,.16,.21,.44,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.87,133.91v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.26,134.09l.08,.09h.06c-.12-.02-.04-.06-.14-.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "283.71 134.08 283.72 134.08 283.71 134.08 283.71 134.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.72,134.13v-.05s-.02-.01-.03-.02c0,.01,0,.04,.03,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.83,134.09s-.08,.01-.12,0l.09,.07s.13,0,.03-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.51,134.16l.02,.02h-.11c-.11,0,.07-.03-.06-.05-.03,.05,.1,.07,.05,.11-.21-.02-.1-.11-.28-.12,.08,.03,.02,.07-.04,.07,.08-.05-.1-.03-.15-.09-.12,0,.04,.06,.01,.09,.06-.06,.23,.08,.28,0l.1,.07c.11,0,.14-.07,.3-.02l-.14-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.6,132.92c.2-.03-.05-.09-.02-.15l.09-.03-.06-.04c-.12,.02,0,.06-.05,.09-.03,.08-.21,.02-.28,.06l.08-.02s-.02,.04,0,.06h-.11c.1,.07,.26-.01,.36,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.63,134.27v.04s.02-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.76,134.29s.03-.02,.02-.04c-.03-.04-.21-.05-.2-.02,.01,.01,.04,.03,.06,.04v-.03s.1,.03,.12,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.27,133.04v-.02c.15,.02,.37-.01,.46,.04-.01-.02-.03-.04,.02-.05,.05,.02,.12,.01,.16,.03-.07-.05-.17-.09-.25-.1-.01,.02-.24,.04-.36,0,.06,.02-.24,.06-.03,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.74,133.07s-.01,0-.02,0c0,.01,.02,.02,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.91,133.05s.03,.02,.04,.03c0-.02-.02-.03-.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.05,132.63c.08,.06,.29-.02,.31,.01v-.02c-.11-.02-.26,.03-.31,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.33,132.48h0l-.21-.02s-.02,.04-.04,.05c.06,.03,.2,0,.28,.04l-.05,.03s.03,0,.06,0c.01,0,.04,0,.05,.01-.12-.05,.05-.07-.08-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.17,134.32h0s-.09-.03-.14-.05l.02,.04c-.05-.01-.09-.03-.1-.05,.02,.04-.19-.03-.13,.04h0c.1,.02,.21,.05,.31,.07-.04-.01,0-.03-.02-.04,.05,0,.08,.03,.12,.03l-.06-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.57,134.66c-.08,.03-.14,.02-.2,.06l.17,.05,.17,.04c-.19-.07,0-.07-.14-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.19,134.86c.09,0,.13,.11,.19,.13,0-.08-.13-.19-.19-.26-.05,.03-.18,.03,0,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.2,134.73h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.11,134.71s.04,0,.07,.02c0-.01-.02-.02-.02-.03h-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "287.79 132.86 287.72 132.85 287.78 132.87 287.77 132.89 287.79 132.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.3,134.39v-.02s0,0,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.3,134.38s.05-.01,.05-.02c.05,0,.08,.04,.11,.05-.04-.02-.09-.1-.16-.11v.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.5,134.41s-.02,0-.04,0c.01,0,.02,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.46,134.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.46,134.41h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "281.82 134.8 281.97 134.83 281.78 134.75 281.82 134.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "278.99 134.79 278.97 134.85 279.05 134.86 278.99 134.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.03,134.47c.06,0,0-.02-.03-.04,0,.01,0,.03,.03,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.98,134.41s0,.01,.02,.02c0,0,0-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.64,135.05h-.08s.06,0,.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.39,134.99c-.03-.07-.16-.14-.24-.21-.15-.05,.05,.08-.05,.08,0,.04,.21,.18,.36,.23l-.05-.05h.15c-.07-.02-.16-.07-.17-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.76,134.87c.07-.03-.04-.08-.1-.12-.08,.03,.05,.04,.1,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.77,133.51l.05,.03s.16,.02,.26,.04c.04-.08,.15,.03,.17-.06-.05,.06-.18-.04-.3-.03-.02,.06-.12-.03-.19,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.88,135c-.08-.05-.25-.06-.24-.11-.02,.11,.14,.11,.26,.18,0-.02-.11-.09-.02-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.51,136.03s-.13-.03-.17-.04c.17,.03-.05,.08,.05,.09,.09-.03,.15,.01,.26,.03-.06,.1-.22-.08-.3,.02,.1,.02,.33,.03,.31,0,.03,.07,.31,.06,.25,.15,.07-.02-.04-.05-.04-.09h.12c-.06-.02-.1-.07-.03-.07,.09,.07,.07-.01,.19,.02l-.07-.1c-.17-.08-.28-.06-.47-.08l-.11,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.36,136.44l-.09-.04s.06,.03,.09,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.45,136.19s.01-.02,.01-.04c-.01,.02-.02,.03-.01,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.44,135.13s.02,.01,.02,.02c0-.01-.02-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.43,135.15s0-.02-.03-.03c.02,.02,.02,.04,.03,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.77,134.96h-.01l.07,.03-.05-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "283.66 135.24 283.66 135.24 283.59 135.23 283.66 135.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.18,135.69s-.01,0-.02-.01h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.6,135.58s0,0-.02,0h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.45,136.31c-.05-.07-.33-.13-.52-.14l.03-.05c-.07,.06-.15-.02-.1,.06-.12,.03-.25,.03-.37,.02-.12-.01-.24-.02-.37,.01-.05-.06-.05-.16-.17-.16,.13,0,.12-.02,.16-.04-.15-.03-.22-.04-.13-.1,.1,.05,.26-.02,.27-.05l-.1-.07,.12,.03s-.02-.03-.02-.05c.06-.04,.14,.02,.18,.06,.03-.04,.03,0,.03-.05,.09,.05,.38,0,.5,.04-.01,0-.05-.02-.05-.03h.14c-.09-.09-.39-.05-.48-.09,.02,.03,0,.04,.02,.07-.17,.02-.42-.06-.62-.05l-.02-.05s-.11,.02-.2,.03l.04-.06c-.14,0-.12-.05-.18-.06,0,0,0,.01,0,.01-.07,.02-.24-.04-.2,0-.07,0-.13-.05-.18-.08,.11-.01,.04-.07-.03-.09-.01,.02,.06,.02,.03,.05-.06,0-.07-.03-.1-.04-.01,.04-.14,0-.07,.06l-.13-.04,.06-.03c-.08-.02-.23-.16-.34-.08-.03-.03-.05-.09-.07-.08,.03,.04-.06,.02-.02,.08-.17-.03-.19-.15-.41-.17l.14-.03s-.07-.04-.02-.05c.09,.06,.14,0,.18,.02-.06-.04-.19-.07-.24-.04v.08s-.07-.02-.1-.03l.03-.06h-.04l-.09-.1c-.1,.04-.2,.07-.3,.03,.05-.02-.03-.07,.05-.06l-.16-.09,.07,.1c-.05-.05-.24-.09-.32-.13-.09,.12-.26-.12-.34,0-.21-.09-.45-.15-.6-.18l-.09,.02,.11,.03s0,.05-.05,.05l-.16-.08s.03,.04,.03,.05l-.14-.03s.07,.07-.03,.07c-.02,0-.04-.02-.05-.03l.03,.04c-.08-.04-.19,.01-.16-.04-.05,0,.05,.04,.02,.06-.07,.04-.09-.05-.16-.04,.11,.03,.07,.07,.12,.11,.16,.02,.26,.06,.38,.12-.04,.03-.19-.07-.21-.02,.06,.01,.14,.05,.22,.05-.12,.03,.06,.05,.14,.09,0,0-.02-.02-.03-.03-.01,0,.31-.01,.23,.08,.04,.03,.08,.05,.06,.07h.06c-.1-.02,.03-.07-.09-.12l.17,.04v.08c.09,0,0-.05,.08-.04,0,.03,.1,.07,.14,.11-.05-.06,.05-.04,.05-.08,.17,.03,0,.05,.1,.09v-.06c.14,.01,.03,.05,.08,.1-.16,.03-.25-.05-.4-.1,.04,.04-.04,0,.03,.07h0c.24,.11,.59,0,.79,.17h-.09l.16,.04c.07,0-.04-.01-.07-.03,.06-.02,.22,0,.28,.06l-.03,.06c.09,.03,.2,.02,.25,.06,.18,.08,.33-.01,.46,.11-.03,.01,.01,.06-.06,.07,.13,0,.08-.05,.22,0-.09-.03,.05-.05,.1-.06l.17,.08s-.16-.06-.1-.11c.11,.05,.32,.03,.37,.12-.01,.03-.09,.02-.09,.06,.06,.05,.07,.03,.16,.04-.1,.1-.28-.06-.32,.05,.05,.02,.11,.03,.17,.04,.05,.01,.1,.02,.11,.06-.01-.05,.12-.07,.16-.04l-.04,.02c.16,.01,.38,.06,.45,.13-.06,0-.13,.03-.18-.02,.03,.01,.02,.03,.02,.05-.03-.06-.28-.04-.31-.09-.03,.04-.1,.06-.06,.11-.04-.08-.19,.03-.24-.05v.11c.06-.08,.12,.06,.25,.02-.04-.03,.01,0,.03-.05,.1,.06,.12-.06,.28,0l-.13,.03c.13,0,.02,.06,.21,.04l-.02-.05c.1,0,.24,.02,.27,0,.11,.05,.36,0,.35,.09-.01,0-.02,0-.03,0l.09,.04s.01-.04,.07-.05c.06-.03,.11,.03,.14,.03h-.03c.14,.04,.25-.07,.36-.03l.15,.03-.02-.08,.2,.07s.09-.02,.02-.05h-.14l.05-.08c.15,.04,.1,0,.18,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "288.5 132.54 288.45 132.58 288.56 132.56 288.5 132.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.44,134.45s.08,.01,.13,.03c-.04-.01-.09-.05-.13-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.75,133.16s.04-.05-.04-.06c.03,.01,0,.05,.04,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.82,133.34l-.13-.07s.06-.09,.02-.08l-.11,.05-.06-.03s.03,.04,.03,.05h.1c-.07,.04,.08,.07,.15,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.53,134.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.48,134.5l.06,.08s.04-.07-.06-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.67,135.25s-.02-.04-.06-.02h.01c-.06,.04-.13-.07-.21-.08v-.06s-.08,.06-.14,.02c.04,.07,.14,.15,.24,.15,.12,.07,.07-.03,.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.43,135.38c-.12-.11-.14-.1-.27-.17v-.06s-.13-.07-.19-.09l.1,.09-.14-.03c.06,.06,.17,.11,.2,.15,.09,.02,.21,.06,.29,.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "279.34 135.16 279.33 135.17 279.43 135.22 279.34 135.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.73,133.9s-.02,0-.04,0c.02,0,.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.85,133.88c.05-.05-.06-.03-.1-.05-.06,0,0,.06-.02,.07,.05,0,.09,.02,.12-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "288.2 133.05 288.13 133.09 288.25 133.07 288.2 133.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.66,134.86l-.11-.07c-.08,0-.2-.04-.35-.07-.09-.03-.18-.06-.27-.08v.04c-.07-.02-.12-.04-.19-.04v.03l-.1-.03c.03,.06,.05,0,.17,.06-.03,.03-.14,.04-.11,.1,.07-.03,.3,.06,.48,.03-.02,0-.04-.01-.05-.02,.02-.04,.12,0,.15,.02-.02,.02-.06,.06,0,.07-.04-.05,.06-.11,.14-.05l-.06,.02c.09,.05,.25-.04,.27,.06l-.04,.02c.05,0,.15,.03,.18,.01-.13,.03-.09-.05-.13-.08,.06-.02,.16,.02,.17,.04l.02-.04c.04,.07,.06-.02,.15,0-.05-.04-.03-.07,0-.06l-.15-.02,.09,.05c-.08,.03-.3-.08-.29,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.83,134.93h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.78,134.6c.05,0,.11,.02,.16,.04v-.02h-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.63,133.97l.1-.04h-.13s.01,.03,.03,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "280.89 135.41 280.72 135.29 280.68 135.32 280.89 135.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.38,134.46c.14,.06-.09,.08,.04,.13,.17,.02,.11-.08,.13-.12h-.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "286.95 133.82 286.92 133.85 287.06 133.91 286.95 133.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.36,135.57c-.15-.07-.1-.2-.3-.2,.03,.01,.02,.02,.02,.04-.12-.03-.04-.06-.12-.1,.04,.06-.12,.04-.04,.09h.1s.04,.06,.06,.09c.05,0-.03-.05-.01-.06,.12,.02,.21,.15,.3,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.44,133.08s-.05,.02-.09,.02c.06,0,.11,.01,.09-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.27,133.14v-.03s-.03,0,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.27,133.1h0s.05,0,.08,0c-.03,0-.06,0-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.9,134.38h0s.01,.01,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.3,134s.02-.01,.02-.02c-.03,0-.03,.01-.02,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.9,134.38h0s-.02,0-.02-.02c0,0,.01,0,.02,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.8,133.97s-.03,0-.05,0c.02,0,.03,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.03,134.38h.02s0,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.69,134.35s0,.01-.01,.02c0,0,0-.01,.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.05,134.62s-.03,.01-.05,.03l.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.79,134.67h-.03s.01,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.69,134.35s.05-.05,.05-.07c-.08,.02-.05,.04-.05,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.79,134.67s.06,.02,.08,.02c.06-.04-.04-.02-.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.13,134.28s-.06,0-.09,0c0,.02,.04,.02,.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.66,134.08h.03s-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.35,134.38s.04,.02,0,.04c-.24,.05-.24-.04-.45-.02-.17,0-.31,.03-.45,.04-.14,0-.28,0-.46,0,.05-.04-.11-.02-.09-.07v.03h-.04s-.08,.02-.16,.05c-.12,0-.01-.05-.11-.07h.08l-.13-.07c-.05,.04,.09,.14-.08,.11-.17,.02-.32-.09-.45-.1,.06,.08-.17-.01-.11,.07l-.12-.06s-.02,.04-.08,.03c.1,.02,.18,.11,.33,.13,.03-.01,.02-.03,.01-.04,.07,0,.08,.03,.12,.04h-.07c.05,.03,.19,.03,.23,.09,.01-.02,.01-.06,.09-.05,.05,0,.08,.03,.11,.04-.08,.01-.03,.04-.09,.03l.05,.05v-.03c.19,.03,.08,.09,.12,.14,.03,0,.03-.01,.03-.03,.04,.02,.1,.03,.15,.06h-.01c.04-.05,.2,.04,.34,.05-.08-.08,.16-.03,.17-.04-.04,.08-.28,.06-.31,.15,.16,0,.28,.06,.4,.12,.08-.11,.43,.01,.51-.15-.06-.01,.1-.11-.08-.13-.08,.03-.03,.1,0,.15l-.17-.07,.04,.04c-.14,0-.02-.03-.18-.02-.04-.06,.12-.04,.12-.09-.07-.02-.12,.05-.19,0l.04-.02c-.06-.05-.15,.02-.19-.04,.05-.02,.13-.02,.21-.02,.08,0,.17,0,.25,0v-.04s-.03,.01-.04,0c.04-.05,0-.08,.13-.11h-.04s-.03-.07,.03-.08c.23,0-.03,.08,.2,.09,.08-.05-.04,0-.07-.04,.02-.08,.23,0,.18-.09,0,.03,.21,.09,.06,.11,.06,.06,.21-.04,.28-.02-.03-.01-.07,0-.09,0,.03-.06,.21-.05,.25,0-.03-.03,.02-.07,.04-.1,.15,0,.16,0,.35,0-.02-.03,.05-.04,.04-.07,.08,0,.07,.05,0,.06,.21-.06,.09,.07,.25,.03-.05,.02,.01,.08-.09,.09-.02,.03,.07,.02,.08,.05h-.11c.06,.06,.22-.01,.37-.01,.04,.06,.21,.15,.31,.09v.05c.11-.06,.38-.09,.45-.12,.16-.04,.04,.06,.12,.07v-.03l.13,.03h0l.13-.02s-.06-.01-.05-.04c.04-.02,.08,0,.13,0,0,0,0,0,0-.01,.05,0,.1-.02,.16-.04,.06-.02,.11-.03,.17-.01l-.04,.03c.06-.02,.15,.03,.23-.05-.04-.08-.11,.05-.16,.03l-.03-.04c.16-.06,.23-.08,.39-.08-.07,.05-.12,.09-.16,.09,.04,.03,.27-.07,.19,.02,.31,0,.31-.21,.6-.2,.05,.01-.02-.03-.08-.02,0,0,0,0,0,.02-.05-.07-.36,.14-.22-.01l.03-.03c-.08-.02-.06,.04-.13,.05-.05,0-.06-.01-.05-.03,0,0-.02,.02-.05,.02l-.03-.09c.12-.04,.2-.08,.29-.07l.05,.07s.06-.03,.09-.03h0c.19-.03,.1-.1,.29-.13,.06-.06-.13-.02,.04-.09,.05,.04,.14,.04,.24,.03,0,0-.02,0-.02-.02,.16-.03,.06-.07,.17-.09-.04,0-.09,0-.13,.02v.02h-.1l.05-.07c-.15-.04-.44,.15-.66,.14,.02-.01,.05-.03,.07-.05-.04,0-.09,0-.14,.01,.03,0,.02,.03,.03,.04-.22,.02-.33,.15-.52,.2l.12,.05-.2,.05v-.07c-.07,.12-.16,.04-.23,.17,.04-.02,.04,0,.07,0l-.08,.07c.05-.07-.15,.02-.17-.04-.26,.03-.64-.03-.95,.06-.22,.09-.28-.08-.46-.05,.02,0,.06,.02,.02,.04-.12,0-.05-.06-.1-.09,.11-.05,.29-.07,.4-.07,.1-.03-.03-.08,.1-.12,.01,0,.07,.05,.04,.06,.12,.04,.42-.14,.3,.03,.17-.1,.18,0,.38-.07l.04,.03,.08-.06s0,.04,.05,.05c.09-.05,.09-.13,.12-.11-.05-.02-.08-.04-.1-.07,.12,.02,.28,0,.35-.05l-.23,.03s0-.02-.01-.04c.18-.05,.25-.08,.41-.05l-.03,.08c.06,0,.13-.07,.16-.03l-.1,.05h.11c.01-.06-.07-.12-.16-.12q.1-.04,.13-.1c-.09,.03,0-.08-.12-.03,.03,.04-.21,.07-.31,.08h.01s-.12,.07-.17,.08l-.05-.03,.14-.05h-.17c-.06,0-.1,.01-.11,.03-.01,.05-.05,.06-.13,.07,.08-.05,.04-.06,.06-.09-.07,.04-.2,.08-.28,.06,.1-.02,.03-.04,.01-.05-.11,.08-.35,.06-.51,.11h.01l-.13,.05-.13,.04h.07c-.03,.11-.22,.1-.33,.17,.04-.02-.02-.02-.02-.03,.03,.02-.03,.05-.06,.03-.05-.06,.12-.03,.1-.06h-.14v.05c-.12,0-.23,.09-.31,.01h.06l-.08-.04s0,.04,.05,.06c-.09,0-.19-.03-.24,.02l-.06-.04c-.07,.06-.14-.04-.23,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.66,134.08h-.06s.04,0,.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.21,133.84h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.03,133.82h.15s-.1-.03-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.76,133.47s.06,.02,.09,.01c-.06-.01-.07-.08-.09-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.9,133.49s-.03,0-.05,0c.01,0,.03,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "288.57 133.06 288.6 133.04 288.49 133.04 288.57 133.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.01,135.3s.02,.02,.04,.03c0,0-.02-.02-.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.3,135.44c-.02-.09-.15-.06-.25-.11,.02,.02-.01,.04-.02,.03l.14,.09c-.06-.08,.05-.03,.13-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.28,135.41l.14,.06s0,.01,.02,.04c.06,.02,.05,0,.06-.03l-.22-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.93,133.96h.08v-.03s-.09,0-.08,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "287.75 133.56 287.83 133.55 287.77 133.53 287.75 133.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "287.74 133.57 287.75 133.56 287.7 133.56 287.74 133.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.03,135.76s.06,.03,.09,.03c-.02,0-.06-.02-.09-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.84,135.8c.05,0,.1,0,.08-.04-.03-.01-.08-.02-.07-.03,.04-.04,.11,0,.18,.04-.07-.05-.14-.13-.17-.17,.03-.04,.13,.01,.09-.06,0,.01-.05,0-.1,0-.04-.01-.08-.02-.07,0-.04-.01-.06-.04-.08-.07-.17-.08-.09,.02-.16,.03l.09,.03h-.01c.19,0,.04,.14,.27,.16-.12,0-.04,.06-.06,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.7,135.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.45,135.31l-.08,.02,.16,.08c-.05-.04,.03-.06-.08-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.97,133.48c.11,.07,.23,.08,.4,.08l-.03-.05s.09,.02,.14,.01c-.09-.04-.26-.12-.45-.11l.02,.04c-.08,0-.02,.01-.07,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.8,134.54s.09,.03,.13,.03l-.1-.07s.05,.06-.03,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.8,133.08s-.08-.02-.08,.04c.15-.05,.17,.09,.3,.03-.09-.03,0-.15-.18-.14-.03-.04-.1,.04-.19,.05,.04,.04,.15-.05,.15,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.55,135.59s.02-.03,.03-.04l-.14-.06s.06,.13,.16,.14l.04-.02-.09-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.42,134.35h-.03c.1,.01,.05-.01,.04-.04,0,.01-.01,.02-.01,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.44,134.31s.01-.02,.03-.02c-.03,0-.03,.01-.03,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.34,135.29c-.06-.01-.03-.02-.06,0,.17,.09,.22,.02,.38,.07-.06-.01-.31-.15-.32-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.53,135.59c.06,.05,.06,.11,.18,.14,.05-.05-.11-.1-.14-.15,.01,.01-.02,.01-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.94,135.71v-.04s.07,.02,.09,.03c-.04-.03-.09-.05-.14-.05-.02,.01,.02,.03,.05,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.09,135.75s-.04-.03-.06-.04c.02,.01,.04,.03,.06,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.23,136.16l-.03-.02h0l.03,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.48,136.31c.06,.03,.09,0,.13,0-.19-.07,.08-.06,.04-.12,.09,0,.28,.1,.28,.03,.05,.08,.26,.09,.33,.13h-.03c.09,.05,.05,0,.1-.01-.22-.05-.34-.15-.56-.16-.02-.04-.23-.11-.08-.13,.05,0,.12,.02,.08,.05,.18,.06,.08-.07,.24-.03l.14,.07v-.04s.04,.02,.06,.04c.06-.01,.11-.02,.17,0l-.15-.04c0-.09,.1-.03,.14-.07-.22-.03-.28-.07-.43-.17-.12-.03,0,.03,.02,.06-.21-.02-.06-.13-.26-.14,.02,.03,.19,.11,.07,.12-.1-.02-.22-.05-.33-.1-.11-.04-.21-.07-.26-.03-.03,0-.05-.02-.08-.03,.03,.03,.05,.06,.08,.09l-.14-.07s.02,.03,.03,.06c-.36-.06-.14-.23-.43-.27,.04,.02,.09,.07,.12,.12h-.11c.15,.08-.08,.09,.15,.19-.14-.07,.04-.04,.06-.05,.03,0,.09,.06,.06,.08l-.07-.02,.09,.09h0c.15,.03,0,.02-.01,.04-.13-.06-.15-.11-.23-.16-.03-.02,.04,.07-.07,.03,.11,.01,.12,.16,.23,.13,.14,0,.26,.14,.43,.11-.02,.03,.05,.07,.12,.1,.07,.03,.13,.06,.07,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.69,131.87c0-.1-.09,.06-.14,0v.04c-.12,.02-.07-.04-.21,0,.05,.14,.25-.03,.35-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.51,135.64c.04,.07-.06,.04,.1,.1l-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.78,135.38s-.04,0,0,.04l.03,.02s.05-.02-.02-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "281.43 135.72 281.49 135.77 281.55 135.74 281.43 135.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.44,135.78c0,.1-.18-.09-.24-.04,.11,.06,.22,.11,.34,.15-.02-.03,.02-.09-.1-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.12,135.95c-.17-.05-.03-.1-.15-.13,0,.01,.03,.06-.04,.02,.05,.06,.22,.09,.24,.18,.16,.02-.04-.08,.13-.05-.05,0-.13-.07-.17-.03v.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.61,135.53c-.07-.04-.11-.04-.16-.02,.02,.04,.09,0,.16,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.08,133.97l-.06-.11s-.03,.06-.1,.04c-.05,.07,.16,.03,.16,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.27,133.24s-.07-.02-.07-.05l-.15,.05s.18,.04,.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.69,135.08s-.18-.01-.17,.05c0,0,.17,0,.17-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "288.32 133.94 288.16 133.93 288.29 133.95 288.32 133.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.6,134.35s-.13-.04-.15,0c.03,0,.06-.02,.09-.02-.02,.04,.03,.02,.05,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "285.47 135.23 285.53 135.25 285.46 135.17 285.47 135.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.59,136.09s.06,.04,.11,.06c-.02-.04-.05-.06-.11-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "280.32 136.09 280.27 136.09 280.35 136.16 280.32 136.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "289.67 133.09 289.57 133.1 289.66 133.1 289.67 133.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.57,133.88c-.06,.01-.02,.07-.07,.07l-.04-.03-.03,.05c.14-.03,.08,.04,.15-.02,0-.03,0-.06,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.59,132.54s.01-.02,0-.03c-.01,0-.01,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.5,132.6h.03c.08-.02,.06-.04,.06-.06-.03,.03-.12,.04-.19,.06l.03-.04c-.06,.02-.1,.04-.1,0-.01,.05-.1,.05-.1,.08,.06-.02,.13-.03,.2-.04,.03,0,.06,0,.08-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.64,135.87c-.11-.08-.07,0-.11,0,.05,.01,.09,.02,.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.54,135.88s-.05-.02-.07-.03c.04,.03,.06,.03,.07,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.97,133.53s-.04-.01-.06-.01c.02,0,.04,0,.06,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.52,133.56s-.01,0-.01-.02c0,0,0,.01,.01,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.34,133.66h-.16c-.08,.07,.11,.03,.17,.03v-.03c.07-.01,.07,.04,.12,.04-.23,0-.37,.17-.6,.14,.03,.02,.03,.05,.09,.05,.24,.02,.42-.06,.65-.07-.03,0-.04-.03-.05-.04,0-.05,.22-.08,.27-.04l-.03-.09,.14-.03s-.02-.02-.02-.02c.04-.01,.05,0,.08,0l-.07,.05c.08-.06,.15-.02,.18-.08-.03-.02-.08-.04-.14-.05,.03,.01,.06,.03,.06,.05-.16,0-.24-.03-.44,.02,.05-.06-.04-.03-.08-.04,0,0,.01,.02,0,.03-.08,0-.17-.04-.16-.08-.08,.05-.31,.06-.33,.1,0,.08,.25-.02,.29,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.85,132.54v-.03l-.08,.02s.07,0,.08,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.85,132.54v.02s0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.45,135.85s-.1-.07-.22-.08c.09,.04,.08,.13,.22,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.03,135.77c.05,0,.13,0,.2,0-.04-.02-.1-.03-.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.88,133.36s0,0,0,.01c0,0,0,0,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.86,133.45c.07-.03,0-.05,0-.08-.03,.02-.13,.04-.18,.08h.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.2,136.25s-.04-.01-.06-.02c.04,.02,.05,.02,.06,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.2,136.25s.06,0,.08,0c-.09-.04-.06,0-.08,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "280.56 136.54 280.63 136.6 280.6 136.51 280.56 136.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.76,136.42l-.05-.02s.02,.02,.05,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.71,136.35s-.11,0-.1,.02l.09,.04s.02-.03,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.85,134.69l.07,.07s0-.05-.07-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.44,136.55l.07,.08s0-.02-.07-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.06,134.67h-.07s.05,0,.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.06,134.67l.12,.02c0-.06-.06-.03-.12-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.04,132.58l.13-.06-.19-.02-.03,.05s.11-.01,.1,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.13,136.02s-.05-.07-.14-.07c.05,.03,.09,.04,.14,.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "282.31 136.58 282.4 136.63 282.31 136.55 282.31 136.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "288.04 134.85 288.04 134.82 288.03 134.82 288.04 134.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "288.03 134.8 288.04 134.82 288.13 134.85 288.03 134.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "285.28 135.98 285.22 135.98 285.3 136.05 285.28 135.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.93,136.72l.03,.02s-.02-.02-.03-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "284.22 136.35 284.05 136.3 284.16 136.36 284.22 136.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.58,136.43s.1,.03,.17,.03c-.05-.01-.14-.08-.17-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.09,134.28s0-.05-.01-.06c.06,.04-.13,.04,.01,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.28,136.3s-.08,0-.1,0c.09,.04,.23,.1,.34,.11,.21-.02-.16-.05-.24-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.26,136.27s0,.02,.02,.03c.02,0,.03,0-.02-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "284.06 136.41 284.14 136.43 284.02 136.38 284.06 136.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.74,136.48c-.1-.04-.1,.02-.14,.02,.05,0,.15,.03,.14-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "289.2 134.26 289.3 134.2 289.23 134.24 289.19 134.23 289.2 134.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.81,135.91s.07,.01,.09,.02l-.04-.05s-.04,.02-.04,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.14,136.82s0,0,.01,.02v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.43,136.78h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.76,136.87c.06-.05,.21,.08,.25,.06,.03,.02-.05,0-.05,.02,.06,.03,.12,.07,.18,.08,.02-.04-.26-.14-.1-.16l.23,.06c-.03-.08,.14,.03,.12-.04-.12-.07-.27,0-.4-.1h.01c-.02,.05-.11-.02-.15-.04,.1,.02,.2,0,.27,.03-.04-.03-.1-.07-.15-.07-.02,.03-.04,.03-.12,.02h-.08c.04,.08,.25,.03,.21,.12-.05,0-.14-.01-.19-.03l-.34-.05v.03h-.02v.03c.11,0,.23,.01,.39,.1l-.05-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.11,136.8s.02,.02,.03,.02c0,0-.02-.02-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.42,136.73v.04s.08-.02,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.76,136.79s0,.03,.02,.04h0l-.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.49,134.24s-.11-.07-.15-.03h.07v.03h.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.4,133.48s.05,0,.08,.01l.05-.07s-.17,.01-.13,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.47,134.83s.07,.01,.13,0c.06-.01,.13-.03,.17-.02l.05-.03c-.17-.06-.15,.08-.35,.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "287.83 135.17 287.82 135.18 287.92 135.22 287.93 135.21 287.83 135.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.61,132.48l.1-.03c-.06,0-.1-.03-.1,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.19,135.16l-.07-.03s-.03,.03-.02,.04c.02,.03,.07,0,.1-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.69,136.98s.17,.05,.21,.09l-.17-.15,.04,.07s-.06-.04-.08-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.57,136.93c-.05,0-.1-.02-.15-.04l.04,.04s.07,0,.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.74,136.98s.11-.01,.11-.01l-.21-.09s.02,.07,.1,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.25,137.02c-.13,.08,.17,.03,.23,.09-.11-.09-.11,0-.23-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.7,134.55l-.04-.04s.01,.03,.04,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.72,134.56l.06-.04s-.05,.03-.07,.04h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.7,134.55h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "283.05 137.19 282.96 137.11 282.95 137.16 283.05 137.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.36,134.7l.03,.03s.12-.02,.14-.06c-.06-.04-.06,.06-.17,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.62,137.21s.19,.05,.18,.01c-.06-.05-.17-.05-.18-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.64,133.03l-.18,.06h.17s-.02-.04,.01-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.75,132.9c.06-.1,.2,0,.19-.1-.13-.03-.09,.1-.2,.04,.02,.03-.06,.06,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.88,131.56c.06,0,.14-.09,.19-.07h-.02c-.08,.02-.12,.07-.2,.04-.02,.02,.01,.02,.02,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.07,131.49l.03,.02s-.02-.02-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.13,137.23s-.16-.01-.05,.03c-.09-.04-.06,.03-.13-.01l.12,.08h-.01c.08-.01,.2-.03,.08-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.95,137.25l-.05-.03s.04,.03,.05,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.06,131.43l.12-.05v.07l.06-.02c.02-.06-.12-.05-.14-.09v.05s-.08-.03-.11,0h.08l-.02,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.76,135.34s-.09-.04-.06-.04c-.06,.02-.12,.04-.18,.06,.1,.05,.4,.02,.54,0-.04-.1-.21,.03-.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.9,136.81h-.04s.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.76,136.81l.03-.06c-.14,.07-.18-.04-.29-.06-.09,0-.13,.06-.23,.04,.09,.07,.12-.04,.24,.02l.11,.08h.23s-.07-.02-.1-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "285.65 136.84 285.63 136.83 285.62 136.83 285.65 136.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.46,135.58s.13,.03,.23,.03h.28c-.1-.01,0-.05,.02-.07-.2,0-.25-.02-.4-.07h0c-.07,.03-.11,0-.14-.02,.01,.05-.19,.15-.01,.18,.01-.02,.04-.03,.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.43,135.43s.01,.01,.02,.02c0,0,0-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.22,135.56h.11c-.06-.03-.05-.04-.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.7,137.62c-.08-.03-.23-.11-.27-.06v-.05c-.12-.04,.03,.08-.16,.02-.39-.15,.22-.1-.12-.23,.02,.11-.45-.11-.53,.02-.16,.01-.13-.08-.27-.06l.04,.03c-.12-.03-.06,.05-.13,.02,.09,.04,.46,.16,.62,.22,.1-.03,.32,.08,.34,.01,.03,0,.17,.05,.25,.08h-.02c.07-.06,.24,.05,.24,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.07,132.86s-.01,0-.02,.02c0,0,.02-.01,.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.07,132.86s.03,.04,.08,0l-.07,.06c.09,.01,.11-.05,.24-.08l-.12-.07-.06,.05-.12-.03c.05,0,.07,.04,.05,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.53,131.21s.06-.1,0-.11l-.03,.07s-.09,0-.06-.04c-.04,.02-.09,.12-.11,.16,.02,.06,.14-.1,.2-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.56,131.25s-.02-.03-.03-.04c0,.01,.01,.03,.03,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.14,131.54s-.02,.03-.03,.06c.09,0,.1,0,.13,.05,.02-.02,.04-.05,.08-.06-.07,0-.04-.09-.18-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.36,131.58s-.03,0-.05,0c.01,0,.03,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.37,134.78l.15-.08c-.16,.09-.21-.04-.3,0l.21-.05s-.02-.03-.04-.04c.24-.04,.32-.07,.49-.1-.06-.03,.06-.04,.02-.07h.12s.15-.1,.12-.14c-.05,.06-.25,.05-.19,.1-.12,.04-.05-.04-.15-.02-.03,.03-.16,.08-.1,.1-.12-.08-.37,.18-.46,.14l-.05,.07s-.08,0-.12-.01c-.06,.05-.25,.09-.29,.05-.03,.03-.12,.07-.07,.09-.1,.04-.02-.09-.13,0,.04-.02,.04,0,.06,0-.03,.04-.08,.11-.12,.13-.04,0-.1-.03-.09-.06l.1-.02v-.08c.1-.11,.16,.04,.22-.09h-.05l.09-.06h-.15c-.1,.05-.3,.06-.36,.15-.1,0-.06-.06-.09-.1-.08,.03,.06,.06-.12,.1-.15-.06-.23,.05-.35,.03l.02-.03c-.16,.03-.34,.05-.52,.04,.03,.05,.25,.04,.14,.12-.09-.09-.3,.06-.39,.05,.01,.06-.12,.04-.04,.1-.07,0-.19-.02-.14-.06-.16,.12-.23-.04-.32,.08,.19,0,.25-.01,.38-.03-.02,.06-.14,.03-.14,.09h-.07c.13,.02-.23,.08-.17,.11-.12,.03-.26,0-.38,.03l.07,.02s-.02,.03-.03,.05c.03-.05,.14,0,.23,0l-.05,.03c.08,.02,.1,.02,.2-.01l.11,.07s.05-.09,.17-.1c.02,0,.07,0,.06,.03h-.11l.12,.11c.07-.07-.04-.14,.12-.19-.05-.02-.11,.05-.13,0-.01-.05,.06-.06,.15-.1l.11,.1h0c.12-.01,.22,0,.23,.02v-.03c.14-.03,.17-.02,.23,.03h-.03s.09,0,.07,.04c.09-.11,.33-.03,.47-.06-.05,0-.03-.05,.02-.08,.08-.02,.07,.05,.14,.03l-.03-.06c.11,.02,.13-.06,.18-.1h.08l-.03-.03c.22-.01,.15-.09,.31-.09l-.07,.06c.13-.06,.19-.02,.31-.07-.02,.03,0,.06,.06,.04,.06-.03,.11-.06,.17-.1l.16-.11h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.04,134.43h-.03s-.02,.02,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.34,135.31h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.64,135.15s-.02,0-.04,0h.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.53,132.41c.1-.03,.1-.02,.21-.08-.07,.03-.17,.06-.21,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.49,133.56v.06l.2-.08c-.12,.01-.09-.03-.2,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.42,131.37h-.03s.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.42,131.37l.06-.02v-.07s-.01,.06-.06,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.17,135.4c-.1,0-.02,.04-.1,.06,.09-.01,.12-.03,.1-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "293.29 131.65 293.25 131.7 293.36 131.65 293.29 131.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.56,134.47c.09,.03,.22,.03,.27,.02,0-.02,.03-.05,0-.08-.12,0-.1,.08-.28,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.68,131.29c-.05-.09,.2-.07,.15-.15l.28-.13c-.09-.12-.12,.09-.18-.04-.02,.03-.12,.09-.06,.1-.04,.06-.16,.07-.25,.11,.04,.04-.06,.1,.06,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.26,134.74s.08-.03,.1-.05c-.04-.01-.11,0-.1,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.79,133.45c-.1,.06,0,.11,.08,.1l-.03,.03,.23-.09c-.2,.06,.03-.25-.28-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.54,137.46l-.14-.06s0,.1-.12,.03c-.02,.05,.09,.03,.17,.05-.03-.04-.01-.05,.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M294.54,129.98h-.02c-.05,.02-.02-.03,0-.05-.07,.02-.16,.1-.19,.08,0,.01,.05,.03-.02,.06v.02c.07-.02,.29-.05,.23-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.47,131.58h.04l-.04-.06c-.06,.02-.02,.06,0,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "291.71 133.61 291.77 133.57 291.71 133.56 291.71 133.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.57,133.93l-.02-.07-.12,.03c.08-.02,.11,.03,.14,.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "286.86 136.7 286.94 136.71 286.94 136.67 286.86 136.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.32,137.34v-.04s-.01,.03,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.47,137.43s-.12-.06-.15-.09h0l-.28-.02c.09,.07,.21,.14,.37,.19-.11-.04,.08-.08,.07-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.58,132.98c.06-.03,.19-.1,.18-.04,.01-.03,0-.05,.02-.08,.04,.05,.13-.03,.2-.06-.09-.02-.19-.07-.35,0-.23,.03-.02,.12-.25,.16,.03,.05,.13,.01,.2,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.06,132.82s-.05-.02-.09,0c.03,0,.06,.01,.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.82,136.75c-.06,0-.02,.04-.02,.05h.04l-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.79,136.81h-.08c.07,.01,.08,.01,.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M294.14,130.79s.09-.04,.13-.07c-.06-.04-.09,.03-.13,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M294.09,130.81s-.04,0-.06-.02v.04s.05-.02,.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M294.14,130.79l-.05,.02s.04,0,.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.11,137.05c.08,.02,.15,.02,.23,.03l-.06-.05c.05,.08-.11-.02-.17,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M294.31,131.09c-.12,.06-.25,.14-.35,.13-.04,.1-.1,.08-.22,.17h-.08l-.04,.07,.05-.03c-.02,.06,.07-.01,.12,0l.05-.08c.13,0,.37-.12,.56-.22,.03,0-.06,0-.05-.03,.16-.01,.15-.09,.28-.09-.05-.02-.1-.02-.15,0-.05,.02-.11,.05-.17,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.98,137.46h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.49,137.3c.01,.05,.07,.07,.21,.12-.04-.05-.06-.1-.21-.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "285.71 137.42 285.72 137.42 285.7 137.41 285.71 137.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.72,137.42l.06,.02s.17,0,.21,.02c-.04-.04-.18-.06-.27-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.19,137.1c-.1,.03,0,.03,.05,.05,0-.03,.08-.03-.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.25,137.17s0-.01-.01-.02c0,0,0,.01,.01,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.46,137.69h.05l-.14-.03s.05,.01,.1,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.62,133.02c-.1,0,.02,.04-.06,.05,.08,0,.01-.03,.06-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M294.8,129.9s-.06-.04,.04-.06l.09,.05h-.02s.03,0,.04,0c-.03,0-.02,0-.03-.02l.11-.06c-.05,0-.12,.05-.18,.02,.01,0,.03,0,.05,0v-.02c-.07,0-.13,0-.21,.06,.06-.02,.07,0,.1,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.56,137.18l.04-.08s-.09,.06-.15,.05v-.04h-.08l.08,.04c-.08,0-.17-.02-.26,0,.11,.06,.25,.02,.38,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.82,137.1c.08,0,.13,.04,.1,.08-.08-.07-.28,0-.33-.1-.02,.04-.06,.09,.08,.1,.17,.02,.44,0,.53,.08,.01-.03,.09-.07-.02-.11l.02,.05c-.22-.02-.13-.07-.38-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.08,133.74s-.08,.03-.14,.04c.02,.03,.08-.02,.14-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.1,133.73s-.02,0-.03,0h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.06,136.56h.11l-.09-.02s-.03,.01-.01,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.43,136.23c-.16,.01,0-.05-.01-.08-.04,.05-.29,.13-.35,.06,.02-.04,.11,0,.09-.02-.08-.01-.26,.06-.35,0-.05,.06,.11,.02,.17,.05,.07,.04-.17,.06-.22,.06l.04,.06c.05-.08,.16-.01,.28-.04v-.04c.18,.02,.17-.03,.35-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.24,136.8c-.08,0-.08-.05-.08-.04-.11,0,0,.04-.07,.06-.08-.02-.19-.02-.28-.04l.05,.02c-.12,0-.18,.07-.35,.04,.06,0,.16,.06,.16,.09,.18-.02,.09-.06,.29-.02,.07-.04-.14-.05-.2-.04-.02-.02,.03-.03,.06-.04,.14,0,.32,0,.43-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.99,136.55l.11-.07c-.14,0-.04-.08-.11-.1-.16,.01-.26,0-.35,.05,.05,0,.1,.01,.15,.02,.01-.02-.05-.03-.02-.04l.19,.04s-.06,.03-.11,.05h.15l-.1,.04s.06,0,.09,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.47,136.38s.02,.02-.01,.02c.06,0,.12,.02,.18,.03-.03-.02-.1-.07-.17-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.64,136.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.26,136.12c-.09-.03-.16,0-.25,.02,.02,.05,.17-.03,.25-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.03,136.79l-.04-.03s-.01,0-.02,0c0,.01,.02,.02,.05,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.04,136.62c-.06,.02-.1,0-.14,0,.03,.03,.07,.05,.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.73,136.71h.02v-.09c-.18-.01-.22,.01-.28-.07,.08,0,.21-.02,.26,0-.03-.02-.27-.07-.41-.03,.17,.01,.01,.09,.19,.07-.02,.05-.21,.07-.26,.13l.14,.05s.12-.06,.1-.07c.07,0,.16,0,.24,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "288.76 136.71 288.75 136.71 288.75 136.72 288.76 136.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.94,136.76s.02,0,.03,0c-.04-.04,.06-.07,.08-.13,.06,0,.09,.09,.12,.06,.09-.01-.1-.01-.02-.04,.08,.02,.21,.05,.23,.08l-.08,.05c.08,0,.16,.02,.22,0h-.03c.24-.08,.15,.07,.38,0-.03-.05-.22,.01-.16-.08,.22,.02-.01-.06,.15-.09-.01,0-.03,0-.04,0,.1-.06,0-.04-.03-.07h.17s-.03-.01-.02-.02h.08c-.05-.03-.1-.04-.22-.03,.07-.08-.15-.08-.23-.12l.02,.02c-.13,.04-.34,.07-.42,.12l.04,.03-.23,.03s.07,.04,.01,.08c-.09,0-.16,.03-.21,.05,.07,0,.14,.01,.19,.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.94,136.82s-.05-.03-.03-.05c-.03,0-.06,.02-.08,.03,.05,0,.08,.04,.11,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.94,136.76s-.02,0-.03,0h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.55,136.38l-.03-.04s0,.03,.03,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.88,136.61h-.04s.04,0,.05,.01h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.08,136.74l.12-.06-.12-.02s-.01,.05,0,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.62,128.46s0,0,.02,0c0,0,0,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.75,128.35s0,.03,0,.04c.01-.01,.01-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.22,128.93s.02,0,.02-.02l-.02,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.3,129.58l-.06,.03c0,.06,.17,0,.26-.02,0-.04,.11-.08,.11-.08,.08-.07,.03-.16,.05-.16,.04-.01,.09-.04,.14-.07,.04-.03,.09-.06,.15-.08,.02-.03,0-.02,0-.04,.03-.03,.06-.02,.07,0,.02-.11,.05-.15,.17-.25l-.02,.07,.07-.05h-.02c.09-.1,.2-.19,.31-.28,.11-.08,.21-.19,.31-.27,.03-.05-.06,.01-.08,0-.02,.03-.08,.06-.11,.07h0l-.06,.08s.02,0,.03,0c-.04,.04-.06,.04-.09,.03-.04,.12-.13,.12-.23,.19-.04,.02-.08-.01-.05-.05,.03,.03,.06-.02,.09-.06-.1-.02-.23,.16-.27,.19,.03,.01-.01,.04,.02,.05-.09,.11-.08,0-.16,.1l-.04,.09c-.11-.03-.15,.12-.29,.12-.02,.05,.07,.1-.06,.15-.04-.01,.05-.07,0-.08-.07,.03-.22,.18-.24,.12q.02,.05,0,.13l-.12,.03v.06s.12-.14,.13-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.94,138.04s-.21,.11-.37,.03c.09,.07,.35,.02,.34,.11l.12-.03c-.18-.02,.04-.07-.09-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M294.05,131.84h.2l.04-.02h-.16c.13-.02,.21-.13,.29-.12v-.02c.05-.06,.2-.12,.2-.05-.06,0-.05,0-.07,.05,.1-.03,.06-.07,.16-.12-.03-.05,0-.14-.14-.09,.1,.02-.03,.07-.02,.1-.14,.07-.02-.03-.14-.03,0-.01-.1,.05-.1,.09l.14-.06c-.06,.19-.41,.09-.4,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M294.7,130.94c-.11,.08,.04-.11-.08,0-.01,.02,.01,.02,.04,.03l.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.35,137.36c-.14-.04-.13,.02-.19,.02,.09,.03,.15,.03,.19-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.17,137.38h-.03s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.79,133.79c.08-.08-.1,0-.16,0,.05,0,.13-.03,.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.28,134.27l-.16,.04v.04c.07-.02,.18-.03,.16-.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "287.79 137.25 287.89 137.24 287.78 137.2 287.79 137.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.69,135.98v-.02s0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.22,135.96s.03,0,.04,.01h-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.7,135.96s.04-.02,.04-.03c-.14-.05-.22,.04-.33,.01-.07,.02,.02,.02,0,.03-.02,0-.09,0-.14,0-.09,.06-.19,.08-.32,.12,.09,0,.32,0,.32-.05l.08,.03s.15-.06,.09-.09l.28-.06v.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M294.86,130.89s-.02,.07,.07,.04c.09-.1,.24-.12,.36-.11,.02,.02-.11,.08-.04,.09,.03-.02-.02-.04,.05-.06,.16-.09,.26-.04,.37-.16v-.05l-.1,.11c-.02-.14-.33,.15-.29-.06-.09,.04-.19,.09-.26,.15,.03,0,.06-.02,.06,0-.09,.08-.11,0-.21,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.5,138.69c-.1-.06-.08-.06-.22-.07,.01,.05,.13,.04,.22,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M294.69,131.27s.05-.03,.07-.02l-.08-.03s0,.03,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.43,134.13s.03,.05,.08,.05c.06-.04-.08,0-.08-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.83,137.85c-.03,.05-.45-.11-.52,.04,.13,0,.34-.04,.41,.04-.03-.06,.18-.03,.11-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.85,133.87l-.11-.02s.05,.07-.06,.06c.07,.02,.11-.01,.17-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.4,134.27s.04,0,.05-.03h-.09s0,.04,.04,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.34,134.34s-.05,.1,.1,.04c-.09,.02-.07-.02-.1-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.34,134.34s-.02,0-.04,0c.02,0,.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.8,138.38s-.01,0-.02-.01c0,0,0,0,.02,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.97,138.3l-.15-.12c-.13-.01-.07,.04-.07,.07l-.11-.07s.03,.07,.03,.11c-.1-.05-.18-.06-.33-.06,.05,.01,.31,.02,.31,.08-.08,.05,.07,.04,.13,.07,0,0,0-.01-.02-.02,.08,0,.18,.05,.18,.01-.02,0-.08,0-.1-.02-.03-.04,.1-.03,.12-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.86,133.83c.11,0,.13,.06,.19,.08,.12-.05,.23-.11,.39-.14-.03-.03,0-.06,.07-.1l-.27,.1c0-.06-.02-.07-.09-.07,.08-.06,.15-.07,.12-.12l-.16,.03c-.1,.08-.19,.14-.24,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.3,137.62c-.04-.06-.23-.01-.34-.03,.05,.04-.03,.03-.1,.02,0,0,.01,.01,0,.02-.13,0-.13-.02-.24,0,.03-.01,.13,.07-.03,.07-.19,0-.02-.1-.28-.09-.06,0-.3,.08-.06,.13,.06,.01,.15,0,.23-.02,.08-.02,.15-.03,.19,.01,.16,0,.2-.08,.29-.05-.03-.01-.1-.02-.08-.05l.31,.03h-.02l.12-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.8,137.61s.03,0,.06,0c-.01,0-.03,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.5,130.2l-.21,.12s.14-.07,.2-.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.44,136.94c.1,.04,.03,.07,.14,.06-.06-.08-.05-.08-.2-.12-.01,0-.04,.04-.09,.04-.1-.03,.03-.07,.05-.1-.12-.04-.34,.03-.47,.08l.23-.05v.08c.1,0,.2,.02,.27,.04-.02-.02,.04-.03,.07-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.11,136.93s-.07,0-.1,0c.03,0,.05,.03,.1,.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.54,133.23s-.02,.01-.03,.02c.02,.05,.07-.03,.12-.02l-.07-.05h.02s-.09,.02-.14,.04h.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.79,129.35h-.06s0,.02,0,.03l.06-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.38,138.43s.01,0,.03,.01h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.31,138.42h0s.05,.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.31,138.41s0,0,0,0l.07,.02s.06-.04,.05-.05c-.06,0-.17,0-.13,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.93,136.39l.06,.06s.08-.02,.12-.03c-.06,0-.12-.02-.18-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.95,135.14c-.05-.03-.02-.1-.16-.04,.03,0,.05,.02,.08,.02h.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.95,135.14s.02,.01,.04,.01h-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.73,133.2c.07-.03,.11-.08,.13-.12l-.13,.04v.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.98,137.94v.08s.11-.05,0-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.87,130.11s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.57,130.19c.11-.03,.17-.15,.3-.18,0,.02-.05,.09-.09,.08-.06,.09,.04,0,.07,.01,0-.02,.04-.05,.07-.05,.07,0-.05,.07,.02,.06-.04,.04-.18,.07-.16,.13,.06-.04,.19-.07,.27-.15-.13,.01,.1-.09,0-.09l-.08,.05s.06-.09,.03-.13h.07s-.06-.02-.13-.01c-.03,.04,.05,.06-.04,.1l-.13-.02,.07-.05c-.11,.05-.26,.11-.28,.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.34,135.58s-.02,0-.03,0c0,0,.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.23,135.59s.05,0,.08,0c-.02-.01-.02-.04-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.4,135.59s0-.07-.03-.04h0s-.03,.03-.03,.03c.02,0,.04,0,.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.91,135.88l-.13,.03c.07,0,.09,0,.08,.03h-.03l.07,.03c-.1-.03,.06-.06,0-.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "286.41 138.21 286.63 138.22 286.41 138.18 286.41 138.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286,138.34s.08,0,.12,0c-.02-.01-.03-.02-.05-.03,.02,.02-.03,.02-.07,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.19,135.87l-.19-.03c-.07,.02,.03,.05,0,.08,.08,0,.19-.02,.18-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "295.61 130.2 295.67 130.25 295.68 130.21 295.61 130.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "292.05 135.03 292.12 135.04 292.1 135.01 292.05 135.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.04,136.58l-.04-.02-.04,.05s.05-.02,.07-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.14,131.4c-.05-.03-.09,.05-.13,.06,0,.01,.08-.02,.13-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.24,135.38h0c-.25,.01,.04-.14-.24-.1-.14,.19-.19,.02-.36,.21h-.1l.07,.02s-.18,.06-.11,.08c.11,0,.43-.15,.53-.07l-.04,.03,.09-.06h-.08c0-.06,.2-.1,.24-.06l-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.68,134.99c.05-.03,.04-.06,.03-.11,.04,0,.09-.05,.11-.03l-.03,.08c.15-.09,.18,.02,.25,.03-.1-.12,.33-.15,.23-.27-.07,.02-.08-.05-.03-.07l-.22,.02c-.11,.15-.49,.24-.59,.29h-.11l.17-.09c-.08-.05-.11,.09-.21,.05,.05,.05,.13,.06,.27,.02h.01s.07,0,.1,.02c-.04,.04-.09,0-.12,.05,.05,.04,.16-.07,.14,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "292.19 135.11 292.2 135.1 292.07 135.08 292.06 135.09 292.19 135.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.38,138.32c.2,.04,.28,.12,.5,.13-.14-.04-.16-.19-.5-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.71,130.32c.09-.07-.06,.02,.03-.06l-.08,.06s.02,.02,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.69,134.63c.11-.04-.02-.05-.02-.06l.02,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M294.31,132.69s.16-.07,.07-.06c.22-.07-.02,.1,0,.11l.17-.03v-.03c.07,0,.19-.08,.27-.14v.04c.15-.08,.06-.1,.17-.17-.07,0-.3,.02-.35,.04-.13,0-.21,.11-.33,.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.1,135.17s.04-.01,.06-.02c-.03,0-.04,.01-.06,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.06,135.23s.01-.04,.04-.06c-.06,.02-.11,.04-.04,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M294.44,132.78l-.19,.05c.02,.06,.15-.08,.12,0,0-.02,.04-.04,.06-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.36,135.91s.02-.08-.1-.04l-.05,.05h.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.48,136.55s-.01,0-.02-.01c0,0,0,0,.02,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.32,136.56s.03,0,.03-.02c-.02,0-.03,.02-.03,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.48,136.48c-.15,0-.12,.04-.12,.07,.03-.01,.07-.02,.1,0-.01-.02,.06-.04,.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.24,137.69c-.06,.02-.01,.03,0,.06,.05,0,.16,0,.16-.05-.09,.04-.1,0-.16-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.52,128.69v.02s0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.67,128.66l.06-.02s0-.05,0-.06c-.08,.08-.15,.16-.21,.2v-.07s-.12,.11-.17,.16h.03l-.08,.08c.22-.01,.27-.3,.43-.27,.12-.11,.06-.04,.17-.14-.11-.03-.12,.16-.24,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.34,134.08s.14-.02,.12,.02c0,.02-.05,.03-.07,.05,.03,0,.09-.03,.14-.06v-.07s0,.03-.07,.06c-.06-.06,.1-.08,.17-.13-.07-.02-.28,.09-.29,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.14,134.25c.08,.03,.22-.02,.27-.08-.13,.01-.14,.11-.27,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.79,138.07c-.08-.03-.15,0-.33,.01,.07,.01,.15,0,.23,0h0c.07,.05-.05-.04,.1-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.5,136.69l.09-.09-.3,.06c.08,0,.23-.04,.21,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.4,137.27l-.16,.02,.09,.03s.08-.03,.07-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "293.25 134.33 293.21 134.34 293.19 134.39 293.25 134.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.31,135.26s-.04,.07,.03,.06l.02,.03c.09-.09,.11-.09,.19-.15-.15,.03-.19,.1-.25,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.3,135.25h.01s0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M294.87,132.39c.05,0,.12-.03,.15-.05,0-.07-.13,.06-.15,.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "287.9 138.11 287.87 138.12 288.04 138.14 287.9 138.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M294.77,132.69s-.11,.03-.14,.08c.05-.01,.13-.04,.14-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.28,129.75c.05-.07,.1-.04,.12-.03,0-.02-.05-.02,0-.06,0-.03-.11,.02-.11,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.88,137.31s.02,0,.05,0c.04,.03-.04,.04-.09,.05l-.12-.04s.19-.04,.14-.05c-.09-.05-.26,.05-.15,.07h-.19s.08,.02,.05,.04l-.06,.03c.15,.04,.51-.03,.71-.07-.03,0-.07,0-.11,.01,.05-.03,.11-.07,.16-.1-.13,.07-.27,.05-.39,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.72,138.24c.18,0,.2,0,.33,0-.06-.06-.33-.02-.33,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.64,134.13h0s-.01,0-.02,0h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.77,134.04h.05s-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.76,134.15l-.12-.02s0,.02-.01,.04l.13-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.65,134.12c.06-.02,.08-.06,.12-.08l-.11,.02s.07-.01,.07,.01c-.06,.03-.07,.04-.07,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.14,130.3c0-.07,.17-.12,.09-.15-.12,.01-.18,.18-.09,.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "292.46 135.38 292.36 135.38 292.44 135.41 292.46 135.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.24,136.29c-.12,.04,0,.08,.01,.1h.03l-.06-.04c.13-.05,.3-.1,.37-.15-.15,.01-.19,.12-.35,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.06,135l-.26,.09s.03,.04-.06,.05c.08,.04,.19-.05,.28-.08,0,0-.02,0-.03,0l.07-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.44,134.65c-.11,.08-.12-.06-.23,.06,.06-.02,.08,0,.08,.02-.09,.08-.08,0-.13,.01-.04,.03-.1,.08-.16,.11-.06,.03-.11,.05-.12,.04-.16,.05-.48,.15-.52,.07,.16-.05-.1-.09,.14-.14-.09-.07-.37,.14-.49,.09l.15-.06c-.2,0-.07-.15-.27-.12l.14-.04s.03-.05-.03-.03l.02,.03c-.07,.02-.1,0-.13,0-.07-.01-.19,.18-.35,.14,.02,.01-.03,.05-.06,.08-.04-.06-.25,.02-.34,.06,.1,.02-.06,.04-.01,.08-.01,0-.03,.01-.04,.02,0,0,.02,0,.02,.02,.01,.02-.1,.1-.16,.07l.05,.04c-.07,.03-.22,.04-.12-.02l-.26,.1c.27-.11,.12,.18,.39-.01,.13-.04,.3-.04,.38-.13,.09,.02,.26-.08,.2,.01l-.2,.04h.06c-.27,.08-.32,.22-.57,.33-.12,.02-.17-.02-.27,0l.03,.07s.11,.03,.15,.06l-.09,.02c.04,.06,.14-.06,.19-.08,0,.08,.21-.05,.18,.04,.18-.05,.01,.11,.29,0h0c.1-.05,.27-.08,.38-.12,.04-.06-.01-.1-.14-.05-.12,.06-.19,.05-.28,.1,0-.02,.16-.08,.08-.08l-.17,.07c-.14-.02,.03-.13-.03-.19l.04,.03s.02-.07,.08-.09l.05,.07c.04-.06,.25-.09,.28-.14v.06c.21-.11,.44-.21,.61-.3,.08,.03-.05,.16,.03,.2-.04,.01-.16,.02-.09,.05,.14-.08,.25-.07,.36-.09l-.04,.05,.14-.05-.06-.02c.13-.02,.3-.06,.41-.13h-.02c.08-.03,.24-.13,.27-.08-.05,.06-.16,.12-.24,.13-.07,.04,.01,.02,.02,.03,.11-.06,.34-.15,.31-.1l.12-.15c-.09,.06-.12,.06-.12,.01,.12-.07,.49-.28,.52-.31-.11-.01-.43,.18-.43,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.02,135.06s.04,0,.06-.01c-.02,0-.04,0-.06,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.07,135.6h0s-.04,0-.07,.02c.02,0,.05,0,.07-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "294.87 132.72 294.85 132.76 294.93 132.71 294.87 132.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.32,134.65h.07v-.06c.05-.02-.18,.06-.07,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.72,136.83l.13-.05h-.12s-.08,.04-.02,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M297.82,128.77s-.03,.01-.04,.01c.02,0,.04,0,.04-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.04,128.1s.02-.01,.02-.02c-.01,0-.02,.01-.02,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M297.97,128.21s0-.02,.02-.03c-.02,0-.02,.02-.02,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.66,129.1s.1-.02,.13,.01c-.08,.04-.1,0-.15,.1,.03-.04,.13-.1,.15-.04-.02,.03-.04,.02-.07,.03h.2v-.03c.03-.05,.13-.08,.13-.05,0-.03-.01-.06,.06-.11,.1,.02,.33-.33,.37-.14,.06,.02-.03-.04,.06-.08,.02,.02,0,.06-.01,.09l.08-.08c-.14,0,.03-.2-.06-.24,.05-.02,.13,.01,.11,.03,0-.03,0-.02,0-.03,.04,.02,.07-.05,.16-.04l-.07,.07h.01c0,.05-.11,.14-.08,.17,.05-.11,.15-.13,.24-.17l.02,.08c-.09-.01-.06,.08-.1,.12,.08-.03,.13-.1,.24-.23h-.01c.1-.07,.08-.12,.16-.18l.04,.02c.06-.08-.04-.06-.05-.05-.05,.15-.16,.09-.22,.2-.03-.02,.03-.09,.07-.13,0-.04-.03,0-.07,.02-.04,.03-.08,.05-.08,.01l.04-.05s-.06,.05-.07,0c.08-.05,.09-.09,.09-.13,0,0-.02,.02-.03,.02-.05-.08,.04-.13,.11-.17h0c.05-.12,.17-.1,.2-.22-.07,.08-.18,.17-.24,.16,.02-.05,.07-.13,.1-.12-.11-.02-.14,.12-.23,.08,0,.05,.04,.06,.07,.04-.08,.11-.17,.04-.22,.15,.01,0,.03-.01,.04-.02-.03,.06-.07,.12-.1,.18-.06,.03-.07-.07-.14,.05,0,.03,.06-.04,.09-.05l-.03,.06c.06-.03,.08-.07,.13-.09-.02,.08-.03,.07-.03,.13l-.13,.06,.03-.07c-.1,.04-.16,.03-.29,.15v.09s.04-.02,.07-.05c0,0,0,.03,.03,.04-.05,.04-.15,.04-.13,.11l-.16,.02h.03c-.11,.09,.02,.1-.11,.18v-.07c-.07,.11-.16,.04-.27,.12l-.08,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M297.97,128.21s0,.03-.01,.05c.01-.02,.01-.03,.01-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.04,128.1h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.16,139h.21c.07,0-.12-.02-.21,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.76,128.85h.05s.02-.06,.03-.08c-.03,.03-.05,.06-.08,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.98,136.73v-.02s-.02,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M290.97,136.67v.05s.1-.05,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.61,134.56h.02s-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.45,134.62c.07,.03,.13-.04,.17-.07-.04,0-.11,.03-.17,.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "296.76 129.26 296.69 129.32 296.71 129.33 296.77 129.27 296.76 129.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.08,132.75c.06-.05-.03-.02-.01-.04l-.1,.07,.11-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.41,136.59c.08-.01,.04-.04,.03-.06-.06,0-.12,.02-.19,.02,.04,.02,.14-.02,.13,.02-.06,.02,.02,0,.02,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.43,136.73s.13-.05,0-.05c-.09,.01-.18,0-.27,.01l.05-.05s-.12,.02-.15,.04c.2-.05-.04,.07,.12,.07,.09-.08,.18-.05,.25-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "293.53 134.7 293.52 134.64 293.51 134.68 293.53 134.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.86,136.15c.15,.02,.23-.04,.38-.1-.1,.05-.32,0-.38,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.09,136.99c-.13,0-.29-.1-.42,.03l.12-.02c-.18,.06,.06,.05,.04,.09h-.18c-.06,.01,.06,.04-.06,.06h.26l-.03-.04,.21-.06c-.13,0,0-.03,.05-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M294.41,133.74s0,.02,0,.03c0,0,.01-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M294.25,133.89c.04-.07,.12-.01,.18-.02,.09-.04,.05-.05,.12-.1-.01-.02-.12,.02-.14,0-.03,.04-.2,.07-.16,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.65,134.61s.2-.09,.27-.07c-.01-.02,.05-.07,.08-.1-.1,.06-.11,.02-.16,.01,.02,0,.02,.03,.02,.04-.02,.02-.04,.05-.09,.07l-.04-.06c-.06,.04,.09,.06-.07,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.81,134.45s.02,0,.02,0c0,0-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.43,135.77c-.06,.05,.07,.06,.08,.05-.02,0-.05-.01-.07-.02,.04,0,.08-.02,.11-.04-.04,0-.08,0-.13,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.77,136.34l.06,.08c.01-.1,.25-.13,.38-.19-.11,.01-.4,.07-.49,.13l.06-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "292.89 135.44 293 135.39 292.92 135.42 292.89 135.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "292.02 136.43 291.66 136.49 291.79 136.51 291.84 136.48 292.02 136.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.75,135.72v-.02h0v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.61,135.75s.02,.05,.08,.03c-.07,0,.06-.08-.08-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.96,135.7c-.06-.03-.09-.02-.19-.02l-.02,.03c.06-.03,.06,0,.08,.01,.01,.03-.08,.03-.11,.06,.07-.02,.14-.05,.18-.05l.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.73,135.77h-.03s.01,0,.02,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.51,136.64c.18-.06,.06,.04,.18,.01l-.07-.07-.11,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.78,130.04s.03-.02,.06-.04c0-.02-.11,.04-.16,.05,0,.05,.09-.01,.1,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "295.84 131.81 295.85 131.87 295.87 131.85 295.84 131.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.25,132.86c.09,0,.06-.06,.07-.08-.09,.03-.03,.06-.07,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.6,136.72s-.08,.01-.12,.02c.02,.01,.08,0,.12-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.94,131.81c.09,0,.22-.17,.25-.08,.04-.1,.13-.09,.14-.17-.1,.13-.25,.09-.35,.17,0,.02-.02,.06-.03,.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "294.09 134.43 294.1 134.42 294.18 134.42 294.08 134.41 294.09 134.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.2,136.98s0,.03,.04,.03c0-.01,.07-.06-.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.88,138.35l.16-.03c-.09,0-.08,.02-.16,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M294.67,134.37l-.08,.02s.07,0,.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.25,134.35c-.1-.02-.1,.12-.23,.13-.12,.03-.01-.08-.1-.08-.24,.14,.1,.18-.21,.2v-.05c-.09,.04-.18,.05-.27,.07,0,0,0,.02-.01,.05-.14,.05-.06,0-.12,.08,.1,.07,.31-.18,.36-.08-.02,0-.04,.02-.06,.03h.05c.07-.05,.17-.09,.27-.14,.13-.06,.26-.13,.31-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M294.76,134.48c.05-.06,.11-.17-.03-.12,.09-.11,.11,0,.16-.04l.03,.06c.07-.11,.09-.16,.04-.19-.03,.06-.11,.05-.16,.07l.08-.07h-.14v.04c-.06,0-.13,0-.2,0l.09-.08c-.14,.07-.36,.1-.47,.19l.21-.07-.08,.07s.13-.09,.21-.07c.09,0,.12,.08,.25,0-.08,.03-.04,.08-.07,.1h.04c-.11,.07-.08,.08-.24,.17-.08,.06-.05,.06-.04,.08,.17-.03,.2-.27,.32-.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "294.44 134.62 294.44 134.62 294.44 134.62 294.44 134.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M294.7,134.71h-.04s-.03,.02-.04,.04l.08-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M294.61,134.7h-.01s0,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.15,136.43h-.04s.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.24,136.42l.08-.05c-.13,0-.1,.06-.17,.06h.06c-.1,.14-.26,0-.4,.14,.13,0,.35-.08,.48-.1,.16-.02,0,.05,.03,.05l.18-.06c-.03-.07-.15,0-.26-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.89,138.48s.02-.02,0-.03v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.74,138.5h-.09s.06,0,.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M288.74,138.5l.15,.02v-.04s-.08,.03-.15,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M297.35,128.87s-.08,.08-.09,.12c0,0,.04,0,.03-.02l.06-.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "294.12 134.72 294.15 134.67 294.04 134.71 294.12 134.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.33,137.17c-.09,.04,.12,.06-.07,.09l.22,.02c.11-.02,.04-.09,.1-.11-.09,0-.06-.05-.24,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M291.66,137.15s-.07,0-.08,0c.02,0,.05,0,.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.8,138.38c.05-.07-.13-.02-.21-.03l.02,.02c-.1,.04-.14,0-.24,0-.06,.03,.09,.05,.16,.05l.17-.02s-.08,0-.11-.01c.07,0,.18-.04,.2-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.59,138.35l-.04-.03s.01,.03,.04,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "296.16 132.12 296.26 132.08 296.18 132.08 296.16 132.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.99,135.25l-.02,.06-.19,.06h.12c0-.06,.15-.04,.24-.1-.08,.01-.02-.08-.14-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.91,138.41s.04,.02,.05,0l.05,.06c.15-.04,.22,0,.33-.06-.15,.02-.25-.06-.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293,136.32c.11-.03,.14-.08,.15-.12-.01,.01-.07,.07-.16,.06h.07l-.06,.04v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.08,136.42c-.11,.11-.21,0-.3,.11,.07-.03,.1,0,.14-.02,.03-.05,.14-.02,.15-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.86,136.75h0s-.04,0-.06,.02l.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M294.9,136.32s-.08,.02-.12,.03c.04,0,.09,0,.12-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M292.93,136.5s0,.01,0,.02h0s0-.02,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.47,135.92v.02s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.62,135.92h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.84,135.94c-.01-.08,.13,0,.17-.11l-.14,.05s.06-.16-.05-.12c.02,.04-.11,.1-.19,.15,.03,0,.07,0,.11-.03,0,.06-.04,.1,.11,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.24,136.26c0-.06,.24-.14,.27-.14-.01-.02-.03-.06,.08-.09,.06-.03-.07,0-.12,.02,.13-.12-.01,.01,.05-.11,.03-.02,.05-.02,.08-.02l-.04-.05c.08-.02,.13-.06,.17-.09-.01-.02,.04-.05,0-.06-.16,.02-.22,.13-.25,.17h-.08c-.07,.06,.04,.03,.07,.03h0s.05-.02,.07-.02c.02,.04-.05,.07-.14,.11-.05-.12-.34,.02-.41-.08-.02,.07-.19,.04-.12,.09-.3,.04,.16-.22-.18-.11-.18,.1-.4,.16-.57,.2,0-.02-.04-.05,.04-.07l-.11,.02-.02,.07c-.09,.04-.19,.06-.28,.1h.02c-.14,.07-.18,.06-.37,.09-.08,.18-.15,.09-.45,.21-.02,.05-.11,.08-.21,.11-.11,.02-.23,.04-.26,.07h.12l-.07,.05c.06-.01,.15-.03,.22-.03,.06,0,.11,0,.12,.02,.09-.03,.2,.02,.25-.06-.09,0-.19,0-.18-.07,.2-.05,.27-.05,.4-.11h0l.15-.05h-.05c.08-.06,.26-.07,.38-.09-.09,.03-.09,.11-.03,.08-.05,.01-.01-.02,.01-.05l.14,.05-.03-.02c.06-.03,.13-.05,.19-.05,.06,0,.11,0,.16,0-.13,.1,.02,.15,.04,.2-.11,.08-.23,.12-.32,.16,.1-.02,.2-.03,.3-.06,.07-.07,.06-.13,0-.17,.15,0,.08-.09,.2-.11,.02,.05,.11,.08,.01,.14l-.08,.03,.16-.04c-.02-.06,.12-.12,.24-.16-.04,0-.07,0-.1,0,.1-.13,.15,0,.22-.1-.07,.05,.11,.04,.19,.01l.07-.07,.08,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.83,138.46l-.12,.08h.24l.06-.04c-.06,.03-.24,0-.18-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "297.96 127.56 297.95 127.62 298.01 127.54 297.96 127.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.93,133.18l-.04-.04c-.02,.07-.07,.02-.15,.08h.12s.05-.04,.08-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "292.1 137.15 292.07 137.18 292.19 137.19 292.1 137.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "290.05 138.51 290.25 138.47 290.09 138.49 290.05 138.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.24,127.36l.02,.06c.05,.04,.15-.16,.17-.19-.02,0,0-.07,0-.07,.04-.02,.1-.08,.07,0,.09-.09-.03-.07-.05-.08,.02,.01-.07,.11-.08,.04,0,.15-.31,.22-.12,.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M297.74,129.68l-.06-.02s0,.11,.06,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.93,131.6l.17-.08s-.14,0-.17,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M297.7,131.79s.08-.06,.13-.09c-.13,0-.34,.15-.52,.26,.06-.04,.02,0,0,.03-.05-.02-.14,.06-.18,.03,.03,.03,.08,.05-.02,.12-.05-.01-.06-.06-.03-.12-.09,.05-.07,.11-.08,.16-.08,.03-.17,.1-.26,.17-.09,.07-.18,.12-.24,.15l-.03-.04-.02,.06c.1,.02,.17-.1,.27-.1,.07-.08,.1-.08,.21-.19,0,.04,.03,.04-.04,.08,.02,0,.08-.06,.12-.11,.07-.07,.08,0,.12,0-.05,.07-.13,.1-.21,.16,.13-.02-.09,.12-.06,.12,.05,.06,.21-.1,.25-.15-.04,.04-.08,.03-.08,0,.08-.08,.24-.07,.34-.17-.03-.05-.1-.01-.15-.02,.21-.15,.31-.24,.51-.36-.02,0-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.4,134.21l-.16,.07s.05,.02,.09,.01c-.07-.03,.07-.05,.07-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.09,128.89l-.08,.07s0,.06,.04,.02c-.05-.03,.08-.07,.04-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.23,128.69s-.01,.01-.02,.02c.01,0,.02-.02,.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.15,128.65s.08,.01,.08,.04c.03-.03,.07-.03,.09-.05h-.05c.07-.05,.16-.15,.13-.05,.01-.06,.05-.1,.09-.09-.01,0,0-.04-.02-.05,.09-.1,.29-.22,.21-.3-.04,.05-.06,.07-.09,.09-.07,.08,.06,.01,0,.08-.11,.04-.22,.07-.33,.18,.03,.04-.04,.08,.03,.09-.08,.11-.06,.02-.13,.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "298.58 128.24 298.58 128.24 298.58 128.24 298.58 128.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.28,128.29c.22-.25,.06,.17,.3-.05-.14,.1-.09-.2-.3,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.52,127.56v-.07c-.07-.01-.09,.13-.17,.23,.08,.01,.11-.13,.17-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.19,136.68c.05,0,.1,0,.14-.03l-.04-.06-.1,.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "291.49 138.11 291.58 138.09 291.42 138.1 291.49 138.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.5,127.46s.05-.05,.08-.08v.05l.03-.12c-.08-.02-.04,.08-.14,.1,.02,.02,.02,.03,.03,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.38,128.69c.01,.07-.12,.1-.13,.17,.03,.02,.07-.03,.12-.08,.04-.05,.09-.11,.14-.08,.06-.07,.13-.14,.17-.21h-.07v.02s-.13,.07-.22,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.42,130.62v.03s0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.88,130.21s.03-.02,.04-.04c-.03,.02-.04,.03-.04,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.23,130.76h.02s0-.02-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.08,131.85s0,0-.01,0h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.9,130.44h-.12l.07-.08s-.07,.03-.08,.01c.04-.12,.09-.08,.15-.14,.04,0-.04,0-.05-.02-.04,.04-.1,.07-.06,.08-.09-.06-.3,.17-.37,.14-.08,.1,.09,.02-.04,.13l-.04-.02c-.07,.09-.1,.14-.17,.21-.13,.06-.29,.14-.38,.14,.07-.07,.15-.14,.22-.2-.04-.07-.21,.15-.21,.18-.16,.1-.08-.11-.26,.03,.05-.09,.17-.19,.21-.3l-.05,.07s0-.05,.01-.08c-.02,0-.05,.05-.08,.04-.03-.06,.11-.12,.12-.21-.08,.1-.13,.02-.18,.14v.08c-.18,.11,.03-.11-.08-.08l.02,.04s-.07,.08-.11,.07v-.02s-.09,.07-.14,.11h-.04c-.11,.06-.1,.13-.21,.2,.03,0,.12-.11,.12-.04-.09,.07-.21,.24-.31,.26,0,.02-.08,.11-.01,.09-.06,.04-.14,.07-.17,.13l-.04-.05s-.02,.07-.07,.1c-.05,.03-.12,.06-.12,.08v-.05l-.07,.08s.04-.02,.05-.02c0,.04-.05,.09-.11,.14,.04-.08-.05,.01-.08,0-.01,.03,0,.02,.01,.03,0-.01,.04,0,.04-.02,.19-.01-.28,.21-.09,.2,.01-.05,.13-.1,.17-.1h-.02c.17-.05,.26-.17,.39-.26-.03,.01-.06,.03-.07,.01,.14-.1,.15-.03,.33-.14l.12-.14c.05,0,.11,.03,.15-.06,.05,0,.1,.02,.03,.09l-.09,.07s.06,.02,.12-.04v-.03s.11-.05,.19-.08l-.03,.11c.05-.07,.06-.02,.08,0-.01,.07-.1,.08-.14,.1-.04,0,.03-.07-.04-.02l-.03,.09c.06-.06,.05,0,.08-.02-.05,0-.18,.15-.25,.13-.03,.07,.1-.06,.04,.05-.13,.07-.11-.01-.22,.04,.08-.05,.07-.13,.14-.13-.02,0-.06,0-.09,.02-.07,.09-.07,.17-.1,.2,.03-.05,.08,0,.07,.04-.09,.03-.07,.11-.19,.18,.03,0,.08-.02,.13-.06,.04-.03,.07-.06,.1-.06,0-.03,.09-.13,.12-.12l-.03,.07c.11-.11,.29-.28,.38-.28-.06-.08,.19-.21,.21-.26,.2-.18,.28-.03,.47-.31h0s.21-.25,.28-.17l-.06-.04c.14-.15,.07,.08,.22-.1l.04,.06c.06-.04,.08-.1,.15-.18h-.03s.07-.04,.11-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.15,131.53h0s.02,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.36,136.85s.13-.1-.01-.07c.06,.03-.16,.09,.01,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.61,127.47s.05-.04,.06-.06c0,.1,.17-.2,.15-.06,.15-.14,.08-.2,.22-.3,0,.04,.04,.04,.07,.04v-.07l.09-.04c-.09-.05-.13,.1-.2,.02l.1-.08s-.1,.04-.13,.06v.05s-.1,.11-.07,0c-.02,.05-.03,.09-.07,.14-.04-.04-.07,.04-.13,.09-.1,.11,.07,.12-.08,.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "293.75 136.57 293.86 136.54 293.75 136.53 293.75 136.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.89,132.84h-.08l.02,.03s.06-.01,.06-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M297.11,132.66l-.09-.05c-.03,.05-.05,.1-.08,.15,.04-.07,.11-.1,.18-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.55,134.89l-.11,.06s.12,0,.11-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.4,134.97l.04-.02s-.03,0-.04,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.43,137.07c.06-.03,.2-.07,.14-.09-.02,.08-.15,.02-.2,.07,.05-.01,.04,.01,.06,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M297.13,132.55c.07-.1,.09,0,.18-.09,0-.03-.18,.05-.18,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M297.12,133.78c-.18,.08-.23,.22-.33,.33l-.03-.07c-.09,.03-.13,.13-.23,.15-.06,0,0,.01,.02,0l-.23,.13c-.12,.12,.19,.01-.03,.14,.02-.11-.18,.06-.18,0-.1,.1-.36,.24-.46,.3-.13,.2,.31-.08,.31,0l-.02-.06c.24-.13,.24-.05,.43-.12l-.16,.09c.1-.02,.05,.02,.18-.07,.06-.08-.11-.03-.15-.09,.17-.04,.24-.11,.32-.17,.08-.06,.16-.12,.34-.17l.08-.12s-.1,.02-.15,0c.21-.05,.33-.3,.54-.37-.02-.05-.19,.1-.26,.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "296.02 134.49 295.88 134.52 295.85 134.57 296.02 134.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "295.27 135.32 295.38 135.28 295.27 135.3 295.27 135.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "292.05 138.21 292.23 138.16 292.11 138.17 292.05 138.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M297.53,132.09h-.07s.03,.03,0,.07c.01-.03,.04-.04,.07-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M297.38,132.46s-.12,.08-.15,.11c.05-.03,.11-.08,.15-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.12,127.6c-.02,.08,.01,.1-.04,.17-.03,0-.04-.03-.01-.08-.1,0-.09,.2-.2,.27l.05,.05s-.03-.04-.04-.06c.08-.04,.13-.09,.17-.14,.04-.06,.08-.12,.13-.17-.01,0-.03,0-.02-.04l.05-.03c-.01-.07-.08,.06-.1,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.29,137.41s-.04,.12-.13,.09c-.07,.09,.17-.08,.17-.02l.06-.07s.03,.06,.03,.08c.05-.01,.19-.02,.17,.02l.24-.11c-.16-.04-.31-.04-.55,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M293.43,137.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M297.7,131.98s.07-.07,.06-.1c-.07,.03-.07,.07-.06,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M297.41,132.53s0,.04,0,.06c.1-.06,.03-.05,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.59,135.48c-.08,.05-.16,.1-.25,.14,.04,0,.09,.03,.06,.08,.06-.03,.12-.06,.19-.09h-.07s.15-.12,.07-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.17,128.04l-.13,.06s.03,0,.04,.02c.03-.02,.06-.02,.09-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.05,128.17s.05-.05,.03-.05c-.01,.01-.02,.03-.03,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M294.56,136.65l-.21,.09c.16-.05,.16-.04,.27-.13l-.13,.03c-.08,.05,.09-.04,.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.07,128.3c.06-.05,.12-.06,.18-.19-.07,0-.15,.15-.18,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.4,126.18s-.07,.09-.04,.09c0-.01,.04-.06,.04-.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "299.41 126.89 299.31 126.94 299.34 126.98 299.41 126.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.16,134.94v-.02s0,0,0-.01c-.01,0-.03,0-.04,0l.04,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.24,134.87s-.05,.02-.07,.03c.02,0,.05-.02,.07-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.37,134.74s-.05,.09-.13,.13c.06-.01,.13,0,.16-.07-.01-.02,.07-.09-.03-.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "295.77 135.38 295.72 135.41 295.75 135.44 295.77 135.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.32,127.72v-.05l-.04,.1s.03-.04,.04-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "298.23 131.45 298.28 131.5 298.28 131.42 298.23 131.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.53,127.78h-.05l.06-.07c-.09-.05-.15,.23-.2,.18,0,.04-.02,.08-.03,.12-.01,.04-.02,.07,0,.11,.03,.08,.1-.1,.17-.06,0-.04,0-.14,.08-.19,.06-.07-.04,.04-.08,.06,0-.03,0-.1,.05-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.36,127.66s0,.08,.02,.09c.06-.05,0-.06,.03-.12l-.05,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.73,134.44l-.1,.04s-.02,.05-.02,.08c.15-.08,.02-.08,.12-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.62,134.49l-.04,.02s.02,0,.04-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "296.62 134.49 296.63 134.48 296.63 134.48 296.62 134.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.54,127.34c-.07,0-.06-.02-.13,.02,.05,.05,.04,.06,.13-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.59,134.62s-.08,.05-.12,.08h.09s.1-.09,.03-.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "298.31 131.69 298.24 131.77 298.34 131.71 298.31 131.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.8,136.14c-.11,.05-.25,.06-.37,.08-.13,.03-.24,.06-.3,.15,.16,.01,.23-.19,.36-.13h-.03c.22,0,.28,0,.47,.01l.16-.08s-.05,0-.06,0c.15-.04,.05-.08,.17-.11-.11,.04-.27,.03-.41,.04v.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "298.82 130.57 298.85 130.46 298.77 130.51 298.82 130.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M297.07,133.97c-.08,.07,.04,.03,.06,.03,.06-.05-.01-.04-.06-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "298.78 130.72 298.87 130.63 298.79 130.68 298.78 130.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.02,132.51c.05-.03,.06,0,.06,0l.06-.04s-.07,0-.13,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.24,129.58s.04-.02,.06-.04c-.02,0-.05,0-.08,0-.02,.02,.02,.02,.02,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.62,127.58l.05,.05c.02-.06,0-.09-.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.11,130.15l.03-.05s-.04,.06-.05,.05l.02-.06c-.09,.07-.02,.06,0,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "295.02 136.91 295.04 136.87 294.79 136.98 295.02 136.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.38,129.95s.02,0,.03-.02l-.03,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.12,130.04c0,.07,.24-.14,.22-.07l.03-.02s-.02-.07-.05-.05c.11-.09-.05-.03,.05-.12h-.06c.09,.05-.12,.18-.15,.26-.02,0,.02-.06,.01-.08l-.06,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.65,131.38l.06,.02s.04-.06,.05-.09l-.11,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.22,129.89l.07-.07s-.1,.04-.07,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.88,127.31c-.04,.06-.17,.17-.13,.22,.07-.07,.08-.15,.13-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.73,131.89l-.03-.09c-.06,.05-.12,.13-.14,.11,.02,.07-.24,.17-.12,.19l.27-.17s-.05,.02-.06,0c0-.02,.05-.05,.07-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.76,128.99c-.07,.04-.26,.22-.36,.36,.1-.01,.27-.24,.36-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.26,136.82c.09-.08,.17-.07,.23-.14-.1,.02-.21,.13-.29,.14-.04,.03,.04,0,.06,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "299.11 130.62 299.18 130.55 299.11 130.56 299.11 130.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.36,132.4s.06-.05,.1-.07h0s-.07,.04-.1,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M297.98,134.55l.04-.08s-.07,.04-.1,.03c.13-.08-.06-.05,0-.14-.1,.11-.05-.04-.13,.02-.22,.15-.47,.45-.68,.44,.09,.02-.03,.09-.11,.14,.02-.09-.04-.06-.18,.01,.06,.04-.14,.08,0,.07v-.02c.15,.04,.49-.26,.64-.19-.15,.07-.35,.21-.5,.33,.19-.02,.42-.28,.68-.36l.04-.08-.2,.06c.17-.1,.27-.23,.43-.29-.03,.07-.16,.17-.13,.2l.37-.13c-.11,.04-.02-.13-.16-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.02,124.19s-.04,.02-.06,.02c.02,0-.01,.06-.02,.09h-.03s0,.05,.01,.07c.07,0,.07-.15,.1-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.88,124.29h.04s-.01-.03-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.06,124.19s-.02,0-.03,0c.01,0,.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.84,128.04c.04-.05,.09-.04,.07-.11l.1-.02c.02-.13,.05-.11,.09-.23-.08,.11-.33,.21-.26,.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.89,128.16c.07-.1-.03,0-.01-.07,0,.01-.06,.1-.07,.15l.08-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.14,136c.06-.02,.17-.06,.23-.1,0-.02-.01-.08-.1-.04,.12,.04-.23,.1-.12,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.14,136h0s-.04,.01-.05,.02l.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.52,129.61s.04,.02,.02,.07l.08,.02c-.05-.05,.12-.15,.18-.2-.05,0-.11,.09-.15,.08,.1-.08,.11-.21,.16-.28-.13,.15-.15,.2-.29,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M297.87,133.72c.09-.01,.23-.02,.37-.17h-.11c.08,0-.07,.09-.11,.12,.06-.1-.11,0-.14-.02l-.1,.08v.07c.07-.04,.07-.03,.09-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.33,124.47l.02-.06c-.05,.14-.03-.05-.08,.04,.04,.03,.08,.02,.05,.11-.18,.1-.06,.33-.2,.43-.02,.06-.08,.05-.08,.06,.01,.05,.06,.03,.09,.01,0-.14,.08-.2,.17-.33-.01,0-.02,0-.02,0,.02-.02,.05-.07,.07-.12,.03-.05,.05-.1,.06-.12l-.02-.09s-.03,.09-.06,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.38,135.94c-.06,0-.12,.06-.15,.08,.05,.02,.12-.05,.15-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.02,127.63c0,.08,.13-.03,.16-.01h-.02s.04-.05,.07-.07c-.06-.02-.15,.11-.2,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.23,133.26h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.12,133.34c.06,.01,.09-.06,.11-.08-.04,.02-.06,.02-.11,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.02,131.64l.04-.06-.09,.06s.03,.01,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M295.61,136.78h.15c-.07,.04-.11,.13,.04,.07l.02-.1c-.07,.04-.09-.02-.22,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "300.13 123.82 300.13 123.8 300.06 123.86 300.06 123.89 300.13 123.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M297.63,134.26l.14-.05s.01-.04,.02-.05c-.1,.02-.06,.05-.16,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.37,124.98l.03-.07c-.03-.06-.05,.07-.09-.01,0,.1-.09,.07-.12,.14,.04,.07,.18-.15,.18-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.09,133.52l.08-.02,.06-.1s-.11,.07-.14,.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "298.69 132.84 298.5 132.96 298.61 132.91 298.69 132.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.51,133.24l-.2,.06c-.04,.07,.03,.04,.07,.05l-.02-.02c.08-.07,.08,0,.15-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.94,132.23s.1-.04,.13-.06c-.03,0-.07,.02-.13,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.28,133.43s-.11,.06-.17,.1c.07-.05,.15-.05,.17-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.1,133.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.52,133.29l-.02-.02s0,.02,.02,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.38,133.46c.17-.08-.05,.13,.13,.04h-.03c.06-.09,.14-.1,.16-.1,0,0,.01-.06-.02-.04-.07,.07-.12,.04-.2,.08,.07-.09,.18-.12,.18-.13-.02,0-.05,0-.08,0l.02,.02c-.11,.04-.06,.06-.17,.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "299.76 133.03 299.75 133.03 299.75 133.04 299.76 133.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.6,131.87v.04s0-.02,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.75,131.91h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.75,131.92v.02s0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.72,132.42s-.02,.03-.03,.04c.01-.01,.02-.03,.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.31,130.91s.01,.02,.02,.03h0s-.01-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.88,132.45s.12-.02,.18-.02c-.01-.03-.01-.06,.01-.11-.05,.09-.12,.09-.2,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.76,133.03s.07-.04,.1-.06l-.1,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.86,132.76s.05-.04,.05-.05c-.02,.01-.04,.03-.05,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.6,131.87s.02-.06,.03-.08c-.03,.03-.03,.06-.03,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.08,131.7s-.05,.06-.08,.1l.08-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "301.07 132.31 301.07 132.31 301.07 132.31 301.07 132.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.09,132.46s-.01-.03-.03-.03c0,.02,.02,.03,.03,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M304.67,128.04l-.04,.06s0,0,.01,.01l.03-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.56,131.68l.08-.06s-.05,.04-.08,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.55,131.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M305.37,127.16c-.1,.23-.28,.47-.32,.66l-.18,.13c0,.09-.04,.18-.08,.27-.05,.08-.1,.15-.15,.2,.01-.1-.11,.04-.15,.1,.04-.02,0,.05-.02,.08-.04,.03,0-.12-.1-.01l.02,.03c-.03,.06-.09,.11-.1,.1,.09-.2,.22-.41,.34-.6-.01-.01-.03-.02-.02-.06,.05-.05,.17-.29,.16-.15,.08-.08,.05-.14,.13-.24l-.04,.04c.02-.1,.14-.27,.07-.26-.02,0-.04,.06-.05,.09h.01c-.11,.21-.25,.3-.38,.51,.05,.04-.05,.12-.09,.21-.12-.11-.19,.28-.32,.43h.03c-.18,.07-.31,.58-.42,.45,.05-.07,.1-.19,.13-.25-.1,.18-.21,.34-.34,.48-.13,.15-.27,.3-.38,.5h.02c-.1,.13-.28,.48-.37,.48-.07,.19-.31,.39-.33,.51-.17,.11-.3,.29-.44,.47-.14,.18-.27,.36-.46,.44v-.08c-.05,.05-.1,.1-.08,.12-.04-.03-.18,.13-.28,.18h0c-.09,.04-.22,.21-.28,.17-.12,.05-.03-.13-.02-.16,.13-.14,.24-.16,.33-.19-.02,.06,.14-.07,.09,.03,.07-.13-.02-.08-.1-.06,.07-.12,.13-.15,.2-.18,.07-.03,.13-.06,.2-.18-.03,.04-.13,.08-.16,.16-.02-.04,.07-.15,.08-.2,.1-.11-.13,.15-.23,.21,.05,.04-.09,.09-.06,.13-.08,.02-.07,.11-.17,.13,.02-.08,.1-.19,.18-.29l-.09,.08s.03,0,.03,0c-.09,.15-.13,.06-.21,.18,0-.02,.03-.07,.07-.12-.11,.09-.25,.18-.3,.28,0,0,0-.03,0-.05-.01,.04-.1,.1-.13,.14-.2-.03-.26,.22-.5,.3v.03c-.12,.11-.39,.32-.48,.37v-.04c-.07,.1-.23,.17-.32,.21-.17,.11-.01,.19-.22,.3-.06-.02-.02-.09-.17,0h.03c-.23,.2-.26,.24-.51,.46-.03,0-.06,0-.09,.01-.06,.1-.26,.28-.41,.38,.02-.08-.07,.02-.13,.04,.08,.03,.17,.06,.33-.03,.06-.08,.13,.03,.28-.07l-.04,.1,.08-.07h-.02s.04-.04,.05-.06h.11s.02-.06-.02-.06c.1-.1,.12-.04,.16-.04l-.03-.09c.09-.04,.18-.15,.3-.19l-.04,.1,.13-.1s-.06,0-.07-.03c.02-.03,.04-.05,.06-.06-.07,.05-.15,.12-.23,.16-.07-.08,.22-.14,.36-.32,.03-.01,.14-.08,.23-.15l.03,.03s.02-.04,.06-.08c.03-.07,.12-.11,.19-.15,.06-.1-.02-.11-.07-.09l.07-.13s-.06,.03-.08,0l.13-.07-.05,.02s.16-.15,.2-.14c-.05,.03-.03,.05-.05,.07,.07-.06,.16-.07,.16-.06-.03-.12,.26-.19,.34-.36l.04,.07c.16-.16,.21-.2,.36-.26-.08,.13-.03,.23-.08,.31,.06-.08,.14-.14,.21-.19,0,0-.02,0-.03,0,.1-.15,.18-.09,.25-.15-.01,.07,0,.13-.13,.23-.04,0,.02-.06,.04-.1l-.11,.08s.02,.08,.11,.01v-.02c.19-.23,.36-.15,.48-.34,.07-.05,.11-.02,.17-.03l-.08,.11,.14-.06h-.01c.11-.09,.28-.3,.33-.3l-.02,.03c.13-.14,.25-.15,.35-.39,.1,0-.04,.12,.03,.15,.1-.07,.17-.23,.22-.19-.12,.14-.15,.27-.32,.37l-.05,.15c.08-.05,.17-.14,.2-.08,0,.04-.15,.19-.05,.15-.05-.01,.05-.11,.07-.1l-.02,.07c.09-.11,.05-.13,.19-.18-.05,.06-.06,.09-.08,.14,0,0,.02-.02,.03-.03,.05,.01,.04,.05,.13,0,.04-.05-.03-.02,.03-.09,.15-.12,.37-.51,.43-.43l-.02,.05,.14-.2c-.05,.07-.04,.01-.07,.02,.11-.12,.19-.26,.29-.38-.04,.01-.12,.09-.11,.15-.08,.07-.11,.07-.14,.04-.12,.22-.25,.24-.37,.38l.03-.08c-.05,.09-.12,.08-.13,.18-.13,.08-.11-.03-.05-.14,.05,0,.09-.06,.17-.15-.05,0-.05-.05-.01-.13,.01-.03,.07-.09,.12-.15,.05-.06,.11-.13,.12-.18-.07,.03-.12,.06-.19,.08-.11,.15-.26,.36-.41,.47,0-.05,.11-.25,.18-.24-.09,.02,.08-.13,.05-.15,.15-.1,.16-.23,.22-.31l.23-.09c-.09,.12,.04,.04-.1,.2,.15-.15,.08,.05,.24-.17,.02-.1,.16-.27,.25-.36,0,.1,.16-.08,.17-.12l-.11,.11c-.08,.01,.1-.12-.01-.05,.07-.09,.16-.2,.22-.2,.1-.12-.03-.04,.04-.11,.03,.02,.08-.05,.11-.11,.03-.06,.06-.1,.07-.03-.04,.05-.07,.1-.11,.16,.1,0,.16-.14,.29-.32-.02,.02-.07,.06-.08,.05-.03-.09,.08-.09,.1-.2v.09c.07-.15,.23-.32,.22-.46,.17-.22,.3-.46,.44-.66h-.06c.22-.21,.16-.53,.35-.74-.04-.09,.26-.5,.07-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.31,130.91s-.02-.04-.03-.06c-.03,.07,0,.05,.03,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M304.33,129.41h0s.02-.01,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.02,130.75h0s.04-.05,.05-.07l-.05,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.62,131.42s0-.01,0-.02v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.06,131.7s.05-.04,.07-.06c-.03,.02-.05,.04-.07,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.46,131.21l.02-.03s-.02,0-.02,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "301.27 131.55 301.26 131.56 301.27 131.55 301.27 131.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.59,131.27c-.04-.07,.21-.19,.21-.32-.03,.03-.16,.1-.12,.13-.16,.17-.05-.08-.2,.1,0,0,0,0,0,.01-.06,.06-.1,.13-.14,.2-.04,.06-.09,.12-.17,.17,.02,0,.07-.04,.08-.02,.06-.08,.12-.15,.15-.19,.06-.03,.11-.08,.18-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M297.11,135.3s.07-.1,.12-.09l-.05-.04c-.24,.14-.05,.19,0,.17,.11-.07,.25-.1,.3-.2-.11,.04-.34,.28-.37,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.25,131.51s-.02-.05-.07,.01c-.02,.06,.11-.02,.07-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.34,123.79c.04-.08,.04-.05,.03-.13-.1,.11-.06,.18-.15,.23,.06,.02,.08-.1,.13-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.56,136.01h.1v-.02l.14-.02-.1,.09c.12-.05,.18-.09,.18-.15-.05-.04-.15-.01-.32,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.3,127.7c.07-.05,.12-.07,.17-.18,.03-.03,.06-.1,.08-.06,.09-.13-.09,.03-.01-.1-.02,.02-.04,.13-.12,.15l.04-.02c-.06,.08-.08,.13-.16,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.23,128.36h0s.02-.03,.02-.04c-.01,0-.02,.01-.03,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.26,128.32h.02s-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.26,128.36h-.03s-.03,.05-.04,.07l.07-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.01,130.06s-.01,0-.02,0c0,0,0,.01,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.12,129.77h.01s0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.84,130.13h.05v-.02c.03-.07,.07-.06,.09-.05,0,0,0-.02,0-.03,.06-.05,.16-.04,.17-.11l-.02,.02s.04-.11,.09-.19c-.03,0-.07-.01-.1,0,.02,0,.01,.07,0,.1-.12,.11-.33,.22-.34,.35l.05-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.72,130.75s-.04,.12-.1,.12c.02,.02,.09-.04,.11-.04-.02-.02,.03-.09,0-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.82,127.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.18,126.9c.02,.09-.09,.08-.06,.15-.07,.12-.19,.18-.13,.07-.13,.11-.05,.23-.15,.28-.04,.1-.19,.23-.23,.24-.05,.16-.2,.4-.3,.55l.03,.02s.03-.13,.1-.1l-.03-.02c.11-.11,.21-.24,.29-.36l.12-.18c.03-.06,.07-.12,.1-.17l.04,.04c.04-.1,.08-.1,.14-.17-.06,.01,0-.04,0-.09-.03,.03-.06,.13-.08,.11,.05-.15,.22-.32,.25-.38h-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M297.97,134.34c.06-.02,.12-.04,.18-.06-.02,.04-.03,.08-.05,.11,.03-.01,.06-.03,.08-.05-.08,.03,.09-.32-.21,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M297.27,135.41s0,.05,0,.06c.02-.04,.03-.07,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M297.27,135.47v.02s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M297.25,135.52s0-.02,.01-.03c0,0-.02,.02-.05,.04h.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.4,123.35v-.02s-.08-.09-.06,.08c.02-.02,.04-.04,.06-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.4,123.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.9,126.62l-.02,.06s.02-.02,.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.42,126.2h-.02s0,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.91,127.01l.1-.14,.02,.04c.04-.09-.05-.07,.05-.17,.03,.03,.11-.04,.1,.04l-.09,.06c.05,.1-.04,.11-.09,.23,.11-.07,.26-.45,.32-.34l.07-.15s-.05,.04-.08,.1c-.06-.04-.11,.02-.14-.04,.04-.06,.05-.11,.09-.09,.06-.13,.04-.24,.13-.32-.02,0-.02-.03-.03-.04,.05-.13,.13-.27,.22-.35-.04,0-.04-.06-.05-.09l-.08,.1h.01s-.03,.08-.07,.11c.02-.03,.04-.01,.05,0-.03,.04-.05,.08-.08,.11,.01,0,.03,.02,.01,.05-.08,.1,0-.15-.08,0,.08,0-.01,.07,.02,.11-.07,.13-.05,.02-.12,.07,0,.01,.01,.02,.02,.01-.11,.07-.2,.3-.25,.2l-.05,.16c.04-.07,.1-.07,.1-.03l-.07,.04,.06,.03-.07,.1s-.02-.16-.1-.07l.02-.04s-.05,0-.08,.07c0,.06,0,.11-.02,.18-.05,.09-.14,.23-.21,.3,.06-.01,.25-.31,.34-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.34,132.2s-.07,.03-.1,.07c.03,.02,.07-.05,.1-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.34,132.2s.01,0,.02,0c0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.33,134.38h-.08s.06-.1,.07-.13c-.04,.06-.14,.15-.07,.16-.05,.02-.1,.05-.15,.07,.03,.07,.18-.11,.24-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.32,134.24s.02-.03,.02-.04c0,0-.01,.02-.02,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "300.22 129.7 300.38 129.68 300.37 129.63 300.22 129.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.57,132.2l-.17,.07s-.08,.09-.11,.15c.01-.05,.23-.1,.27-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.12,130.6s.01,0,.02,0h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.84,130.01c-.09,.05-.19,.2-.21,.1l-.12,.16s-.12,.08-.09-.03c-.05,.04-.1,.14-.15,.23-.05,.07-.09,.13-.14,.13l-.07,.11c.11-.12,.19-.11,.28-.19-.21,.2-.27,.35-.48,.57-.02,.12,.12-.04,.18,0,.1-.11,.3-.3,.33-.43,.09,0,.2-.25,.21-.16-.03-.17,.19-.12,.15-.28l.09-.05c-.02-.05,0-.08,.02-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.72,123.58c-.02,.11-.06-.05-.07,.08h.08v-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.73,136.67c-.06,.03-.15,.05-.17,.09,.04,0,.15-.05,.17-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.13,134.75c.05,.01,.01,.04-.06,.11,.13-.04,.29-.16,.36-.16l-.06-.02,.1-.06c-.08,.01,.01-.09,.05-.12-.22,.15-.15,.13-.39,.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "300.42 129.9 300.3 129.99 300.41 129.93 300.42 129.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.15,133.15l.05-.04s-.06,.03-.08,.04c0,0,.01,.01,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.12,133.15s0-.01-.01-.02c0,.02,0,.02,.01,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.05,124.88c.03-.06,.06-.12,.12-.2,0,0,0,0-.02,0l.04-.08s-.05,.04-.06,0c.06-.15,.06,.04,.14-.07,0-.04-.05,.05-.06,0,.07-.13,.11-.02,.16-.01-.02-.1,.11-.2,.09-.24,.05,.02,.09-.03,.12-.11-.04-.13,.05-.16-.02-.29-.04,.12-.1,.24-.24,.41-.07,.03-.05-.06-.13,.05-.02,.28-.35,.55-.28,.78,.07-.1,.11-.16,.14-.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "301.57 123.86 301.57 123.87 301.57 123.86 301.57 123.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.82,123.43s.02-.28-.09-.12c-.09,.22-.11,.37-.15,.51v.03c.11-.06,.16-.34,.24-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.18,124.66l-.02,.02s0,0,.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.51,129.29l.05,.05c0-.07,.03-.08-.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.53,134.31s.07-.08,.16-.15c-.08,.05-.21,.11-.16,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.68,134.16s.04-.03,.05-.04l-.05,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "298.18 134.92 298.2 134.86 298.17 134.88 298.18 134.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.63,129.23c.06-.06,.1-.07,.11-.06-.02-.01-.05-.01-.02-.05l-.09,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.83,123.27l.02-.07-.07,.06s.02,.03,.05,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.97,124.21c-.01-.1,.07-.07,.11-.1-.04,.03-.02-.03,0-.08l.06-.06c-.04-.07-.09,.2-.13,.12l.06-.18-.13,.27s0,.04,.04,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.11,128.55c-.06,.01-.09,.2-.12,.11-.12,.13-.17,.3-.25,.42l.05,.04c.11-.19,.11-.14,.22-.34l-.03,.02c.04-.09,.09-.18,.16-.19l-.04-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.06,129.52s-.05,.04-.07,.05c.02,0,.05-.04,.07-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.96,129.59c-.1,.07-.2,.13-.26,.15,.11-.1,.12-.17,.17-.26-.05,.05-.05,.13-.13,.16v-.03l-.16,.12s.05-.02,.06,0c-.09,.06-.05,.13-.07,.17,.1-.09,.11-.09,.19-.13-.08,.07,.06,.06-.06,.19,.09-.05,.11-.12,.19-.16l.06-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.97,129.57v.02h.01s0-.01-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.17,124.21s-.11,.19-.13,.26c.06-.06,.14-.22,.13-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.94,128.56s0,0-.01,0c0,0,0,.02,0,.02v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.9,128.56s.02,0,.03,0h0s-.02-.01-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.85,128.71l.06-.09s-.09,.03-.06,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.9,128.56s-.01,0-.02,.02l.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.93,128.58l-.02,.03s.02-.02,.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.77,122.48l.09,.02c0-.09-.06-.04-.09-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.28,131.13v.06c.06-.01,.1-.1,.14-.13-.03,0-.11,.09-.14,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "299.13 133.72 299.16 133.7 299.16 133.7 299.13 133.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.08,133.81l.09,.05s-.07-.08,.08-.13c.03,.04,.09-.03,.14-.08-.02-.04-.16,.06-.12-.01l-.11,.07s-.08,.08-.08,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.07,128.14v.08l.05-.06s-.04-.03-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.13,128.16s.02-.01,.03-.03l-.03,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299,134.18c.07-.05,.03,.01,.02,.04,.16-.1,.31-.24,.41-.26,0-.07-.13-.02-.23,.01-.03,.08,.02,0,.05,.03-.07,.05-.23,.11-.24,.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "300.37 131.25 300.36 131.34 300.42 131.24 300.37 131.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.35,123.8c-.02,.11-.2,.3-.14,.36,0,.09,.1-.02,.11,.04,.08-.22-.13,.12-.09-.07,.06,0,.11-.11,.1-.17l.09-.03-.04-.02s.05-.09,.07-.14c-.03,.02-.05,.11-.07,.07,.02-.03,.04-.07,.06-.1-.01,.02-.02,.02-.03,.03,0,.02-.02,.04-.03,.06-.02,.02-.02,0-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.4,123.75l.03-.07s-.04,.03-.04,.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.56,123.65s-.01,0-.02-.02v.02h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.62,123.47c-.05-.08-.06,.15-.11,.09-.04,.01,.02-.14,.07-.19,.01-.06-.06,.12-.06,0-.02,.15-.05,.24-.09,.32,0,0,.01-.01,.02-.02l.04,.05s.01-.08,0-.11c.04-.02,.04,.01,.05,.04,.02-.06,.03-.17,.08-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.58,123.65h-.03s.01,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.5,123.74l-.02-.02s0,.02,.02,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.35,126.77s0,.09,.03,.05c-.06,0,.06-.14-.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.42,126.5h.06c.01-.05,.02-.1,.04-.15-.03,.05-.06,.1-.1,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.44,125.72s.03-.1,.08-.13c-.04,0-.08,.08-.08,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.7,126.17s-.01,0-.02,0h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.73,124.12c-.02,.12-.1,.25-.12,.3h.06c-.18,.27-.26,.51-.46,.66v-.03l-.04,.25s-.06,.05-.11,.12l-.02-.08,.02-.02s-.05-.03-.04-.12c.02-.05,.06-.08,.09-.1l-.05,.16c.07-.05,.09-.23,.11-.28-.02,.02-.06,0-.09,.03,.06-.08,.13-.19,.19-.28v.06c.03-.08,0-.13-.05-.11-.09,.01-.12,.26-.19,.4h.01c-.05-.01-.06,.17-.12,.29,.04-.04,.06-.04,.08-.04-.05,.17-.11,.21-.21,.34v-.1c-.1,.04-.07,.18-.14,.25,.08,0,.03-.04,.1-.1h-.01c.05-.1,.04,.04,.09-.03,0,.1-.11,.15-.09,.26-.03,.09-.16,.23-.24,.33,.07,0,.03,.03,.1,.06l-.05,.07c.07-.08,.11-.18,.15-.21-.02-.02,.04-.06,.04-.1,.02,.01,.06,.03,.09-.05v.08c.07-.17,.11,.1,.19-.15l-.02,.02c0-.09,.11-.17,.17-.26l-.02,.02c.07-.18,.2-.28,.24-.55,.12-.14,.25-.28,.32-.44-.06,0,.06-.16-.02-.11,.01-.11,.06-.03,.07-.14,.03,.07,.11-.07,.14-.03l.04-.11c-.08,.18,0-.11-.1,0,0,.07-.03,.08-.07,.07,.04-.06,.05-.18,.11-.16v.03s.05-.16,.1-.15v.03c0-.08,.04-.11,0-.16,.1-.05,.06-.35,.17-.31l-.05,.13c.09-.05,0,.13,.03,.16h-.06c.04,.05-.02,.13-.01,.17h-.02c.01,.09-.07,.03-.05,.13,.05,.01,.05-.12,.09-.12,.03,0,0,.09,.01,.12-.02,0-.07,.1-.1,.13v.04s-.02,.05-.06,.13l.04,.03c-.09,.11-.12,.32-.08,.35-.15,.1-.14,.24-.26,.29,0,.02,.01,.04,.05,0-.03,.08-.07,.17-.12,.27-.04,.09-.09,.18-.12,.27l.06-.02c-.06,.1-.08,.21-.11,.26,.13-.21,.28-.38,.27-.43-.01,.01-.02,0-.04-.01,.09-.03,.17-.32,.23-.24-.11,.11-.05,.38-.2,.36v.11s-.07,.13-.16,.15h.05l-.06,.12s-.01-.04-.01-.05l-.13,.12v.12c-.17,.13-.2,.5-.38,.58h.01c-.02,.08-.06,.19-.1,.28,.12-.06,.18-.27,.27-.32,.16-.18,.15-.42,.29-.56,.07,0-.05,.12-.01,.14l.05-.14h.07c.01-.12,.09-.2,.16-.28h-.01s.06-.11,.09-.18c.03-.07,.05-.16,.08-.24,.05-.17,.11-.34,.22-.4l.17-.2c0-.09,0-.15,0-.18,0,.04-.03,.07-.04,.11-.06,0,.05-.14-.03-.07l-.09,.11h.01c-.09,.05-.09,.28-.21,.31-.07,0,.02-.2,.04-.32v.02s.14-.26,.08-.25c-.02,.04-.03,.02-.06,.01,.08-.15,.13-.26,.18-.39l-.03-.02c.09-.05,.06-.28,.13-.26l-.03-.05c.02-.24,.19-.37,.2-.63,.09-.11,.05-.18,.02-.26-.02,.08-.09,.1-.11,.11,.02-.04,.11-.08,.06-.15-.06,.15-.15,.16-.22,.33,.02,0,.02,.1,.03,.09-.09,.21-.15,.51-.24,.61-.08,.11,0-.1-.13,0v.05s-.09,.09-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.56,125.27s.02,0,.04-.01c0-.02,0-.03-.04,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.69,127.14c.15-.04-.09,.13-.1,.2,.01-.02,.01,0,.02,0l-.07,.09s-.02-.03-.07-.05c-.05,.05-.1,.17-.13,.27,.05-.02,.14-.1,.09,.02l-.05,.04s.06-.03,.04,.02c-.1,.07,0,.02-.1,.14l.08-.1,.02,.07c.18-.25,.27-.53,.42-.68l-.02-.02s-.01,.03-.02,.04c0-.09-.09-.06-.13-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "301.84 127.14 301.84 127.13 301.84 127.14 301.84 127.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.98,124.43v-.02s-.01,.04,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.08,122.32c0,.06,0,.09-.03,.14,.03-.02,.07-.02,.11-.09-.07,.07-.03-.06-.07-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.59,125.9s-.03,.07-.05,.1c.03-.02,.06-.05,.05-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.53,126s-.05,.03-.06,.06c.02,0,.04-.03,.06-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.28,122.7s-.02,.03-.03,.04l.08-.08s0-.08,.01-.11l.08-.02-.05,.18,.09-.08v.08s.04-.12,.06-.16c0,.01-.02,0-.02,0l.03-.1c-.03,.07-.1,.07-.06-.04,.03,.02,.03,.06,.06-.01-.01-.02-.05,0-.06,0v.03c-.06,.05-.06-.06-.08-.09,.06,.05,.05-.08,.09-.11-.16,.2-.03-.23-.17-.06-.02-.1,.04-.07,.07-.09,.05-.12,.1-.36,.18-.55v.1c.07-.15,0-.3,.04-.37l-.04-.04c-.07,.08-.18,.41-.28,.41l.09-.11c-.04-.07,0-.15,.03-.23,.03-.08,.06-.16,.03-.23-.07-.12-.02,.05-.09,.11,.01,.16-.03,.31-.06,.45-.03,.15-.07,.3-.08,.46,.06-.04,.01-.21,.1-.23v.07c0-.15,.11-.12,.12-.25,.05,.02-.01,.12-.04,.16l.07-.06c.04,.14-.1,.07-.02,.18-.1-.02-.01,.16-.12,.13,0,.11-.05,.32-.13,.34-.04,.17,.05,.12,.01,.23l.09,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.47,122.4v-.05s0,.05,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.54,126.5s.09-.05,.07-.09c-.06,.1-.04,0-.07,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.61,125.7c.02-.06,.02-.09-.01-.09-.06,.05,.01,.05,.01,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.7,125.48c0-.09,.01-.02-.05-.02l-.1,.15h.05c.02-.09,.07-.04,.11-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.54,127.26s0-.01,.02-.03c0,0,0,.01-.02,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.62,127.15s-.05,.04-.06,.08c.03-.03,.02,.04,.06-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.75,135.23s.03,.06-.02,.11c.08-.04,.15-.12,.22-.16l-.2,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M298.68,135.36h.04v-.02s-.02,.02-.04,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.57,128.93s.1-.06,.08-.09c-.04-.03-.12,.15-.17,.14l.09-.14s-.06,0-.1,.08l.02,.04-.09,.08s.07-.04,.08-.02c-.03,.05-.08,.05-.13,.1,0,.05,0,.08-.04,.14,.1-.13,.3-.29,.27-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.25,129.33s.04-.05,.05-.07c-.02,.03-.04,.05-.05,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.27,134.98s-.13-.02-.04-.12l-.1,.04c-.07,.12,.01,.09,.07,.11-.09,.03-.16,.1-.16,.16,.06,0,.24-.19,.24-.11l.04-.09c.15-.04,.11-.03,.3-.13-.04-.05-.26,.12-.36,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.09,135.24l.07-.07-.28,.13c0,.08,.13-.03,.2-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.75,133.87c-.12,.16,.11,.02-.02,.17,.05-.02,.09-.05,.13-.08,0-.03-.23,.05-.05-.11,.03-.04,.07-.04,.11-.06-.04,.05-.14,.17-.02,.1l-.03-.03,.14-.12s-.19,.09-.26,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.66,123.19q-.06,.01-.12,.11s.05-.12,.1-.09v.02l.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.76,123.77v-.07l-.07,.16s.05-.07,.07-.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "301.49 129.34 301.56 129.21 301.49 129.29 301.49 129.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "300.89 131.6 300.78 131.71 300.88 131.63 300.89 131.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.17,121.26s.07-.04,.03-.07c-.01,.06-.06,.09-.08,.07,.02,.03,.03,.05,.05,.08,0-.03,0-.06,0-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.62,134.37c.08-.03,.17-.1,.25-.17,.04-.04,.07-.07,.11-.11-.1,.06-.2,.06-.3,.14l-.05,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.98,134.09s.08-.06,.12-.12c-.04,.04-.08,.08-.12,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.54,129.43c.03-.09,.13-.15,.16-.15-.07-.03,.05-.11,.08-.18l-.02,.08,.05-.11c-.17,.07-.22,.2-.28,.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M299.99,133.7c.06-.01,.18-.03,.26-.05,.06-.09,.24-.24,.18-.26l-.44,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.03,120.77c-.03-.11,.1-.04,.08-.1-.05,.02-.04-.1-.05-.15,.03,.1-.15,.15-.04,.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "301.3 121.07 301.24 121.17 301.31 121.16 301.3 121.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.3,127.88c-.07,.2-.28,.34-.35,.52-.07,.06,0-.05-.03-.03-.06,.08-.01,.15-.1,.27l.23-.28c-.01,.06,.04,0,.07-.01-.02,.01-.04,.02-.07,.03,.11-.14,.19-.34,.33-.47l-.09-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.53,130.23h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.53,130.33v-.08s-.11,.09-.09,.13l.09-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.92,123.33h0c.04-.06,.05-.06,.07-.16l-.03-.09c-.03,.09-.08,.19-.08,.28l.04-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "301.02 131.93 300.99 131.96 300.99 132.03 301.02 131.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.09,120.33s-.02,.05-.02,.11l.02-.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "301.98 128.81 301.86 128.9 301.99 128.84 301.98 128.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.95,129.2s-.04-.03,0-.09c.04-.07-.07-.02-.12,.05,.05,0-.02,.08-.02,.13,.03-.05,.08-.08,.14-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.93,122.91c.04-.08-.02-.06-.03-.09-.02,.05,0,.05,.02,.06l-.06,.08s.04,.02,.06-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.6,133.24l.2-.18-.23,.15c.07-.03,.01,.03,.04,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.03,130.33c.02-.08-.03-.06-.06-.08-.03,.06-.02,.08,0,.08-.07,.12-.08,.02-.17,.1-.11,.2-.24,.35-.36,.52,.14-.09,.21-.28,.38-.39l-.02-.05c.06,0,.18-.11,.24-.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "302.3 126.59 302.32 126.51 302.24 126.64 302.3 126.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.92,122.68s.02,.1,.06,.05c0,.04,.02,0,.02,0,0-.03-.04,0-.05-.02,0-.02,.01-.05,.02-.08-.02,.02-.03,.04-.05,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.02,123.07l.03-.03h-.06s.02,0,.03,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.3,120.11h0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.36,120.06v.09c.08-.02,.01-.17,.1-.12,0,.1-.04,.13-.07,.19,0,.01,0,.02,.02,.01l-.05,.06c.04,.14,.03,.15,.05,.3l-.06,.09,.05-.02v.16h.02c.03-.1-.03-.1,.04-.19h-.05c.06-.07-.03-.07,.04-.12-.01,.13,.05-.09,.1-.03-.02-.05,0-.12,0-.2,.02,.1,.1-.08,.12-.13-.06,.02,.02-.12-.04-.05-.02-.21,.1-.4,.12-.53-.03,0-.02-.06-.05-.03,.11-.13,.13-.48,.12-.6-.05,.05-.03-.05-.08,.03,.01,0,.02-.01,.03,.02-.01,.03-.05,.04-.07,.06,0-.05,0-.1-.01-.15-.06,.09-.12,.23-.15,.39,.03-.01,0,.07,.01,.11-.03-.07-.02,.03-.04,.04,.08,.02-.03,.21,0,.29-.11,.02-.15,.25-.21,.35,.03,.06,0-.07,.06-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.65,118.95s0,.01,0,.03v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.51,119.46s0,0-.02,0c0,0,.01,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.63,118.87s.03-.01,.04,0l-.02,.09s.03-.02,.05-.04c0-.03-.01-.07-.01-.1-.01,.02-.02,.05-.05,.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "301.7 118.92 301.7 118.92 301.7 118.92 301.7 118.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.36,120.22c-.1,.04,0,.11-.08,.18,.07,0,.05-.15,.08-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.42,127.32s-.09,.04-.14,.11c.05,0,.12-.09,.14-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.1,123.13l.06-.08h-.03l.11-.17c-.06,.01-.17,.14-.13,.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M300.28,134.27c-.09,.06-.05,.05-.08,.11,.05-.05,.16-.1,.08-.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "302.39 124.48 302.38 124.42 302.32 124.56 302.39 124.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "301.27 120.02 301.23 120.12 301.27 120.05 301.27 120.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.1,122.12h.03s-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.02,122.4s.13,.04,.18-.15v-.14l-.06,.02s0,.02,0,.06h-.06l.02-.15-.06,.11h0c.02,.06,0,.18,.04,.22-.05,.07-.04-.05-.06,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "302.12 122.53 302.07 122.56 302.11 122.56 302.1 122.59 302.12 122.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.49,126.77s.06-.03,.09-.07c-.03,.04-.06,.1-.09,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.58,126.7s.01-.02,.02-.02c0,0-.01,.01-.02,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "302.53 127.13 302.52 127.08 302.49 127.13 302.53 127.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.41,132.21c-.14,.06-.02,.09-.11,.19,.14-.12,.02-.09,.11-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.46,123.94s.01-.08,0-.11c-.06,.07,0,.06,0,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.61,126.87c-.06,.13-.01,.11-.03,.21,.03,.03,.19-.29,.25-.42,.03-.13-.11,.1-.11,.05-.05,.04-.08,.22-.11,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.36,123.26l.07-.13-.09,.05,.03,.02s-.04,.04-.01,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.54,124.05s.03-.12-.03-.07c.03,0-.01,.08-.02,.12l.05-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "301.27 132.7 301.4 132.58 301.28 132.66 301.27 132.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.39,122.97l-.05,.04s.04-.01,.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.39,122.97l.06-.05s0,.08,0,.11c0-.06,.04-.1,.01-.15-.03-.04-.05,.03-.08,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.64,126.6c.06,0,.09-.11,.12-.16l-.02,.02,.05-.12-.15,.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.51,129.95l.05-.1c-.02-.07-.17,.2-.17,.08,0-.02,.02-.03,.03-.04-.06-.04-.07,.14-.13,.12,0,.13,0-.03,.1-.07l-.04,.11c.05-.08,.17-.21,.19-.18-.04,.05-.08,.07-.03,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.55,129.77l-.15,.03c.04-.07,.05-.14,.06-.18l-.26,.29s.07-.05,.04,.03c-.04,.01,0,.07,.02,.09-.03-.09,.1-.12,.15-.2,.03-.01,.03,.01,.02,.05,.04-.05,.07-.07,.12-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.43,129.87l-.02,.02h0v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.56,123.54s.01-.08,.06-.1c-.03-.06-.04,.06-.06,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.2,121.64s.01-.05,.03-.07l-.07-.02,.04,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.04,120.99l.02-.02c.05,.04-.06,.23,.02,.22,0-.16,.11-.04,.11-.22l-.06-.02,.05-.2s-.07,.04-.06-.02c0,0-.04,.16-.08,.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.69,123.33h-.03s.02,.02,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.65,123.35s.01-.16-.02-.12c-.02,.12-.02,.13,.02,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.29,133.2s.16-.13,.2-.17c-.02-.04-.15,.1-.2,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.49,122.67c0-.07,.04-.09,.05-.07l-.02,.08,.08-.11c0-.08-.08-.01-.06-.2-.04,.07-.05,.22-.06,.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "302.78 128.33 302.68 128.42 302.67 128.45 302.78 128.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "302.9 126.18 302.94 126.15 302.86 126.17 302.9 126.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "302.73 123.61 302.74 123.53 302.7 123.58 302.73 123.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "302.75 123.52 302.75 123.5 302.74 123.53 302.75 123.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.96,129.11c-.08,.04,0-.14-.1,0h.01c-.12,.04-.22,.36-.34,.39-.02,.06,.02,.03,.04,.04l-.07,.09c.07-.03-.01,.05,.08-.01-.01,0,0-.04,0-.06,.23-.21-.04,.2,.2-.07v-.09s-.06,.07-.08,.06c.09-.09,.13-.29,.26-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.7,123.27l.02-.08s-.02-.1-.06-.01c.07-.04,.01,.07,.04,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.21,127.96c-.06,.06-.08,.17-.16,.25h-.06c-.01,.1-.1,.23-.16,.38-.02-.06-.08,.05-.12,.06l.1-.03-.06,.08c.18-.11,.28-.49,.45-.63v-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "302.95 127.49 302.96 127.44 302.87 127.54 302.95 127.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.24,121.28s-.02,.11,.03,.06l.02-.15-.06,.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.99,126.04l.04-.05h-.04s.01,.01,.02,.01l-.02,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.96,126h.03s-.01-.01-.03,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "302.72 128.98 302.76 128.87 302.73 128.89 302.72 128.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "302.23 121.08 302.27 121.02 302.26 120.97 302.23 121.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "302.24 121.12 302.26 121.17 302.31 121.07 302.24 121.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.74,122.62s-.01,.02-.02,.02c0,0,.01,0,.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.72,122.64s-.01-.1-.05,.02c.02,0,.03,0,.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.84,132.39c.1-.08,.23-.18,.26-.29-.08,0-.17,.19-.26,.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.24,125.87c-.08,.11-.11,.1-.16,.24,.06,0,.11-.15,.16-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.07,127.56s.1-.08,.16-.15c.05-.07,.1-.14,.14-.11l.02-.09c-.03,.12-.06,.04-.1,.06,.01-.04,.04-.05,.06-.07-.06,0-.19,.27-.28,.29,.02,0,0,.05,0,.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "302.27 120.48 302.27 120.45 302.22 120.45 302.27 120.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "301.67 133.41 301.75 133.36 301.69 133.33 301.67 133.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.41,118.43l-.04,.14h.07l-.02-.14c.16-.05,.13-.25,.22-.51-.04,0-.02-.06,0-.11h-.08s-.02,.12-.02,.19l-.04-.04c-.03,.2-.14,.38-.15,.49,.01-.03,.04,0,.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.09,129.31c-.13,0,0-.02-.13,0-.03,.08,.02,.05,.06,.02,.06,.03-.07,.16-.09,.25,.14-.05,.06-.17,.16-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.36,124.02l-.09,.12c.07,.02-.04,.17-.04,.21,.06-.1,.15-.23,.13-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.05,129.09s.01,0,.02,0c0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.13,129.04c.02-.07-.03,.01-.06,.04,.02,0,.02,.03,.06-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.85,127.81s.05-.22,.02-.19c-.03,.05-.06,.1-.1,.15l.03,.02c-.04,.05-.12,.08-.13,.18,.02,.04,.02,.1-.03,.18-.1,.2-.25,.31-.36,.48-.03,.13-.08,.17-.06,.29,.11-.1,.02-.12,.12-.17v.1s.03-.07,.07-.08c0-.04-.04-.04,.01-.1,.03,.07,.18-.27,.26-.24-.06,0,.03-.13,.06-.19,.05-.01,0,.04-.01,.1,.06-.06,.07-.09,.13-.24,.06,.01,.06,.04,.15-.05l-.04-.06c.12-.16,.16-.07,.23-.2,.02-.1,.1-.31,.07-.31-.03,.04-.07,.09-.08,.09,.09-.23,.29-.44,.36-.53l-.03,.08c.11-.13,.2-.39,.27-.42,.04,.03-.08,.11,0,.07,.04-.07,.07-.13,.11-.2,0,0-.02,.02-.02,.03l.05-.21c-.08,.04-.07,.25-.16,.27l.03-.11s-.03,.09-.07,.1v-.07l-.09,.09h.01c-.11,.19-.1-.1-.24,.15v.03s.04-.09,.06-.09c.02,.03-.06,.13-.09,.19h-.06c-.06,.24-.21,.53-.28,.78-.07,0-.22,.18-.19,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.22,129h-.06s0,.04,0,.06l.06-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.78,118.77l-.03-.07h.06l-.02-.14c-.06,.05-.03,.2-.08,.2h.01l-.02,.11c0-.09,.07-.02,.07-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "302.39 120.12 302.36 120.11 302.34 120.22 302.39 120.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.22,118.54l-.07-.1v.03s.02,.21,.07,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.08,118.77c.02,.13-.09,.09-.09,.23,.03,.09-.05,.23,.03,.2-.02-.01-.05,.06-.07,.1,.01,.03,.03-.05,.06-.06v.11s.16-.1,.14-.28h-.02c.07-.09,0-.27,.09-.31-.07-.01-.05-.16-.09-.25-.02,.05-.04,.09-.06,.08,.06,.02-.02,.14-.02,.2,.01-.03,.02-.01,.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.13,118.5h0v-.02s0,0,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.54,127.8c-.03,.06-.14,.14-.17,.27,.06-.08,.15-.22,.17-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.41,119.99c.02-.13-.07,.01-.04-.12h.03l-.04-.05h0l-.02,.03c-.03,.08,0,.32,.06,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.4,128.89l.06,.03c.04-.18,.27-.35,.15-.39-.07,.09-.13,.22-.19,.34l-.02-.06-.08,.12s.04,.08-.03,.13c.02,.01,.08-.12,.11-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.95,118.76s-.08,.15-.02,.25c.02-.08,.05-.18,.02-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.95,121.42l-.02,.16s.07-.06,.1-.04c-.02-.12,.08-.18,.03-.26h-.08v-.1l-.06,.24s.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.47,123.95c0,.07,.05,0,.07-.07l.02-.17c-.03,.16-.14,.17-.14,.35l.05-.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "303.57 123.7 303.57 123.7 303.57 123.7 303.57 123.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.5,123.7s-.02,.08-.02,.11c.03-.04,.06-.09,.09-.11v-.09s-.05,0-.07,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.56,127.02s0,.02,0,.03v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.58,127.08l-.02-.03s0,0,0-.01c0,.03-.02,.06-.03,.08l.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.66,126.93c-.02,.08-.05,.06-.03,.12,.04-.07,.12-.27,.05-.23l-.09,.11v-.06s0,.07-.02,.15c.02-.03,.07-.05,.09-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.32,132.7c.09-.1,.01,.03,.08,0l-.02,.04s.03,0,.05-.01c.05-.03-.07-.12,.11-.24h.03s.02-.05,.02-.07c-.09,.11-.22,.16-.27,.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.23,132.92c.05-.07,.13-.1,.1-.14-.03,.04-.09,.11-.1,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.34,119.66l.06-.12s0,.05,0,.06c.1,.03,0-.13,.02-.18-.03,.08-.1,.15-.08,.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "303.66 124.27 303.59 124.33 303.62 124.33 303.66 124.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.93,123.78h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.62,124.18c.06-.02,0-.03,.06-.11,.02,.03,.02,.1,.08,.03,.04-.13,.05-.21,.13-.29-.04,.03-.08,.04-.02-.08-.02,.03,.04-.13,.07-.12,0,.09-.01,.01-.04,.08,.04,0,.08-.15,.13-.14,.01-.09-.07-.06-.1,0v-.09c-.06,.12-.14,.24-.21,.32,.06-.03-.01,.07-.02,.13l-.06-.02s-.03,.11-.07,.13c.02,0,.12,0,.05,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.89,123.82s.04-.03,.05-.04c-.02,.01-.03,.03-.05,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.51,119.85l.03-.2c0,.06-.04,.05-.05,.01l-.02,.2h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.56,122.86s.01-.03,.01-.05c0,.02-.01,.04-.01,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.57,122.81s.01-.03,.02-.05c0,0-.01,.02-.02,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.52,123c.05-.04,.02-.06,.04-.14,0,.02-.01,.03-.02,.04-.03-.02,.04-.14-.03-.09l-.05,.17c0,.07,.06-.06,.07,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.76,125.35c.04-.06,0-.07-.01-.08-.02,.06-.06,.16,.01,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.75,125.27s0-.02,0-.03c-.01,.02-.01,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.75,126.97c.1,0,.18-.25,.2-.37-.06,.08-.14,.11-.17,.19,.08-.09,0,.03,.03,.03l-.08,.1s.01,.04,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M301.96,118.54l.03-.11c-.04-.06,0-.14-.04-.21,0,.04,.01,.21,0,.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302,118.41v.03h0s0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302,118.41v-.03s0,0,0,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "301.84 118.18 301.82 118.21 301.86 118.29 301.84 118.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.32,118.7l-.05,.27,.07-.14c-.07-.01,.01-.08-.02-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.93,125.47s.03-.02,.05-.02c.02-.02,.02-.06,.02-.07l-.07,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.35,130.84c.06-.02,.15-.21,.1-.16-.03,.12-.11,.05-.1,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.92,127.61l.06-.06s.03-.07,.03-.09c-.03,.04-.12,.07-.09,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.5,130.38s.07-.06,.09-.05c.05-.12-.04,0-.09,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.47,130.37s.02,.01,.04,0c-.01,0-.02,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.55,130.52h.18v-.05s-.07-.14-.18,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M304.19,124.79s-.03-.01-.04-.03l-.06,.17c.03-.05,.06-.11,.1-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M304.14,124.65l.08,.04c.03-.13-.09,.05-.04-.1-.06,.06-.05,.17-.11,.19h.08s-.03-.07,0-.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "304.15 124.76 304.15 124.76 304.15 124.76 304.15 124.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M304.34,126.01c-.07,.12-.13,.24-.21,.36,0,.08,.07,.03,.11,0-.05,.1-.11,.21-.12,.32,.14-.17,.08-.34,.2-.45l-.05,.03h.01c-.06,.13-.06,.02-.11,.06,.05-.06,.13-.19,.16-.27,.06-.13,.06,.04,.12-.09-.03-.04-.12,0-.12,.03,.01,0,.02,0,.01,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.61,130.7s.05-.03,.07-.08l-.07,.02s-.01,.05,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M302.44,118.18c-.03-.05-.05,0-.06-.09,0,.18,.03,.24,.06,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.42,120.03h0s.03,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.41,120.16s-.05-.12,0-.14c-.04,0-.12,0-.12,.16,.04-.07,.08,.07,.12-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "304.52 127.27 304.43 127.34 304.55 127.29 304.52 127.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M304.58,127.49s.07,.01,.08-.07c-.02-.08-.09,.1-.1,0,.02-.05,.02-.08,.04-.12-.06-.02-.11,.2-.17,.23v-.07c-.05,.24,.09,.05,.15,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M304.57,124.59c-.04,.15-.11-.03-.13,.17,0-.1,.09-.02,.13-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M304.12,130.21s.08-.07,.09-.05c-.03,.08-.14,.26-.16,.21-.11,.14-.05,.23,.08,.03,.01-.05,.17-.24,.2-.32-.07,.04-.09-.03-.21,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M304.26,129.76l.03,.04c-.05,.06-.08,.15-.12,.18l.14-.03-.07,.08,.08-.07-.03-.04c.07-.11,.12-.22,.18-.33-.09,.09-.1-.04-.21,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M304.17,129.97h-.03s.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "304.51 122.83 304.49 122.92 304.52 122.94 304.51 122.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M305.04,127.36l-.03,.06,.15-.1v.03s.2-.45,.31-.54h-.01l.11-.18c-.06,.03-.04-.05-.1-.03,.05-.04,.13-.11,.16-.19-.04,0-.12,.12-.1,0-.12,.17-.1,.23-.25,.48,.03-.04,.03-.03,.04-.02-.15,.26-.25,.21-.37,.54,.03,.03,.08-.15,.08-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M305.18,126.42c.1-.16,.09-.4,.14-.56-.01-.02-.05,.04-.06,.05l.04-.02c-.02,.15-.12,.36-.19,.44,.03-.03-.05,.19-.05,.28,.02-.06,.07-.2,.09-.27,.05-.02,.04,.01,.04,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M305.06,126.64s0-.02,0-.03c0,.02,0,.04,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M305.26,126.41c.05-.12,.14-.2,.13-.32-.07,.05-.17,.22-.13,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M305.23,127.76s.05-.07,.07-.1l.05,.02-.04-.09-.07,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M305.69,126.75h0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M305.76,126.64s-.01-.08-.05-.05c.04,0-.01,.09-.02,.17,.03-.01,.05-.04,.07-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M305.62,126.95c-.07-.03,.02-.05,0-.16,.01-.02,.03-.02,.05-.03-.02-.04-.06,.02-.1,.08-.04,.07-.08,.13-.07,.04l-.04,.09c.07,0,.03,.14,.15-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M305.75,127.34v.02s.01-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M305.52,127.68v-.03c.07-.03,.06,.11,.14-.02l.09-.26s-.22,.12-.23,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M305.74,124.75s0-.08,.02-.13l-.1,.11c0,.07,.04,.03,.07,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M305.8,126.85s.02,.03,.02,.08c.05-.07,.04-.1,.09-.21l-.11,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.23,129.66l-.04-.04s.02,.02,.04,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.33,129.75s-.06-.06-.09-.09h.01l.08,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.18,129.64l-.02-.03s0,.01,.02,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.28,130.58h-.05s.05,.01,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.95,130.51h0c-.09-.1,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.16,130.51l.06-.03-.07-.07h.07v-.1c-.1-.09-.06,.03-.16-.03l.08,.15s-.05,0-.06,0c0,0,.02,0,.04,.01l.04,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.3,129.55c.05,.08,.13,.12,.22,.16l-.09-.21,.06-.08c.12,.05,.21,.12,.25,.12l.09,.1,.03-.02-.02-.03-.13-.13c-.12-.06-.25-.12-.36-.19l-.04,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.31,131.22s.02,0,.02-.01c-.04,0-.04,0-.02,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.44,130.79s-.05,0-.05,0c.03,.02,.06,.04,.05,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "279.69 130.07 279.68 130.07 279.7 130.12 279.69 130.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "279.57 131.17 279.56 131.17 279.56 131.2 279.57 131.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.74,129.73v.04s0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.25,129.56l-.04-.04h0l-.24-.25,.02,.14-.08,.17,.19,.09c.03,.1,.07,.2,.12,.3l.1-.02,.13,.1,.15,.06,.1,.17-.14,.18,.07,.09,.08,.2-.04,.08-.26-.2,.16,.17-.12,.04-.05-.11-.3-.12,.05-.14-.24,.05c-.05-.08-.1-.15-.14-.24l-.07-.18-.23-.18h-.16l-.16-.12c-.09-.07-.19-.14-.28-.22l-.15-.2-.08,.04,.22-.2-.12-.06-.21-.27-.23-.13c.03,.08,.06,.15,.12,.24l-.02-.12,.19,.14s.1,.11,.05,.13l-.12-.1c.04,.13,.13,.09,.16,.23l-.18-.02c-.07-.05-.15-.13-.21-.1,0,.09,.07-.02,.1,.07,0,.02-.03,.04,.01,.1l-.02-.04,.26,.24,.02,.17s-.01-.06,.01-.06c-.02,.09,.04,.01,.07,.07-.01-.04-.03-.07-.08-.1l.1-.05c.06,.03,.1,.07,.14,.12h-.07s.08,.07,.12,.1v-.03l.18,.12,.03,.09,.21,.08s0-.07,.03-.06c.11,.1,.02,.2,.19,.24,.01,.05,.06,.13,.01,.16,.04,.08-.03-.02-.08-.08,.03,.04,.01,.05-.02,.06l-.08-.12c0,.1-.08-.1-.05,.05-.07-.14-.22-.1-.27-.25l-.16-.03c-.07-.06-.13-.12-.2-.18,.11,.12,.16,.26,.3,.32l-.04-.07,.25,.17v-.03c.15,.12,.15,.21,.2,.22v-.02s.16,.15,.18,.16h.02c0,.06,.15,.06,.15,.12v-.03s-.06-.03-.1-.06l.06-.03c.06,.06,.13,.16,.25,.19l-.02,.06,.19,.17s0-.06,.04-.04l.16,.18s.09-.07,.18,.01v-.02l.11,.11,.07-.08s.09,.05,.03,.1c.07,.04,.14,.09,.15,.14h-.04l.08,.06,.06-.07,.03,.05s.02-.03-.03-.07c.09-.03,.2,.12,.26,.09-.01,.02-.04,.05-.11,0,.15,.14,.28,.02,.44,.17,.01-.02,0-.06,.02-.08,.13,.17,.08,.1,.18,.26l-.1-.02c-.08-.07-.13-.17-.25-.17l.02,.08s.28,.08,.3,.18c0-.01-.07-.09,0-.05,.08,.07-.09,.03,.06,.11l-.2-.07c-.09-.02-.15,.08-.19,.07-.06-.06-.13-.11-.19-.17,.04,.12-.18,0-.07,.13,.07-.03,.11,.06,.18,.1l.06-.06c.15,.04,.29,.11,.43,.13-.01-.1,.16,.02,.14-.07l.12,.1s.08,0,.12,.04c.1-.05-.21-.18-.13-.12v.05c0-.14-.43-.38-.29-.38,.08,.16,.36,.19,.38,.34l.12-.03s.07,.07,.13,.08c0,.03-.11,.07,.01,.1l.04-.06c.05,.04,.05,.11,.09,.12-.04,.01,0,.06-.01,.09,.06,0,.15,.05,.19,.07l-.05,.02,.08,.03,.04,.15h.12l.2,.14-.04,.03c.05,.08,.23,0,.18,.04,.04,.05,.08,.1,.04,.14,.09,.07,.41,.07,.5,.18v.06l-.08-.04c0,.07,.14,.06,.09,.13h-.06l-.09-.11-.07,.06,.21,.08,.11,.2,.07-.02-.09-.08,.05-.08s.17,.08,.15,.06c.03,0-.08-.07-.18-.09-.02-.02-.03-.02-.04-.03h0c.12,.02,.23,.05,.35,.06-.09-.01,0-.09-.15-.1h.05c.08,0,.15,.06,.26,.13h.2c.24,.04,.37,.18,.64,.27-.11,.03-.17-.13-.26-.03l.11,.07,.08-.02s.03,.03,.04,.05c.2,.05,.18-.07,.38,0l-.06,.03,.29,.12,.03-.05c.1,.04,.18,.13,.3,.13-.12-.06-.13-.13-.09-.13l.07,.05s.05-.04,.11-.03c.07,.01,.14,.03,.2,.04-.06,.05,.17,0,.09,.07,.17,0,.41,0,.49,.06,.04,.05-.05,.06-.11,.08l.13,.03,.1-.16,.19,.05s.1-.05,.14-.08l-.1-.07c-.05,.04-.24-.02-.22,.06-.1-.05-.14-.11-.25-.14h.1c-.2-.07-.37,0-.54-.1,0,.05-.08,.04-.13,.06-.11-.03-.21,0-.33-.07,.02,.07-.16,.04-.23,.08,0-.06-.09-.08-.1-.14,.11-.06,.3,0,.45,.02l.06-.08-.05,.03-.09-.13-.04,.04c-.15-.05-.08-.1-.1-.11l-.06,.06c-.12-.06-.21-.15-.39-.15l.08-.08c.11,.08,.32,.05,.53,.12-.07-.05-.04-.11-.07-.16l-.18-.04,.13,.13c-.08,0-.05-.08-.16-.02,.11-.06-.11-.12-.1-.16-.14-.06-.25-.09-.35-.14-.1-.04-.2-.09-.33-.15l-.06-.08c.09,.04,.22,.06,.25,.14v-.03c.1,.04,.22,.06,.27,.13l.08-.03c.03,.08,.22,.05,.17,.14,.17,.03,.02-.13,.22-.07,.11,0,.22,.08,.38,.12h-.01s.18,.03,.18,0c-.23-.03-.23-.24-.39-.17l-.05-.09s-.1,0-.17-.01l.02,.04c-.03-.05-.18-.11-.28-.12l-.09,.02-.02-.08c-.11-.02-.23-.06-.34-.08,.1,.06-.14-.02,.09,.05-.08,.02-.19,.03-.3,0l-.09-.14s.06-.04,.11-.04l.1,.04v-.07l.15,.03-.07-.15-.3-.06c-.13-.12-.35-.11-.53-.19l-.09-.09c-.15-.05-.33-.16-.53-.12l.03-.05c-.06,.03-.11-.06-.16-.09-.08,.01,.02,.09-.09,.09,.06,.04,.12,.08,.19,.12-.09-.02-.18-.05-.27-.09v.06s.21,.04,.16,.11c-.05-.02-.1-.04-.14-.06l-.02,.03-.07-.08c.05,.05-.05,.02-.05,.04-.02-.04,0-.07-.05-.09-.06-.02-.19-.01-.25-.07l-.02,.06c-.06,.02-.16-.05-.21-.03-.08-.11-.12-.02-.25-.1-.02-.08,.12,0,.16-.02-.1-.08-.17-.08-.25-.14,.02-.02,.05-.04,.11,0l.05-.08-.22-.13c.08-.02-.03-.08-.06-.1-.04,0-.11-.07-.16-.09l.02-.09h-.09l-.09-.11c0,.07-.1-.02-.15-.04,.04,.04,.08,.09-.02,.07,.17,.02,.35,.19,.35,.29-.13,.02-.35-.11-.4-.18l-.05-.1c-.05,.02-.15,0-.09,.1l-.15-.07-.09-.14s0-.04,.01-.06c-.03-.02-.05-.04-.07-.05-.02-.07,.01-.1,.09-.1,.06,.03,.06,.07,.02,.09h.06l.11,.08v-.02l.18,.13-.09-.1s.08,.02,.1,.06v-.07c.08,.04,.17,.07,.26,.1-.14-.08-.28-.16-.42-.24-.14-.08-.27-.16-.37-.27,0,.04,.03,.14,.01,.18h.03c.05,.06,0,.06-.05,.07l-.21-.18s0-.03,0-.04c-.04,.02-.02,.06-.11,.08l.05,.06-.03-.05,.1,.09h-.13s-.11-.02,.08,.02c-.03,.01-.11,0-.09,.07l.07,.1h.08l.11,.11-.03,.08c-.03-.08-.16-.12-.22-.19l-.03,.06-.1-.05,.06,.05s-.05,0-.1-.03c.01-.08-.11-.18-.09-.25,0-.05,.13,.13,.16,.11,0-.06-.2-.15-.11-.19-.07,0,.01-.09-.09-.03l.04-.04,.13,.1-.02-.08,.09,.04c-.05-.03-.05-.13,.01-.12l-.12-.1,.03-.03c-.06-.13-.13-.08-.11-.09,0-.03-.05-.1,0-.09l-.02-.05-.03,.04-.16-.12-.04-.11-.14-.07s-.08-.11-.03,.03c-.12-.07-.11-.19-.23-.27h.07l.05,.07s.01,0,0-.02l.03,.03s-.02-.04,.02-.05c.04,.03,.07,.07,.07,.02-.05-.02-.04-.03-.03-.04Zm3.65,3.73s.02,.07-.04,.03l.04-.03Zm-.56-1.31s-.04-.03-.05-.05c0,0,.02,.02,.05,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.21,129.52h0c.06,.03,.05,.03,.04,.04l.03,.04v-.05h0l-.07-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.06,130.43h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.8,129.74l.05-.05-.03-.04-.06,.04c-.05-.05,.06,.15,.05,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.58,116.12l.11,.06c.09,.16,.2,.36,.25,.42-.03-.05-.01-.05,0-.06,.05,.06,.17,.12,.13,.19,.14,.12,.09-.05,.21,.08l-.09-.1-.06,.05c-.11-.13,.03-.16-.1-.29l-.13-.07c-.02-.07,0-.12-.05-.18,0,.02,0,.06-.03,.07l-.03-.08c-.02,.06-.03-.13-.05,.05v-.1c-.11-.1-.08-.17-.14-.27l-.11-.04c.02,.06,.04,.12,.07,.18l.02,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.28,115.24l-.03-.12s.02,.08,.03,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.34,115.48c.01-.1-.03-.15-.06-.24l.03,.15,.03,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M257.46,116.02v.09l.07-.03c-.03-.09-.17-.21-.1-.25-.02-.02,0,.04-.04,.04l-.1-.17v.14c.1,.06,.13,.32,.17,.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "261.33 116.34 261.29 116.28 261.26 116.29 261.33 116.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.1,116.22l.05,.08v-.07s-.04,0-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.1,116.22l-.02-.03s.01,.03,.02,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.45,116.57s.02,.01,.03,.02c-.02-.02-.03-.03-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.94,116.99s.02,.03,.04,.05l-.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.55,116.57s0,.03,.01,.04c0,0,0-.02-.01-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.81,116.98s-.04-.09-.03-.11c.04,.03,.07,.08,.07,.13,.07-.02,.05,.05,.07-.04v.02c-.03-.08,.06-.09-.07-.18v.05s-.07-.05-.11-.09v-.07s0,.03-.05,0c-.02-.04-.04-.07-.06-.11,0,.03-.03,0-.05,0,0,.03,.02,.06-.01,.04,0,0,0-.01,0-.02,0,.02-.05,0-.08-.03,.04,.05,.1,.16,.12,.21,.02,.09-.17-.02-.08,.09,.12,.02,.03-.01,.13-.04,0,.04,0,.05,.03,.08l-.02-.07c.08,.05,.08,.03,.15,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.23,115.44l.08,.09v-.09c0,.05-.04,.01-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.09,117.08s.02,.06,.08,.08c.03-.06,.12,.01,.1-.09l-.06-.07c.08,.02,.03-.1-.02-.16-.04,0-.04,.06-.1,.02v-.04c0,.16,.14,.11,.13,.25-.08-.07-.05,.03-.13,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.59,115.34s0,.02,.02,.04c0-.02-.01-.04-.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.54,115.33s.04,0,.05,0c-.03-.1,.21,.07,.08-.18v.09h-.07v-.02l-.02-.07h-.06v-.09c-.12,.03,.16,.26,.02,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.48,116.75v.05l.03-.07s-.05-.02-.03,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.82,115.36h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.89,115.43c.03,.08-.03,.07-.03,.05,.03,.05,.06,.09,.09,.13l-.07,.04s-.03-.07-.04-.1c0,.03,0,.06,0,.1,.05,.02,.08,.04,.08,.11-.02,.07-.08-.11-.11-.06,.03,0,.13,.11,.12,.19l.03-.05,.09,.17c-.06-.14,.08,.01,.02-.14,0,.03-.02,.03-.03,.05-.03-.05-.02-.07-.06-.11h-.04c-.04-.09,.09-.03,.02-.11,.07,.09,.14,.02,.19,.18,.06,0,.02-.07,.02-.11-.04-.02-.04,.01-.08-.03,.07-.03-.03-.08-.04-.15,0-.07-.17-.11-.2-.27l-.02,.02s.04,.06,.06,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.79,115.55c-.01-.07,.03-.08,.02-.19-.01-.05-.05-.08-.07-.07,.04,.1-.02,.13,.05,.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "259.38 115.82 259.45 115.67 259.33 115.63 259.38 115.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "262.02 117.16 262.06 117.13 261.99 117.12 262.02 117.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "262.34 117.32 262.31 117.28 262.27 117.27 262.34 117.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.5,115.78l.19,.22-.1-.18c-.05-.04-.09-.06-.09-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.88,116.3s0-.05,0-.08l-.2-.22,.1,.19s.11,.07,.09,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.59,115.81c.09,.06,.22,.17,.26,.19-.13-.13-.26-.37-.31-.48h-.05c-.05-.07-.1-.17-.15-.2l.21,.44,.03,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.84,116.34l.02,.05,.03,.02-.05-.09s0,.03,0,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "258.9 116.45 258.91 116.44 258.88 116.42 258.9 116.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.29,115.55c-.02-.16-.08-.06-.04-.2l-.09,.14s0,.03,0,.03c.05,.05,.09,.06,.13,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.17,115.53h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.4,117.53l.05,.14s.05,.01,.09,.04c0,.02-.09,.04,0,.08,0,.08-.1-.07-.09,.01,.09,.12,.14,.11,.21,.16,0,0-.07-.17-.07-.17l.11-.04-.16-.15s.06-.03,.03-.09c0,.01-.06-.05-.07-.04-.03-.04-.06-.08-.09-.12,.02,.07,.06,.16,.06,.21l-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.88,117.23l.1,.1-.07-.13c-.06-.04-.03,.08-.1-.03,.02,.03,.04,.05,.06,.08,0-.01,0-.02,.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.3,117.53s.06,.09,.08,.12c-.03-.05-.04-.09-.08-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.28,117.49l.02-.04s-.03,.02-.02,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.3,117.53s-.02-.03-.02-.04v.02s.01,.01,.02,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.43,116.23s.03,.06,.03,.07c-.01-.09,.1,.06,.01-.06-.03-.01-.04-.02-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.65,118.05h0s-.02,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.2,117.53s-.03-.03-.04-.05c0,.03,.02,.04,.04,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.92,116.04c-.07,0-.09,.04-.02,.17v-.02c.11,.09,.23,.29,.29,.35,.05,.13-.07-.02-.04,.08,.07,.09,.11,.16,.15,.23l.14,.22s-.08-.1-.09-.09c.04,.13-.07,.14-.02,.26,.09-.03,.14,.21,.14,.24l-.06-.1s-.02,.02-.02,.03c-.08-.04-.05-.19-.14-.19,0,.05-.17,.03-.06,.21,.02-.02,.05,.03,.07,.05,0,.04-.03,.06-.06,.04,.05,.05,.12,.11,.12,.2h-.03l.17,.28-.09-.02s.03,.04,.03,.07l.09,.09-.02-.08c.05,.01,.1,.05,.14,.07-.06,.04,.08,.17,.1,.26v-.03l.08,.08c-.07-.09-.09-.19-.14-.31-.06-.1-.12-.06-.15-.19,.13,.11-.01-.05,.09,.02,.03,.03,.04,.05,.06,.08,.02,0,.07-.03,0-.11-.04-.02-.09-.11-.11-.15,.07,.07,.05,0,.1,.05,0-.03-.03-.07-.04-.1,.03,.05,0,.07-.03,.06-.02-.11-.1,.04-.13-.13h.08l-.02-.03s.12,.08,.1,.02c.05,.05,.03,.08,.05,.12l.03-.03,.03,.07-.03-.14c.14,.19,.07-.08,.2,.14,0,.08-.07,.03-.09,.1,.04-.05,.16,.12,.23,.22h-.04l.13,.14,.05-.04c-.01-.08-.12-.06-.11-.15,.02,.02,.12,.07,.16,.11l-.02-.09,.14,.21c.02-.06,.09,.08,.14,.11-.02-.03-.04-.06-.03-.1l.03-.02s-.04-.09-.09-.08c0,.01,.03,.06,0,.07-.04-.04-.04-.08-.05-.12-.03-.01-.02,0-.03,.01,.01-.02,0-.11,0-.16,.02-.06-.04-.13-.1-.19-.06-.07-.1-.13-.05-.16-.15-.08-.25-.21-.36-.34-.1-.14-.19-.28-.33-.37,0-.1,.02-.08-.07-.22-.11-.14-.28-.4-.37-.44-.1-.13,.04-.13-.04-.3,.03,.06-.03,.1-.03,.15-.06-.04,0-.08-.03-.11Zm1.38,1.95s0,.02,0,.03c0-.01,0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.41,118.09v-.03h0v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.47,118.3h-.02s.01,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.67,118.37s-.08,0-.09-.06c-.06,0-.04,.06-.07,.09,.07,.01,.11,.05,.13,.1,.03-.03-.02-.12,.03-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.62,118.5s.02,0,.03,0h0s-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.19,118.2v.04s.02-.02,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.68,118.24l-.05-.06s.01,.04,.03,.05c-.13,0,0-.14-.17-.17,.14,.11-.06,.15,.1,.25,.1,.05,.04-.07,.1-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "260.45 118.43 260.45 118.43 260.45 118.43 260.45 118.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.4,118.42c.05,.15,.25,.28,.32,.42,.1-.06,.23,.16,.32,.1l-.02-.02c0-.08,.07,.02,.11,.04-.04-.1-.12-.17-.22-.26,.04-.05,.13,.1,.18,.1,.01,.03,.04,.06,.08,.1v-.05c-.13-.05-.2-.32-.34-.31,0,.05,.1,.11,.05,.13-.07-.03-.15-.14-.23-.17,.02,.04,.03,.08,.04,.12-.07-.08-.18-.12-.24-.19,0,.03-.04,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.4,117.37v.02s0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M257.73,115.88c-.02-.07-.18-.25-.18-.31l.02,.15,.16,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.55,117.98s.06,.02,.09,.02c0-.02-.05-.12-.12-.11l.08,.07-.05,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.42,116.46s0,.05,.02,.07c.02,0-.01-.05-.02-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.44,116.54h0c.06,.13-.02,.21,.12,.37h.08c.04,.05,.02,.07,.04,.11,.12,0-.08-.12-.02-.14l-.06-.03c.06-.14-.11-.19-.16-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.43,116.54h0s-.03-.06-.06-.1l.06,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.95,117.92v-.05s-.06-.04-.09-.03c0,.04,.06,.06,.09,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.71,118.12c-.03-.06-.06-.07-.12-.08l.12,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.93,117.69s.02,0,.03-.01c-.03-.01-.03,0-.03,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.82,117.73c.09,.09,.06-.1,.16,.04,0-.02-.04-.06-.05-.08-.04,0-.11-.04-.13-.04-.03,0,.09,.08,.02,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.89,117.92s0,.04,0,.06c.01-.01,.02-.03,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.94,118.08c.02-.07-.03-.05-.05-.1,0,0-.02,.02-.02,.03l-.1-.09c.05,.05,.08,.12,.16,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.94,119.29s-.04-.02-.05-.03c0,.01,.01,.02,.05,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.12,119.25v-.02s0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.07,118.38c.1,.07,.19,.18,.23,.22h0c.09,.06,.18,.16,.21,.23,.01,0,.05-.01,.07-.01,.03,.04,.15,.11,.18,.16-.02,.04-.08,0-.14-.04-.06-.05-.12-.09-.16-.03,.04,.02,.09,.12,.16,.17-.01-.03-.02-.07-.03-.1,.07,.04,.14,.13,.12,.17l.04-.03c.09,.03,.11,.1,.14,.15,0-.02,0-.03,0-.05l.09,.03s.01,.1,.06,.14c.07,.02,.01-.08,.08-.08l.08,.05s-.08-.06-.07-.1l-.03,.04c-.02-.09-.1-.02-.11-.11h-.1c0-.06,.1-.05,.12-.1-.05-.05-.15-.08-.15-.11-.07-.04,.05,.06-.02,.05-.17-.12-.08-.26-.28-.33h0c-.2-.08-.1-.18-.31-.25,0,.02,0,.05-.03,.03-.05-.1-.17-.14-.28-.23l.02,.06h-.08s.13,.04,.22,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.52,118.86s0-.02,0-.03c-.01,0-.01,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.11,116.69c0,.09-.06-.06-.1-.1,0,.02,0,.03,0,.03l.05,.13s.07,0,.04-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.02,116.63s0,0,0,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.99,116.67s.02-.02,.03-.04c-.01,.02-.07-.09-.03,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.66,118.28h.05l-.11-.18s-.11,.09,.06,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.59,118.31l-.04,.1c.13,.04,.13,.12,.23,.18,.02-.01,0-.09-.1-.15h.06c-.12-.05-.06-.1-.15-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.92,118.46s.03,.02,.04,.02l-.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.86,118.36l-.04,.04,.11,.06s-.07-.08-.07-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "261.06 118.36 261.06 118.35 261.05 118.35 261.06 118.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.16,118.42h0l-.1-.06s.06,.07,.09,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.22,117.48c.18,.23,.08,.2,.25,.39v-.07c.14,.06,0,.08,.09,.18,.02,.02,0-.09,.08-.02,.09,.08,0,.05,.03,.1v-.03s.04,.03,.04,.05l.05-.05c.1,.12,.2,.16,.24,.29,.08,.02-.08-.13,.03-.07,0,.02,.02,.06,.04,.09,.01-.03,.05-.03,.09-.01-.13-.03-.09-.19-.22-.17,0-.02,.04-.04,0-.08h-.07s-.12-.13-.17-.17c.04,0,.16,.12,.09,0-.05-.06-.07,0-.13-.08l.02-.04c-.05-.13-.17-.04-.16-.18-.12-.1-.23-.22-.29-.18v.04s.03-.03,.05-.02c.07,.06,.03,.09,.05,.14-.04-.06-.07-.06-.12-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.39,118.36s0,.03-.04,.02c.04,.03,.04,.06,.05,.09v-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.88,118.34c.05,.04,.1,.09,.15,.14,.05-.03-.07-.08-.09-.14,0,.02-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "263.34 118.42 263.3 118.43 263.37 118.46 263.34 118.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.26,118.81s.07-.02,0-.11l.02,.06c-.05-.05-.12-.07-.16-.15,.04-.03,.02-.15,.1-.08l-.12-.12c.1,.11,0,.16-.03,.2l.19,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.26,117.15s-.06-.1-.04-.11c-.04,.05-.02,.03,.04,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M257,116.24c-.05-.12,.05,0,.07-.02l.07,.03s.05-.03,.07-.1c-.02,0-.12-.14-.08-.04-.02-.04-.06-.11-.07-.16v.12l-.1-.2c.04,.08-.02,.12,.05,.25l-.09-.06,.09,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M257.06,115.96v-.05s0,.03,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.94,118.52s0-.11-.05-.09c.07,.05-.04,.05,.05,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.87,118.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.1,118.8c-.09-.08-.07-.02-.12-.03l.02-.06s-.1-.05-.13-.07c.02,.02,.04,.04,.03,.06,.17,.08-.02,.09,.12,.21-.11-.14,.1-.01,.08-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.87,118.64s-.02-.01-.02-.03c0,0,.01,.02,.02,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.31,118.66c.06,.02,.16,.12,.17,.07,.12,.13-.01,.1,.09,.22l.02-.08,.13,.07c-.06-.08,.02-.03,.06-.03-.08-.14-.32-.15-.36-.32-.13-.12-.12,0-.1,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.02,118.12l-.03-.13s-.11-.09-.06,.03c.06,0,.05,.07,.1,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M257.6,116.13s.09,.12,.09,.19c.01-.05-.05-.21-.09-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.28,118.69s.01-.08-.06-.07c0,.02,.02,.04,.06,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M257.57,116.26s.01,.09,.02,.14c.06,.01,0-.08-.02-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M257.52,116.26s0-.03,.01-.05c-.01,0-.01,.02-.01,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M257.59,116.52s-.06-.17-.07-.26c0,.02-.02,.03-.05,0,0,.05,.01,.1,.02,.15,.02,.03,.09,.03,.11,.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "257.57 116.26 257.57 116.25 257.57 116.25 257.57 116.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M257.56,116.22v.03l.08,.06c.03-.05-.07-.1-.07-.16-.03-.02-.03,.02-.04,.07,0,0,.02,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.36,118.77s0,.06-.04,.04c.01,.05,.05,.05,.09,.05-.09-.05-.01-.05-.05-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.17,116.67l-.05-.04c.03,.09,.07,.18,.11,.26-.02-.07-.04-.15-.06-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.31,118.92s-.12-.07-.12-.1c0,.09-.09,0-.01,.11,.01-.02,.14,.04,.13-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.14,118.98h.01l-.07-.09c-.06,0,.03,.06,.05,.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "262.97 118.8 262.89 118.73 262.99 118.87 262.97 118.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.61,117.5l-.06-.14-.04,.02c-.04-.11-.15-.32-.14-.31h-.01l-.09-.19c-.02,.16,.2,.4,.24,.59l.05,.06s0-.09,.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.16,117.45s.05,.04,.06,.04c-.02-.02-.04-.04-.06-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.37,117.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.17,117.11s0,0,0,.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.51,117.61c-.05-.06-.1-.11-.14-.17,.02,.03,.03,.05,.05,.07l-.04,.05c.06,.05,.12,.09,.14,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M257.74,116.6s.02,.04,.02,.06c-.08,.03-.06-.17-.15-.15,.04,.15,.21,.42,.2,.44,.08,.14,.26,.4,.28,.37l.03-.04,.06,.12c-.02-.06-.01-.07,.01-.06,.06,.03,.07,.14,.03,.15,.05,.07,.09,.2,.16,.21l-.05-.15,.03,.02c-.04-.08-.07-.21-.01-.18-.04-.04-.1-.15-.08-.05-.01-.06-.13-.16-.11-.21,0-.07-.07-.14-.1-.23h-.04c-.07-.1-.1-.13-.18-.27v.09s-.09-.12-.11-.2v.09h.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "263.51 118.96 263.51 118.92 263.44 118.93 263.51 118.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.35,118.17s.07,0,.11-.02c-.02,0-.04-.03-.06-.05-.02,.03-.14-.07-.06,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.4,118.08s0,.02,0,.03c0,0,0-.01,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.87,119.05s0,0,0,.02v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.86,119s.02,.03,.01,.04c.01-.01,.03-.02-.01-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M257.22,116.47l-.1-.22c0,.05-.02,.08-.04,.06,.06,.02,.12,.19,.14,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M257.54,116.81c-.02-.09-.16-.31-.18-.26l.06,.09h0c.08,.04,.01,.12,.12,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M257.4,116.69h0l-.07-.09s0,.11,0,.15c.05,.05,.07,0,.08-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M257.41,116.64s0,.03,0,.05v-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M257.11,116.39s.02,.09,.04,.14c.06,.03-.02-.12-.04-.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "265.37 119.31 265.29 119.27 265.31 119.3 265.37 119.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M257.68,117.02c.01,.07,.08,.13,.13,.19-.06-.12-.07-.21-.08-.27-.01,0,0,.04-.03,.04-.09-.12-.04,.01-.11-.09l.04,.14h.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M257.46,116.88l.03,.08s-.01-.05-.03-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258,117.47c-.02-.06,0-.1-.06-.14l.07-.03c-.1-.08-.08-.05-.17-.11,.04,.08,.07,.16,.09,.24h0l.08,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M257.97,117.59c-.01-.05-.03-.11-.05-.16,0,.03,.02,.11,.05,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M257.66,117.27s0,.01,0,.02h0v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M257.46,116.88l-.03-.06s.01,.04,.03,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M257.29,116.82s.06,.06,.06,.03c.07,.19,.17,.37,.28,.48,.11,.19-.06,.16,.1,.33,.17,.22,.31,.48,.4,.6h.01c.07,.05,.12,.21,.18,.28l-.02,.06,.18,.15-.04-.11,.07,.04c-.23-.21-.19-.52-.39-.71-.04-.14-.04-.19-.09-.35-.03,0-.05,0-.06-.04,.02,.09,.05,.18,.08,.27-.04,0-.08-.11-.07-.14-.04,0,.05,.1-.02,.06-.06-.08-.04-.1-.04-.14l-.04,.03c-.08-.13,.06-.03-.04-.18l-.04,.05c-.04-.07-.13-.19-.14-.24-.05-.06-.12-.21-.17-.33h0c-.09-.22-.13-.01-.22-.27,0,.03,0,.07,.05,.13h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.79,119.59c-.12-.03-.18-.14-.22-.2,0,.03-.02,.03-.06,.03l-.02-.05s-.07,.01-.03,.06h.08s0,.12,.04,.14v-.07c.05,.02,.09,.07,.07,.09h.09l.04,.05,.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.04,119.48l.05-.02s-.07-.03-.11-.04c.02,.02,.04,.04,.06,.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "260.13 118.46 260.18 118.53 260.13 118.42 260.13 118.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.81,119.62s0-.02,0-.03c-.02,0-.03,0,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.25,118.95c.12,.06,.17,.2,.27,.29-.08,.04-.14-.17-.22-.12,.04,.06,.1,.11,.16,.16,.06,.05,.11,.1,.12,.17,.04,.01-.08-.12,.03-.1,.01,.13,.2,.16,.2,.25,.02,0,.04,0,.02-.04,.09,.11,.16,.08,.25,.18-.07,.05,.13,.19,.18,.29,.06-.02,.12,.04,.19,.12,.07,.07,.15,.15,.24,.17-.31-.23-.33-.42-.62-.64h.11c-.14-.05-.04-.22-.25-.28-.13-.06-.28-.21-.31-.27h-.06c-.07-.12-.15-.13-.25-.16v-.06c-.08-.04-.02,.04-.06,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.4,118.18c.05,.07,.04,.08,.09,.06-.04-.08-.07-.09-.09-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.95,118.16s0-.02,0-.02c0,0,0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.89,118.84v-.07s.06,.08,.06,.1l.03-.03c.05,.05,.08,.15,.12,.16,.03-.06-.03-.12-.09-.18-.06-.06-.13-.13-.12-.2,0,0,0-.04,.03-.03,.05,.04,.07,.12,.05,.12,.03-.01,.07-.03,.12,.05l-.05,.03s.12,.1,.1,.14l.02-.02c.12,.14-.04,.08,.04,.19-.03-.04,0-.06,0-.06l.15,.17h.05s.17,.13-.08-.2v-.06l-.14-.06c.06-.03,0-.08-.06-.15-.07-.07-.15-.14-.15-.21v.03c-.13-.28-.02-.18-.09-.41,.05,.04,.08,.02,.09,0-.01,.02-.04,.01-.06-.02-.01-.2-.28-.23-.29-.41-.04-.02-.08-.05-.04,.03,.04,0,.11,.18,.18,.23,0,.04-.03,.07,.05,.13-.06,0-.08-.01-.06,.09,.03,.02,.03,0,.04-.02,.12,.17,.05,.16,.06,.25-.03-.02-.13-.15-.11-.06-.1-.09,0-.15-.08-.19-.11,0-.25-.34-.4-.39,0,.04-.04,.03-.05,.06,.05,.07,.11,.05,.15,.06,.03,.17,.23,.34,.35,.53l.06-.05c.05,.1,.08,.22,.01,.21-.06-.03-.1-.11-.1-.15,0,.03-.07,.06,0,.15,.03,.02,.06,.03,.1,.08l-.03,.03c.07,.12,.09,.02,.17,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.95,118.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.82,118.41s.06,.06,.05,.09l.03-.07-.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.02,119.18s-.04,0-.06,.01l.02,.04s.08,.02,.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.36,119.94s0,.01,.01,.02c0,0,0-.01-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.08,118.82h0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.5,120.47s.01,.06,.04,.09c0-.05-.03-.09-.04-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265,122.53l.04,.03s-.02-.01-.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.2,118.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.81,120.11h0c-.04-.09-.15-.04-.07,.02,.07,.04,.07,0,.12,.05,0-.01-.03-.03-.04-.04,.05-.02,.11,.08,.17,.11-.05-.03-.12-.17-.19-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.52,121.31s.04,.02,.07,.04c-.03-.01-.05-.02-.07-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.99,122.53c-.05-.03-.14-.08-.17-.08l-.04,.02s-.08-.05-.12-.07v.02c-.16-.01-.18-.14-.19-.19,.08,.12,.3,.02,.29,.16,.08,.04,.12,0,.1-.02-.01-.01-.01-.05-.05-.04,.04,.02,.03,.05,.02,.06-.18-.05,0-.11-.2-.16-.04,.06-.18-.08-.27-.07,.1,.02,.06,.08,.09,.13-.12-.12-.09,.04-.22-.05-.08-.06-.07-.13,0-.11-.12-.04-.18-.13-.19-.18,.06,.07,.24,.11,.21,.06-.04-.01-.08-.03-.07,0-.03-.1-.32-.19-.29-.25v.04c-.18-.13-.21-.03-.38-.19,.01,.04-.04,.06-.12-.01l.04-.02h-.02c-.07-.14-.27-.09-.31-.17-.04-.04,.09,.08-.03,.03,0-.01-.1-.11-.15-.09-.13-.09-.21-.21-.27-.33,.07,.08,.21,.12,.15,.18,.09,.02,.14,0,.2,.05,.09-.01,0-.12-.01-.18,.06,.04,.11,.15,.17,.13l-.15-.14c.25,.07,.29,.13,.5,.25-.1-.06,.03-.07-.1-.15,.04,.04,0,.05-.01,.08-.02-.1-.1-.14-.18-.22,.02,.04,.02,.08-.06,.05-.18-.06-.34-.22-.46-.32l-.05,.05-.1-.08c.13,.02,.04-.07-.02-.16,0,.03,0,.05,0,.07-.09-.09-.08-.06-.17-.13l-.02,.03s-.07-.08-.12-.12c-.05-.04-.11-.08-.15-.11v-.08s-.04,.02-.06,.01h.02c0,.08,.09,.2,.07,.25-.09-.07-.16-.16-.21-.22-.07-.05,.03,.06,0,.06-.04-.02-.04-.06-.06-.09,0,.02,.03,.08,0,.1-.2-.16-.17-.25-.29-.4,.06,.09-.07-.02-.1,0,.06,.04,.11,.12,.06,.11-.04-.02-.08-.06-.11-.1,0,0,0,.01,0,.02-.06-.1-.05-.05-.12-.14l-.17-.04,.04-.03s-.09-.09-.13-.13c0-.03,.08-.04-.03-.12l-.03,.05-.08-.08,.05-.02c-.07-.07-.08-.08-.11-.05-.06-.11-.11-.26-.26-.37,.02,.03,0,.02,0,.05l-.15-.19,.06,.02-.11-.07,.02-.04s-.03,.01-.05,.03c-.04-.02-.08-.08-.08-.11v.03c-.09-.09-.06,.02-.17-.09,.03,.04,.04,.07,.05,.1,.13,.15,.21,.34,.41,.45h-.07s0,.02,.01,.03c.02,.07-.07-.06-.02,.04,.05,.03,.06,.06,.03,.08l.12,.04c-.08-.03-.08-.08-.11-.14,.03,.02,.08,0,.15,.1,.11,.22-.22-.03-.23,.04,.03,.03,.05,.05,.02,.06-.1-.11-.02,0-.1-.04-.13-.14,.12-.03-.05-.19-.1-.13-.23,.1-.28-.17-.05-.05-.1-.1-.15-.16-.06-.07-.02-.12-.08-.19-.04,.06-.19-.12-.18-.17l-.02,.04c-.03-.08-.1-.08-.1-.16,0,0,.01,.07-.05,.03,.03,.03,.06,.07,.07,.11-.13-.12-.27-.15-.37-.26,.08,.08,.03,.19,.15,.26,0,.03,0-.07,.04-.02l.11,.21c-.02-.09,.13,.1,.07,0-.01,.03-.06-.07-.09-.08l.06-.04c.1,.07,.08,.19,.12,.29l-.06-.04c.07,.06,.13,.14,.2,.22,.07,.08,.14,.17,.2,.24l-.03-.12s.06,.05,.11,.1v.1c.31,.13,.26,.39,.48,.5-.02,0-.02-.02-.03-.03,.17,.1,.05,.1,.2,.22,.09,.06,.07-.04,.05-.06,.17,.04,.03,.1,.22,.18,.02,.07-.01,.11,.04,.16h.04c.14,.11,0,.03,.05,.13,.22,.13,.35,.12,.6,.38h-.08c.08-.01,.07,.11,.16,.12-.05-.01-.04,.04,0,.08-.08-.12,.1,.04,.09-.03,.04-.03-.12-.09-.13-.13l.12,.05c-.09-.11-.12-.09-.23-.22,.16,0,.18,.08,.38,.12-.02-.04-.05-.07-.07-.11,.03,0,.06,.01,.09,.02-.09-.03-.11-.15-.03-.12,.03,.08,.08,.11,.2,.17l.03-.07s-.03,0-.02,0c-.09-.04-.07-.08-.09-.13,.11,.04,.17,.15,.19,.22,0-.04-.03-.11,.03-.08,.06,.04,.18,.14,.13,.17-.13-.1-.09-.02-.18-.03,.12,.08,.1,.14,.15,.22h-.14c.04,.05,.1,0,.21,.11,.02,.03-.07,.03-.03,.1l.02-.03c.1,.09,.22,.09,.27,.12,.04,.11,.27,.15,.26,.2,.17,.05,.15,.1,.39,.17,.02,0,0-.08,.11,0-.02,.07,.23,.06,.21,.17,.02-.07,.2,.08,.28,.05,.11,.04,.09,.12,.21,.14l-.02-.02c.16,.15,.43,.21,.57,.33-.03-.01-.04-.06-.03-.08l.15,.06h-.08c.08,.01,.14,.06,.21,.08-.04-.02-.05-.07-.06-.09,.03-.02,.07,0,.11,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.67,122.4v-.04s-.02,.02,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262,120.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.22,121.02s-.06-.09-.08-.1c.02,.04,.05,.07,.08,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.99,122.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.22,118.73l.02,.02s0-.05,0-.08c-.03-.01-.14-.16-.1-.04l.07,.05v.06s0-.02,.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260,118.61l.06,.04-.07-.11s.01,.05,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.48,117.81l-.02-.04s.01,.04,.02,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.48,117.81l.03,.07c.01-.11,0-.02-.03-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.07,119.57c-.07-.07-.04,.02-.12-.05-.02,.01,.02,.04,.02,.07l.09-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.03,118.1h-.05c.06,.05,.08,.11,.07,.16,.02-.04,.04-.07-.02-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.05,118.26s-.02,.03-.03,.06c.01-.01,.02-.03,.03-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.91,118.6c-.03,.05-.29-.3-.21-.04,.07,.02,.06,.04,.05-.04l.17,.18v-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.8,119.59v.06s.06-.02,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.72,119.65s-.03,0-.05,.01l.04,.06c.08,.04,.06-.05,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.88,119.7c.05,.09-.18-.07-.06,.07,.03-.01,.12,0,.06-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.31,119.81s-.04,.02-.07,.02l.22,.1s-.16-.06-.15-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.35,119.94s0,0,.01,0h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.42,120.02c.02-.05-.09-.06-.08-.08-.03,0-.08-.05-.1-.03,.02,.05,.15,.09,.18,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.15,120.19c.07,.05,.23,.11,.26,.07-.13-.03-.01-.07-.09-.12,0-.02,.01,.03-.03,.02-.21-.09,.06-.11-.11-.2-.06,.07-.16-.1-.2-.09-.05,.05-.06,.18,.11,.2v.04l-.15-.06c.05,.11,.3,.04,.2,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.11,118.47l.03-.02c-.04-.09-.26-.42-.43-.55v.02l.14,.17,.06,.2,.15,.1,.04,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.47,118.34l.06,.07c-.06-.13-.08-.09-.16-.2,.03,.05,.05,.1,.09,.15h-.06c.1,.09,.04-.02,.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.94,119.41v.06s.01-.01,.02-.02c.03,.02,.04,.06,.05,.09,0-.05,.03-.01,.07,0l-.08-.14s-.01,.06-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.94,119.49v-.03s0,.01,0,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "265.55 120.03 265.45 120.05 265.46 120.12 265.55 120.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M267,120.04s-.08-.04-.03-.06c.03,0,.04,.03,.06,.05-.01-.08-.16-.05-.11-.11l-.06,.07s.08,.05,.14,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.79,120.06c-.06-.04-.12-.13-.21-.08,.08,0,.13,.13,.21,.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "262.68 119.94 262.8 120.04 262.72 119.95 262.68 119.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.23,119.67s0,.01,.01,.02c0,0,0-.01-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.23,119.65h-.02l.02,.02s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "261.2 119.67 261.21 119.66 261.21 119.66 261.2 119.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.19,119.72c.06,.05,.1,0,.11,.07,.03-.02-.02-.06-.05-.1,0,.02-.03,.02-.06,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.95,120.33l-.09-.08v.08s.23,.06,.11-.06c-.04-.02,.07,.08-.03,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.41,120.19s.15,.07,.17,.04l-.09-.08,.03,.05s-.08,0-.12-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "267.06 120.08 267.05 120.09 267.13 120.13 267.06 120.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.31,119.84s.11,.04,.15,.06c-.05,0-.14-.12-.15-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.55,119.19s-.08,0-.06,.13c.04,.02,.12,.01,.15,.09-.12-.07-.01,.06-.05,.05,.18,.11,.08-.06,.09-.12-.02,0-.05-.05-.09-.09l.04-.04-.06-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.67,119.32s0,.01,0,.02c0,0,0,0,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.77,118.98l-.03,.03s.06,.02,.08,.03c-.03-.04-.06-.07-.06-.11h0c-.09-.04-.06-.12-.12-.18-.11-.04,.02,.12,.03,.15l.1,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.35,120.34c.07,.09,.12,0,.17,.01-.11-.03-.04,.04-.17-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.73,120.28s-.03,.05,.04,.1c.01,0,0-.07-.04-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.15,120.35v.03s-.03-.01-.04-.02l.07,.07,.05-.03-.08-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.62,120.31c-.07,.02,.07,.13,.08,.14l.12,.03c-.07-.06-.23-.09-.2-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.65,120.1l.02,.04,.02-.06c-.05-.02-.02,0-.05,.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "267.44 120.2 267.34 120.18 267.38 120.21 267.44 120.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "263.26 120.38 263.27 120.43 263.3 120.47 263.26 120.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "262.84 120.42 262.73 120.31 262.78 120.39 262.84 120.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.42,119.36h-.04s.06,.04,.09,.06c-.02-.02-.03-.04-.05-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.92,120.42l.04,.04c.07-.03-.08-.05-.06-.09-.1,0-.02,.06-.02,.11,.04-.02-.06-.06,.04-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "265.66 120.59 265.58 120.54 265.65 120.59 265.66 120.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.01,120.37c.07,.04-.14-.19-.14-.14,.02,.04,.13,.08,.14,.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "267.14 120.43 267.05 120.46 267.12 120.5 267.14 120.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.07,120.4c-.11-.02-.25-.09-.33-.11,.12,.04,.21,.12,.33,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.55,120.67h-.01s0,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.63,120.9h0c.12,0,.14,.03,.23,.08,0-.07-.11-.12-.16-.18h0s-.03-.05-.02-.08c-.06-.06-.1-.05-.12-.04,.13,.05,0,.08,.11,.11-.14-.03,0,.07-.23-.02h.05c-.06-.02-.1-.06-.1-.02,0,.01,.05,.05,0,.05-.04-.08-.13-.09-.16-.19,0,.02-.02,.03-.05,0,.05,.02,.06,.04,.08,.06-.03-.02-.16,.02-.19,.06,.07,.04,.15,.08,.22,.11-.02-.02-.03-.04,0-.06l.08,.1c.12,.04,.19-.06,.26,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.82,120.64s.04,0,.04-.02c-.02-.02-.06-.01-.08-.02l.04,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "263.06 120.85 263.06 120.85 263.06 120.86 263.06 120.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.91,120.79c.04,.08,.04,.12,.17,.19-.01-.04-.03-.1-.01-.12-.02,.02-.1-.03-.15-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.1,120.71s-.02,0-.03,0h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.07,120.71l-.18-.04c.01,.08,.08,.08,.16,.18,.01-.01,.04-.01,.09,.01l.08,.06c-.05-.07-.2-.19-.15-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.98,119.49s-.02,.06,.06,.12c-.08-.08,.05-.05-.06-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.25,120.39l-.11-.02v.09c.04-.06,.09-.06,.11-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M267.01,120.75l-.03-.09s-.07,.01-.12,.04c.07,.03,.13-.02,.15,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.2,119.42s0,.04,.02,.09c.03,.04,.06,.03,.1,.06,.07-.02-.07-.14-.1-.21-.06-.05-.1-.17-.19-.17l.07,.15s.07,.02,.1,.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "264.23 120.95 264.21 120.95 264.28 121.04 264.29 121.04 264.23 120.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "263.86 121.03 263.8 120.94 263.78 120.94 263.84 121.03 263.86 121.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.48,121.1s-.03,.02-.06,.01l-.02-.03s.03,.06,.14,.1c.08,.01-.03-.06-.05-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.35,121.02l.05,.07s-.02-.04-.05-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.3,121.18s-.03-.09,.02-.07l-.13-.07s.02,.05,0,.05l.12,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.32,121.02h.06c-.21-.11,.04,.15-.17,.02,.05,.09,.14,.01,.23,.06-.02-.03-.14-.03-.12-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.38,120.09h-.02s.02,.01,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.29,120.05l.08,.03s-.07-.07-.1-.08l.02,.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "265.84 121.11 265.87 121.19 265.96 121.19 265.84 121.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.99,121.14c-.07-.02-.11-.04-.06-.06-.1-.02-.28-.03-.35-.03l.09,.08s-.07-.04-.03-.07c.03,.03,.15,.06,.1,.1,.08-.02,.23,.01,.27,.08,.05-.05,.08-.12-.04-.16,.03,.02,.02,.03,.02,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M258.55,119.75s0,.04,0,.05l-.06-.06,.04,.12c-.05-.11,.13,0,.02-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.96,121.21l-.03,.03s.06,.04,.1,.05c-.02-.03-.04-.06-.07-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.34,121.13l.03,.08c.06,.02,.01-.05-.03-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.39,120.55s-.07-.03-.07,0l.11,.11c-.05-.05,.08-.03-.04-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "266.25 121.23 266.18 121.18 266.22 121.26 266.33 121.23 266.29 121.19 266.25 121.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "263.75 121.27 263.76 121.28 263.75 121.23 263.75 121.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "263.74 121.33 263.75 121.27 263.66 121.23 263.74 121.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.23,121.07c-.02,.09-.26-.14-.21-.04l.08,.05h0s.17,.08,.18,.08l-.04-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.03,121.04h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "267.64 120.93 267.63 120.94 267.73 120.99 267.64 120.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.16,121.27s.07,.02,.11,.04c-.04-.02-.08-.04-.11-.06v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.39,121.37s.06,.04,.1,.05l-.11-.1s-.04,.02,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.2,121.52s.08,.09,.14,.14l.02-.07s-.03,.03-.1-.04c-.02-.05-.02-.13-.14-.17,.02,.06,.16,.11,.09,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.19,120.72h.09s-.06-.06-.09-.1c.08,.08-.09,0,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.24,120.97s-.06-.06-.11-.07c0,.05,.04,.03,.11,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.26,120.29l-.11-.06c.02,.07,.11,.16,.13,.2l.06,.04c.12,.03-.18-.13-.08-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.28,120.44h0v0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "264.38 121.45 264.46 121.48 264.41 121.43 264.38 121.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.87,121.49s-.02-.03-.03-.04c0,.01,.01,.03,.03,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.87,121.42l-.08-.02s.03,.03,.05,.05c0-.01,0-.02,.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266,121.57v.02s.01-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.87,121.49s.06,.06,.12,.07c-.02-.01-.05-.03-.08-.04-.02-.01-.03-.02-.04-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "265.99 121.57 266 121.57 266 121.57 265.99 121.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.37,120.95s-.15-.01-.05,.04l.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M267.21,121.29v-.03h-.01s0,.02,.01,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M267.41,121.31l.18,.08s.05-.03,.08-.02l-.08-.06-.02,.03s-.08-.05-.11-.07c-.05,.08-.15,0-.24,.04,.05,.03,.14,.03,.17,.05l.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M267.22,121.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.67,121.09l.23,.03c-.08-.02-.18-.06-.28-.1,.02,.02-.03,.05,.05,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.55,121.03s0-.02,0-.03c.03,0,.04,0,.05,0-.05-.03-.11-.05-.15-.08l-.04,.08c.07-.01,.09,.05,.13,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.61,121.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.7,121.39c.09,.06,.14,.09,.23,.12,.08-.02-.18-.14-.16-.22l-.02,.03-.1-.12c.05,.09,.03,.2,.03,.26l.03-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.07,121.73l-.02-.06c.28,.08,.11,.24,.41,.27l.07,.13c.16,0,.3,.14,.39,.1,.07,.04,.06,.09,.13,.14,.14,.02,.05-.06,.13-.08-.01-.01-.12-.08-.04-.1-.05-.07-.21-.05-.2-.11-.04,.04-.17-.04-.24-.05,0-.09-.23-.09-.26-.16,0,.02,0,.04-.04,.04-.04-.04-.06-.15-.16-.19,.09,.08-.05,.03-.1,0l.02-.05c-.07-.03-.21-.07-.13,.03l-.06-.03,.11,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.44,121.81v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.75,121.58s.04,.07,.06,.11h.06c-.12-.04-.03-.06-.12-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.34,121.72s-.09-.01-.12-.04l.08,.09s.14,.04,.04-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "264.22 121.68 264.22 121.69 264.22 121.68 264.22 121.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.21,121.73v-.05s-.01-.02-.01-.02c0,.01-.02,.04,.01,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.01,121.97l.02,.02-.11-.02c-.1-.05,.08-.01-.05-.07-.04,.04,.08,.09,.03,.12-.21-.08-.08-.14-.25-.2,.07,.05,0,.07-.05,.06,.09-.04-.1-.05-.13-.12-.12-.04,.03,.07,0,.09,.08-.05,.22,.13,.29,.07l.08,.09c.11,.03,.16-.02,.31,.06-.04-.04-.08-.07-.12-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.16,121.36l-.11-.03c.08,.09,.27,.04,.36,.11,.21,.01-.04-.1,0-.15h.1l-.05-.06c-.12,0-.02,.06-.07,.07-.05,.06-.22-.03-.3,0h.09s-.03,.03-.02,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.04,121.79s.03,.04,.05,.05v-.03c.06,.01,.1,.05,.12,.08,0-.01,.04-.01,.03-.03-.02-.05-.2-.1-.2-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.1,121.85v.04s.02-.02,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.51,121.61s-.02-.05,.03-.04c.05,.03,.12,.04,.16,.06-.06-.07-.16-.12-.24-.15-.01,.02-.25-.02-.36-.08,.06,.03-.25,.01-.05,.09l.02-.02c.07,.02,.17,.04,.26,.06,.08,.02,.15,.04,.19,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.7,121.63s.02,.03,.03,.04c0-.02-.01-.03-.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.53,121.62s0,0-.01-.01c0,.01,.02,.02,.01,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.93,121.25c.07,.08,.3,.03,.31,.06l.02-.06-.03,.04c-.09-.04-.25,0-.3-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.24,121.15h0l-.21-.05s-.03,.04-.05,.05c.06,.04,.2,.03,.28,.08l-.06,.03s.04,0,.06,0c.01,0,.04,0,.05,.02-.12-.06,.06-.06-.06-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.42,121.93s-.18-.08-.14,0h0c.1,.05,.2,.09,.3,.14-.04-.02,0-.04-.01-.05,.05,.02,.07,.05,.11,.06l-.05-.06h0l-.13-.08v.05s-.08-.05-.08-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.92,121.66c-.09,0-.15-.02-.22,0l.31,.19c-.17-.13,0-.07-.1-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.5,121h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.43,120.96s.04,.02,.07,.05c0-.02-.01-.03-.01-.04h-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.5,121.01c-.06,.01-.19-.03-.04,.13,.09,.02,.1,.16,.16,.19,.01-.08-.08-.23-.12-.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "268.61 121.42 268.54 121.4 268.6 121.43 268.59 121.44 268.61 121.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.77,122.04l-.02,.08s.05,0,.05,0c.05,.02,.07,.06,.1,.08-.04-.04-.07-.12-.13-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.91,122.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.9,122.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.95,122.21s-.03,0-.04,0c.01,0,.02,.01,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.75,122.14v-.02s0,0,0,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "262.11 121.82 262.13 121.87 262.28 121.94 262.11 121.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "259.32 121.08 259.28 121 259.24 121.05 259.32 121.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.42,122.07s0,.01,.01,.02c0,0,0-.01-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.45,122.14c.07,0,0-.02-.02-.05,0,.01-.01,.03,.02,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.83,122.31s.06,.03,.08,.02l-.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.66,122.22c-.01-.07-.13-.18-.2-.27-.14-.09,.04,.09-.07,.06,0,.03,.16,.24,.31,.33l-.04-.06,.16,.04c-.07-.04-.14-.11-.17-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.07,122.2c.08-.02-.02-.09-.08-.14-.09,.01,.04,.05,.08,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M267.95,121.95c-.06,.05-.17-.07-.3-.09-.04,.06-.12-.06-.2-.02l.05,.04s.16,.06,.26,.09c.05-.07,.15,.06,.19-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.12,121.17c-.06-.08-.23-.14-.21-.19-.04,.1,.11,.15,.21,.27,0-.03-.09-.13,0-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.98,124.27l.12,.02c-.06-.03-.09-.09-.02-.07,.08,.09,.08,0,.19,.06l-.05-.12c-.16-.12-.28-.12-.47-.18-.04,.02-.08,.03-.13,.05-.03-.06-.13-.07-.17-.09,.17,.07-.07,.06,.03,.11,.1,0,.15,.05,.27,.09-.09,.08-.21-.13-.31-.05,.05,.02,.13,.05,.2,.07,.07,.02,.12,.02,.12,0,.01,.07,.31,.13,.23,.2,.08,0-.04-.06-.03-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.5,124.34s.14-.04,.18,0h-.05c.17,.06,.38,.16,.44,.23-.06-.01-.14,0-.18-.06,.03,.02,0,.04,0,.05-.01-.07-.28-.1-.3-.16-.04,.03-.11,.04-.09,.09-.03-.09-.21-.02-.24-.1v.11c.05-.07,.09,.09,.23,.08-.04-.04,.02,0,.04-.04,.1,.08,.14-.03,.29,.07h-.14c.14,.03,0,.06,.21,.09v-.05c.1,.02,.24,.07,.27,.05,.1,.07,.37,.06,.35,.16-.01,0-.02,0-.03,0l.09,.06s.02-.04,.08-.03c.07-.01,.11,.05,.14,.06h-.03c.14,.06,.28-.02,.38,.04l.15,.06v-.09c.06,.04,.12,.08,.19,.11-.04-.05,.1,0,.04-.05-.05-.01-.09-.02-.14-.04l.07-.05c.15,.07,.11,.02,.19,.02-.02-.04-.1-.08-.2-.13-.1-.05-.22-.09-.32-.11l.04-.05c-.08,.05-.15-.05-.11,.04-.27,.02-.5-.15-.78-.12-.04-.07-.02-.17-.14-.19,.14,.02,.13,0,.17-.01-.15-.06-.22-.08-.12-.12,.1,.07,.28,.03,.3,0l-.09-.09,.12,.05s0-.03,0-.05c.07-.03,.15,.04,.17,.09,.04-.03,.03,0,.04-.04,.08,.07,.39,.09,.51,.15-.01,0-.04-.03-.04-.04l.15,.02c-.08-.1-.4-.12-.48-.19,.01,.03,0,.04,0,.07-.18-.02-.42-.14-.63-.17v-.05s-.13,0-.22-.01l.05-.05c-.15-.04-.12-.07-.17-.11,0,0,0,.01,0,.01-.08,0-.24-.09-.21-.04-.07-.02-.12-.08-.17-.12,.12,0,.06-.06,0-.1-.02,.01,.05,.03,.02,.06-.06-.02-.07-.04-.09-.06-.02,.04-.15-.03-.09,.05l-.12-.07,.07-.02c-.08-.04-.21-.2-.33-.15-.02-.03-.03-.11-.05-.09,.02,.05-.06,0-.04,.08-.17-.07-.16-.19-.38-.27h.15s-.06-.04-.01-.05c.08,.08,.14,.04,.18,.07-.06-.06-.18-.11-.23-.1l-.02,.07-.09-.05,.05-.05h-.05s-.04-.08-.07-.12c-.11,.02-.22,.02-.31-.04,.06,0-.02-.07,.06-.04l-.14-.12,.05,.12c-.04-.06-.23-.14-.3-.21-.12,.09-.24-.19-.34-.09-.2-.13-.43-.25-.58-.32h-.09l.1,.05s-.02,.05-.06,.03l-.14-.12s.03,.05,.02,.06c-.04-.02-.09-.04-.13-.07,.04,.03,.06,.09-.04,.06-.02,0-.04-.03-.05-.04l.02,.05c-.07-.07-.19-.04-.15-.09-.05,0,.04,.05,0,.06-.07,.02-.08-.08-.16-.09,.1,.06,.05,.09,.1,.14,.15,.07,.25,.13,.36,.22-.04,.02-.18-.12-.21-.07,.05,.03,.13,.08,.21,.11-.13,0,.05,.07,.12,.12,0-.01-.01-.02-.03-.03-.02,0,.31,.07,.22,.13,.03,.04,.07,.07,.05,.08,.02,0,.04,.01,.06,.02-.09-.05,.05-.07-.07-.15,.05,.03,.11,.05,.16,.08l-.03,.07c.1,.03,.02-.05,.11-.02,0,.02,.09,.1,.12,.15-.04-.07,.06-.02,.07-.06,.16,.08-.02,.05,.08,.12v-.06c.15,.05,.03,.06,.07,.12-.17-.02-.24-.13-.39-.21,.03,.05-.05,0,.02,.07h0c.11,.08,.26,.13,.4,.18,.14,.05,.28,.09,.36,.2h-.09l.15,.06c.07,.02-.04-.02-.06-.05,.06,0,.22,.05,.28,.13l-.05,.05c.09,.05,.22,.06,.26,.12,.16,.12,.33,.07,.44,.22-.03,0,0,.06-.08,.06,.14,.02,.09-.03,.23,.05-.08-.05,.06-.04,.12-.04l.16,.12s-.15-.09-.08-.12c.11,.07,.32,.1,.36,.2-.02,.03-.1,0-.1,.04,.05,.07,.07,.05,.16,.07-.13,.07-.28-.12-.34-.03,.1,.06,.25,.09,.27,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.84,123.83h.02s0,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.58,124.4s.02-.02,.02-.03c-.02,.01-.02,.02-.02,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M267.48,124.84l-.09-.06s.06,.04,.09,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.9,122.81h0l-.07-.03,.07,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.69,122.66s0-.03-.02-.04c.01,.03,0,.05,.02,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.1,122.81h-.01l.06,.05-.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.77,123.16s-.01-.02-.02-.03c0,0,.02,.02,.02,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.37,123.62h0l-.02-.02,.02,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "269.4 121.24 269.34 121.27 269.46 121.27 269.4 121.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.88,122.23s.08,.03,.13,.07c-.04-.02-.08-.07-.13-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.52,121.71c.05-.02,.06-.04-.03-.06,.02,.02-.02,.04,.03,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.42,121.79c-.08,.03,.07,.09,.14,.11l-.12-.1c.05,0,.07-.07,.03-.07l-.12,.03s-.04-.03-.06-.04c-.03,0,.02,.04,.02,.06l.1,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.94,122.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.9,122.29l.04,.09s.06-.06-.04-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.86,121.98s-.01-.04-.05-.04h0c-.06,.02-.11-.1-.19-.14v-.06s-.08,.04-.13-.03c.02,.08,.1,.19,.2,.22,.1,.1,.08,0,.16,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M267.33,122.22s-.02,0-.04,0c.02,.01,.03,.01,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M267.46,122.23c.06-.04-.06-.05-.09-.08-.06,0-.02,.06-.03,.07,.05,.01,.09,.04,.13,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "269 121.69 268.92 121.72 269.05 121.72 269 121.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.4,122.98l-.15-.05,.09,.07c-.09,.01-.29-.14-.3-.07l-.09-.1c-.12-.04-.37-.19-.6-.3v.04c-.08-.03-.13-.07-.2-.09v.04l-.1-.05c.02,.07,.05,.02,.16,.1-.04,.03-.16,0-.13,.08,.08-.02,.29,.14,.49,.14l-.05-.03s.13,.02,.15,.06c-.02,.01-.07,.04,0,.07-.03-.06,.09-.09,.16-.01h-.06c.08,.08,.26,.03,.26,.14h-.05c.05,.03,.15,.07,.18,.06-.14,0-.09-.07-.12-.1,.06,0,.16,.06,.16,.08l.03-.03c.02,.08,.06,0,.15,.04-.05-.05-.01-.07,.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.19,122.46s.1,.05,.16,.07v-.02l-.16-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.19,123.04h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M267.22,122.27h.11l-.13-.03s0,.02,.02,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.9,122.03l-.05,.02c.06,.05,.13,.1,.19,.15-.05-.06-.09-.11-.14-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.85,122.6c.17,.07,.13-.05,.16-.09l-.17-.05c.13,.09-.11,.06,.02,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M267.58,122.19l-.04,.02s.09,.06,.13,.09c-.03-.04-.06-.07-.09-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.49,122.49c-.14-.12-.05-.22-.26-.28,.03,.02,.02,.03,.01,.04-.11-.06-.03-.07-.1-.14,.03,.07-.14,0-.07,.07l.1,.02s.03,.07,.04,.11c.05,.01-.02-.06,0-.06,.12,.05,.18,.2,.27,.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.05,121.79v-.03s-.03,0,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.23,121.76s-.06,.01-.09,.01c.06,.02,.11,.03,.09-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.05,121.76s.05,0,.08,0c-.03,0-.06-.02-.08-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.41,123.4h.03s-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.51,123.3h0s-.02-.01-.02-.02c0,0,.01,.01,.02,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.56,123.31s-.03,0-.05,0c.02,0,.03,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.41,123.4s-.04,0-.06,0c.02,0,.04,0,.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.98,122.99s.02,0,.03-.01c-.03,0-.04,0-.03,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.37,123.72h-.03s.01,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.51,123.3h0s.01,.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.36,123.54s-.01,.01-.01,.02c0,0,.01-.01,.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M267.06,122.58c-.06,.02,.07,.15-.11,.09-.18-.02-.31-.16-.44-.19,.05,.09-.17-.05-.13,.04l-.11-.08c.03,.05-.03,.04-.09,.01,.1,.05,.16,.14,.31,.19,.03,0,.02-.03,.02-.04,.07,.01,.07,.05,.11,.07h-.07c.05,.03,.19,.06,.22,.12,.02-.02,.03-.05,.11-.03,.05,.01,.08,.05,.1,.06-.08,0-.04,.03-.1,0l.04,.06v-.03c.19,.07,.07,.11,.1,.16,.03,0,.03,0,.03-.02,.04,.03,.09,.06,.14,.09h-.01s.2,.09,.34,.11c-.07-.09,.17,0,.19,0-.05,.07-.31,0-.35,.09,.17,.03,.27,.11,.39,.19,.05-.05,.16-.02,.27,0,.11,.02,.23,.03,.29-.04-.06-.02,.12-.08-.06-.14-.09,.01-.05,.09-.03,.14l-.16-.1,.04,.05c-.14-.04-.01-.03-.18-.06-.03-.07,.13,0,.14-.06-.07-.03-.13,.02-.2-.04h.04c-.05-.07-.16-.02-.19-.09,.12-.02,.32,.04,.48,.08v-.04s-.03,0-.04,0c.05-.04,0-.08,.15-.08h-.04s-.02-.08,.05-.08c.23,.06-.05,.08,.18,.13,.09-.04-.04-.01-.06-.06,.04-.07,.23,.06,.2-.05,0,.03,.2,.12,.05,.12,.05,.07,.23,0,.29,.02-.03-.02-.07-.01-.1-.02,.05-.05,.23-.01,.27,.03-.03-.04,.03-.06,.06-.08,.15,.04,.17,.04,.36,.07-.01-.03,.06-.03,.06-.06,.08,0,.07,.06,0,.06,.22-.02,.08,.08,.25,.08-.06,0,0,.08-.11,.07-.03,.02,.07,.04,.07,.06h-.11c.06,.05,.23,.01,.38,.03,.03,.06,.19,.17,.3,.14v.05c.11-.03,.4-.02,.47-.04,.17-.02,.03,.06,.11,.09v-.03l.13,.05h.13s-.06-.02-.05-.04c.04-.01,.08,0,.13,.02,0,0,0,0,0-.01,.1,0,.24-.05,.35,0l-.04,.02c.07,0,.16,.05,.25,0-.03-.08-.13,.03-.17,0l-.02-.04c.17-.03,.26-.03,.42-.01-.08,.04-.13,.07-.18,.07,.03,.03,.29-.04,.2,.04,.32,.04,.35-.17,.66-.12,.05,.02-.01-.03-.08-.03,0,0,0,0,0,.02-.04-.06-.39,.1-.23-.03l.04-.02c-.08-.03-.07,.03-.14,.03-.05,0-.06-.02-.05-.04,0,0-.03,.01-.06,.02l-.02-.09c.13-.02,.22-.05,.31-.03l.04,.07s.06-.02,.1-.02h0c.21,0,.11-.09,.32-.08,.08-.05-.13-.04,.05-.08,.05,.05,.14,.06,.24,.06,0,0-.02,0-.01-.02,.17-.01,.07-.06,.18-.07-.05,0-.09-.02-.14,0v.02h-.11l.07-.08c-.14-.04-.48,.08-.7,.05l.08-.04h-.14s.02,.03,.02,.04c-.23,0-.37,.11-.57,.14l.11,.07-.21,.02v-.07c-.08,.1-.17,.01-.25,.13,.04,0,.04,0,.07,.01l-.09,.05c.06-.06-.16,0-.17-.07-.07,0-.14,0-.22-.01l-.25-.04c-.17-.03-.35-.04-.52-.03-.24,.04-.27-.13-.47-.13,.01,0,.06,.03,.01,.04-.13-.02-.04-.07-.09-.1,.13-.03,.31-.03,.42,0,.11-.01-.02-.08,.12-.09,.01,0,.06,.06,.02,.07,.11,.06,.47-.07,.31,.08,.19-.07,.19,.03,.41,0l.03,.04,.09-.05s0,.04,.05,.05c.1-.04,.11-.12,.15-.1-.05-.03-.08-.05-.09-.08,.12,.04,.29,.04,.37,0h-.24s0-.04,0-.05c.19-.02,.28-.03,.44,.02l-.05,.07c.06,0,.15-.05,.17,0l-.11,.04h.12s-.05-.11-.15-.13q.11-.03,.15-.09c-.09,.02,.01-.08-.12-.05,.02,.04-.23,.04-.33,.04h.01s-.13,.05-.19,.05l-.05-.04,.15-.02c-.1-.01-.27-.05-.29,0-.02,.05-.06,.05-.15,.05,.09-.03,.05-.05,.08-.08-.08,.03-.22,.05-.3,.01,.1,0,.04-.03,.02-.05-.13,.06-.37,0-.54,.02h.01l-.29,.05h.07c-.05,.11-.25,.09-.37,.13,.04-.02-.01-.02-.01-.03,.03,.03-.04,.04-.07,.02-.04-.07,.13-.01,.11-.04l-.14-.03v.06c-.14-.02-.27,.04-.33-.05h.07l-.08-.05s0,.04,.04,.07c-.1,0-.19-.07-.25-.04l-.05-.06c-.09,.04-.14-.07-.23-.03-.03-.02,.04,.02,0,.04-.25,.01-.24-.08-.46-.1-.36-.05-.58-.06-.95-.15,.06-.03-.11-.04-.08-.09l-.02,.03-.02-.02s-.09,.02-.17,.02c-.12-.04,0-.05-.1-.09l.08,.02-.12-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.71,123.61s.01,0,.02,0c0,0,0,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.82,123.53s-.06-.01-.09-.02c0,.02,.04,.03,.09,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.37,123.72s.06,.02,.08,.03c.07-.04-.03-.02-.08-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.65,123.71s-.04,0-.05,.02l.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.42,123.48c-.08,0-.05,.04-.06,.06,.02-.02,.06-.05,.06-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M267.81,122.25s.02,0,.02,0h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M267.65,122.21l.16,.04s-.1-.07-.16-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.55,122.05s.03,.01,.05,0c-.02,0-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.46,122.02s.05,.03,.09,.03c-.05-.02-.06-.09-.09-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "269.37 121.77 269.41 121.75 269.3 121.72 269.37 121.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.21,122.42s.02,.03,.03,.04c0,0-.01-.02-.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.47,122.63c0-.09-.14-.1-.23-.18,.01,.03-.02,.03-.03,.02l.12,.13c-.04-.09,.06-.01,.13,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.57,122.15c.05,.04,.05,.01,.06,0l-.2-.13,.13,.1s0,.01,.01,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M267.52,122.33s.05,.01,.08,.02l.02-.03s-.1-.02-.1,.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "268.47 122.08 268.44 122.1 268.52 122.11 268.47 122.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "268.44 122.1 268.39 122.09 268.43 122.1 268.44 122.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.17,122.34s-.05-.03-.09-.06c.03,.03,.05,.05,.09,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.83,121.88h0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.65,122.55h-.09l.15,.12c-.04-.05,.05-.05-.06-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.05,122.16s.09,.03,.14,.03c-.09-.06-.25-.15-.44-.19v.05c-.07-.02-.02,0-.07,.01,.09,.09,.22,.12,.39,.15l-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.25,122.64s.09,.05,.13,.05l-.09-.09s.04,.07-.04,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.6,121.83s-.07-.03-.09,.03c.16-.02,.16,.12,.3,.08-.09-.05,.03-.15-.16-.17-.02-.04-.11,.03-.2,.01,.04,.05,.16-.02,.15,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.75,122.62l-.08-.05s.03-.02,.04-.03c-.04-.03-.09-.06-.13-.1,0,.04,.03,.14,.13,.19h.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.95,122.56s.02-.01,.03-.01c-.03,0-.03,0-.03,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.93,122.59h-.03c.1,.03,.06,0,.05-.03-.01,0-.02,.02-.02,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.57,122.77c-.05-.03-.02-.03-.06-.02,.16,.13,.22,.08,.38,.17-.06-.03-.28-.22-.32-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.25,123.59l-.02-.03h0l.02,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.03,122.79v-.04s.07,.04,.09,.06c-.04-.04-.07-.08-.13-.09-.02,0,.01,.04,.04,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.46,123.53c.05,.04,.09,.04,.13,.04-.18-.12,.09-.04,.07-.1,.09,.03,.26,.17,.28,.1,.03,.09,.25,.16,.32,.21h-.03c.08,.07,.05,0,.1,0-.22-.11-.32-.24-.54-.31-.01-.05-.2-.17-.05-.15,.05,0,.12,.05,.07,.07,.17,.1,.1-.05,.25,.04l.13,.11v-.04s.05,.03,.06,.05c.07,0,.12,.01,.17,.04l-.14-.07c.02-.08,.11,0,.16-.04-.22-.09-.27-.14-.4-.28-.11-.06,0,.04,0,.06-.21-.08-.04-.15-.24-.21,.02,.04,.17,.17,.04,.14-.19-.09-.46-.33-.57-.28-.03-.01-.05-.03-.07-.05,.03,.04,.04,.08,.06,.11-.04-.03-.08-.07-.13-.11,.04,.03,.01,.04,.02,.07-.35-.16-.09-.26-.37-.39,.04,.03,.07,.1,.1,.15l-.11-.04c.13,.13-.1,.08,.11,.24-.12-.11,.05-.03,.08-.04,.03,.02,.08,.09,.04,.09l-.07-.04,.07,.11h0c.14,.08,0,.03-.02,.03-.12-.1-.12-.15-.19-.22-.02-.03,.03,.08-.08,0,.11,.04,.08,.19,.21,.2,.14,.04,.24,.21,.42,.23-.06,.05,.28,.21,.15,.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.13,122.82s.04,.04,.06,.06c-.01-.02-.03-.04-.06-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.72,120.94c.02-.1-.1,.05-.14-.02l-.02,.04c-.12,0-.05-.05-.2-.04,.03,.14,.26,.02,.36,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.62,122.61c.03,.08-.07,.02,.08,.12l-.08-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264,122.96s-.04-.01-.01,.04l.02,.02s.05-.01,0-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "261.52 122.66 261.57 122.73 261.63 122.72 261.52 122.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.52,122.72c-.02,.1-.16-.15-.24-.11,.09,.1,.2,.18,.31,.25-.01-.04,.04-.08-.07-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.63,123.02s.09,.03,.16,.06c-.06-.05-.11-.07-.16-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.7,122.57l-.04-.12s-.05,.05-.11,.02c-.06,.06,.16,.06,.15,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.06,122.07s-.06-.03-.06-.06l-.17,.02s.18,.08,.23,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.84,123.15s.17,.03,.18,0c-.05,.03-.18-.06-.18,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "268.95 122.58 268.79 122.55 268.92 122.59 268.95 122.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.13,122.84s-.13-.08-.15-.04h.1s.02,.03,.05,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "265.77 123.24 265.82 123.28 265.77 123.18 265.77 123.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "270.49 121.99 270.38 121.97 270.47 121.99 270.49 121.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.22,122.62s.02-.06,0-.06c-.07,0-.03,.06-.08,.06l-.04-.04-.04,.04c.15,0,.08,.05,.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.52,121.57s-.02,.01-.01,.02c0,0,.01-.01,.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.44,121.63c.08,0,.07-.02,.06-.04-.03,.02-.13,.02-.2,.03l.03-.03c-.06,.01-.11,.03-.1-.02-.02,.05-.11,.04-.12,.07,.12-.02,.32-.01,.32-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.64,123.4s-.05-.03-.07-.04c.04,.04,.06,.05,.07,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.64,123.4s.09,.04,.11,.01c-.09-.1-.08-.02-.11-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.25,122.42s0-.01,0-.02c0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.76,122.4c-.01,.08,.26,.03,.29,.11-.05,0-.11-.02-.16-.03-.09,.06,.11,.06,.17,.07v-.03c.08,0,.07,.05,.12,.05-.24-.02-.41,.1-.64,.03,.03,.03,.03,.05,.08,.07,.12,.03,.23,.04,.34,.04,.11,0,.22-.01,.34,0-.03-.01-.04-.03-.04-.05,.01-.06,.24-.04,.28,0l-.02-.1s.1,0,.14,0c-.01,0-.01-.02-.01-.02,.04,0,.05,.01,.08,.02l-.08,.04c.09-.05,.16,0,.2-.05-.02-.03-.08-.05-.13-.07,.03,.02,.05,.04,.05,.06-.16-.03-.24-.07-.45-.06,.06-.05-.04-.03-.07-.05,0,0,.01,.02,0,.03-.08,0-.17-.06-.15-.1-.09,.05-.33,0-.35,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.72,122.47s-.04-.02-.06-.02c.02,0,.04,.02,.06,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.7,121.6s.07,.01,.08,.03v-.03s-.05,0-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.78,121.63v.02s0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.4,123.71s-.09-.05-.2-.06c.06,.01,.13,.03,.2,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.61,123.85s-.09-.09-.21-.13c.08,.06,.05,.14,.21,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.65,122.29s-.01,0-.01,.01c0,0,.01,0,.01-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.62,122.38c.08-.02,.01-.05,.02-.07-.04,.02-.14,.01-.19,.04l.17,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.21,123.67s.06,.02,.08,.02c-.08-.07-.06-.02-.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.21,123.67s-.04-.02-.06-.03c.04,.03,.05,.04,.06,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.68,123.64s-.11-.04-.1-.01c.03,.02,.06,.04,.08,.06,0-.02,.03-.03,.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.71,123.72s-.03-.03-.05-.04c0,0,.01,.02,.05,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.39,123.31s.02-.04-.06-.08l.06,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.55,123.26l-.07-.03s.05,.02,.07,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.55,123.26l.12,.04c0-.06-.06-.04-.12-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.96,121.7l.14-.05-.19-.04-.04,.04c.05,0,.11,0,.09,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.25,123.93s-.04-.08-.13-.1l.13,.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "268.59 123.45 268.49 123.37 268.49 123.4 268.59 123.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "268.49 123.43 268.49 123.4 268.49 123.4 268.49 123.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "265.35 123.91 265.42 124 265.41 123.93 265.35 123.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.17,124.03h.07c-.06-.03-.12-.06-.17-.09,.03,.03,.07,.06,.1,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.56,123.94s.1,.05,.17,.07c-.04-.03-.13-.12-.17-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.68,123.06s.01-.04,0-.06c.05,.05-.14,.02,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.3,123.97s0,.02,.01,.03c.02,0,.03,0-.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.53,124.18c.22,.03-.15-.09-.22-.18-.03,0-.08-.02-.1-.02,.08,.06,.22,.16,.32,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M264.06,124.05s.05,.03,.07,.04l-.11-.08,.04,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.72,124.04c-.1-.07-.1,0-.15-.02,.05,0,.15,.07,.15,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "269.8 123.06 269.91 123.02 269.83 123.05 269.79 123.03 269.8 123.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.97,123.98s.07,.03,.09,.04l-.03-.06s-.05,0-.05,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.02,124.22s0,.01,0,.02v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263,124.18s.02,.02,.02,.03c0-.01-.01-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.11,123.09s-.1-.08-.15-.05c.02,0,.05,.02,.07,.02v.02h.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.17,122.49s.05,.01,.08,.02l.06-.06s-.17,0-.14,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.31,123.51c-.17-.09-.17,.03-.37-.03,.03,.04,.23,.01,.31,.05l.06-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "268.29 123.76 268.31 123.76 268.21 123.7 268.2 123.7 268.29 123.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.56,121.67h.11c-.07-.02-.1-.05-.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.59,123.76l-.07-.04s-.03,.02-.03,.03c.01,.03,.07,.02,.1,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "263.44 124.42 263.29 124.35 263.32 124.4 263.44 124.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M263.6,124.52s.12,.02,.12,.02l-.2-.15s0,.07,.08,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.26,123.42l-.04-.05s0,.03,.04,.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "270.35 123.41 270.27 123.43 270.28 123.44 270.35 123.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.27,123.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.07,123.53c-.06-.05-.07,.06-.19,0l.03,.04s.13,0,.16-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.51,122.22c-.06,.01-.13,.03-.19,.04,.06,0,.12,0,.17,0,0-.02-.02-.03,.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.64,122.1c.07-.08,.21,.03,.21-.07-.13-.05-.11,.09-.21,.01,.02,.03-.07,.05,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.16,120.86l.03,.03s-.02-.02-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.96,120.92c.06,0,.15-.08,.2-.06h-.01c-.08,0-.13,.06-.2,.02-.02,.02,0,.02,.01,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.16,120.8l.13-.04v.06h.06c.03-.07-.11-.07-.13-.11v.06s-.08-.03-.12,0h.08l-.02,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.46,124.11c-.03-.1-.22,0-.31-.07-.04-.01-.09-.06-.06-.06l-.19,.02c.1,.06,.41,.11,.56,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.5,124.68c-.1-.02-.14,.03-.25-.02,.08,.09,.14,0,.25,.09l.1,.1,.24,.04s-.07-.02-.1-.03l.05-.05c-.16,.04-.18-.08-.29-.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "265.62 124.86 265.6 124.84 265.59 124.84 265.62 124.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.84,124.88s.03,0,.04,0h-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.79,124.07s.01,.02,.02,.02c0,0,0-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.76,124.27s.05-.03,.03-.05c.09,.05,.36,.09,.52,.12-.11-.03,.02-.04,.03-.06-.21-.04-.25-.08-.4-.15h0c-.07,.02-.11,0-.14-.04,0,.05-.23,.12-.05,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.54,124.16s.08,0,.12,.01c-.06-.03-.04-.04-.12-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.98,122.12s.02,.04,.08,.02l-.08,.05c.09,.02,.12-.04,.25-.06l-.12-.08-.07,.04s-.08-.02-.12-.04c.05,0,.07,.05,.05,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.98,122.12s-.01,0-.02,.01c.01,0,.02,0,.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.65,120.63s.07-.09,.01-.11l-.04,.06s-.09,0-.06-.05c-.04,.02-.11,.11-.13,.14,.01,.06,.15-.08,.21-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.68,120.67s-.02-.03-.03-.04c0,.01,0,.03,.03,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.23,120.91s-.03,.03-.04,.06c.09,0,.1,.01,.13,.06,.02-.01,.04-.05,.09-.06-.07-.01-.03-.09-.17-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.45,120.98s-.03,0-.05,0c.01,0,.03,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273,124.05l.17-.06c-.18,.07-.22-.07-.32-.05l.22-.02s-.02-.03-.04-.04c.26,0,.35-.02,.53-.04-.06-.03,.07-.04,.03-.07h.13s.17-.07,.15-.12c-.06,.06-.27,.02-.21,.08-.13,.02-.04-.04-.15-.04-.04,.03-.18,.06-.11,.09-.11-.09-.41,.12-.5,.07l-.06,.06-.13-.03c-.07,.05-.27,.06-.31,.01-.04,.02-.14,.06-.09,.08-.12,.03,0-.1-.14-.01,.04-.01,.05,0,.06,0-.04,.04-.1,.1-.15,.12-.05,0-.1-.04-.09-.07h.1v-.09c.13-.1,.18,.06,.26-.06h-.06l.11-.06-.15-.03c-.11,.05-.32,.03-.4,.11-.11-.02-.05-.07-.07-.11-.09,.02,.05,.07-.14,.08-.14-.08-.25,.01-.37-.01l.03-.03c-.17,0-.37,0-.54-.04,.02,.06,.25,.07,.13,.14-.08-.11-.32,.01-.41-.02,0,.06-.13,.02-.05,.09-.07-.02-.19-.06-.14-.08-.19,.09-.24-.07-.35,.03,.19,.04,.27,.02,.4,.02-.03,.05-.15,.01-.16,.07l-.07-.02c.13,.05-.25,.06-.2,.09-.13,.01-.27-.04-.4-.04l.07,.04s-.03,.02-.05,.04c.05-.04,.15,.03,.24,.04l-.06,.02c.07,.04,.1,.04,.21,.03l.11,.08s.07-.08,.19-.08c.02,0,.08,.02,.06,.04h-.12l.11,.11c.09-.05-.02-.15,.16-.16-.05-.03-.12,.02-.14-.03,0-.05,.07-.04,.18-.06l.1,.12h0c.13,0,.23,.03,.23,.05v-.03c.16,0,.19,0,.24,.06h-.03s.09,.01,.06,.05c.06-.05,.14-.04,.24-.03,.09,.01,.19,.03,.27,.03-.05-.02-.02-.06,.04-.07,.09,0,.07,.06,.15,.06l-.02-.07c.11,.04,.15-.04,.2-.07,.03,0,.05,.02,.08,.02l-.02-.04c.23,.01,.17-.07,.34-.05l-.08,.05c.14-.05,.2,0,.33-.03-.02,.03,0,.06,.06,.05,.13-.05,.25-.11,.38-.16h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.8,124.29h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.1,124.01s-.02,0-.04-.01h.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.75,123.78h-.03s-.02,.01,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.5,121.71c.1-.02,.1,0,.22-.05-.07,.02-.19,.04-.22,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.27,122.73v.06l.21-.05c-.12,0-.09-.04-.21,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.52,120.77h-.03s.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.52,120.77h.07v-.08s-.01,.06-.07,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.56,124.18c-.1-.01-.03,.04-.12,.04,.09,0,.14-.01,.12-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "274.32 121.08 274.43 121.05 274.36 121.04 274.32 121.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.17,123.5c.09,.05,.22,.06,.28,.05,.01-.02,.04-.05,.02-.08-.13-.01-.12,.07-.3,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.79,120.72c-.04-.09,.22-.04,.16-.13l.29-.11c-.08-.13-.13,.08-.17-.05-.02,.03-.13,.08-.07,.1-.04,.06-.17,.06-.26,.09,.04,.05-.08,.09,.05,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.81,123.71s.09-.02,.11-.03c-.04-.02-.12,0-.11,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.67,122.77l-.04,.03,.25-.05c-.22,.03,.07-.24-.28-.08-.11,.05-.02,.1,.07,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.77,119.48h-.02c-.05,.01-.01-.03,0-.05-.07,.01-.17,.09-.19,.07,0,.01,.05,.03-.02,.06v.02c.07-.01,.29-.03,.23-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.55,120.92c-.06,.02-.03,.05,0,.06h.04l-.04-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "272.5 122.81 272.56 122.77 272.5 122.76 272.5 122.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.29,123.03h-.12c.08,0,.11,.05,.14,.08v-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.9,125s.05,.02,.08,.02v-.04s-.05,0-.08,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.17,125.28l.02-.03s-.03,.02-.02,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.47,122.29c.06-.02,.21-.08,.19-.02,.02-.03,0-.05,.03-.08,.04,.05,.14-.01,.21-.03-.09-.03-.19-.1-.36-.04-.24,0-.03,.12-.27,.14,.03,.05,.13,.03,.2,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.91,122.17s.06,.02,.09,.02c-.02-.03-.05-.03-.09-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.85,125.1v-.06c-.06-.01-.04,.03-.04,.05h.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.81,125.09l-.08-.03c.07,.04,.08,.04,.08,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.31,120.25s-.04,.02-.06,.03c.02,0,.05,0,.06-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.21,120.29s.03-.01,.04-.02c-.02,0-.03,0-.05-.03v.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.31,120.25s.09-.04,.13-.06c-.06-.05-.09,.02-.13,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.23,125.19c.03,.09-.11-.05-.18-.02,.08,.03,.16,.06,.24,.08l-.05-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.89,120.88l.06-.07c.13,.02,.39-.09,.59-.19,.03,0-.06,0-.05-.03,.16-.01,.16-.08,.3-.07-.09-.06-.21,0-.33,.06-.13,.06-.26,.12-.36,.11-.05,.1-.11,.08-.24,.15h-.08l-.05,.05,.05-.03c-.03,.05,.08,0,.12,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.36,125.27c0,.05,.06,.08,.2,.16-.03-.06-.04-.11-.2-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.57,125.44l.05,.03s.18,.04,.22,.07c-.04-.05-.17-.09-.27-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "265.56 125.44 265.57 125.44 265.56 125.43 265.56 125.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.85,125.55s0,0,0-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.12,125.24c-.11,0,0,.03,.04,.06,0-.03,.09-.01-.04-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.17,125.31s0-.02-.01-.02c0,0,0,.01,.01,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.44,122.38c.08,0,.02-.03,.07-.04-.1,0,.01,.04-.07,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.04,119.41s-.05-.04,.04-.06l.09,.05h.03s-.02-.01-.03-.02l.12-.05c-.05,0-.13,.03-.18,0,.01,0,.03,0,.05,0v-.02c-.07-.02-.13,0-.21,.06,.06-.02,.07,0,.09,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M266.79,125.38c.08,.03,.12,.07,.08,.1-.07-.09-.29-.07-.32-.18-.02,.04-.08,.07,.06,.11,.17,.07,.46,.09,.54,.19,.02-.03,.11-.06,0-.11v.05c-.22-.06-.11-.09-.37-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M267.6,125.54s-.11,.03-.17,.02v-.04l-.08-.02,.07,.06c-.08-.02-.17-.06-.27-.06,.11,.08,.26,.07,.39,.12l.06-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.86,122.98s-.09,.02-.15,.02c.02,.04,.09,0,.15-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.86,122.98h.03s-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.3,125.14l-.09-.05s-.03,0-.02,.02l.11,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.3,125.02c.19,.05,.19,0,.38,.02-.18-.02,0-.05,0-.08-.05,.04-.33,.08-.38-.01,.03-.04,.11,.03,.1,0-.08-.02-.28,0-.36-.07-.06,.04,.11,.05,.17,.09,.06,.06-.19,.02-.24,0l.03,.07c.07-.07,.17,.03,.3,.02v-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.25,125.33c-.11-.02,0,.04-.09,.04-.08-.03-.19-.06-.29-.1l.05,.03c-.13-.03-.2,.04-.37-.04,.06,.03,.15,.09,.15,.13,.2,.02,.1-.04,.31,.04,.08-.02-.14-.08-.21-.08-.01-.02,.03-.02,.07-.03,.14,.03,.34,.06,.45,.06-.08-.02-.08-.07-.08-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.16,125.28l.13-.04c-.14-.03-.03-.09-.09-.12-.17-.02-.26-.07-.38-.03l.15,.04s-.05-.04-.01-.05l.19,.08s-.06,.02-.13,.02c.05,0,.11,.02,.16,.03-.04,0-.08,.01-.11,.02,.05,0,.06,.02,.09,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "268.82 125.09 268.82 125.09 268.81 125.08 268.82 125.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.63,125.03l.18,.05s-.09-.08-.17-.07c0,.01,.01,.02-.02,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.25,124.88c.01,.06,.19,0,.27,.02-.09-.04-.17-.03-.27-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.78,125.21l-.02-.04s0,.03,.02,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.04,125.47h.03s-.03,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.09,125.49s-.03,0-.04,0c.02,0,.04,0,.05,.02l-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.62,125.18c.08,.02,.22,.01,.27,.05-.03-.03-.27-.11-.43-.09,.17,.04,0,.09,.19,.1-.04,.05-.23,.04-.3,.08,.05,.03,.09,.05,.14,.08,.03-.02,.13-.04,.12-.06,.08,.01,.18,.03,.27,.05v-.09c-.17-.04-.22-.02-.26-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.25,125.53c-.07,.01-.11,0-.15-.02,.03,.03,.07,.06,.15,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.06,125.53s-.05-.05-.02-.05c-.03,0-.07,0-.09,.01,.05,.01,.08,.05,.11,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.11,125.48c-.03-.05,.08-.06,.1-.11,.06,.02,.08,.1,.11,.08,.1,0-.1-.03-.02-.05,.08,.04,.21,.08,.23,.12l-.1,.03c.08,.01,.16,.05,.23,.04h-.03c.26-.04,.15,.09,.39,.07-.02-.06-.23-.02-.15-.1,.23,.05,0-.06,.17-.07-.01,0-.03,0-.04,0,.11-.04,0-.04-.02-.07l.18,.02s-.03-.01-.02-.02h.08s-.1-.05-.23-.05c.06-.04-.02-.07-.1-.1-.05-.02-.1-.04-.13-.05v.03c-.13,.01-.36,0-.45,.04l.03,.04c-.08,0-.16,0-.24,0,.02,.02,.06,.06,0,.08-.1-.02-.18-.01-.23,0,.08,.02,.15,.05,.19,.08h0s.02,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "268.88 125.39 268.89 125.39 268.88 125.38 268.88 125.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.16,125.52l-.03-.04h-.02s.02,.02,.05,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M268.17,125.29l.13-.03-.12-.04s-.02,.04,0,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.06,117.92s-.01,.03,0,.04c.01-.01,.02-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.92,118.03s0,0,.02,0c0,0,0,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.56,119.12l-.06,.03c0,.06,.17,.01,.27,0,0-.04,.11-.08,.11-.08,.08-.07,.03-.16,.06-.17,.08-.03,.18-.11,.29-.14,.02-.03,0-.02,0-.04,.03-.03,.06-.01,.07,0,.03-.11,.05-.15,.19-.24l-.03,.07,.08-.05h-.02c.1-.09,.2-.19,.32-.28,.11-.09,.22-.18,.32-.26,.03-.04-.06,.01-.08,0-.02,.03-.08,.06-.11,.07h0s-.04,.05-.07,.07c.03-.02,.03,0,.04,0-.05,.04-.06,.04-.09,.02-.04,.12-.14,.13-.23,.2-.04,.02-.08-.01-.05-.06,.03,.03,.06-.02,.09-.06-.05-.01-.11,.03-.16,.08-.05,.04-.1,.1-.12,.11,.03,.02-.01,.04,.02,.05-.1,.11-.08,0-.16,.09l-.04,.09c-.11-.04-.17,.1-.3,.1-.02,.05,.07,.1-.06,.16-.04-.02,.06-.08,0-.08-.07,.04-.23,.17-.25,.11q.01,.05,0,.13l-.12,.03v.06s.12-.14,.13-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.52,118.5s.02,0,.02-.01h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.12,121.31c.07,0,.14,0,.2,0h-.12c.13-.03,.23-.13,.3-.12v-.02c.06-.05,.22-.11,.21-.04-.06,0-.05-.01-.08,.04,.11-.02,.07-.06,.17-.11-.02-.05,0-.15-.13-.1,.1,.02-.03,.07-.03,.1-.15,.06-.02-.03-.13-.04,0-.01-.11,.04-.11,.09l.14-.05c-.08,.19-.42,.07-.43,.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.81,120.48l.05-.03c-.12,.07,.05-.1-.08,0-.01,.02,.01,.02,.03,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M267.09,125.72l-.03-.02s.02,.01,.03,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M267.09,125.72c.09,.04,.15,.06,.2,.02-.14-.06-.14,0-.2-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.59,123.12c.1-.08-.11,0-.16,0,.05,0,.14-.02,.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.99,123.54l-.17,.02v.04c.07-.01,.19,0,.17-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "267.77 125.68 267.77 125.73 267.88 125.74 267.77 125.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.56,124.91s.03,.01,.04,.02h0l-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.76,124.93c-.08,0,.02,.02-.01,.03-.02,0-.1,0-.15-.03-.11,.04-.22,.03-.36,.05,.09,.01,.34,.07,.35,.02,.03,.02,.05,.03,.08,.04,.03-.03,.17-.04,.11-.07l.3-.02-.02,.04s.04-.01,.05-.03c-.13-.07-.24,0-.35-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.05,125v-.02s0,0,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.03,120.41s-.03,.07,.07,.04c.1-.1,.26-.1,.37-.09,.01,.02-.12,.07-.04,.09,.04-.01-.01-.04,.05-.06,.17-.08,.26-.04,.38-.15v-.06l-.11,.1c0-.15-.34,.15-.29-.07-.09,.04-.2,.08-.28,.14,.03,0,.06-.01,.06,0-.1,.07-.11-.02-.22,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.82,120.77s.06-.02,.08-.01l-.08-.03s0,.03,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.24,123.48c.07-.03-.08-.02-.08-.06-.02,.04,.03,.05,.08,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.64,123.2l-.11-.03s.04,.08-.07,.06c.07,.02,.12,0,.18-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.11,123.56s.04,0,.05-.02l-.09-.02s0,.05,.04,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.04,123.62s-.06,.09,.1,.05c-.09,0-.07-.03-.1-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273,123.6s.03,0,.04,.01c0,0-.02-.01-.04-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.1,122.96h-.17c-.11,.08-.21,.14-.28,.21,.11,.02,.12,.07,.18,.1,.14-.05,.26-.08,.42-.09-.03-.04,.01-.06,.09-.09l-.29,.07c.01-.06,0-.07-.09-.08,.09-.05,.16-.05,.14-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.73,119.75l-.23,.1s.15-.06,.22-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.48,125.76s.05-.02,.08-.01c.1,.06,.02,.07,.13,.09-.05-.09-.03-.09-.18-.16-.02,0-.05,.03-.1,.02-.1-.04,.05-.07,.07-.09-.11-.07-.36-.03-.51-.02,.08,0,.16,0,.25,0v.08c.09,.02,.19,.06,.26,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.22,125.68h0s-.07-.03-.1-.03c.03,.01,.05,.03,.1,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.34,122.64s.06,0,.09,.01c-.01,.01-.03,0-.04,.02,.02,.05,.08-.03,.13-.01l-.06-.05h.03s-.09,.02-.15,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.06,118.9h-.06s0,.02,0,.03l.06-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "270.18 125.28 270.23 125.35 270.36 125.34 270.18 125.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.51,124.35s.02,.01,.04,.02l-.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.44,124.32l.06,.03s0-.11-.16-.06c.03,0,.05,.03,.08,.03h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.78,122.52l-.14,.03v.08c.07-.03,.11-.07,.14-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.8,119.74c.11-.03,.18-.14,.31-.17,0,.02-.06,.09-.09,.08-.07,.09,.04,0,.07,.02,0-.02,.05-.05,.08-.05,.07,.01-.06,.06,.02,.06-.05,.04-.19,.06-.17,.13,.06-.04,.2-.06,.28-.14-.13,.01,.11-.09,0-.09-.03,.02-.06,.03-.09,.05-.04-.05,.07-.09,.04-.13h.07s-.06-.02-.12-.01c-.03,.04,.05,.06-.05,.1l-.13-.03,.07-.04c-.11,.05-.27,.1-.29,.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.1,119.68s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.8,124.71s-.02,0-.04,0c0,0,.02,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.86,124.73s0-.07-.02-.04h0s-.03,.02-.04,.02c.02,0,.04,0,.06,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.68,124.7s.06,0,.08,0c-.02-.01-.02-.04-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.16,124.96c.08,0,.1,.02,.08,.04h-.03l.07,.04c-.1-.05,.07-.05,.02-.09h-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.59,124.96l-.2-.05c-.08,.01,.02,.06,0,.08,.08,.01,.21,0,.2-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "276.91 119.77 276.84 119.76 276.89 119.81 276.91 119.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "272.69 124.24 272.63 124.27 272.7 124.28 272.69 124.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "270.26 125.48 270.23 125.46 270.18 125.5 270.26 125.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.14,120.99s.08-.01,.14-.05c-.05-.03-.1,.04-.14,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.78,124.68v-.05h0c-.26-.01,.06-.14-.23-.13-.17,.17-.2,0-.41,.16l-.1-.03,.07,.04s-.2,.03-.13,.06c.11,.01,.47-.09,.57,0l-.04,.02,.1-.05h-.08c0-.07,.22-.08,.26-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.96,124.06c-.08,.01-.08-.06-.02-.07h-.24c-.07,.07-.2,.12-.34,.15-.13,.03-.27,.04-.33,.06l-.11-.02,.19-.05c-.08-.06-.12,.07-.23,.02,.04,.06,.13,.07,.28,.06h.01s.07,.02,.11,.04c-.05,.04-.1-.02-.13,.03,.04,.04,.18-.05,.15,.03,.06-.02,.05-.05,.05-.11,.05,0,.1-.04,.12-.01l-.04,.08c.17-.08,.19,.04,.25,.05-.08-.13,.37-.12,.28-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.76,124.36h.01s-.09-.03-.13-.04h-.01s.09,.03,.13,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.96,119.82l-.08,.06s.02,.02,.05,0c.1-.07-.06,.02,.03-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.35,123.89l.02,.06c.12-.03-.01-.05-.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.29,122.17s.17-.05,.08-.05c.23-.05-.03,.1,0,.11l.18-.02v-.03c.08,0,.21-.07,.29-.13v.05c.16-.07,.06-.1,.19-.16-.07-.01-.31,0-.36,.02-.14,0-.22,.1-.37,.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.61,124.46s.02-.03,.05-.05c-.06,.01-.12,.02-.05,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.66,124.41s.05,0,.06-.02c-.03,0-.05,0-.06,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.41,122.27l-.2,.03c.01,.06,.17-.06,.13,.02,0-.02,.05-.03,.07-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.6,125.02h.16s.04-.06-.1-.04l-.06,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.73,125.53s-.01-.01-.02-.01c0,0,0,0,.02,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.74,125.46c-.16-.02-.13,.02-.14,.05,.03,0,.08,0,.11,0-.01-.02,.07-.03,.03-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.6,125.51s-.04,0-.04,.01c.03,0,.04,0,.04-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.82,118.25v.02s0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.97,118.23l.07-.02s0-.05,0-.06c-.09,.07-.16,.16-.22,.2v-.07s-.12,.11-.17,.16h.03s-.05,.05-.08,.08c.22,0,.27-.31,.44-.27,.13-.11,.06-.04,.18-.14-.11-.04-.12,.16-.25,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.11,123.46s.15,0,.12,.04c0,.02-.05,.03-.08,.04,.03,0,.1-.02,.16-.04l.02-.07c-.06,.02-.02,.03-.09,.05-.05-.06,.12-.07,.2-.1-.07-.03-.3,.06-.33,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.88,123.62c.07,.04,.23,0,.29-.05-.14,0-.16,.09-.29,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.83,125.61c-.11,0-.22,0-.33,0,.08,.02,.25,0,.22,.07l.11-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.46,126.06h-.17l.08,.04s.08-.01,.08-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "273.94 123.71 273.91 123.76 273.99 123.71 273.94 123.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.87,124.52s-.05,.07,.02,.07l.02,.03c.11-.07,.13-.07,.23-.12-.16,.01-.21,.07-.27,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.85,124.51h.01s0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.06,121.86c0-.07-.14,.06-.16,.05,.05,.01,.13-.02,.16-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.77,122.21s-.11,.02-.15,.07c.06-.01,.14-.04,.15-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.66,119.23s-.12,.01-.12,.08c.06-.07,.1-.03,.12-.02,0-.02-.05-.02,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M269.96,126.18s.02,0,.05,0c.04,.04-.05,.03-.1,.04-.04-.02-.08-.04-.12-.06-.03-.05,.2,0,.15-.03-.09-.06-.29,0-.17,.05l-.2-.02s.08,.02,.05,.03l-.07,.02c.08,.03,.21,.05,.36,.05,.15,0,.3,0,.41,0-.03,0-.07-.01-.12,0l.18-.07c-.15,.04-.29,0-.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.54,123.58l-.12-.03s0,.02-.02,.04h.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.56,123.48h.05s-.04,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.42,123.55h0s-.02,0-.03,0h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.51,123.5c-.06,.03-.08,.03-.08,.04,.06,0,.09-.05,.14-.06h-.12s.08,0,.07,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.47,119.73c-.12,.02-.19,.18-.1,.16,.01-.07,.18-.12,.1-.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "273 124.66 272.9 124.65 272.97 124.69 273 124.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.58,125.39c-.13,.02-.02,.08,0,.1h.03l-.06-.04c.14-.03,.34-.05,.41-.09-.17-.01-.22,.08-.39,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.64,124.42s.05,0,.07,0c-.02,0-.04,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.61,124.96h0s-.05,0-.08,.01c.02,0,.05,0,.08-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.69,124.36l-.29,.06s.03,.04-.07,.05c.08,.05,.21-.02,.3-.04h-.03l.08-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.46,124.22c.12-.06,.24-.12,.25-.14-.06,0-.18,.03-.28,.07-.1,.04-.19,.07-.2,.07-.13,.07-.12-.07-.25,.04,.06-.01,.09,0,.08,.02-.11,.07-.09,0-.14,0-.1,.06-.29,.14-.31,.13-.18,.04-.52,.12-.56,.04,.17-.04-.09-.1,.17-.13-.08-.07-.4,.11-.52,.05l.17-.04c-.21-.02-.06-.16-.27-.15l.16-.02s.03-.04-.03-.04v.04c-.06,.02-.09-.01-.13-.03-.07-.02-.23,.15-.39,.1,.02,.01-.03,.04-.07,.07-.04-.06-.26,0-.36,.03,.1,.03-.07,.04-.03,.08-.01,0-.03,0-.05,.01,0,0,.02,0,.02,.02,0,.02-.12,.09-.18,.06l.04,.04c-.07,.02-.24,.02-.12-.03-.1,.02-.19,.04-.29,.06,.3-.07,.1,.2,.41,.04,.14-.03,.32-.01,.41-.09,.09,.03,.28-.06,.21,.03-.07,0-.14,.01-.21,.02h.07c-.29,.06-.37,.19-.65,.28-.13,0-.18-.05-.29-.04l.02,.07s.11,.04,.15,.08h-.1c.03,.07,.15-.04,.22-.05-.01,.08,.23-.02,.19,.06,.19-.03,0,.11,.31,.03h0c.11-.05,.29-.05,.42-.09,.05-.06,0-.1-.14-.06-.14,.05-.21,.03-.31,.07,0-.02,.18-.07,.1-.07l-.18,.06c-.14-.03,.05-.12,0-.19l.04,.03s.03-.07,.09-.08l.04,.08c.05-.05,.28-.06,.32-.11v.06c.23-.08,.49-.15,.68-.23,.08,.04-.08,.16,0,.2-.05,0-.17,0-.11,.04,.16-.06,.28-.04,.39-.06l-.05,.04,.16-.04-.06-.03c.14,0,.32-.04,.45-.1h-.02c.09-.04,.27-.11,.29-.06-.06,.06-.19,.1-.27,.11-.07,.03,.01,.02,.02,.04,.12-.06,.37-.12,.34-.08l.15-.14c-.1,.05-.14,.05-.13,0l.33-.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "275.84 122.29 275.93 122.24 275.86 122.24 275.84 122.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.01,124.03h.07v-.06s-.16,.05-.07,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.09,123.98h0s.01,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M270.93,125.85l.15-.02-.12-.03s-.1,.04-.03,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.3,117.78s-.01,.03-.01,.05c.01-.02,.01-.03,.01-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.37,117.67s.02-.01,.03-.02c-.01,0-.02,.01-.03,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.37,117.67h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.3,117.78s.01-.02,.02-.03c-.02,0-.02,.02-.02,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.04,118.59l-.08,.09s.1-.02,.13,.01c-.08,.04-.1,0-.15,.1,.03-.04,.13-.11,.15-.04-.02,.03-.04,.02-.07,.03h.2v-.03c.03-.06,.13-.09,.14-.05,0-.03-.01-.07,.06-.11,.1,.03,.35-.33,.38-.14,.06,.02-.02-.04,.06-.08,.02,.02,0,.06-.01,.09l.08-.08c-.15,0,.03-.2-.05-.24,.05-.02,.13,.01,.11,.03,0-.03,0-.02,0-.03,.04,.02,.07-.05,.16-.05l-.07,.07h.01c0,.06-.11,.15-.08,.17,.06-.12,.15-.13,.24-.18l.02,.08c-.09-.01-.06,.09-.1,.13,.08-.03,.13-.11,.24-.24h-.01c.1-.07,.08-.12,.17-.18l.04,.02c.07-.08-.03-.06-.05-.05-.06,.15-.17,.09-.23,.21-.03-.02,.03-.09,.07-.14,0-.07-.15,.12-.15,.04l.04-.05s-.06,.05-.07,0c.08-.05,.09-.09,.1-.13,0,0-.02,.02-.04,.02-.05-.08,.05-.13,.11-.17h0c.06-.12,.18-.09,.21-.23-.07,.09-.19,.17-.24,.16,.02-.05,.07-.13,.11-.12-.11-.02-.14,.12-.24,.08-.01,.05,.03,.06,.07,.04-.08,.11-.17,.04-.23,.15l.04-.02c-.03,.06-.07,.12-.1,.18-.06,.03-.07-.07-.14,.05,0,.03,.06-.05,.09-.05l-.03,.06c.06-.03,.08-.08,.13-.1-.02,.08-.03,.07-.03,.13l-.14,.06,.03-.07c-.11,.04-.16,.04-.29,.15v.09s.04-.02,.07-.05c0,0,0,.03,.03,.04-.05,.04-.16,.04-.14,.1l-.16,.02h.03c-.12,.09,.02,.1-.12,.18v-.07c-.07,.1-.16,.04-.27,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.14,118.35s-.03,.01-.04,.02c.02,0,.04,0,.04-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "278.05 118.42 278.11 118.41 278.14 118.34 278.05 118.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.22,125.73v.05s.11-.04,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.23,125.79v-.02s-.02,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.15,124.02c.06,.04,.14-.03,.18-.04-.04,0-.12,.02-.18,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.33,123.97h.03s-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.05,118.84s-.05,.05-.07,.07h.02s.04-.04,.06-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.96,122.31l.11-.02c.07-.05-.03-.02,0-.05l-.11,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.7,125.72c.08,0,.05-.04,.04-.05h-.2s.15-.02,.14,.03c-.07,0,.02,0,.02,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.7,125.85s.15-.03,.01-.05l-.29-.02,.06-.04s-.13,.01-.16,.02c.22-.02-.06,.07,.11,.08,.11-.07,.2-.03,.27,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "274.23 124.11 274.23 124.05 274.2 124.08 274.23 124.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.25,125.35c.15,.04,.25-.01,.42-.06-.11,.03-.34-.03-.42,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.29,126.07c-.14-.02-.28-.14-.44-.04h.14c-.2,.03,.06,.05,.03,.09l-.19-.04c-.07,.02,.06,.06-.08,.06l.28,.06-.02-.06,.24-.02c-.14-.02,.01-.03,.06-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.08,123.37c.05-.07,.13,0,.19-.01,.1-.03,.06-.06,.14-.09-.01-.03-.12,.01-.15,0-.04,.04-.21,.06-.18,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.26,123.23s0,.02,0,.03c0,0,.01-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.6,123.93s-.05,.04-.11,.06l-.04-.06c-.07,.03,.09,.07-.09,.11,0,.05,.22-.07,.29-.04,0-.02,.06-.06,.1-.09-.11,.05-.12,0-.17,0,.02,0,.02,.03,.02,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.58,123.89s-.01,0-.03,0c.01,0,.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.91,125.04c-.07,.05,.06,.06,.08,.06l-.07-.03,.13-.02h-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.06,125.54h.07l.05,.08c.03-.1,.28-.1,.43-.14-.12,0-.43,.02-.54,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.45,124.78s.08-.03,.12-.04c-.03,0-.06,.02-.09,.02l-.03,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.98,125.66l.14,.04,.06-.02,.2-.02c-.13,0-.26,.01-.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.25,125.04l.02-.02h-.02v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.19,125.09c-.07-.01,.08-.07-.09-.04-.03,.04,.02,.05,.09,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.22,125.09h-.03s.01,0,.02,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.49,125.05c-.06-.03-.09-.03-.2-.05l-.02,.02c.07-.02,.06,.01,.08,.03,0,.03-.09,.02-.13,.04,.07,0,.16-.03,.2-.03h.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.8,125.78c.2-.03,.06,.05,.19,.04l-.06-.08-.13,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.03,119.63s.03-.02,.07-.04c0-.02-.12,.04-.17,.04,0,.05,.09-.01,.1,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "276.98 121.43 276.95 121.39 276.96 121.45 276.98 121.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.32,122.33c-.1,.03-.03,.06-.08,.08,.1,0,.07-.06,.08-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.74,125.87s.09,.01,.14,0c0-.03-.08,0-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.05,121.39c.09,.02,.23-.17,.26-.08,.05-.1,.15-.08,.16-.16-.12,.12-.27,.07-.38,.16,0,.02-.03,.06-.04,.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "274.85 123.9 274.87 123.89 274.95 123.9 274.84 123.88 274.85 123.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.41,126.07s-.01,.03,.04,.04c0-.01,.08-.05-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.36,124.21h-.01s0,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "275.19 124.12 275.19 124.12 275.19 124.12 275.19 124.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.17,124.17c-.15,.04-.07,0-.14,.07,.1,.07,.34-.16,.39-.05-.02,0-.05,.02-.06,.02h.06c.17-.09,.54-.16,.66-.3-.1-.03-.12,.11-.26,.11-.13,.02,0-.08-.09-.09-.27,.11,.08,.19-.25,.18v-.05c-.09,.03-.19,.04-.28,.06,0,0,0,.02-.02,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.45,124.22h-.04s-.04,.02-.05,.03l.09-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.47,123.89h-.09s.07,0,.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.16,123.76l-.09,.06s.15-.08,.23-.06c.09,.01,.12,.09,.26,.02-.09,.02-.05,.08-.09,.1h.04c-.12,.07-.1,.08-.27,.15-.09,.06-.06,.06-.05,.08,.18-.02,.25-.25,.35-.12,.06-.06,.13-.16-.02-.13,.11-.11,.12,0,.18-.02l.03,.06c.09-.1,.12-.15,.07-.19-.04,.06-.12,.03-.18,.06l.09-.06h-.15v.02c-.06,0-.14,0-.21,0l.1-.08c-.16,.06-.38,.07-.51,.16l.22-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.51,125.67h-.04s.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M272.6,125.67l.09-.04c-.14-.02-.12,.05-.19,.04l.06,.02c-.13,.11-.28-.04-.44,.08,.14,.02,.38-.03,.52-.04,.17,0,0,.05,.03,.05l.2-.04c-.02-.07-.16-.02-.27-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.66,118.46s-.08,.08-.09,.12c0,0,.04,0,.03-.02l.06-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.85,124.2l.03-.05s-.08,.02-.12,.02l.09,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.52,126.27c-.1,.03,.11,.07-.09,.08l.23,.04c.12,0,.06-.08,.12-.1-.1-.02-.05-.06-.26-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M271.78,126.3s.05,0,.09,0c-.05-.01-.07-.01-.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.25,121.71s.08-.02,.11-.04c-.03,0-.06,0-.09,0l-.03,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.63,124.71l-.03,.06-.21,.04h.12s.16,0,.27-.06c-.08,0-.01-.08-.15-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.42,125.66c.12-.01,.16-.06,.18-.1-.01,0-.09,.06-.18,.04l.08,.03h-.07v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.21,126.07h0s-.04,0-.07,.01h.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.48,126.04c-.09-.02-.2-.02-.18-.09,.22-.02,.3,0,.44-.06h0l.17-.04h-.06c.09-.05,.29-.05,.41-.06-.1,.02-.11,.11-.05,.08-.05,0,0-.02,.02-.04l.15,.06-.03-.03c.15-.05,.27-.04,.37-.03-.15,.08,0,.15,.01,.2-.13,.07-.26,.1-.36,.13,.11,0,.22-.01,.32-.03,.09-.07,.09-.12,.02-.17,.16,.02,.1-.08,.23-.09,.02,.05,.11,.09,0,.14l-.09,.02,.18-.02c0-.06,.14-.11,.28-.14-.04,0-.08-.01-.1,0,.11-.11,.15,0,.23-.07-.01,.03,.14,.03,.22,.01l.09-.07,.07,.08c.01-.06,.27-.13,.31-.13-.01-.02-.02-.06,.1-.08,.06-.03-.07,0-.13,.01,.16-.12-.01,.01,.07-.11,.03-.01,.06-.02,.08-.02l-.04-.05c.09-.01,.15-.05,.19-.08-.01-.02,.05-.05,.01-.06-.17,0-.26,.1-.29,.15h-.08c-.09,.05,.04,.03,.07,.03h0s.05-.02,.07-.02c.02,.03-.06,.07-.16,.11-.04-.13-.36,0-.42-.11-.03,.07-.21,.03-.13,.08-.33,.02,.19-.21-.18-.12-.21,.08-.45,.11-.64,.13,.01-.02-.03-.05,.05-.07h-.12l-.03,.07c-.1,.03-.21,.05-.32,.07h.02c-.16,.05-.2,.05-.41,.06-.11,.18-.17,.07-.51,.15-.06,.09-.46,.08-.52,.12l.13,.03-.08,.03c.13,0,.36-.04,.36,.03,.1-.01,.21,.05,.28-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.33,125.84s0,.01-.01,.02h0s0-.01,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.5,125.77c-.13,.1-.22-.04-.33,.06,.08-.02,.1,0,.16,0,.04-.04,.15,0,.18-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.11,125.5v.02s.01-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.5,125.56c0-.08,.14,0,.19-.09l-.16,.04s.08-.16-.04-.13c.02,.04-.13,.09-.23,.13,.04,0,.07,0,.13-.02-.01,.06-.05,.1,.11,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.45,125.87s-.08,.01-.13,.02c.05,0,.09,0,.13-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.26,125.51h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "279.3 117.12 279.28 117.18 279.34 117.09 279.3 117.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.87,122.73c-.03,.07-.08,.02-.17,.07h.12s.05-.03,.09-.03l-.04-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "272.3 126.4 272.43 126.43 272.34 126.38 272.3 126.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.57,116.91l.03,.06c.06,.04,.14-.17,.16-.2-.02,0,0-.07,0-.07,.04-.02,.1-.08,.07,0,.09-.09-.03-.07-.05-.07,.02,.01-.07,.11-.09,.05-.02,.15-.3,.23-.12,.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.02,119.27l-.07-.03s0,.11,.07,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.09,121.21l.18-.07s-.15,0-.18,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.8,122.04c.08-.07,.11-.08,.23-.18-.01,.04,.03,.04-.05,.08,.02,0,.09-.05,.14-.11,.08-.06,.09,0,.13,0-.06,.07-.15,.1-.24,.15,.14-.01-.1,.11-.08,.12,.04,.06,.23-.09,.27-.13-.05,.03-.09,.03-.09,0,.09-.07,.25-.07,.37-.16-.02-.05-.1-.01-.15-.03,.23-.15,.34-.24,.55-.36-.02,0-.02,0-.02,0l.13-.1c-.14,0-.35,.16-.55,.27,.06-.04,.02,0,0,.03-.06-.02-.14,.06-.18,.03,.02,.03,.08,.05-.03,.13-.05-.01-.06-.06-.02-.13-.1,.04-.08,.11-.1,.16-.18,.05-.41,.26-.54,.3l-.03-.04-.03,.06c.1,.02,.18-.1,.29-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.26,123.79l-.18,.06s.05,.02,.1,.02c-.07-.03,.08-.05,.08-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.4,118.47l-.08,.07s0,.06,.04,.02c-.05-.03,.08-.07,.04-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.55,118.26s-.01,.01-.02,.02c.01,0,.02-.02,.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.47,118.22s.08,.01,.08,.04c.03-.03,.07-.03,.09-.05h-.05c.07-.05,.17-.15,.13-.05,.01-.06,.06-.1,.09-.09-.01,0,0-.04-.02-.05,.05-.05,.12-.11,.18-.16,.05-.06,.08-.11,.04-.14-.25,.33-.14-.15-.4,.15,.24-.25,.06,.17,.31-.06-.08,.09,.06,.01,0,.08-.12,.04-.23,.07-.34,.18,.03,.04-.04,.08,.03,.09-.09,.11-.06,.02-.14,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.86,117.1v-.07c-.07,0-.09,.14-.17,.24,.08,.01,.11-.14,.17-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.7,125.97l-.12,.07c.05,0,.11,0,.16,0l-.04-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.81,116.95s.02,.03,.03,.05l.08-.08v.05l.03-.12c-.08-.02-.04,.08-.14,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.7,118.25c0,.07-.12,.1-.13,.18,.03,.02,.07-.03,.12-.08,.04-.05,.09-.11,.14-.08,.06-.07,.14-.14,.18-.21h-.07v.02s-.14,.07-.23,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.35,121.51c.02-.05,.14-.1,.18-.1h-.02c.18-.05,.27-.18,.41-.27-.03,0-.07,.03-.07,0,.16-.09,.16-.01,.35-.13l.13-.14c.06,0,.12,.04,.16-.06,.06,0,.1,.02,.02,.09l-.1,.07s.06,.02,.13-.04v-.03s.12-.05,.2-.08c-.01,.04-.02,.07-.04,.11,.06-.07,.06-.02,.08,0-.02,.07-.11,.08-.16,.1-.04,0,.04-.07-.04-.02l-.03,.1c.07-.06,.06,0,.09-.02-.06,0-.19,.15-.27,.13-.04,.07,.11-.06,.04,.05-.14,.07-.11-.01-.23,.03,.09-.05,.08-.13,.15-.13-.02,0-.06,0-.1,.02-.08,.09-.09,.17-.12,.2,.04-.05,.08,0,.08,.04-.1,.03-.09,.11-.21,.18,.05,.02,.19-.11,.24-.12,0-.03,.1-.13,.13-.12-.01,.02-.02,.05-.04,.07,.13-.11,.32-.28,.41-.28-.05-.08,.21-.22,.23-.26,.21-.19,.29-.04,.5-.33h0s.23-.26,.3-.17l-.06-.04c.15-.15,.07,.08,.23-.1l.04,.06c.07-.05,.09-.11,.16-.19h-.03s.07-.05,.11-.09h-.13l.08-.08c-.05,.04-.08,.04-.08,.01,.04-.12,.09-.08,.15-.15,.04,0-.04,0-.05-.02-.05,.04-.1,.08-.07,.09-.09-.06-.3,.18-.38,.16-.09,.1,.1,.02-.05,.14l-.04-.02c-.08,.09-.11,.15-.19,.22-.14,.06-.31,.14-.4,.14,.08-.07,.16-.14,.24-.21-.04-.07-.23,.16-.23,.18-.16,.11-.08-.12-.26,.03,.05-.09,.18-.2,.23-.31-.02,.02-.03,.05-.05,.07-.02,0,0-.05,.02-.08-.02,0-.06,.05-.08,.04-.02-.06,.12-.12,.13-.21-.09,.1-.13,.02-.19,.14l-.02,.08c-.18,.11,.05-.11-.07-.09l.02,.04s-.08,.09-.11,.08v-.02s-.1,.07-.15,.12h-.04c-.12,.07-.11,.14-.22,.21,.03,0,.13-.11,.12-.04-.1,.07-.23,.24-.33,.26,0,.02-.09,.11-.02,.09-.06,.04-.15,.07-.18,.12l-.04-.05c.05,.06-.2,.15-.21,.18v-.05l-.07,.08s.04-.02,.05-.03c0,.04-.05,.1-.12,.15,.05-.08-.05,.01-.08,0-.02,.03,0,.02,0,.03,0-.01,.04,0,.04-.02,.2,0-.3,.21-.1,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.26,121.48s0,0-.01,0h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.47,120.37h.02s0-.02-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.68,120.23v.03s0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.19,119.79s.03-.03,.04-.04c-.04,.02-.04,.03-.04,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.35,121.16h0s.02,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.73,126.24s.16-.08,0-.07c.06,.03-.18,.07,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.94,117.01s.05-.04,.07-.06c0,.1,.18-.2,.16-.06,.16-.14,.08-.2,.22-.31,0,.04,.04,.04,.07,.04v-.08l.09-.05c-.09-.05-.13,.1-.2,.03l.1-.09s-.1,.05-.13,.07v.05s-.09,.12-.07,0c-.02,.05-.03,.1-.07,.15-.04-.04-.08,.04-.14,.09-.11,.11,.07,.12-.09,.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "274.19 125.96 274.19 126 274.31 125.98 274.19 125.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.87,122.51s.07-.01,.07-.04h-.08v.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.19,122.3l-.09-.05-.1,.15c.05-.07,.12-.09,.19-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.33,124.48l-.13,.05c.05,0,.13,0,.13-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.2,124.53s-.04,0-.04,.02l.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.77,126.47c.07-.02,.23-.04,.16-.07-.03,.08-.16,0-.23,.04,.05,0,.04,.02,.06,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.22,122.19c.08-.1,.1,0,.2-.09,0-.03-.2,.04-.2,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.77,124.38v-.06c.26-.12,.25-.04,.46-.1-.06,.03-.12,.06-.18,.08,.1-.02,.05,.02,.19-.06,.07-.08-.11-.03-.15-.09,.35-.08,.35-.24,.74-.31l.1-.12s-.11,.02-.15,0c.22-.05,.37-.29,.6-.36-.02-.05-.21,.1-.28,.08-.2,.08-.26,.22-.38,.32l-.02-.07c-.1,.02-.15,.12-.26,.14-.06,0,0,.01,.02,0l-.26,.11c-.14,.12,.2,.01-.05,.15,.03-.11-.2,.05-.19,0-.11,.1-.4,.23-.52,.28-.08,.09,0,.08,.11,.05,.1-.03,.22-.08,.22-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "276.69 124.17 276.87 124.1 276.71 124.12 276.69 124.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "275.97 124.89 276.1 124.85 275.98 124.86 275.97 124.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.67,121.73h-.07s.02,.03,0,.07c.02-.03,.05-.03,.08-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.32,122.22c.06-.02,.12-.07,.17-.11-.05-.01-.13,.08-.17,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.46,117.13c-.02,.08,0,.1-.05,.17-.04,0-.04-.03-.01-.08-.11,0-.09,.21-.2,.29l.05,.05s-.03-.04-.04-.06c.16-.08,.19-.22,.31-.33-.01,0-.03,0-.02-.04l.05-.03c-.01-.07-.08,.06-.1,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.6,126.86l.08-.06s.02,.06,.02,.09c.06,0,.21,0,.18,.04,.09-.03,.19-.06,.28-.09-.08-.03-.16-.04-.26-.05-.09-.01-.2-.01-.34,0,0,.02-.07,.11-.15,.07-.09,.08,.19-.05,.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M273.7,126.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.85,121.62s.08-.07,.07-.1c-.07,.03-.08,.07-.07,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.52,122.17s0,.04-.01,.06c.11-.06,.03-.06,.01-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.29,125.07l-.28,.13s.09,.03,.05,.08l.21-.08h-.07s.17-.11,.09-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.51,117.57l-.13,.07s.03,0,.05,.01c.03-.02,.06-.03,.09-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.39,117.71s.05-.05,.03-.06c-.01,.01-.03,.03-.03,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.1,126.13l-.15,.02c-.1,.04,.1-.03,.08,.02l-.24,.07c.18-.04,.18-.02,.3-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.41,117.84c.06-.06,.12-.06,.18-.2-.07,0-.15,.16-.18,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.73,115.66s-.07,.09-.03,.09c0-.01,.03-.07,.03-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.75,116.39s-.06,.04-.1,.06l.03,.03s.05-.06,.07-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.05,124.5s-.05,.01-.08,.03c.03,0,.05-.02,.08-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.97,124.56v-.02s0,0,0-.01c-.01,0-.03,0-.04,0l.04,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.2,124.37s-.07,.09-.15,.13c.07-.01,.14,0,.17-.06-.01-.02,.08-.09-.02-.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "276.47 125.05 276.5 124.99 276.44 125.02 276.47 125.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.67,117.25v-.05l-.04,.1s.03-.04,.04-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "279.45 121.09 279.49 121.13 279.5 121.06 279.45 121.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.69,117.42c0,.08-.07,.16-.04,.23,.03,.09,.1-.11,.17-.07,0-.04,0-.14,.09-.2,.06-.07-.04,.04-.08,.06,0-.03,0-.1,.06-.14h-.05l.06-.07c-.09-.05-.16,.24-.21,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.72,117.18c-.02,.05,0,.08,.02,.09,.07-.05,0-.06,.03-.12l-.05,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.62,124.09l-.11,.04s-.03,.05-.04,.07c.17-.07,.03-.08,.15-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.5,124.13h-.04s.02,.01,.04,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "277.5 124.13 277.51 124.12 277.5 124.12 277.5 124.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.9,116.84c-.07,0-.06-.02-.13,.03,.05,.05,.04,.06,.13-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.32,124.34h.09s.11-.08,.04-.08l-.13,.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "279.51 121.33 279.43 121.41 279.54 121.35 279.51 121.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.08,125.84h-.03c.23,.01,.29,.02,.5,.05l.19-.07s-.06,0-.06,0c.16-.03,.06-.07,.19-.09-.12,.03-.3,0-.45,0v.02c-.23,.08-.58,.02-.74,.19,.16,.03,.27-.17,.4-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "280.1 120.18 280.13 120.07 280.04 120.12 280.1 120.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.09,123.66c.07-.05-.01-.05-.06-.04-.09,.07,.04,.03,.06,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.04,120.33s.07-.06,.1-.09l-.08,.05-.02,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.21,122.17l.07-.04s-.07,0-.13,.04c.06-.03,.06,0,.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.55,119.16s.04-.03,.06-.04h-.08s.02,.03,.02,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.97,117.09l.05,.05c.02-.07,0-.09-.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.41,119.75l.03-.05s-.04,.06-.05,.05l.02-.06c-.09,.08-.02,.06,0,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "275.49 126.47 275.51 126.44 275.24 126.52 275.49 126.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.42,119.63c0,.08,.25-.15,.23-.08l.04-.02s-.02-.07-.05-.05c.12-.09-.05-.03,.05-.13h-.06c.09,.05-.13,.19-.16,.28-.02,0,.02-.06,.01-.08l-.06,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.69,119.53s.02,0,.03-.02l-.03,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.99,120.94l-.11,.08,.06,.02s.04-.07,.06-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.53,119.47l.07-.07s-.1,.05-.07,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.23,116.8c-.04,.07-.17,.18-.13,.23,.07-.07,.08-.16,.13-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.93,121.54l-.02-.09c-.06,.05-.13,.13-.15,.11,.02,.07-.26,.17-.14,.19l.29-.17s-.05,.02-.06,0c0-.02,.06-.06,.08-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.11,118.53s-.1,.08-.17,.15c-.07,.07-.15,.16-.21,.23,.1-.01,.29-.25,.38-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.76,126.4c.11-.07,.19-.06,.26-.13-.11,.01-.25,.12-.32,.12-.05,.02,.04,.01,.06,.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "280.39 120.23 280.46 120.15 280.39 120.17 280.39 120.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "279.62 121.97 279.5 122.05 279.61 121.98 279.62 121.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.75,124.07c-.25,.15-.53,.45-.77,.43,.1,.02-.05,.09-.14,.14,.03-.09-.04-.07-.2,0,.06,.04-.16,.07-.02,.07v-.02c.16,.05,.56-.22,.71-.15-.16,.07-.4,.19-.57,.31,.2,0,.48-.25,.76-.33l.05-.08-.22,.05c.19-.09,.31-.22,.48-.28-.04,.07-.18,.17-.16,.2,.13-.04,.27-.08,.4-.13-.12,.04,0-.13-.17-.02l.05-.08s-.08,.04-.1,.04c.14-.08-.05-.05,.02-.15-.11,.11-.05-.04-.14,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.14,113.69h.04s-.01-.03-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.28,113.58s-.04,.02-.06,.02c.02,0-.01,.06-.02,.1h-.04s0,.05,.01,.07c.08,0,.06-.16,.1-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.32,113.58s-.02,0-.03,0c.01,0,.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.19,117.56c.04-.05,.09-.04,.08-.11l.1-.02c.02-.14,.05-.12,.09-.24-.08,.12-.34,.23-.27,.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.25,117.67c.08-.1-.04,0-.01-.07,0,.02-.07,.11-.07,.15l.09-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.96,125.5c.12,.05-.26,.08-.15,.14,.07-.02,.19-.04,.26-.09,0-.02,0-.08-.11-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.81,125.64h0s-.04,.01-.05,.01h.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.15,118.87c-.14,.15-.16,.21-.31,.32-.01,.05,.04,.02,.02,.07l.08,.02c-.05-.05,.13-.16,.19-.2-.05,0-.11,.1-.16,.08,.11-.08,.12-.22,.18-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.89,123.39c.1,0,.25,0,.4-.16h-.12c.09,0-.08,.09-.12,.12,.07-.1-.11-.01-.15-.03l-.11,.07v.07c.07-.04,.07-.03,.1-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.45,114.47c0-.15,.07-.22,.15-.35-.01,0-.02,0-.02,0,.03-.04,.11-.21,.12-.25l-.03-.09s-.03,.1-.06,.08v-.06c-.03,.14-.02-.05-.06,.04,.04,.02,.09,.01,.05,.11-.17,.12-.04,.35-.16,.46-.02,.06-.08,.05-.08,.07,.02,.05,.06,.02,.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.91,125.67c.05,.02,.14-.04,.17-.07-.06,0-.13,.05-.17,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.38,117.12c0,.08,.14-.03,.16-.02h-.02c.02-.05,.04-.05,.07-.07-.06-.02-.15,.12-.2,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.19,123.02c.06,.01,.1-.06,.12-.08-.04,.02-.07,.02-.12,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.31,122.94h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.29,121.21l-.09,.06s.03,.01,.05,0l.04-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.37,126.37c-.08,.04-.09-.02-.23,.01h.16c-.08,.05-.13,.13,.03,.08l.04-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.37,113.2v-.03l-.07,.07v.03s.05-.05,.07-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.73,123.89s.01-.04,.02-.05c-.11,.02-.07,.05-.17,.11,.05-.02,.1-.03,.15-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.6,114.3c0,.11-.08,.08-.11,.15,.04,.07,.17-.17,.18-.07l.03-.07c-.03-.06-.05,.08-.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.14,123.2l.09-.02,.07-.1s-.12,.07-.16,.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "279.81 122.51 279.61 122.63 279.73 122.58 279.81 122.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.6,122.92l-.21,.06c-.05,.07,.03,.04,.07,.06l-.02-.02c.09-.07,.09,0,.16-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.35,122.09s0-.03-.03-.03c0,.02,.02,.03,.03,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.39,123.11c-.05,.02-.12,.06-.19,.11,.07-.05,.15-.05,.19-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.02,121.53h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.03,121.54v.02s0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.42,121.24s-.05,.04-.07,.07c.03-.02,.05-.05,.07-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.4,120.22h0s.04-.05,.05-.07l-.06,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.77,118.73h0s.02-.01,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.41,121.26s-.06,.07-.09,.11l.09-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.94,121.43l-.02,.04s.02-.02,.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.87,121.26s.06-.04,.08-.07c-.02,.02-.05,.04-.08,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.85,121.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.13,122.08s.13-.02,.19-.02c-.01-.03,0-.07,.02-.12-.06,.09-.14,.09-.21,.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "282.34 121.94 282.34 121.94 282.34 121.94 282.34 121.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.79,120.78l.03-.03s-.02,0-.03,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.7,120.38s-.02-.04-.03-.06c-.04,.07,0,.05,.03,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.92,120.84c-.04-.07,.22-.2,.23-.34-.04,.04-.17,.11-.13,.14-.17,.18-.05-.09-.22,.11,0,0,0,0,0,.01-.13,.13-.16,.29-.33,.4,.03,0,.07-.05,.08-.02,.07-.09,.13-.17,.16-.2,.06-.04,.12-.08,.19-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.95,120.97v.02s0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "282.57 121.14 282.57 121.15 282.58 121.14 282.57 121.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.94,121.43s.02-.06,.03-.08c-.03,.03-.03,.06-.03,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.2,121.86s.11-.05,.14-.06c-.03,0-.08,.03-.14,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.93,122.71s.08-.04,.11-.06l-.11,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.93,122.71h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.2,123.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.04,122.43s.05-.04,.06-.06c-.02,.02-.04,.03-.06,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.7,120.38s.01,.02,.02,.03h0s-.01-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.97,122.06s-.02,.03-.04,.04c.02-.01,.03-.03,.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.31,116.67c-.11,.25-.25,.35-.38,.58,.05,.04-.05,.13-.08,.24-.13-.11-.17,.31-.31,.49h.03c-.09,.04-.17,.2-.24,.33-.07,.13-.14,.23-.19,.17,.05-.07,.11-.2,.14-.27-.2,.4-.51,.65-.75,1.09h.02c-.1,.14-.3,.52-.39,.52-.04,.1-.12,.2-.19,.3-.07,.1-.14,.19-.15,.25-.34,.24-.58,.8-.96,.98v-.08c-.05,.05-.1,.11-.08,.13-.04-.03-.19,.14-.29,.19h0c-.09,.05-.24,.22-.3,.19-.13,.05-.02-.13,0-.17,.14-.15,.25-.17,.35-.21-.03,.07,.15-.08,.09,.03,.08-.14-.02-.08-.1-.06,.14-.26,.27-.12,.42-.39-.03,.04-.14,.08-.17,.17-.02-.04,.07-.16,.09-.21,.11-.12-.14,.15-.24,.23,.05,.04-.09,.1-.07,.14-.09,.02-.07,.12-.18,.15,.03-.09,.11-.21,.2-.31l-.09,.09s.03,0,.03,0c-.1,.16-.13,.07-.22,.2,0-.02,.03-.08,.07-.13-.12,.1-.26,.2-.32,.3,0,0,0-.03,0-.05-.02,.04-.11,.11-.15,.14-.2-.02-.28,.23-.54,.32v.03c-.13,.12-.42,.35-.52,.39v-.04c-.08,.11-.25,.17-.35,.22-.19,.12-.03,.2-.26,.3-.06-.02-.02-.09-.17,0h.04c-.25,.22-.29,.25-.57,.47-.04,0-.06,0-.1,.01-.07,.11-.3,.28-.47,.37,.03-.08-.07,.02-.14,.04,.08,.03,.17,.06,.35-.02,.07-.08,.14,.04,.3-.06-.02,.03-.04,.07-.06,.1,.03-.02,.06-.05,.1-.07h-.02s.05-.04,.06-.06h.11s.03-.06-.01-.06c.12-.11,.13-.04,.17-.03l-.03-.09c.1-.04,.21-.15,.33-.19l-.05,.1,.14-.11s-.06,0-.07-.03c.02-.03,.04-.05,.06-.07-.08,.06-.17,.13-.25,.17-.06-.08,.24-.15,.39-.33,.03-.01,.16-.08,.26-.15l.03,.03s.02-.04,.07-.08c.04-.07,.13-.11,.21-.16,.07-.1-.01-.11-.06-.09l.09-.13s-.07,.03-.09,0l.14-.08-.05,.02s.18-.16,.21-.15c-.05,.03-.04,.05-.05,.08,.08-.06,.17-.07,.17-.06-.02-.12,.27-.22,.38-.38l.03,.08c.18-.16,.23-.21,.39-.28-.09,.13-.05,.24-.1,.32,.07-.08,.16-.15,.23-.2,0,0-.02,0-.03,0,.11-.16,.19-.09,.27-.16-.02,.08,0,.13-.15,.24-.04,0,.03-.07,.04-.1l-.12,.08s.02,.08,.12,0v-.02c.21-.24,.38-.17,.51-.37,.08-.05,.12-.02,.18-.04l-.09,.11,.15-.07h-.01c.11-.1,.3-.32,.36-.32l-.02,.03c.14-.15,.26-.17,.38-.41,.11-.01-.04,.13,.03,.15,.1-.08,.18-.25,.24-.21-.13,.16-.16,.29-.34,.4l-.06,.16c.08-.05,.19-.16,.22-.09,0,.04-.16,.2-.06,.16-.05-.01,.06-.12,.08-.1l-.03,.07c.09-.11,.06-.14,.2-.19-.05,.06-.07,.1-.09,.15,0,0,.02-.02,.03-.03,.05,.01,.04,.05,.13,0,.05-.06-.03-.02,.03-.09,.16-.14,.39-.56,.45-.48l-.02,.05c.05-.07,.1-.14,.14-.22-.05,.08-.04,.02-.07,.02l.31-.42s-.13,.1-.12,.16c-.08,.07-.12,.07-.14,.05-.13,.24-.26,.27-.38,.42l.03-.09c-.06,.09-.12,.1-.14,.19-.13,.09-.11-.03-.05-.14,.05,0,.1-.07,.18-.16-.05,0-.05-.05,0-.14,.02-.07,.22-.25,.25-.36-.07,.04-.13,.07-.2,.09-.12,.16-.27,.4-.43,.52,0-.05,.12-.27,.19-.27-.1,.02,.08-.14,.05-.16,.15-.12,.17-.25,.23-.34l.24-.11c-.1,.13,.04,.04-.11,.21,.16-.16,.08,.05,.25-.19,.03-.11,.17-.3,.26-.4,0,.11,.16-.1,.17-.14l-.12,.12c-.08,.02,.1-.13-.01-.05,.07-.1,.16-.22,.23-.23,.1-.13-.03-.04,.04-.13,.07,.04,.16-.31,.18-.16-.05,.06-.07,.11-.11,.17,.1,0,.17-.16,.3-.35-.03,.02-.08,.07-.08,.05-.03-.1,.08-.1,.11-.21v.1c.07-.17,.24-.36,.22-.5,.18-.24,.28-.52,.43-.74l-.06,.02c.24-.24,.16-.58,.35-.83-.04-.09,.23-.56,.06-.36-.09,.26-.26,.53-.3,.73l-.18,.15c-.01,.19-.15,.41-.23,.51,.01-.11-.1,.06-.15,.12,.04-.02,0,.06-.02,.09-.04,.04-.01-.12-.1,0l.02,.03c-.03,.06-.09,.12-.1,.11,.1-.22,.2-.45,.33-.67-.01-.01-.03-.02-.02-.06,.06-.05,.17-.32,.16-.17,.08-.09,.05-.16,.12-.26l-.04,.04c.02-.11,.14-.29,.06-.28-.03,.01-.04,.06-.05,.1h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.1,117.24s-.03,.05-.04,.07c0,0,0,0,.01,.01l.03-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.66,122.97l-.02-.02s0,.02,.02,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.48,123.14c.19-.07-.07,.13,.13,.04h-.04c.08-.09,.16-.1,.18-.1,0,0,.02-.06-.02-.04-.08,.07-.13,.03-.22,.07,.08-.09,.2-.12,.21-.13-.02,0-.05,0-.08,0l.02,.02c-.12,.04-.06,.06-.19,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.06,124.89l-.05-.04c-.27,.12-.07,.19-.02,.17,.13-.07,.28-.09,.35-.18-.13,.03-.4,.26-.42,.13,0-.02,.09-.1,.14-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.49,121.14s-.01-.06-.07,.02c-.03,.06,.11-.02,.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.57,113.15c.03-.08,.04-.06,.02-.14-.09,.12-.04,.19-.13,.25,.06,.02,.07-.11,.12-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.36,125.68h.01l.14-.03-.12,.08c.14-.05,.2-.08,.21-.14-.04-.04-.15-.02-.35,.08h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.82,116.95h0l-.04,.03s.03-.01,.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.83,116.98s.06-.11,.08-.07c.09-.15-.09,.03-.01-.1-.02,.01-.03,.1-.07,.14-.05,.08-.07,.14-.16,.23,.07-.06,.12-.08,.17-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.62,117.83s.02,0,.02-.01c0,0-.01,0-.02,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.62,117.87h-.03s-.03,.05-.05,.07l.07-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.59,117.86h0s.02-.03,.03-.04c-.01,0-.02,.02-.03,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.33,119.63s-.01,0-.02,0c0,0,0,.01,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.46,119.33h.01s0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.16,119.71h.06v-.02c.03-.07,.07-.07,.1-.06,0,0,0-.02,0-.03,.06-.05,.16-.05,.18-.11l-.02,.02s.05-.12,.1-.2c-.04,0-.07-.01-.1,0,.02,0,0,.07,0,.11-.13,.11-.35,.23-.37,.37l.06-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.02,120.35s-.05,.12-.11,.13c.02,.02,.1-.04,.12-.04-.02-.02,.04-.09,0-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.19,116.85h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.71,117.72s.03-.13,.1-.11l-.03-.02c.11-.12,.21-.25,.29-.39,.08-.14,.15-.27,.22-.38l.04,.04c.05-.11,.08-.1,.15-.19-.06,.02,0-.04,0-.09-.03,.04-.06,.13-.08,.12,.04-.15,.22-.34,.25-.41h-.11c.02,.1-.09,.1-.06,.18-.07,.13-.19,.2-.14,.08-.13,.12-.05,.24-.16,.29-.05,.1-.19,.25-.23,.27-.04,.17-.2,.43-.3,.59l.03,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.93,124.03l.19-.06-.07,.11,.09-.05c-.08,.03,.13-.32-.22-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.08,125.09s0,.05,0,.06c.02-.04,.04-.07,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.04,125.21s0-.02,.02-.03c-.01,0-.03,.02-.06,.03h.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.07,125.16v.02s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.6,112.69v-.02s-.09-.08-.05,.09l.05-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.6,112.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.77,115.56s-.01,.01-.02,.02c0,0,.01,0,.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.28,116.43l.1-.16,.02,.04c.04-.09-.06-.07,.04-.18,.03,.03,.11-.05,.11,.03l-.09,.07c.05,.1-.04,.12-.08,.24,.11-.07,.25-.48,.32-.38l.06-.16s-.05,.04-.07,.11c-.06-.04-.11,.03-.14-.03,.04-.06,.05-.12,.08-.1,.05-.14,.03-.25,.13-.34-.02,0-.02-.03-.03-.04,.04-.14,.12-.29,.21-.38-.04,0-.04-.06-.05-.09l-.08,.11h.01s-.03,.08-.07,.12c.02-.04,.04-.02,.05-.01-.03,.05-.04,.09-.08,.12,.01,0,.04,.01,.01,.05-.08,.11,0-.15-.08,.01,.08-.01,0,.07,.03,.12-.07,.14-.05,.03-.12,.07,0,.02,.01,.02,.02,0-.11,.08-.18,.32-.24,.22-.01,.06-.02,.11-.04,.17,.04-.08,.1-.08,.1-.04l-.07,.05,.06,.03-.07,.11s-.03-.17-.1-.06l.02-.04s-.05,0-.08,.08c0,.06,0,.11-.02,.19-.05,.1-.14,.24-.21,.32,.06-.01,.26-.33,.35-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.26,116.04l-.02,.06s.02-.03,.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.55,121.85h.01s0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.55,121.85s-.08,.03-.11,.08c.04,.02,.09-.06,.11-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.31,123.94s.02-.03,.02-.04c0,0-.02,.02-.02,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.31,124.08h-.09c.05-.05,.07-.1,.09-.14-.05,.06-.17,.15-.09,.16l-.17,.06c.03,.07,.2-.11,.26-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.73,119.23v-.04c-.05,.03-.11,.05-.16,.08,.05,0,.11-.02,.16-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.78,121.85c-.06,.03-.11,.06-.17,.08,.03,.03-.09,.09-.12,.16,.01-.06,.25-.1,.3-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.43,120.18s.01,0,.02,0h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.97,119.67l-.13,.16s-.13,.08-.09-.03c-.06,.04-.11,.15-.16,.24-.05,.08-.1,.14-.15,.14l-.08,.12c.11-.13,.2-.12,.29-.21-.22,.21-.29,.38-.51,.61-.03,.13,.12-.04,.19,0,.11-.12,.31-.33,.35-.46,.09-.01,.21-.26,.22-.17-.02-.18,.21-.13,.17-.29l.09-.05c-.02-.05,0-.08,.02-.16-.09,.06-.2,.21-.22,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.94,112.91c-.01,.11-.07-.04-.06,.09h.08l-.02-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.36,126.36c-.07,.03-.17,.03-.19,.07,.04,0,.17-.03,.19-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M278.99,124.56c.14-.04,.32-.17,.39-.16l-.06-.02,.12-.05c-.08,0,.02-.09,.06-.12-.25,.14-.18,.12-.43,.25,.05,.01,.01,.05-.07,.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "281.63 119.55 281.75 119.49 281.76 119.46 281.63 119.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.24,122.82s0-.01-.01-.02c0,.02,0,.02,.01,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.27,122.83l.05-.04s-.06,.03-.09,.04c0,0,.01,.01,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.47,113.98l-.02,.02s0,0,.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.47,113.63c0,.14-.09,.29-.16,.44-.07,.14-.14,.27-.09,.39,.13-.2,.12-.29,.24-.46,0,0,0,0-.02,0l.03-.09c-.02,.05-.05,.04-.06,.01,.06-.16,.06,.03,.14-.09,0-.04-.05,.06-.06,0,.06-.14,.12-.02,.16-.03-.02-.1,.1-.21,.08-.26,.05,.01,.09-.03,.11-.13-.05-.14,.04-.17-.04-.3-.03,.13-.08,.26-.21,.45-.06,.04-.06-.06-.13,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "282.81 113.12 282.81 113.12 282.8 113.12 282.81 113.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.81,113.12c.11-.07,.16-.37,.23-.46-.05,0,0-.29-.1-.11-.08,.24-.1,.39-.12,.54v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.87,118.82l.05,.05c0-.07,.03-.09-.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.71,123.87s.05-.03,.06-.04l-.06,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.53,124.02s.09-.08,.18-.15c-.08,.05-.23,.11-.18,.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "279.09 124.59 279.1 124.64 279.12 124.57 279.09 124.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.99,118.76c.07-.07,.1-.08,.11-.07-.02-.01-.05-.01-.02-.05-.03,.04-.06,.08-.09,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.03,112.58l.02-.07-.07,.06s.02,.03,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.34,113.42s-.02-.03-.02-.09l.06-.07c-.05-.07-.08,.21-.12,.13l.05-.19-.11,.3s0,.04,.04,.02c-.02-.1,.07-.08,.1-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.53,118.08l-.04-.06c-.06,.02-.1,.21-.12,.13-.12,.14-.19,.31-.27,.44l.05,.03c.11-.2,.12-.14,.23-.36l-.03,.02c.05-.1,.09-.19,.17-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.42,119.04s-.05,.04-.08,.06c.02,0,.05-.05,.08-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.26,119.33l.07-.21c-.1,.08-.2,.14-.27,.17,.12-.11,.12-.18,.17-.28-.05,.06-.05,.14-.13,.17v-.03l-.16,.13s.05-.02,.07-.01c-.09,.07-.05,.14-.07,.18,.1-.1,.11-.09,.2-.15-.08,.08,.06,.06-.07,.2,.09-.05,.11-.13,.2-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.33,119.09v0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.44,113.51s-.1,.21-.12,.28c.06-.07,.13-.24,.12-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.22,118.2s.04-.06,.06-.1c-.03,.03-.08,.04-.06,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.31,118.07l-.02,.04s.02-.02,.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.28,118.05s.02,0,.03,0h0s-.02-.01-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.32,118.05s0,0-.01,0c0,0,0,.01,0,.02v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.28,118.05s-.01,0-.02,.02l.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.91,111.77h.09c0-.08-.06-.02-.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.57,120.74v.06c.06-.02,.1-.1,.14-.14-.03,0-.11,.1-.14,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.16,123.51l.09,.05s-.07-.08,.09-.14c.03,.04,.09-.03,.16-.09-.02-.04-.17,.07-.12,0l-.12,.08s-.09,.09-.09,.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "280.21 123.42 280.24 123.4 280.24 123.4 280.21 123.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.5,117.62s.02-.02,.03-.03l-.03,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.45,117.6v.08l.05-.07s-.04-.03-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.03,123.89c.08-.05,.03,.01,.01,.05,.09-.05,.17-.11,.25-.16,.08-.05,.14-.1,.19-.11,0-.08-.13-.02-.24,.02-.04,.09,.02,0,.05,.03-.08,.05-.25,.11-.27,.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "281.71 120.85 281.67 120.86 281.65 120.95 281.71 120.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.58,113.07c-.01,.12-.18,.33-.11,.38,0,.1,.1-.03,.11,.03,.06-.23-.12,.14-.1-.06,.06,0,.1-.13,.08-.18l.09-.04-.04-.02c.02-.05,.04-.1,.05-.15-.03,.02-.04,.11-.07,.08,.02-.04,.03-.07,.05-.11-.01,.02-.02,.02-.03,.03,0,.02-.01,.04-.02,.07-.02,.02-.03,0-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.73,112.99l-.02-.03s0,.03,.02,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.63,113.02s.02-.05,.02-.07c-.02,.02-.04,.03-.03,.07h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.8,112.9h-.03s.01,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.73,112.61c-.01,.16-.04,.25-.07,.34,0,0,.01-.01,.01-.02l.04,.04s0-.09,0-.12c.04-.03,.04,0,.05,.03,.02-.07,.03-.18,.07-.17-.05-.08-.05,.15-.11,.1-.04,.02,.01-.15,.06-.21,0-.07-.06,.13-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.78,112.9s-.01,0-.02-.02v.02h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.72,116.16s0,.09,.03,.05c-.06,0,.05-.15-.03-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "282.83 115.86 282.87 115.71 282.77 115.87 282.83 115.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.78,115.06s.03-.11,.08-.14c-.03,0-.08,.09-.08,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.06,115.51s-.01,0-.02,0h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.07,116.53c.15-.05-.09,.14-.1,.22,.01-.03,.01-.01,.02,0l-.07,.1s-.02-.03-.07-.05c-.05,.06-.1,.19-.13,.28,.05-.02,.15-.11,.1,.01l-.05,.04s.06-.04,.05,.02c-.11,.08,0,.02-.1,.15l.08-.11,.02,.07c.19-.26,.28-.57,.42-.73l-.02-.02s-.01,.03-.02,.04c0-.1-.09-.06-.13-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.33,114.33s-.06,.18-.11,.31c.03-.05,.06-.04,.08-.05-.03,.19-.09,.23-.19,.38v-.11c-.1,.04-.06,.19-.13,.27,.08-.02,.04-.05,.1-.12h-.01c.04-.11,.04,.04,.09-.03,0,.11-.1,.16-.08,.28-.03,.1-.16,.25-.24,.36,.07,0,.04,.03,.11,.06l-.05,.07c.07-.09,.11-.19,.15-.22-.02-.02,.04-.06,.04-.11,.02,0,.06,.02,.09-.06v.08c.07-.18,.11,.1,.19-.17l-.02,.02c0-.09,.1-.18,.15-.29l-.02,.02c.06-.2,.18-.31,.22-.6,.11-.15,.25-.31,.31-.48-.06,0,.05-.17-.03-.11,0-.12,.06-.03,.06-.15,.03,.07,.11-.08,.14-.05l.03-.12c-.07,.2-.02-.11-.1,.01,0,.08-.02,.09-.06,.08,.04-.07,.03-.19,.09-.18v.03c.03-.06,.05-.17,.1-.16v.03c0-.08,.03-.12-.01-.17,.1-.06,.04-.37,.16-.34-.01,.05-.03,.1-.04,.14,.09-.06,0,.14,.04,.16l-.06,.02s-.01,.12,0,.17h-.03c.02,.09-.06,.04-.05,.14,.05,.01,.05-.13,.08-.14,.03,0,0,.09,.02,.12-.02,0-.07,.11-.09,.15v.04s-.01,.06-.05,.14l.04,.02c-.08,.12-.1,.35-.06,.37-.14,.12-.13,.27-.26,.33,0,.02,.01,.04,.05,0-.05,.17-.17,.4-.21,.58l.06-.03c-.05,.11-.07,.23-.09,.29,.12-.23,.25-.43,.24-.48-.01,.01-.02,0-.04-.01,.1-.03,.16-.35,.23-.26-.11,.13-.04,.4-.19,.39v.11s-.06,.14-.14,.18h.05l-.05,.13s-.01-.04-.01-.05c-.04,.04-.09,.09-.13,.13v.12c-.09,.08-.13,.21-.18,.33-.05,.13-.11,.25-.19,.3h.01c-.01,.08-.05,.2-.09,.31,.12-.07,.16-.3,.26-.36,.17-.2,.15-.45,.29-.6,.07,0-.05,.13-.01,.14l.05-.14h.07c.01-.13,.08-.22,.15-.31h-.01c.06-.1,.1-.28,.15-.46,.04-.18,.1-.36,.21-.44,.06-.08,.11-.15,.16-.23-.01-.1,0-.16-.01-.19,0,.05-.03,.07-.03,.12-.06,0,.04-.15-.03-.07l-.08,.12h.01c-.09,.06-.08,.3-.19,.35-.07,.01,.02-.21,.03-.34v.02s.12-.29,.06-.27c-.02,.04-.03,.02-.06,.02,.07-.17,.11-.28,.15-.43l-.03-.02c.09-.06,.04-.3,.12-.28l-.03-.05c.02-.26,.16-.4,.15-.68,.08-.13,.03-.19,0-.27-.01,.09-.08,.11-.09,.13,.01-.04,.1-.09,.04-.16-.04,.16-.12,.18-.18,.37,.03,0,.02,.11,.03,.09-.04,.12-.06,.25-.09,.38-.03,.12-.07,.23-.11,.28-.07,.12,0-.11-.13,.02v.05s-.08,.1-.06,.02c-.02,.13-.08,.27-.1,.32h.06c-.08,.15-.14,.28-.19,.41-.06,.12-.13,.23-.23,.31v-.03l-.04,.26s-.07,.06-.11,.13l-.03-.08,.02-.02s-.05-.03-.05-.12c.02-.06,.06-.09,.08-.11l-.04,.17c.07-.06,.08-.25,.1-.3-.02,.02-.06,0-.09,.03,.06-.09,.12-.21,.18-.31v.06c.03-.08,0-.14-.05-.1-.09,.02-.11,.28-.18,.43h.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "283.22 116.51 283.22 116.5 283.22 116.51 283.22 116.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.89,114.5s.02,0,.04-.02c0-.02-.01-.03-.04,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.25,113.58v-.02s-.01,.04,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.2,111.57c0,.06,0,.09-.02,.15,.03-.02,.06-.03,.1-.1-.07,.08-.03-.05-.08-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.82,115.41s.04-.03,.06-.06c-.02,.02-.05,.04-.06,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.93,115.24s-.03,.08-.05,.11c.03-.03,.06-.06,.05-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.6,111.61v-.06s0,.05,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.3,111.32c.06-.05-.01-.22,.08-.25v.08c-.02-.15,.1-.13,.1-.27,.06,.02,0,.13-.02,.17l.06-.07c.06,.14-.09,.08,0,.19-.1,0,0,.17-.1,.15,.02,.12-.04,.33-.11,.36-.03,.18,.07,.12,.04,.24l.1,.04s-.01,.04-.02,.05l.07-.09s-.01-.08,0-.12l.08-.03c0,.06-.01,.13-.02,.19,.03-.03,.05-.06,.08-.09v.08c.06-.02,.03-.13,.04-.17,0,.01-.02,.01-.02,.01l.03-.1c-.02,.08-.1,.08-.06-.03,.03,.02,.03,.06,.05-.02-.01-.02-.05,0-.06,0v.04c-.06,.06-.06-.06-.08-.09,.06,.05,.05-.09,.08-.12-.15,.22-.04-.24-.17-.04-.02-.1,.04-.07,.06-.1,.04-.13,.07-.38,.12-.59,0,.03,.01,.07,.02,.1,.04-.17-.06-.31-.01-.39l-.04-.04c-.08,.09-.12,.45-.23,.45,.03-.04,.05-.08,.07-.12-.09-.14,.08-.35,.02-.48-.08-.11-.01,.05-.08,.13,.01,.16,0,.32,0,.48-.02,.16-.04,.31-.03,.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.89,115.85s.1-.06,.07-.1c-.06,.1-.04,0-.07,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.95,115.03c.02-.07,.02-.1-.02-.1-.06,.06,.02,.05,.02,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.93,114.93c.02-.1,.07-.05,.1-.15,0-.09,0-.03-.05-.02l-.09,.16h.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.94,116.62s0,.01-.02,.03c0,0,0-.01,.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283,116.54s-.05,.05-.06,.08c.03-.03,.02,.04,.06-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.63,125.07c.08-.04,.18-.11,.26-.15l-.22,.04c.05-.01,.03,.06-.04,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M279.61,125.08h.01s-.03,0-.05,0h.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.67,118.75s-.04,.05-.05,.07c.02-.03,.04-.05,.05-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.71,118.61c0,.05,0,.09-.05,.15,.11-.13,.32-.32,.28-.35,.03,0,.1-.07,.08-.1-.04-.03-.13,.16-.17,.16l.09-.15s-.06,0-.1,.09l.02,.05s-.06,.06-.09,.09c.02-.02,.07-.05,.08-.02-.04,.05-.09,.06-.13,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.27,124.8l.05-.09c.16-.04,.12-.03,.32-.13-.04-.05-.29,.12-.39,.14-.03-.04-.13-.02-.03-.13l-.11,.04c-.09,.13,0,.1,.07,.12-.09,.03-.18,.1-.18,.16,.07,0,.28-.19,.27-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.03,124.98l.09-.07-.31,.12c-.01,.08,.14-.02,.22-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.84,123.57c-.15,.16,.12,.02-.04,.18l.15-.08s-.25,.05-.05-.11c.04-.04,.08-.04,.12-.05-.05,.05-.16,.17-.03,.1l-.03-.03c.05-.04,.11-.08,.16-.12-.04-.02-.21,.09-.29,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.86,112.42c-.06,.02-.05,.02-.11,.13,.02,.03,.04-.13,.09-.11v.03l.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.98,112.93l-.05,.17s.04-.07,.06-.1l-.02-.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "282.86 118.77 282.86 118.83 282.94 118.69 282.86 118.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "282.17 121.23 282.19 121.2 282.07 121.33 282.17 121.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.13,110.49l.06,.08v-.09s.05-.05,.02-.07c-.01,.06-.06,.1-.08,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.21,123.68s-.09,.08-.14,.12c.05-.03,.1-.06,.14-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M280.67,124.09c.13-.05,.27-.18,.4-.29-.11,.06-.22,.06-.33,.14l-.07,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.92,118.92c.03-.09,.14-.16,.17-.16-.07-.02,.05-.12,.09-.19l-.02,.08,.05-.12c-.17,.09-.23,.22-.29,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.12,123.39c.06-.01,.19-.03,.27-.05,.07-.09,.27-.24,.21-.27l-.49,.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282,109.99c-.04-.11,.09-.05,.07-.11-.05,.03-.05-.1-.06-.15,.04,.1-.13,.17-.01,.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "282.25 110.38 282.31 110.35 282.3 110.26 282.25 110.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.5,117.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.31,117.78c-.06,.09,0,.16-.09,.29,.08-.1,.15-.21,.23-.31,0,.06,.02,.02,.06,0l-.05,.03c.12-.15,.21-.36,.34-.51l-.09-.03c-.07,.22-.3,.37-.36,.56-.07,.07,0-.05-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.89,119.76h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.8,119.91l.09-.06v-.09s-.11,.1-.09,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.09,112.57l.04-.03h0c.04-.06,.05-.06,.06-.17l-.04-.09c-.02,.09-.07,.21-.06,.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.31,121.55l-.04,.03v.07s.03-.07,.04-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.01,109.54s-.01,.05,0,.11v-.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "283.38 118.28 283.37 118.25 283.25 118.35 283.38 118.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.34,118.66c0-.05-.04-.03,0-.09,.04-.07-.07-.02-.12,.06,.05,0-.02,.08-.03,.13,.04-.05,.08-.09,.14-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.1,112.1c.04-.09-.03-.06-.04-.09-.01,.05,0,.05,.03,.06l-.05,.09s.04,.02,.06-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.78,122.91l.21-.2-.25,.16c.07-.03,0,.03,.04,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.4,119.84c.03-.09-.03-.06-.06-.08-.03,.06-.02,.09,0,.08-.08,.13-.08,.03-.17,.11-.11,.21-.25,.38-.39,.56,.07-.05,.13-.12,.19-.2,.06-.08,.12-.16,.21-.22l-.02-.06c.06,0,.19-.12,.24-.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "283.67 115.91 283.69 115.82 283.61 115.96 283.67 115.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.07,111.86s.03,.1,.06,.05c0,.04,.02-.01,.02-.01,0-.03-.04,0-.06-.02v-.08l-.03,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.17,112.22h.02s0,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.2,112.25l.03-.04h-.04s.01,.02,.02,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.18,109.28h0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.35,107.97s.03-.02,.04,0c0,.03,0,.06-.01,.09,0-.01,.03-.02,.04-.04,0-.03-.02-.07-.03-.1,0,.03-.02,.06-.04,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.37,108.05s0,.02,0,.03v-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "282.42 108.01 282.42 108.01 282.42 108.01 282.42 108.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.32,108.59s0,0-.02,0c0,0,.01,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.32,108.59c.08,0,0,.22,.04,.3-.11,.04-.12,.27-.18,.38,.03,.06,0-.07,.06-.04v.09c.08-.03,0-.18,.09-.13,.02,.1-.03,.14-.05,.21,0,.01,.01,.02,.02,.01l-.04,.07c.06,.13,.06,.15,.09,.3l-.05,.1,.05-.03v.16h.04c.02-.11-.04-.1,.02-.2h-.05c.05-.08-.04-.06,.02-.13,0,.14,.04-.1,.09-.04-.03-.05-.02-.13-.03-.2,.04,.1,.08-.09,.1-.15-.06,.03,.01-.13-.04-.05-.04-.21,.06-.43,.06-.56-.03,0-.02-.06-.05-.02,.1-.15,.04-.51,.02-.63-.04,.06-.03-.05-.07,.04,.01,0,.02-.02,.03,.02,0,.03-.04,.05-.06,.08-.01-.05-.02-.1-.03-.15-.06,.1-.08,.26-.09,.42,.03-.02,.02,.07,.03,.11-.05-.07-.02,.03-.04,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.25,109.39c-.09,.05,0,.11-.05,.19,.07-.02,.03-.16,.05-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.81,116.66s-.08,.05-.14,.13c.05-.01,.12-.1,.14-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.29,112.3l.05-.09h-.03c.03-.06,.07-.12,.09-.19-.05,.02-.15,.16-.11,.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M281.37,123.99c-.1,.06-.06,.05-.1,.11,.06-.05,.18-.1,.1-.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "283.66 113.62 283.61 113.78 283.67 113.69 283.66 113.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "282.11 109.3 282.15 109.22 282.15 109.19 282.11 109.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.24,111.32h-.06v-.15l-.04,.12h0c.03,.06,.01,.19,.06,.22-.05,.08-.04-.04-.06,.05,.04-.04,.13,.03,.17-.18v-.15l-.07,.02s0,.02,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.21,111.27h.03s-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "283.26 111.68 283.21 111.71 283.25 111.72 283.24 111.75 283.26 111.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.87,116.08s.06-.03,.09-.08c-.03,.04-.06,.1-.09,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.96,116s.01-.02,.02-.03c0,0-.01,.01-.02,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "283.9 116.45 283.9 116.39 283.87 116.45 283.9 116.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.57,122.02c.15-.13,.03-.09,.13-.2-.15,.06-.03,.1-.13,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.7,113.12s0-.09,0-.12c-.06,.08,0,.06,0,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.99,116.18c-.07,.14-.02,.11-.03,.22,.02,.03,.2-.31,.25-.46,.02-.14-.11,.11-.11,.06-.05,.05-.07,.24-.11,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.56,112.42l.06-.15-.08,.06,.03,.02s-.04,.05,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.74,113.29l.05-.06s.02-.13-.04-.07c.03,0,0,.09-.01,.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "282.52 122.34 282.66 122.22 282.53 122.3 282.52 122.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.57,112.11l-.04,.05s.03-.02,.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.64,112.17c-.01-.06,.03-.11,0-.16-.04-.04-.04,.04-.06,.09,.02-.02,.03-.04,.05-.05,0,.04,.01,.09,.02,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.02,115.89c.06,0,.08-.12,.12-.17l-.02,.02,.05-.13-.15,.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.81,119.37v0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.67,119.5c0,.14,0-.03,.11-.07l-.04,.11c.06-.08,.18-.23,.2-.2-.04,.06-.08,.07-.03,.08l.05-.11c-.02-.07-.18,.21-.17,.09,.01-.02,.02-.03,.03-.04-.06-.04-.08,.15-.14,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.58,119.39s.08-.05,.04,.03c-.04,.01,0,.08,.02,.09-.03-.1,.11-.13,.17-.22,.03-.01,.03,.01,.02,.05,.04-.05,.08-.08,.12-.11l-.16,.04c.04-.07,.06-.14,.07-.2-.09,.11-.18,.21-.27,.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.84,112.59c-.04-.06-.03,.07-.05,.11,.02,.02,0-.09,.05-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.26,110.75s0-.05,.02-.08l-.07-.02,.05,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.03,110.09v-.03c.07,.04-.02,.24,.05,.23-.02-.16,.1-.05,.08-.24h-.06l.03-.23s-.07,.05-.06-.01c0,0-.02,.17-.05,.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.83,112.35c0,.13,0,.14,.03,.13-.03-.02,0-.17-.03-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.89,112.46l-.03,.02s.02,0,.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.72,122.69s-.16,.11-.22,.18c.05,.04,.18-.14,.22-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.69,111.71v.08l.06-.12c-.01-.09-.08,0-.07-.2-.04,.08-.04,.24-.04,.32,0-.07,.03-.1,.05-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.08,117.79v.03s.07-.08,.11-.13c-.03,.03-.07,.06-.11,.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "284.27 115.43 284.3 115.39 284.23 115.42 284.27 115.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "283.97 112.66 283.93 112.72 283.96 112.75 283.97 112.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "283.97 112.64 283.97 112.66 283.97 112.65 283.97 112.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.36,118.5c-.08,.05,0-.15-.1,0h.02c-.12,.05-.23,.4-.35,.44-.03,.06,.02,.03,.04,.04l-.07,.1c.07-.04-.01,.05,.08-.01-.01,0,0-.04,0-.06,.24-.24-.04,.21,.2-.08v-.09s-.06,.08-.08,.07c.1-.1,.14-.31,.26-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.85,112.3c.06-.05,.02,.07,.05,.09l.02-.08s-.03-.1-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.12,118.03l.11-.04-.06,.08c.2-.13,.29-.53,.47-.69v-.11c-.06,.07-.08,.18-.17,.27h-.06c-.01,.11-.1,.26-.16,.41-.01-.06-.08,.05-.12,.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "284.35 116.8 284.35 116.75 284.27 116.86 284.35 116.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.29,110.43v-.16l-.04,.12h0s-.01,.11,.03,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.38,115.22h-.03s.01,.02,.02,.01l-.02,.04,.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.32,115.23h.03s-.01-.01-.03,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "284.13 118.38 284.16 118.26 284.13 118.28 284.13 118.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "283.26 110.1 283.25 110.05 283.23 110.17 283.26 110.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "283.27 110.25 283.31 110.14 283.25 110.21 283.27 110.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.87,111.73s-.02-.11-.05,.03c.02,0,.03-.01,.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.89,111.71s-.01,.02-.02,.02c0,0,.01-.01,.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.13,121.99c.1-.08,.25-.2,.28-.32-.08,0-.18,.21-.28,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.59,115.07c-.07,.13-.1,.12-.15,.27,.06,0,.1-.17,.15-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.74,116.45c-.06,0-.2,.29-.29,.33,.02,0,0,.06,0,.09,.09-.02,.22-.35,.3-.3,0-.03,.01-.07,.02-.1-.03,.13-.06,.05-.1,.07,.02-.05,.04-.06,.07-.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "283.19 109.51 283.14 109.52 283.19 109.54 283.19 109.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "282.92 122.99 282.9 123.07 282.98 123.01 282.92 122.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.07,107.55l-.02,.15h.07l-.04-.15c.15-.07,.09-.28,.13-.55-.05,0-.03-.06-.03-.11l-.07,.02c.05,.03,0,.12,.02,.19l-.05-.04c0,.21-.07,.4-.06,.52,0-.03,.04,0,.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.5,118.71c-.13,.01,0-.02-.13,.01-.03,.08,.01,.05,.06,.01,.06,.03-.07,.18-.09,.26,.14-.06,.06-.18,.16-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.62,113.12l-.09,.14c.08,.01-.03,.18-.03,.23,.05-.11,.14-.25,.12-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.48,118.46s-.01,0-.02,0c0,0,.01,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.54,118.42c.02-.08-.03,.01-.06,.05,.02,0,.02,.03,.06-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.8,116s.04-.1,.06-.11c.02,.03-.05,.15-.08,.21h-.06c-.06,.27-.2,.58-.27,.85-.07,0-.23,.21-.19,.11-.04,0,.06-.24,.02-.2l-.1,.16h.04c-.04,.07-.12,.11-.13,.22,.02,.05,.03,.11-.03,.19-.1,.22-.25,.34-.36,.53-.03,.14-.09,.18-.07,.31,.12-.11,.02-.12,.13-.19l-.02,.11s.05-.07,.09-.09c0-.04-.04-.04,.01-.11,.03,.07,.18-.29,.27-.28-.06,0,.03-.14,.06-.2,.05-.01,0,.04-.01,.11,.06-.07,.08-.1,.13-.27,.06,0,.06,.04,.15-.07l-.04-.06c.11-.18,.15-.09,.23-.23,.02-.1,.1-.33,.07-.33-.03,.05-.07,.11-.08,.1,.08-.25,.29-.49,.35-.59,0,.03-.02,.06-.03,.08,.1-.15,.19-.44,.25-.47,.04,.03-.07,.12,0,.07l.1-.23-.02,.03c.02-.07,.03-.15,.04-.22-.08,.05-.07,.27-.15,.3l.02-.12s-.02,.1-.06,.11v-.07l-.09,.1h.01c-.1,.21-.11-.1-.23,.19v.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.63,118.37h-.06s0,.05,0,.07l.06-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.43,107.95c0-.09,.07-.03,.06-.12l-.04-.07,.05-.02-.03-.12c-.05,.06,0,.21-.06,.22h.01v.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "283.24 109.15 283.22 109.27 283.27 109.16 283.24 109.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.79,107.51h0v-.02s0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.89,107.54l-.08-.09v.04s.06,.21,.08,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.78,108.25s-.04,.07-.05,.11c.02,.02,.02-.06,.05-.07v.12c.06-.02,.16-.13,.11-.31l-.02,.02c.05-.12-.04-.29,.05-.34-.07,0-.07-.16-.12-.25-.01,.05-.03,.1-.05,.09,.07,.01,0,.15,0,.21,0-.03,.02-.02,.02-.03,.03,.13-.08,.11-.07,.25,.04,.09-.01,.24,.06,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.95,117.09c-.03,.06-.13,.17-.16,.3,.06-.08,.14-.25,.16-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.25,108.89l-.05-.04h0l-.02,.03c-.02,.08,.04,.33,.08,.14,0-.14-.07,.02-.05-.12l.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.81,118.25l.06,.03c.04-.19,.27-.39,.16-.43-.08,.1-.13,.25-.2,.37v-.06l-.1,.13s.04,.08-.03,.14c.02,.01,.08-.13,.12-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.66,108.07c.02-.08,.03-.19-.01-.26-.02-.02-.06,.17,.01,.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.98,110.43v.17s.05-.07,.08-.06c-.02-.13,.07-.2,0-.27h-.08v-.1c-.01,.09-.03,.17-.05,.26,0-.01,.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.72,112.89s.05-.1,.08-.13v-.09s-.06,0-.07,.1c0,.05-.02,.09-.01,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.72,113.03c0,.08,.05,0,.07-.08v-.18c0,.17-.12,.2-.11,.38l.04-.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "284.8 112.76 284.8 112.76 284.8 112.76 284.8 112.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.96,116.26s0,.02,0,.03v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.98,116.33l-.02-.03s0,0,0-.01c0,.03-.02,.06-.03,.09l.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.96,116.26s.07-.06,.09-.1c-.01,.08-.05,.07-.03,.13,.04-.07,.12-.29,.04-.25l-.09,.13v-.07s0,.07-.02,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.85,122.06h.03l.03-.08c-.1,.12-.23,.18-.3,.32,.1-.11,.01,.03,.08,0l-.02,.04s.03,0,.05-.02c.05-.03-.07-.13,.13-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.62,122.39s-.09,.12-.11,.16c.06-.07,.14-.11,.11-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.21,108.55s0,.05,0,.07c.1,.01-.02-.13,0-.19-.01,.08-.08,.17-.04,.25l.05-.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "284.86 113.41 284.89 113.42 284.92 113.35 284.86 113.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.17,112.81s-.03,.03-.04,.05c.02-.02,.03-.04,.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.89,113.26c.06-.02,0-.03,.05-.12,.02,.03,.03,.1,.08,.03,.04-.14,.04-.23,.11-.32-.04,.04-.08,.05-.03-.08-.02,.03,.03-.14,.06-.13,0,.1,0,.01-.03,.09,.04,0,.06-.16,.12-.16,0-.09-.07-.06-.1,.02v-.09c-.05,.13-.12,.27-.19,.37,.05-.04,0,.08,0,.14h-.06s-.03,.11-.06,.14c.03,0,.12-.01,.06,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.17,112.81h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.38,108.87h-.02v-.22c0,.07-.03,.06-.04,.02v.2h.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.69,112.03c.05-.05,.02-.07,.03-.15,0,.02-.01,.03-.02,.04-.03-.02,.03-.15-.04-.09l-.04,.18c0,.08,.06-.07,.07,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.73,111.82s0-.03,.02-.05c0,0-.01,.02-.02,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.72,111.88s0-.04,.01-.06c0,.02,0,.04-.01,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.1,114.48c.04-.07,0-.07-.01-.09-.01,.06-.06,.18,.01,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.08,114.4s0-.03,0-.03c-.01,.02-.01,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.15,116.19c.1-.02,.18-.27,.19-.41-.06,.09-.13,.13-.16,.21,.08-.1,0,.03,.04,.03l-.08,.11s.01,.04,.01,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.63,107.59l.02-.12c-.05-.06-.03-.14-.07-.21,0,.04,.05,.22,.05,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.65,107.47s0-.02,0-.04v.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M282.66,107.44v-.03s0,0,0,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "282.45 107.23 282.44 107.27 282.49 107.34 282.45 107.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.01,107.7c0,.1,0,.19-.02,.29,.02-.05,.03-.11,.05-.16-.07,0,0-.08-.03-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.32,114.57s.02-.06,.02-.08l-.07,.1s.03-.02,.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.74,120.3c.06-.03,.16-.22,.11-.17-.03,.13-.12,.06-.11,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.33,116.85l.07-.07s.03-.08,.03-.1c-.03,.05-.12,.08-.09,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.92,119.81s.07-.06,.09-.05c.05-.13-.04,0-.09,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.88,119.81s.02,.01,.04,0c-.01,0-.02,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.14,119.89s-.07-.14-.18,.07l.18-.02v-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.43,113.7l.08,.03c.03-.14-.09,.07-.04-.11-.06,.07-.04,.19-.1,.21l.08-.02s-.04-.06-.02-.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "285.45 113.82 285.45 113.82 285.45 113.82 285.45 113.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.49,113.84s-.03-.01-.04-.02l-.05,.19c.03-.06,.05-.12,.09-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.71,115.12c-.06,.13-.13,.27-.21,.4,0,.09,.07,.02,.11-.02-.05,.11-.09,.24-.11,.36,.13-.19,.06-.37,.18-.49l-.05,.04h.01c-.06,.14-.06,.02-.11,.08,.05-.07,.13-.21,.16-.3,.05-.14,.06,.03,.12-.11-.03-.04-.12,.02-.12,.04,.01,0,.02-.01,.01,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.1,120.06l-.07,.02s-.02,.06,0,.06c.02-.01,.05-.04,.07-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M283.05,107.14s-.05,0-.08-.08c.02,.19,.07,.25,.08,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.28,108.92h0s.03,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M284.29,109.07s-.06-.12-.02-.14c-.04,0-.12,.02-.1,.18,.03-.08,.08,.06,.11-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "285.94 116.45 285.85 116.53 285.97 116.46 285.94 116.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286,116.68s.07,0,.08-.09c-.02-.08-.09,.12-.1,0,.01-.05,.02-.09,.04-.13-.06-.02-.11,.22-.17,.26v-.07c-.04,.26,.09,.05,.15,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.86,113.6c-.04,.16-.11-.02-.12,.2,0-.1,.09-.03,.12-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.47,119.76c-.11,.15-.06,.25,.08,.02,.01-.06,.18-.26,.21-.36-.07,.05-.09-.03-.21,.16,.05-.04,.08-.08,.09-.06-.03,.09-.14,.28-.17,.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.6,119.33h-.03s.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.6,119.33l.14-.05-.07,.09,.08-.08-.03-.04,.19-.36c-.09,.1-.11-.03-.23,.2l.03,.04c-.05,.07-.08,.17-.12,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M285.68,111.74s0,.06-.01,.1l.03,.02s0-.08-.02-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.47,116.5l-.03,.07c.05-.04,.1-.08,.15-.12v.03s.18-.51,.29-.61h-.01c.04-.07,.07-.13,.11-.2-.06,.04-.04-.05-.1-.03,.05-.04,.13-.13,.15-.22-.04,0-.12,.14-.1,.01-.12,.19-.1,.25-.24,.53,.03-.05,.02-.03,.04-.03-.14,.3-.23,.25-.34,.61,.04,.03,.08-.16,.08-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.53,115.4s.04,.01,.04,.08c.09-.18,.08-.44,.12-.61-.01-.02-.05,.04-.06,.06l.04-.03c-.02,.16-.11,.39-.18,.48,.03-.04-.04,.2-.04,.3,.02-.07,.07-.22,.08-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.45,115.72s0-.02,0-.04c0,.03,0,.04,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.65,115.47c.04-.14,.14-.22,.12-.36-.07,.06-.16,.25-.12,.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.67,116.91s.05-.08,.07-.11l.05,.02-.04-.09-.07,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.16,115.66s-.01-.08-.05-.05c.04,0,0,.1-.02,.18,.03-.02,.05-.05,.07-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.09,115.79h0s0,.02,0,.02c0,0,0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.92,115.93l-.04,.1c.07-.02,.03,.14,.15-.03-.07-.02,.01-.05,0-.17,.01-.02,.03-.03,.05-.04-.04-.09-.18,.34-.17,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.18,116.42v.02s.01-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M286.96,116.79v-.03c.07-.04,.06,.11,.14-.04l.08-.29s-.22,.15-.22,.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.05,113.65s0-.09,.02-.14l-.1,.13c0,.07,.04,.02,.08,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M287.24,115.97c.05-.08,.04-.11,.08-.23l-.11,.14s.03,.03,.02,.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "261.27 116.63 261.26 116.63 261.27 116.68 261.27 116.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.19,115.99l.08-.06c.09,.09,.16,.19,.19,.2l.05,.13h.04v-.04l-.09-.17-.29-.3-.12,.24c.03,.09,.08,.16,.15,.23v-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.91,116.04v-.03s-.02,0,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.93,116.04s.02,.04,.03,.06l-.03-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M260.97,116.1l.05,.1s-.03-.06-.05-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.59,117.19h.07l-.05-.1,.07,.04,.04-.11c-.08-.12-.08,0-.15-.09l.03,.17s-.05-.01-.06-.01c0,0,.02,.01,.03,.03l.02,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.4,117.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.4,117.13h0c-.05-.11,0-.01,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.5,115.65v.04s0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.54,117.09s-.01,0-.01,0c0,0,0,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.47,116.35l.06-.03-.02-.05-.07,.02c-.03-.06,.01,.16,.03,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M259.29,115.05s-.04,.03-.02,.1v-.04c.05,.11,.11,.22,.17,.33l-.03,.17s0-.07,.03-.05c-.04,.08,.04,.03,.05,.09,0-.04,0-.08-.05-.13h.11s.08,.09,.1,.15l-.07-.03,.08,.15,.02-.03c.04,.06,.08,.12,.12,.18v.09l.18,.15s.01-.07,.05-.05c.07,.13-.04,.21,.11,.3,0,.05,.03,.14-.03,.15,.02,.09-.03-.03-.05-.11,.02,.05,0,.05-.04,.05l-.05-.14c-.02,.1-.05-.12-.06,.03-.02-.16-.18-.17-.18-.33l-.15-.09c-.05-.08-.09-.16-.13-.24,.07,.16,.07,.32,.19,.42l-.02-.08,.18,.25v-.03c.11,.17,.09,.25,.14,.28l.02-.02s.1,.18,.12,.2h.02c-.02,.07,.11,.12,.1,.18l.02-.03s-.06-.05-.09-.1h.07c.04,.08,.08,.2,.18,.26l-.04,.05,.13,.23s.02-.05,.05-.03c.03,.08,.07,.15,.1,.22,.02-.04,.12-.04,.17,.07v-.02l.08,.14,.09-.05s.07,.08,0,.11c.05,.06,.11,.13,.11,.19l-.03-.02,.05,.09,.08-.05,.02,.06s.03-.03-.01-.08c.09,0,.17,.18,.23,.17-.02,.02-.05,.03-.12-.03,.11,.19,.28,.1,.39,.29,.02-.02,.01-.06,.05-.07,.08,.2,.05,.12,.11,.31l-.09-.05c-.06-.09-.08-.2-.19-.25v.08c0,.05,.24,.17,.24,.28,0,0-.04-.11,.02-.04,.06,.09-.1,0,.03,.13l-.17-.14c-.08-.05-.17,.04-.2,.01l-.14-.22c.01,.13-.18-.06-.11,.1,.08-.01,.1,.09,.15,.15l.07-.04c.13,.09,.25,.2,.39,.26,.02-.1,.15,.06,.16-.03l.1,.13s.08,.02,.11,.07c.11-.02-.16-.23-.09-.15l-.02,.04c.02-.07-.06-.19-.13-.29-.06-.1-.12-.19-.05-.17,.03,.18,.31,.29,.29,.44h.13s.05,.09,.1,.13c0,.03-.12,.03-.01,.1l.05-.05c.04,.06,.02,.12,.06,.14-.04,0-.02,.06-.03,.09,.06,.02,.13,.1,.17,.12h-.05l.08,.06v.16l.12,.04,.17,.18-.04,.02c.04,.09,.23,.06,.17,.08,.02,.06,.05,.13,0,.16,.07,.09,.39,.18,.45,.31v.06l-.09-.07c0,.07,.13,.1,.06,.15h-.06l-.06-.14-.08,.04,.19,.14c.02,.08,.05,.14,.07,.22h.08l-.07-.1,.07-.07s.15,.12,.14,.09c.03,0-.06-.09-.16-.13-.01-.02-.02-.03-.03-.04h0l.35,.15c-.08-.04,.02-.09-.13-.14h.06c.08,.03,.14,.12,.22,.22,.07,.02,.14,.03,.2,.04,.23,.11,.33,.28,.59,.43-.12,0-.15-.16-.26-.09,.03,.03,.06,.06,.09,.09h.09l.03,.06c.19,.1,.2-.02,.38,.11h-.06c.09,.08,.18,.14,.26,.2l.04-.04c.09,.06,.16,.17,.28,.19-.11-.09-.1-.16-.06-.15l.06,.07c.01-.08,.22,.04,.31,.08-.07,.03,.17,.05,.07,.09,.17,.04,.42,.1,.49,.17,.03,.05-.07,.05-.13,.06l.13,.05,.13-.14,.19,.09,.16-.04-.09-.09c-.06,.02-.25-.07-.24,.02-.09-.07-.12-.14-.23-.19l.1,.03c-.19-.12-.38-.09-.53-.23,0,.05-.09,.02-.15,.03-.11-.06-.21-.05-.32-.14,0,.07-.17,0-.25,.03,0-.06-.08-.1-.07-.16,.13-.03,.3,.07,.45,.12l.08-.07-.06,.02-.06-.15-.05,.03c-.14-.08-.06-.11-.08-.13l-.07,.04c-.05-.04-.1-.09-.15-.13-.05-.05-.11-.09-.2-.11l.09-.06c.09,.12,.31,.13,.5,.24-.06-.07-.01-.12-.03-.17l-.18-.08,.11,.15c-.08-.02-.04-.09-.16-.06,.12-.03-.08-.14-.07-.18-.25-.2-.4-.25-.62-.46l-.04-.09c.08,.06,.21,.12,.22,.2v-.04c.1,.07,.22,.11,.25,.19h.08c0,.08,.2,.1,.13,.18,.17,.07,.05-.12,.24-.02,.11,.02,.21,.13,.36,.2h0c-.01-.05,.18,.06,.18,.05-.23-.08-.19-.28-.36-.25l-.03-.1c-.05,.03-.1-.01-.17-.05v.05c-.01-.05-.15-.15-.24-.19h-.09v-.09c-.12-.05-.23-.1-.33-.16,.09,.08-.14-.06,.08,.07-.08,0-.2-.02-.3-.07l-.06-.16s.07-.02,.12-.01l.09,.07v-.07l.16,.07-.04-.16-.29-.13c-.11-.15-.32-.22-.48-.32-.02-.03-.05-.07-.07-.11-.13-.09-.29-.25-.49-.27l.04-.04c-.07,.02-.09-.09-.13-.13-.08,0,0,.09-.12,.07l.15,.17-.25-.16-.02,.06s.2,.1,.14,.15l-.13-.1-.03,.02-.05-.1c.03,.06-.05,0-.06,.02,0-.04,.01-.07-.02-.1-.06-.03-.18-.06-.23-.14l-.04,.05c-.06,0-.15-.1-.19-.09-.05-.13-.12-.05-.22-.17,0-.08,.12,.03,.16,.03-.07-.11-.15-.13-.21-.21,.03-.02,.06-.02,.11,.04l.07-.07-.18-.18c.09,0-.01-.08-.04-.11-.04,0-.09-.1-.13-.14l.04-.09-.09-.02-.05-.14c-.02,.06-.09-.05-.14-.08,.03,.06,.05,.11-.04,.06,.16,.08,.29,.3,.26,.39-.13-.02-.3-.21-.34-.3,0-.04-.02-.07-.03-.11-.06,0-.15-.04-.12,.07l-.13-.11-.05-.16s0-.04,.03-.05c-.02-.03-.04-.06-.05-.07,0-.07,.04-.09,.12-.07,.05,.05,.04,.08,0,.09h.06l.08,.13,.02-.02c.05,.06,.09,.12,.14,.17-.02-.04-.04-.09-.06-.13,.04,.01,.07,.05,.08,.09v-.07l.24,.18c-.05-.06-.11-.12-.17-.18-.06-.06-.12-.12-.18-.18-.11-.12-.23-.23-.28-.37-.01,.04-.02,.15-.04,.18l.03,.02c.03,.07-.02,.05-.07,.05l-.14-.25s.01-.03,.02-.04c-.04,0-.04,.05-.13,.05l.03,.08v-.05l.05,.12-.12-.06s-.1-.04,.06,.06c-.03,0-.1-.04-.11,.03l.03,.12,.08,.03s.05,.09,.07,.14l-.05,.07c0-.08-.12-.16-.15-.25l-.05,.04-.08-.08,.04,.06s-.05-.02-.08-.06c.04-.07-.06-.21-.02-.27,.01-.04,.1,.16,.12,.16,.03-.06-.16-.21-.06-.22-.07-.02,.04-.08-.08-.06l.05-.03s.07,.09,.1,.14v-.08l.08,.06s-.01-.14,.04-.11c-.03-.04-.06-.09-.09-.13l.04-.02c-.02-.15-.1-.12-.08-.12,0-.03-.02-.11,.02-.09v-.05l-.04,.03-.12-.16v-.12l-.12-.11s-.04-.13-.04,.02c-.09-.12-.05-.22-.14-.33l.07,.02,.03,.09s.02,0,.01-.02l.02,.04s0-.04,.03-.04c.03,.04,.05,.08,.06,.04-.04-.04-.04-.04-.02-.04l-.02-.05-.02-.02h.02c-.06-.09-.11-.2-.16-.3l-.03,.14-.13,.14c.05,.05,.11,.1,.16,.15l.02,.33h.1c.03,.06,.06,.1,.09,.15l.13,.1,.05,.2-.19,.13,.04,.11c0,.07,.02,.14,.03,.22l-.07,.06c-.07-.09-.14-.18-.2-.27,.04,.07,.07,.15,.11,.21h-.13l-.02-.12-.26-.21,.08-.12c-.08-.01-.16-.02-.24-.03l-.06-.28-.02-.19c-.06-.08-.11-.16-.17-.25l-.15-.06-.12-.17c-.07-.1-.13-.21-.19-.31l-.09-.24h-.09l.27-.1-.1-.09-.11-.34-.17-.21c0,.08,0,.17,.03,.27l.02-.13,.13,.2c.01,.05,.06,.14,0,.14l-.08-.14c0,.14,.09,.13,.07,.28l-.16-.08c-.05-.08-.1-.18-.16-.17-.03,.09,.07,0,.07,.11Zm4.3,5.65s0,.08-.05,.02l.05-.02Zm-.23-1.43s-.03-.04-.04-.06c0,.01,.01,.03,.04,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "260.83 117.65 260.83 117.64 260.82 117.68 260.83 117.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261,115.99l.02,.04,.02-.04v-.02l-.07-.04h0c.05,.05,.04,.05,.02,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.69,117.31l-.05-.02s.04,.04,.05,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M262.54,118.23s-.04,0-.02,0c0,0,.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M261.79,117.56s-.04-.02-.05-.01c.02,.03,.05,.05,.05,.01Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M254.13,264.5h-44.71c2.66-9.52,5.6-20.07,9.59-32.98,.3-.97,.6-1.95,.91-2.94,3.32-10.65,7.91-24.7,13.88-41.18,20.84-2.63,41.68-5.26,62.53-7.89,4.81,17.34,9.63,34.68,14.44,52.02,3.05,10.99,6.1,21.98,9.16,32.98"
  })), /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M140.16,196.14c-2.86-.21-4.79-3-4-5.75,.42-1.45,1.53-2.6,2.97-3.05l.35-.11c-1.86-.53-3.06-2.33-2.85-4.25l.24-2.15c.14-1.28,.89-2.41,2.02-3.04l.43-.24-11.24,.63c-3.04,.17-5.47-2.49-5.03-5.5,.32-2.16,2.05-3.84,4.22-4.08l25.63-2.92,.63-.72c1.83-2.11,4.54-3.23,7.32-3.03h0c.74-.01,2.46-.19,4.19,.3,6.2,1.74,8.43,5.78,7.58,8.77,4.35,.26,2.75,.16,7.1,.42-2.02,8.46-.55,17.27-2.56,25.73-11.17-.22-25.82-.78-36.98-1Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "v",
    x1: 172.61,
    y1: 170.99,
    x2: 152.7,
    y2: 166.15
  })), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M244.73,124.25c8.56,10.46,9.69,32.87,8.98,50.9-.59,14.87-12.05,27.03-26.86,28.47-17.15,1.67-34.3,3.34-51.45,5.01-.2-12.51-.4-25.02-.59-37.53,13.44-2.04,26.88-4.08,40.31-6.12-.74-13.81-1.48-27.62-2.22-41.43-.32-5.92,12.12-9.02,20.26-7.22,6.21,1.37,9.96,5.95,11.57,7.93Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "v",
    x1: 139.32,
    y1: 177.55,
    x2: 142.31,
    y2: 177.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "v",
    x1: 139.32,
    y1: 187.21,
    x2: 142.31,
    y2: 187.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M127.49,170.33s.25,.21,.62,.46c2.22,1.53,1.86,4.03-.77,5.25l-.38,.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "v",
    x1: 252.05,
    y1: 183.88,
    x2: 247.55,
    y2: 143.91
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contactUs.5097a20f0d58ea6596d657b28aa74967.svg";
export { ForwardRef as ReactComponent };